/*! Image eReader - v2.3.7 - 2025-02-17
* www.comprodls.com
* Copyright (c) 2025 ComproDLS | Compro Technologies; Licensed comproDLS © 2015-2016 */
/*! Image eReader - v2.3.7 - 2025-02-17
* www.comprodls.com
* Copyright (c) 2025 ComproDLS | Compro Technologies; Licensed comproDLS © 2015-2016 */
/*members "", "\b", "\t", "\n", "\f", "\r", "\"", JSON, "\\", apply,
    call, charCodeAt, getUTCDate, getUTCFullYear, getUTCHours,
    getUTCMinutes, getUTCMonth, getUTCSeconds, hasOwnProperty, join,
    lastIndex, length, parse, prototype, push, replace, slice, stringify,
    test, toJSON, toString, valueOf
*/


// Create a JSON object only if one does not already exist. We create the
// methods in a closure to avoid creating global variables.

if (!this.JSON) {
    this.JSON = {};
}

(function () {
    "use strict";

    function f(n) {
        // Format integers to have at least two digits.
        return n < 10 ? '0' + n : n;
    }

    if (typeof Date.prototype.toJSON !== 'function') {

        Date.prototype.toJSON = function (key) {

            return isFinite(this.valueOf()) ?
                   this.getUTCFullYear()   + '-' +
                 f(this.getUTCMonth() + 1) + '-' +
                 f(this.getUTCDate())      + 'T' +
                 f(this.getUTCHours())     + ':' +
                 f(this.getUTCMinutes())   + ':' +
                 f(this.getUTCSeconds())   + 'Z' : null;
        };

        String.prototype.toJSON =
        Number.prototype.toJSON =
        Boolean.prototype.toJSON = function (key) {
            return this.valueOf();
        };
    }

    var cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
        escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
        gap,
        indent,
        meta = {    // table of character substitutions
            '\b': '\\b',
            '\t': '\\t',
            '\n': '\\n',
            '\f': '\\f',
            '\r': '\\r',
            '"' : '\\"',
            '\\': '\\\\'
        },
        rep;


    function quote(string) {

// If the string contains no control characters, no quote characters, and no
// backslash characters, then we can safely slap some quotes around it.
// Otherwise we must also replace the offending characters with safe escape
// sequences.

        escapable.lastIndex = 0;
        return escapable.test(string) ?
            '"' + string.replace(escapable, function (a) {
                var c = meta[a];
                return typeof c === 'string' ? c :
                    '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
            }) + '"' :
            '"' + string + '"';
    }


    function str(key, holder) {

// Produce a string from holder[key].

        var i,          // The loop counter.
            k,          // The member key.
            v,          // The member value.
            length,
            mind = gap,
            partial,
            value = holder[key];

// If the value has a toJSON method, call it to obtain a replacement value.

        if (value && typeof value === 'object' &&
                typeof value.toJSON === 'function') {
            value = value.toJSON(key);
        }

// If we were called with a replacer function, then call the replacer to
// obtain a replacement value.

        if (typeof rep === 'function') {
            value = rep.call(holder, key, value);
        }

// What happens next depends on the value's type.

        switch (typeof value) {
        case 'string':
            return quote(value);

        case 'number':

// JSON numbers must be finite. Encode non-finite numbers as null.

            return isFinite(value) ? String(value) : 'null';

        case 'boolean':
        case 'null':

// If the value is a boolean or null, convert it to a string. Note:
// typeof null does not produce 'null'. The case is included here in
// the remote chance that this gets fixed someday.

            return String(value);

// If the type is 'object', we might be dealing with an object or an array or
// null.

        case 'object':

// Due to a specification blunder in ECMAScript, typeof null is 'object',
// so watch out for that case.

            if (!value) {
                return 'null';
            }

// Make an array to hold the partial results of stringifying this object value.

            gap += indent;
            partial = [];

// Is the value an array?

            if (Object.prototype.toString.apply(value) === '[object Array]') {

// The value is an array. Stringify every element. Use null as a placeholder
// for non-JSON values.

                length = value.length;
                for (i = 0; i < length; i += 1) {
                    partial[i] = str(i, value) || 'null';
                }

// Join all of the elements together, separated with commas, and wrap them in
// brackets.

                v = partial.length === 0 ? '[]' :
                    gap ? '[\n' + gap +
                            partial.join(',\n' + gap) + '\n' +
                                mind + ']' :
                          '[' + partial.join(',') + ']';
                gap = mind;
                return v;
            }

// If the replacer is an array, use it to select the members to be stringified.

            if (rep && typeof rep === 'object') {
                length = rep.length;
                for (i = 0; i < length; i += 1) {
                    k = rep[i];
                    if (typeof k === 'string') {
                        v = str(k, value);
                        if (v) {
                            partial.push(quote(k) + (gap ? ': ' : ':') + v);
                        }
                    }
                }
            } else {

// Otherwise, iterate through all of the keys in the object.

                for (k in value) {
                    if (Object.hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) {
                            partial.push(quote(k) + (gap ? ': ' : ':') + v);
                        }
                    }
                }
            }

// Join all of the member texts together, separated with commas,
// and wrap them in braces.

            v = partial.length === 0 ? '{}' :
                gap ? '{\n' + gap + partial.join(',\n' + gap) + '\n' +
                        mind + '}' : '{' + partial.join(',') + '}';
            gap = mind;
            return v;
        }
    }

// If the JSON object does not yet have a stringify method, give it one.

    if (typeof JSON.stringify !== 'function') {
        JSON.stringify = function (value, replacer, space) {

// The stringify method takes a value and an optional replacer, and an optional
// space parameter, and returns a JSON text. The replacer can be a function
// that can replace values, or an array of strings that will select the keys.
// A default replacer method can be provided. Use of the space parameter can
// produce text that is more easily readable.

            var i;
            gap = '';
            indent = '';

// If the space parameter is a number, make an indent string containing that
// many spaces.

            if (typeof space === 'number') {
                for (i = 0; i < space; i += 1) {
                    indent += ' ';
                }

// If the space parameter is a string, it will be used as the indent string.

            } else if (typeof space === 'string') {
                indent = space;
            }

// If there is a replacer, it must be a function or an array.
// Otherwise, throw an error.

            rep = replacer;
            if (replacer && typeof replacer !== 'function' &&
                    (typeof replacer !== 'object' ||
                     typeof replacer.length !== 'number')) {
                throw new Error('JSON.stringify');
            }

// Make a fake root object containing our value under the key of ''.
// Return the result of stringifying the value.

            return str('', {'': value});
        };
    }


// If the JSON object does not yet have a parse method, give it one.

    if (typeof JSON.parse !== 'function') {
        JSON.parse = function (text, reviver) {

// The parse method takes a text and an optional reviver function, and returns
// a JavaScript value if the text is a valid JSON text.

            var j;

            function walk(holder, key) {

// The walk method is used to recursively walk the resulting structure so
// that modifications can be made.

                var k, v, value = holder[key];
                if (value && typeof value === 'object') {
                    for (k in value) {
                        if (Object.hasOwnProperty.call(value, k)) {
                            v = walk(value, k);
                            if (v !== undefined) {
                                value[k] = v;
                            } else {
                                delete value[k];
                            }
                        }
                    }
                }
                return reviver.call(holder, key, value);
            }


// Parsing happens in four stages. In the first stage, we replace certain
// Unicode characters with escape sequences. JavaScript handles many characters
// incorrectly, either silently deleting them, or treating them as line endings.

            text = String(text);
            cx.lastIndex = 0;
            if (cx.test(text)) {
                text = text.replace(cx, function (a) {
                    return '\\u' +
                        ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
                });
            }

// In the second stage, we run the text against regular expressions that look
// for non-JSON patterns. We are especially concerned with '()' and 'new'
// because they can cause invocation, and '=' because it can cause mutation.
// But just to be safe, we want to reject all unexpected forms.

// We split the second stage into 4 regexp operations in order to work around
// crippling inefficiencies in IE's and Safari's regexp engines. First we
// replace the JSON backslash pairs with '@' (a non-JSON character). Second, we
// replace all simple value tokens with ']' characters. Third, we delete all
// open brackets that follow a colon or comma or that begin the text. Finally,
// we look to see that the remaining characters are only whitespace or ']' or
// ',' or ':' or '{' or '}'. If that is so, then the text is safe for eval.

            if (/^[\],:{}\s]*$/
.test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, '@')
.replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']')
.replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {

// In the third stage we use the eval function to compile the text into a
// JavaScript structure. The '{' operator is subject to a syntactic ambiguity
// in JavaScript: it can begin a block or an object literal. We wrap the text
// in parens to eliminate the ambiguity.

                j = eval('(' + text + ')');

// In the optional fourth stage, we recursively walk the new structure, passing
// each name/value pair to a reviver function for possible transformation.

                return typeof reviver === 'function' ?
                    walk({'': j}, '') : j;
            }

// If the text is not JSON parseable, then a SyntaxError is thrown.

            throw new SyntaxError('JSON.parse');
        };
    }
}());

// Generated by CoffeeScript 1.9.2
var $, Util, _gettext, _t, gettext, ref;
var ESCAPE_MAP = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#47;"
};
gettext = null;

if (typeof Gettext !== "undefined" && Gettext !== null) {
  _gettext = new Gettext({
    domain: "annotator"
  });
  gettext = function(msgid) {
    return _gettext.gettext(msgid);
  };
} else {
  gettext = function(msgid) {
    return msgid;
  };
}

_t = function(msgid) {
  return gettext(msgid);
};

if (!(typeof jQuery !== "undefined" && jQuery !== null ? (ref = jQuery.fn) != null ? ref.jquery : void 0 : void 0)) {
  console.error(_t("Annotator requires jQuery: have you included lib/vendor/jquery.js?"));
}

if (!(JSON && JSON.parse && JSON.stringify)) {
  console.error(_t("Annotator requires a JSON implementation: have you included lib/vendor/json2.js?"));
}

$ = jQuery;

Util = {};

Util.flatten = function(array) {
  var flatten;
  flatten = function(ary) {
    var el, flat, i, len;
    flat = [];
    for (i = 0, len = ary.length; i < len; i++) {
      el = ary[i];
      flat = flat.concat(el && $.isArray(el) ? flatten(el) : el);
    }
    return flat;
  };
  return flatten(array);
};

Util.contains = function(parent, child) {
  var node;
  node = child;
  while (node != null) {
    if (node === parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};

Util.getTextNodes = function(jq) {
  var getTextNodes;
  getTextNodes = function(node) {
    var nodes;
    if (node && node.nodeType !== Node.TEXT_NODE) {
      nodes = [];
      if (node.nodeType !== Node.COMMENT_NODE) {
        node = node.lastChild;
        while (node) {
          nodes.push(getTextNodes(node));
          node = node.previousSibling;
        }
      }
      return nodes.reverse();
    } else {
      return node;
    }
  };
  return jq.map(function() {
    return Util.flatten(getTextNodes(this));
  });
};

Util.getLastTextNodeUpTo = function(n) {
  var result;
  switch (n.nodeType) {
    case Node.TEXT_NODE:
      return n;
    case Node.ELEMENT_NODE:
      if (n.lastChild != null) {
        result = Util.getLastTextNodeUpTo(n.lastChild);
        if (result != null) {
          return result;
        }
      }
      break;
  }
  n = n.previousSibling;
  if (n != null) {
    return Util.getLastTextNodeUpTo(n);
  } else {
    return null;
  }
};

Util.getFirstTextNodeNotBefore = function(n) {
  var result;
  switch (n.nodeType) {
    case Node.TEXT_NODE:
      return n;
    case Node.ELEMENT_NODE:
      if (n.firstChild != null) {
        result = Util.getFirstTextNodeNotBefore(n.firstChild);
        if (result != null) {
          return result;
        }
      }
      break;
  }
  n = n.nextSibling;
  if (n != null) {
    return Util.getFirstTextNodeNotBefore(n);
  } else {
    return null;
  }
};

Util.readRangeViaSelection = function(range) {
  var sel;
  sel = Util.getGlobal().getSelection();
  sel.removeAllRanges();
  sel.addRange(range.toRange());
  return sel.toString();
};

Util.xpathFromNode = function(el, relativeRoot) {
  var exception, result;
  try {
    result = simpleXPathJQuery.call(el, relativeRoot);
  } catch (_error) {
    exception = _error;
    console.log("jQuery-based XPath construction failed! Falling back to manual.");
    result = simpleXPathPure.call(el, relativeRoot);
  }
  return result;
};

Util.nodeFromXPath = function(xp, root) {
  var i, idx, len, name, node, ref1, step, steps;
  steps = xp.substring(1).split("/");
  node = root;
  for (i = 0, len = steps.length; i < len; i++) {
    step = steps[i];
    ref1 = step.split("["), name = ref1[0], idx = ref1[1];
    idx = idx != null ? parseInt((idx != null ? idx.split("]") : void 0)[0]) : 1;
    node = findChild(node, name.toLowerCase(), idx);
  }
  return node;
};

Util.escape = function(html) {
  return html ? html.replace(/&(?!\w+;)/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'): "";
};

Util.uuid = (function() {
  var counter;
  counter = 0;
  return function() {
    return counter++;
  };
})();

Util.getGlobal = function() {
  return (function() {
    return this;
  })();
};

Util.maxZIndex = function($elements) {
  var all, el;
  all = (function() {
    var i, len, results;
    results = [];
    for (i = 0, len = $elements.length; i < len; i++) {
      el = $elements[i];
      if ($(el).css('position') === 'static') {
        results.push(-1);
      } else {
        results.push(parseFloat($(el).css('z-index')) || -1);
      }
    }
    return results;
  })();
  return Math.max.apply(Math, all);
};

Util.mousePosition = function(e, offsetEl) {
  var offset, ref1;
  if ((ref1 = $(offsetEl).css('position')) !== 'absolute' && ref1 !== 'fixed' && ref1 !== 'relative') {
    offsetEl = $(offsetEl).offsetParent()[0];
  }
  offset = $(offsetEl).offset();
  return {    
    top: e.pageY,
    left: e.pageX
  };
};

Util.preventEventDefault = function(event) {
  return event != null ? typeof event.preventDefault === "function" ? event.preventDefault() : void 0 : void 0;
};

Util.escapeHtml = function(string) {
  return String(string).replace(/[&<>"'\/]/g, function (c) {
      return ESCAPE_MAP[c];
    });
};

//# sourceMappingURL=util.js.map

// Generated by CoffeeScript 1.9.2
var fn, functions, i, j, len, len1,
  slice = [].slice;

functions = ["log", "debug", "info", "warn", "exception", "assert", "dir", "dirxml", "trace", "group", "groupEnd", "groupCollapsed", "time", "timeEnd", "profile", "profileEnd", "count", "clear", "table", "error", "notifyFirebug", "firebug", "userObjects"];

if (typeof console !== "undefined" && console !== null) {
  if (console.group == null) {
    console.group = function(name) {
      return console.log("GROUP: ", name);
    };
  }
  if (console.groupCollapsed == null) {
    console.groupCollapsed = console.group;
  }
  for (i = 0, len = functions.length; i < len; i++) {
    fn = functions[i];
    if (console[fn] == null) {
      console[fn] = function() {
        return console.log(_t("Not implemented:") + (" console." + name));
      };
    }
  }
} else {
  this.console = {};
  for (j = 0, len1 = functions.length; j < len1; j++) {
    fn = functions[j];
    this.console[fn] = function() {};
  }
  this.console['error'] = function() {
    var args;
    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
    return alert("ERROR: " + (args.join(', ')));
  };
  this.console['warn'] = function() {
    var args;
    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
    return alert("WARNING: " + (args.join(', ')));
  };
}

//# sourceMappingURL=console.js.map

// Generated by CoffeeScript 1.9.2
var Delegator,
  slice = [].slice,
  hasProp = {}.hasOwnProperty;

Delegator = (function() {
  Delegator.prototype.events = {};

  Delegator.prototype.options = {};

  Delegator.prototype.element = null;

  function Delegator(element, options) {
    this.options = $.extend(true, {}, this.options, options);
    this.element = $(element);
    this._closures = {};
    this.on = this.subscribe;
    this.addEvents();
  }

  Delegator.prototype.destroy = function() {
    return this.removeEvents();
  };

  Delegator.prototype.addEvents = function() {
    var event, i, len, ref, results;
    ref = Delegator._parseEvents(this.events);
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      event = ref[i];
      results.push(this._addEvent(event.selector, event.event, event.functionName));
    }
    return results;
  };

  Delegator.prototype.removeEvents = function() {
    var event, i, len, ref, results;
    ref = Delegator._parseEvents(this.events);
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      event = ref[i];
      results.push(this._removeEvent(event.selector, event.event, event.functionName));
    }
    return results;
  };

  Delegator.prototype._addEvent = function(selector, event, functionName) {
    var closure;
    closure = (function(_this) {
      return function() {
        return _this[functionName].apply(_this, arguments);
      };
    })(this);
    if (selector === '' && Delegator._isCustomEvent(event)) {
      this.subscribe(event, closure);
    } else {
      this.element.delegate(selector, event, closure);
    }
    this._closures[selector + "/" + event + "/" + functionName] = closure;
    return this;
  };

  Delegator.prototype._removeEvent = function(selector, event, functionName) {
    var closure;
    closure = this._closures[selector + "/" + event + "/" + functionName];
    if (selector === '' && Delegator._isCustomEvent(event)) {
      this.unsubscribe(event, closure);
    } else {
      this.element.undelegate(selector, event, closure);
    }
    delete this._closures[selector + "/" + event + "/" + functionName];
    return this;
  };

  Delegator.prototype.publish = function() {
    this.element.triggerHandler.apply(this.element, arguments);
    return this;
  };

  Delegator.prototype.subscribe = function(event, callback) {
    var closure;
    closure = function() {
      return callback.apply(this, [].slice.call(arguments, 1));
    };
    closure.guid = callback.guid = ($.guid += 1);
    this.element.bind(event, closure);
    return this;
  };

  Delegator.prototype.unsubscribe = function() {
    this.element.unbind.apply(this.element, arguments);
    return this;
  };

  return Delegator;

})();

Delegator._parseEvents = function(eventsObj) {
  var event, events, functionName, i, ref, sel, selector;
  events = [];
  for (sel in eventsObj) {
    functionName = eventsObj[sel];
    ref = sel.split(' '), selector = 2 <= ref.length ? slice.call(ref, 0, i = ref.length - 1) : (i = 0, []), event = ref[i++];
    events.push({
      selector: selector.join(' '),
      event: event,
      functionName: functionName
    });
  }
  return events;
};

Delegator.natives = (function() {
  var key, specials, val;
  specials = (function() {
    var ref, results;
    ref = jQuery.event.special;
    results = [];
    for (key in ref) {
      if (!hasProp.call(ref, key)) continue;
      val = ref[key];
      results.push(key);
    }
    return results;
  })();
  return "blur focus focusin focusout load resize scroll unload click dblclick\nmousedown mouseup mousemove mouseover mouseout mouseenter mouseleave\nchange select submit keydown keypress keyup error".split(/[^a-z]+/).concat(specials);
})();

Delegator._isCustomEvent = function(event) {
  event = event.split('.')[0];
  return $.inArray(event, Delegator.natives) === -1;
};

//# sourceMappingURL=class.js.map

// Generated by CoffeeScript 1.9.2
var Range,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Range = {};

Range.sniff = function(r) {
  if (r.commonAncestorContainer != null) {
    return new Range.BrowserRange(r);
  } else if (typeof r.start === "string") {
    return new Range.SerializedRange(r);
  } else if (r.start && typeof r.start === "object") {
    return new Range.NormalizedRange(r);
  } else {
    console.error(_t("Could not sniff range type"));
    return false;
  }
};

Range.nodeFromXPath = function(xpath, root) {
  var customResolver, evaluateXPath, namespace, node, segment;
  if (root == null) {
    root = document;
  }
  evaluateXPath = function(xp, nsResolver) {
    var exception;
    if (nsResolver == null) {
      nsResolver = null;
    }
    try {
      return document.evaluate('.' + xp, root, nsResolver, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
    } catch (_error) {
      exception = _error;
      console.log("XPath evaluation failed.");
      console.log("Trying fallback...");
      return Util.nodeFromXPath(xp, root);
    }
  };
  if (!$.isXMLDoc(document.documentElement)) {
    return evaluateXPath(xpath);
  } else {
    customResolver = document.createNSResolver(document.ownerDocument === null ? document.documentElement : document.ownerDocument.documentElement);
    node = evaluateXPath(xpath, customResolver);
    if (!node) {
      xpath = ((function() {
        var i, len, ref, results;
        ref = xpath.split('/');
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          segment = ref[i];
          if (segment && segment.indexOf(':') === -1) {
            results.push(segment.replace(/^([a-z]+)/, 'xhtml:$1'));
          } else {
            results.push(segment);
          }
        }
        return results;
      })()).join('/');
      namespace = document.lookupNamespaceURI(null);
      customResolver = function(ns) {
        if (ns === 'xhtml') {
          return namespace;
        } else {
          return document.documentElement.getAttribute('xmlns:' + ns);
        }
      };
      node = evaluateXPath(xpath, customResolver);
    }
    return node;
  }
};

Range.RangeError = (function(superClass) {
  extend(RangeError, superClass);

  function RangeError(type, message, parent1) {
    this.type = type;
    this.message = message;
    this.parent = parent1 != null ? parent1 : null;
    RangeError.__super__.constructor.call(this, this.message);
  }

  return RangeError;

})(Error);

Range.BrowserRange = (function() {
  function BrowserRange(obj) {
    this.commonAncestorContainer = obj.commonAncestorContainer;
    this.startContainer = obj.startContainer;
    this.startOffset = obj.startOffset;
    this.endContainer = obj.endContainer;
    this.endOffset = obj.endOffset;
  }

  BrowserRange.prototype.normalize = function(root) {
    var n, node, nr, r;
    if (this.tainted) {
      console.error(_t("You may only call normalize() once on a BrowserRange!"));
      return false;
    } else {
      this.tainted = true;
    }
    r = {};
    if (this.startContainer.nodeType === Node.ELEMENT_NODE) {
      r.start = Util.getFirstTextNodeNotBefore(this.startContainer.childNodes[this.startOffset]);
      r.startOffset = 0;
    } else {
      r.start = this.startContainer;
      r.startOffset = this.startOffset;
    }
    if (this.endContainer.nodeType === Node.ELEMENT_NODE) {
      node = this.endContainer.childNodes[this.endOffset];
      if (node != null) {
        n = node;
        while ((n != null) && (n.nodeType !== Node.TEXT_NODE)) {
          n = n.firstChild;
        }
        if (n != null) {
          r.end = n;
          r.endOffset = 0;
        }
      }
      if (r.end == null) {
        node = this.endContainer.childNodes[this.endOffset - 1];
        r.end = Util.getLastTextNodeUpTo(node);
        r.endOffset = r.end.nodeValue.length;
      }
    } else {
      r.end = this.endContainer;
      r.endOffset = this.endOffset;
    }
    nr = {};
    if (r.startOffset > 0) {
      if (r.start.nodeValue.length > r.startOffset) {
        nr.start = r.start.splitText(r.startOffset);
      } else {
        nr.start = r.start.nextSibling;
      }
    } else {
      nr.start = r.start;
    }
    if (r.start === r.end) {
      if (nr.start.nodeValue.length > (r.endOffset - r.startOffset)) {
        nr.start.splitText(r.endOffset - r.startOffset);
      }
      nr.end = nr.start;
    } else {
      if (r.end.nodeValue.length > r.endOffset) {
        r.end.splitText(r.endOffset);
      }
      nr.end = r.end;
    }
    nr.commonAncestor = this.commonAncestorContainer;
    while (nr.commonAncestor.nodeType !== Node.ELEMENT_NODE) {
      nr.commonAncestor = nr.commonAncestor.parentNode;
    }
    return new Range.NormalizedRange(nr);
  };

  BrowserRange.prototype.serialize = function(root, ignoreSelector) {
    return this.normalize(root).serialize(root, ignoreSelector);
  };

  return BrowserRange;

})();

Range.NormalizedRange = (function() {
  function NormalizedRange(obj) {
    this.commonAncestor = obj.commonAncestor;
    this.start = obj.start;
    this.end = obj.end;
  }

  NormalizedRange.prototype.normalize = function(root) {
    return this;
  };

  NormalizedRange.prototype.limit = function(bounds) {
    var i, len, nodes, parent, ref, startParents;
    nodes = $.grep(this.textNodes(), function(node) {
      return node.parentNode === bounds || $.contains(bounds, node.parentNode);
    });
    if (!nodes.length) {
      return null;
    }
    this.start = nodes[0];
    this.end = nodes[nodes.length - 1];
    startParents = $(this.start).parents();
    ref = $(this.end).parents();
    for (i = 0, len = ref.length; i < len; i++) {
      parent = ref[i];
      if (startParents.index(parent) !== -1) {
        this.commonAncestor = parent;
        break;
      }
    }
    return this;
  };

  NormalizedRange.prototype.serialize = function(root, ignoreSelector) {
    var end, serialization, start;
    serialization = function(node, isEnd) {
      var i, len, n, nodes, offset, origParent, textNodes, xpath;
      if (ignoreSelector) {
        origParent = $(node).parents(":not(" + ignoreSelector + ")").eq(0);
      } else {
        origParent = $(node).parent();
      }
      xpath = Util.xpathFromNode(origParent, root)[0];
      textNodes = Util.getTextNodes(origParent);
      nodes = textNodes.slice(0, textNodes.index(node));
      offset = 0;
      for (i = 0, len = nodes.length; i < len; i++) {
        n = nodes[i];
        offset += n.nodeValue.length;
      }
      if (isEnd) {
        return [xpath, offset + node.nodeValue.length];
      } else {
        return [xpath, offset];
      }
    };
    start = serialization(this.start);
    end = serialization(this.end, true);
    return new Range.SerializedRange({
      start: start[0],
      end: end[0],
      startOffset: start[1],
      endOffset: end[1]
    });
  };

  NormalizedRange.prototype.text = function() {
    var node;
    return ((function() {
      var i, len, ref, results;
      ref = this.textNodes();
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        node = ref[i];
        results.push(node.nodeValue);
      }
      return results;
    }).call(this)).join('');
  };

  NormalizedRange.prototype.textNodes = function() {
    var end, ref, start, textNodes;
    textNodes = Util.getTextNodes($(this.commonAncestor));
    ref = [textNodes.index(this.start), textNodes.index(this.end)], start = ref[0], end = ref[1];
    return $.makeArray(textNodes.slice(start, +end + 1 || 9e9));
  };

  NormalizedRange.prototype.toRange = function() {
    var range;
    range = document.createRange();
    range.setStartBefore(this.start);
    range.setEndAfter(this.end);
    return range;
  };

  return NormalizedRange;

})();

Range.SerializedRange = (function() {
  function SerializedRange(obj) {
    this.start = obj.start;
    this.startOffset = obj.startOffset;
    this.end = obj.end;
    this.endOffset = obj.endOffset;
  }

  SerializedRange.prototype.normalize = function(root) {
    var contains, e, i, j, len, len1, length, node, p, range, ref, ref1, targetOffset, tn;
    range = {};
    ref = ['start', 'end'];
    for (i = 0, len = ref.length; i < len; i++) {
      p = ref[i];
      try {
        node = Range.nodeFromXPath(this[p], root);
      } catch (_error) {
        e = _error;
        throw new Range.RangeError(p, ("Error while finding " + p + " node: " + this[p] + ": ") + e, e);
      }
      if (!node) {
        throw new Range.RangeError(p, "Couldn't find " + p + " node: " + this[p]);
      }
      length = 0;
      targetOffset = this[p + 'Offset'];
      if (p === 'end') {
        targetOffset--;
      }
      ref1 = Util.getTextNodes($(node));
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        tn = ref1[j];
        if (length + tn.nodeValue.length > targetOffset) {
          range[p + 'Container'] = tn;
          range[p + 'Offset'] = this[p + 'Offset'] - length;
          break;
        } else {
          length += tn.nodeValue.length;
        }
      }
      if (range[p + 'Offset'] == null) {
        throw new Range.RangeError(p + "offset", "Couldn't find offset " + this[p + 'Offset'] + " in element " + this[p]);
      }
    }
    contains = document.compareDocumentPosition == null ? function(a, b) {
      return a.contains(b);
    } : function(a, b) {
      return a.compareDocumentPosition(b) & 16;
    };
    $(range.startContainer).parents().each(function() {
      if (contains(this, range.endContainer)) {
        range.commonAncestorContainer = this;
        return false;
      }
    });
    return new Range.BrowserRange(range).normalize(root);
  };

  SerializedRange.prototype.serialize = function(root, ignoreSelector) {
    return this.normalize(root).serialize(root, ignoreSelector);
  };

  SerializedRange.prototype.toObject = function() {
    return {
      start: this.start,
      startOffset: this.startOffset,
      end: this.end,
      endOffset: this.endOffset
    };
  };

  return SerializedRange;

})();

//# sourceMappingURL=range.js.map

// Generated by CoffeeScript 1.9.2
var Annotator, _Annotator, g, ref,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

_Annotator = this.Annotator;

Annotator = (function(superClass) {
  extend(Annotator, superClass);

  Annotator.prototype.events = {
    ".annotator-adder button click": "onAdderClick",
    ".annotator-adder button mousedown": "onAdderMousedown",
    ".annotator-mic-adder button.text-adder click": "onAdderClick",
    ".annotator-mic-adder button.text-adder mousedown": "onAdderMousedown",    
    ".annotator-mic-adder button.mic-adder click": "onMicAdderClick",
    ".annotator-mic-adder button.mic-adder mousedown": "onAdderMousedown",      
    ".annotator-hl click": "onHighlightMouseover",
    ".annotator-hl mouseout": "startViewerHideTimer"
  };

  Annotator.prototype.html = {
    adder: '<div class="annotator-adder"><button>' + _t('Annotate') + '</button></div>',
    micAdder: '<div class="annotator-mic-adder"><button class="text-adder"></button><button class="mic-adder"></button></div>',
    wrapper: '<div class="annotator-wrapper"></div>'
  };

  Annotator.prototype.options = {
    readOnly: false
  };

  Annotator.prototype.plugins = {};

  Annotator.prototype.editor = null;

  Annotator.prototype.viewer = null;

  Annotator.prototype.selectedRanges = null;

  Annotator.prototype.mouseIsDown = false;

  Annotator.prototype.ignoreMouseup = false;

  Annotator.prototype.viewerHideTimer = null;

  function Annotator(element, options) {
    this.onDeleteAnnotation = bind(this.onDeleteAnnotation, this);
    this.onCloseAnnotation = bind(this.onCloseAnnotation, this);
    this.onEditAnnotation = bind(this.onEditAnnotation, this);
    this.onAdderClick = bind(this.onAdderClick, this);
    this.onMicAdderClick = bind(this.onMicAdderClick, this);
    this.onAdderMousedown = bind(this.onAdderMousedown, this);
    this.onHighlightMouseover = bind(this.onHighlightMouseover, this);
    this.checkForEndSelection = bind(this.checkForEndSelection, this);
    this.checkForStartSelection = bind(this.checkForStartSelection, this);
    this.clearViewerHideTimer = bind(this.clearViewerHideTimer, this);
    this.startViewerHideTimer = bind(this.startViewerHideTimer, this);
    this.showViewer = bind(this.showViewer, this);
    this.onEditorSubmit = bind(this.onEditorSubmit, this);
    this.onEditorHide = bind(this.onEditorHide, this);
    this.showEditor = bind(this.showEditor, this);
    this.changeOptions = bind(this.changeOptions, this);
    Annotator.__super__.constructor.apply(this, arguments);
    this.plugins = {};
    if (!Annotator.supported()) {
      return this;
    }
    if (!this.options.readOnly) {
      this._setupDocumentEvents();
    }
    this._setupWrapper()._setupViewer()._setupEditor();
    this._setupDynamicStyle();
    /* Provide support for speaking functionality. */
    if(options && options.isMic) {
      this.adder = $(this.html.micAdder).appendTo(this.wrapper).hide(); 
    } else {
      this.adder = $(this.html.adder).appendTo(this.wrapper).hide();  
    }    
    Annotator._instances.push(this);
  }

  Annotator.prototype._setupWrapper = function() {
    this.wrapper = $(this.html.wrapper);
    this.element.find('script').remove();
    /* Add annotator-wrapper only if its not present.*/
    if(!((this.element.find('.annotator-wrapper')).length)) {
      this.element.wrapInner(this.wrapper);
      //$(this.element).children(':not(.activity)').wrapAll(this.wrapper);    
    } 
    this.wrapper = this.element.find('.annotator-wrapper');
    return this;
  };

  Annotator.prototype._setupViewer = function() {
    this.viewer = new Annotator.Viewer({
      // readOnly: this.options.readOnly
    });
    /*var g = Util.getGlobal();
    var renderHtml = function (annotation) {
      var convert = Util.escapeHtml;
      if (g.Showdown && typeof g.Showdown.converter === "function") {
          convert = (new g.Showdown.converter).makeHtml
      }
      if (annotation.text) {
          return convert(annotation.text)
      } else {
          return "<i>" + _t("No comment") + "</i>"
      }
    };*/
    /*Function to escape regular expressions.*/
    /*var escapeRegExp = function(string) {
      return string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    }*/ 
    /*Function to replace some content in a string with some other content.*/
    /*var replaceAll = function(string, find, replace) {
      return string.replace(new RegExp(escapeRegExp(find), 'g'), replace);
    }*/     
    var self = this;
    var urlCheck = new RegExp("([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?");
    this.viewer.hide().on("edit", this.onEditAnnotation).on("delete", this.onDeleteAnnotation).on("close", this.onCloseAnnotation).addField({
      load: (function(_this) {
        return function(field, annotation) {
          /*annotation.text = replaceAll(annotation.text,"https"," https");
          annotation.text = replaceAll(annotation.text,"&nbsp;"," ");
          annotation.text = replaceAll(annotation.text,"<br></div>","</div>");
          var separators = ["<br>","<div>"];*/

          //split annoatation on br and div
          //annotation.text = (annotation.text).split(new RegExp(separators.join('|'), 'g')).join("\n");
          
          //check if annotation contains video url
          if (urlCheck.test(annotation.text)) {
            try {
              if(window.parent.myReader && window.parent.myReader.readerOptions && window.parent.myReader.readerOptions.config && window.parent.myReader.readerOptions.config.applyEditor) {
                var re = /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\S*[^\w\s-])([\w-]{11})(?=[^\w-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/ig;
          
                //replace video url with iframe 
                annotation.text = (annotation.text).replace(re,
                                  '<iframe height="150px" width="100%" src="http://www.youtube.com/embed/$1" allowfullscreen></iframe>');
              }
            } catch(error) {
            }
            /*annotation.text = replaceAll(annotation.text, '\n','<br>');*/                                               
            /*var render = renderHtml(annotation);*/
            /*$(field).html(render);*/
            /*$(field).html(Util.escape(annotation.text));*/
          }
          else if (annotation.text) {
            /*annotation.text = replaceAll(annotation.text, '\n','<br>'); */           
            /*var render = renderHtml(annotation);*/
            //$(field).html(render);
            /*$(field).html(Util.escape(annotation.text));*/
          } else {
            $(field).html("<i>" + (_t('No Comment')) + "</i>");
          }
          //annotation.text = (annotation.text).split("\n").join("<br>");
          $(field).html(Util.escape(annotation.text));
          return _this.publish('annotationViewerTextField', [field, annotation]);
        };
      })(this)
    }).element.appendTo(this.wrapper).bind({
      "mouseover": this.clearViewerHideTimer,
      "mouseout": this.startViewerHideTimer
    });
    return this;
  };

  Annotator.prototype._setupEditor = function() {
    this.editor = new Annotator.Editor();
    this.editor.hide().on('hide', this.onEditorHide).on('save', this.onEditorSubmit).addField({
      type: 'textarea',
      label: _t('Comments') + '\u2026',
      load: function(field, annotation) {
        return $(field).find('textarea').val(annotation.text || '');
      },
      submit: function(field, annotation) {
        return annotation.text = $(field).find('textarea').val();
      }
    });
    this.editor.hide().on('hide', this.onEditorHide).on('save', this.onEditorSubmit).addField({
      type: 'checkbox',
      label: _t('Mark as closed'),
      load: function(field, annotation) {
        if(!annotation._id) {
          $($(field).find('input')[0]).parent().hide();
        } else {
          $($(field).find('input')[0]).parent().show();
        }
        return $(field).find('input')[0].checked = annotation.isClosed || false;
      },
      submit: function(field, annotation) {
        return annotation.isClosed = $(field).find('input')[0].checked;
      }
    });
    this.editor.element.appendTo(this.wrapper);
    return this;
  };

  Annotator.prototype._setupDocumentEvents = function() {
    $(document).bind({
      "mouseup": this.checkForEndSelection,
      "mousedown": this.checkForStartSelection
    });
    return this;
  };

  Annotator.prototype._setupDynamicStyle = function() {
    var max, sel, style, x;
    style = $('#annotator-dynamic-style');
    if (!style.length) {
      style = $('<style id="annotator-dynamic-style"></style>').appendTo(document.head);
    }
    sel = '*' + ((function() {
      var j, len, ref, results;
      ref = ['adder', 'outer', 'notice', 'filter'];
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        x = ref[j];
        results.push(":not(.annotator-" + x + ")");
      }
      return results;
    })()).join('');
    max = Util.maxZIndex($(document.body).find(sel));
    max = Math.max(max, 1000);
    style.text([".annotator-adder, .annotator-outer, .annotator-notice {", "  z-index: " + (max + 20) + ";", "}", ".annotator-filter {", "  z-index: " + (max + 10) + ";", "}"].join("\n"));
    return this;
  };

  Annotator.prototype.destroy = function() {
    var base, idx, name, plugin, ref;
    Annotator.__super__.destroy.apply(this, arguments);
    $(document).unbind({
      "mouseup": this.checkForEndSelection,
      "mousedown": this.checkForStartSelection
    });
    $('#annotator-dynamic-style').remove();
    this.adder.remove();
    this.viewer.destroy();
    this.editor.destroy();
    this.wrapper.find('.annotator-hl').each(function() {
      $(this).contents().insertBefore(this);
      return $(this).remove();
    });
    /* Dont't remove anotator-wrapper as it force the activity iframe to refresh, which creates problem. */
    // this.wrapper.contents().insertBefore(this.wrapper);
    // this.wrapper.remove();
    this.element.data('annotator', null);
    ref = this.plugins;
    for (name in ref) {
      plugin = ref[name];
      if (typeof (base = this.plugins[name]).destroy === "function") {
        base.destroy();
      }
    }
    idx = Annotator._instances.indexOf(this);
    if (idx !== -1) {
      return Annotator._instances.splice(idx, 1);
    }
  };

  Annotator.prototype.getSelectedRanges = function() {
    var browserRange, i, j, len, normedRange, r, ranges, rangesToIgnore, selection;
    selection = Util.getGlobal().getSelection();
    ranges = [];
    rangesToIgnore = [];
    if (!selection.isCollapsed) {
      ranges = (function() {
        var j, ref, results;
        results = [];
        for (i = j = 0, ref = selection.rangeCount; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
          r = selection.getRangeAt(i);
          browserRange = new Range.BrowserRange(r);
          normedRange = browserRange.normalize().limit(this.wrapper[0]);
          if (normedRange === null) {
            rangesToIgnore.push(r);
          }
          results.push(normedRange);
        }
        return results;
      }).call(this);
      selection.removeAllRanges();
    }
    for (j = 0, len = rangesToIgnore.length; j < len; j++) {
      r = rangesToIgnore[j];
      selection.addRange(r);
    }
    return $.grep(ranges, function(range) {
      if (range) {
        selection.addRange(range.toRange());
      }
      return range;
    });
  };

  Annotator.prototype.createAnnotation = function() {
    var annotation;
    annotation = {};
    this.publish('beforeAnnotationCreated', [annotation]);
    return annotation;
  };

  Annotator.prototype.setupAnnotation = function(annotation) {
    var e, j, k, len, len1, normed, normedRanges, r, ref, root;
    root = this.wrapper[0];
    annotation.ranges || (annotation.ranges = this.selectedRanges);
    var orgid, productid, productcode, itemid;
    try {
      if(window.parent.myReader && window.parent.myReader.readerOptions && window.parent.myReader.readerOptions.config) {
        var config = window.parent.myReader.readerOptions.config;
        if (config !== undefined && config !== null) {
          if (config.orgid) {
            orgid = config.orgid;      
          }        
          if (config.productid) {
            productid = config.productid;      
          }
          if (config.productcode) {
            productcode = config.productcode;      
          }        
          if (config.itemid) {
            itemid = config.itemid;      
          }
        }
      }
    } catch(error) {

    }
    if(orgid !== null && orgid !== undefined) {
      annotation.orgid = orgid;
    }    
    if(productid !== null && productid !== undefined) {
      annotation.productid = productid;
    }
    if(productcode !== null && productcode !== undefined) {
      annotation.productcode = productcode;
    }    
    if(itemid !== null && itemid !== undefined) {
      annotation.itemid = itemid;
    }
    normedRanges = [];
    ref = annotation.ranges;
    for (j = 0, len = ref.length; j < len; j++) {
      r = ref[j];
      try {
        normedRanges.push(Range.sniff(r).normalize(root));
      } catch (_error) {
        e = _error;
        if (e instanceof Range.RangeError) {
          this.publish('rangeNormalizeFail', [annotation, r, e]);
        } else {
          throw e;
        }
      }
    }
    annotation.quote = [];
    annotation.ranges = [];
    annotation.highlights = [];
    for (k = 0, len1 = normedRanges.length; k < len1; k++) {
      normed = normedRanges[k];
      annotation.quote.push($.trim(normed.text()));
      annotation.ranges.push(normed.serialize(this.wrapper[0], '.annotator-hl'));
      $.merge(annotation.highlights, this.highlightRange(normed));
    }
    annotation.quote = annotation.quote.join(' / ');
    $(annotation.highlights).data('annotation', annotation);
    $(annotation.highlights).attr('data-annotation-id', annotation._id);
    return annotation;
  };

  Annotator.prototype.updateAnnotation = function(annotation) {
    if(annotation.id === undefined && annotation._id !== undefined) {
      annotation.id = annotation._id;
    }    
    this.publish('beforeAnnotationUpdated', [annotation]);
    $(annotation.highlights).attr('data-annotation-id', annotation._id);
    this.publish('annotationUpdated', [annotation]);
    return annotation;
  };

  Annotator.prototype.deleteAnnotation = function(annotation) {
    var child, h, j, len, ref;
    if(annotation.id === undefined && annotation._id !== undefined) {
      annotation.id = annotation._id;
    }        
    if (annotation.highlights != null) {
      ref = annotation.highlights;
      for (j = 0, len = ref.length; j < len; j++) {
        h = ref[j];
        if (!(h.parentNode != null)) {
          continue;
        }
        child = h.childNodes[0];
        $(h).replaceWith(h.childNodes);
      }
    }
    this.publish('annotationDeleted', [annotation]);
    return annotation;
  };

  Annotator.prototype.loadAnnotations = function(annotations) {
    var clone, loader;
    if (annotations == null) {
      annotations = [];
    }
    loader = (function(_this) {
      return function(annList) {
        var j, len, n, now;
        if (annList == null) {
          annList = [];
        }
        now = annList.splice(0, 10);
        for (j = 0, len = now.length; j < len; j++) {
          n = now[j];
          _this.setupAnnotation(n);
          try {
            if(window.parent.myReader && window.parent.myReader.readerOptions && window.parent.myReader.readerOptions.config) {          
              var config = window.parent.myReader.readerOptions.config;
              if (config !== null && config!== undefined && config.readerSettings !== null && config.readerSettings !== undefined && (!config.readerSettings.isSyntheticSpread || (config.readerSettings.isSyntheticSpread && $('html').width() < 768)) && navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
                $("html").width("+=1");
                $("html").width("-=1");
              }
            }
          } catch(error) {   
          }  
        }
        if (annList.length > 0) {
          return setTimeout((function() {
            return loader(annList);
          }), 10);
        } else {
          return _this.publish('annotationsLoaded', [clone]);
        }
      };
    })(this);
    clone = annotations.slice();
    loader(annotations);
    return this;
  };

  Annotator.prototype.dumpAnnotations = function() {
    if (this.plugins['Store']) {
      return this.plugins['Store'].dumpAnnotations();
    } else {
      console.warn(_t("Can't dump annotations without Store plugin."));
      return false;
    }
  };

  Annotator.prototype.highlightRange = function(normedRange, cssClass) {
    var hl, j, len, node, ref, results, white;
    if (cssClass == null) {
      cssClass = 'annotator-hl';
    }
    white = /^\s*$/;
    hl = $("<span class='" + cssClass + "'></span>");
    ref = normedRange.textNodes();
    results = [];
    for (j = 0, len = ref.length; j < len; j++) {
      node = ref[j];
      if (!white.test(node.nodeValue)) {
        results.push($(node).wrapAll(hl).parent().show()[0]);
      }
    }
    return results;
  };

  Annotator.prototype.highlightRanges = function(normedRanges, cssClass) {
    var highlights, j, len, r;
    if (cssClass == null) {
      cssClass = 'annotator-hl';
    }
    highlights = [];
    for (j = 0, len = normedRanges.length; j < len; j++) {
      r = normedRanges[j];
      $.merge(highlights, this.highlightRange(r, cssClass));
    }
    return highlights;
  };

  Annotator.prototype.addPlugin = function(name, options) {
    var base, klass;
    if (this.plugins[name]) {
      console.error(_t("You cannot have more than one instance of any plugin."));
    } else {
      klass = Annotator.Plugin[name];
      if (typeof klass === 'function') {
        this.plugins[name] = new klass(this.element[0], options);
        this.plugins[name].annotator = this;
        if (typeof (base = this.plugins[name]).pluginInit === "function") {
          base.pluginInit();
        }
      } else {
        console.error(_t("Could not load ") + name + _t(" plugin. Have you included the appropriate <script> tag?"));
      }
    }
    return this;
  };

  Annotator.prototype.showEditor = function(annotation, location) {
    //Get annotation id and add it on editor.
    if(annotation._id) {
      this.editor.element.attr("id",annotation._id);
    }
    this.editor.element.css(location);
    this.editor.element.css("position", "fixed");
    this.editor.load(annotation);
    this.publish('annotationEditorShown', [this.editor, annotation]);
    return this;
  };

  Annotator.prototype.changeOptions = function(options) {
    this.options = options;
    if (this.options.readOnly) {
      $(document).unbind({
        "mouseup": this.checkForEndSelection,
        "mousedown": this.checkForStartSelection
      });
    } else {
      this._setupDocumentEvents();
    }
  };  

  Annotator.prototype.onEditorHide = function() {
    this.publish('annotationEditorHidden', [this.editor]);
    return this.ignoreMouseup = false;
  };

  Annotator.prototype.onEditorSubmit = function(annotation) {
    return this.publish('annotationEditorSubmit', [this.editor, annotation]);
  };

  Annotator.prototype.showViewer = function(annotations, location) {
    if(navigator.userAgent.indexOf("MSIE") !== -1 || window.navigator.userAgent.indexOf('Trident/') !== -1) {
      location.left = event.clientX + document.body.scrollLeft;
    }
    if(location.left < 320) {
      location.left = location.left + 15;
    }
    else {
      location.left = location.left - 10; 
    }
    this.viewer.element.css(location);
    this.viewer.load(annotations);
    return this.publish('annotationViewerShown', [this.viewer, annotations]);
  };

  Annotator.prototype.startViewerHideTimer = function() {
    if (!this.viewerHideTimer) {
      //return this.viewerHideTimer = setTimeout(this.viewer.hide, 250);
    }
  };

  Annotator.prototype.clearViewerHideTimer = function() {
    clearTimeout(this.viewerHideTimer);
    return this.viewerHideTimer = false;
  };

  Annotator.prototype.checkForStartSelection = function(event) {
    if (!(event && this.isAnnotator(event.target))) {
      this.startViewerHideTimer();
    }
    return this.mouseIsDown = true;
  };

  Annotator.prototype.checkForEndSelection = function(event) {
    var container, j, len, range, ref;
    this.mouseIsDown = false;
    if (this.ignoreMouseup) {
      return;
    }
    this.selectedRanges = this.getSelectedRanges();
    ref = this.selectedRanges;
    for (j = 0, len = ref.length; j < len; j++) {
      range = ref[j];
      container = range.commonAncestor;
      if (this.isAnnotator(container)) {
        return;
      }
    }
    var config;
    try {
      if(window.parent.myReader && window.parent.myReader.readerOptions && window.parent.myReader.readerOptions.config) {
        config = window.parent.myReader.readerOptions.config;
      }
    } catch(error) {
    }
    if (event && this.selectedRanges.length && !this.viewer.isShown()) {
      if(config !== null && config!== undefined && config.applyEditor) {
        //remove html editor to stop video on double click
        var htmleditor = document.getElementsByClassName("wysiwyg-editor");
        if(htmleditor.length !== 0) {
          $(htmleditor).remove();
        } 
      }
      var position = Util.mousePosition(event, this.wrapper[0]);
      var adderWidth = this.adder.width();
      //calculating mouse left position in IE
      if(navigator.userAgent.indexOf("MSIE") !== -1 || window.navigator.userAgent.indexOf('Trident/') !== -1) {
        position.left = event.clientX + document.body.scrollLeft;
      }
      
      /*adjust adder position if not fully visible*/
      if(position.left > $(window).width()) {
        position.left = $(window).width();
      }
      if (position.left < 0) {
        position.left = 0;
      }
      if((position.left - adderWidth)  < 0) {
        if (this.adder.hasClass("annotator-mic-adder")) {
          position.left = position.left + 35;
        } else {
          position.left = position.left + 20;
        }
      }
      if((adderWidth + position.left) > ($(window).width())) {
        if (this.adder.hasClass("annotator-mic-adder")) {
          position.left = position.left - 40;
        } else {
          position.left = position.left - 25;
        }
      }
      /*ends*/
      var headerHeight = 0;
      if (config !== undefined && config !== null && config.myReaderAdapter !== undefined && config.myReaderAdapter !== null && config.myReaderAdapter.getHeaderHeight) {
        headerHeight = config.myReaderAdapter.getHeaderHeight();  
      }
      
      var adderTop = position.top;
      if((headerHeight - adderTop) > 0) {
        this.adder.addClass("annotator-invert-y");
        this.adder.css("transform","scaleY(-1)");
        this.adder.css("-ms-transform","scaleY(-1)");
        this.adder.css("-webkit-transform","scaleY(-1)");
        position.top = position.top + headerHeight;
      }
      else {
        this.adder.removeClass("annotator-invert-y");
        this.adder.css("transform","");
        this.adder.css("-ms-transform","");
        this.adder.css("-webkit-transform","");
      }
      if (config !== null && config!== undefined && config.readerSettings !== null && config.readerSettings !== undefined && (!config.readerSettings.isSyntheticSpread || (config.readerSettings.isSyntheticSpread && $('html').width() < 768)) && navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
        $("html").width("+=1");
        $("html").width("-=1");
      }
      if (this.adder.hasClass("annotator-mic-adder")) {
        position.top -= 50;
        position.left -= 35;  
      }      
      return this.adder.css(position).css("position","fixed").show();
    } else {
      try {
        if(window.parent.myReader && window.parent.myReader.readerOptions && window.parent.myReader.readerOptions.config) {
          var config = window.parent.myReader.readerOptions.config;
          if (config !== null && config!== undefined && config.readerSettings !== null && config.readerSettings !== undefined && (!config.readerSettings.isSyntheticSpread || (config.readerSettings.isSyntheticSpread && $('html').width() < 768)) && navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
            $("html").width("+=1");
            $("html").width("-=1");
          }
        }
      } catch(error) {
      }
      return this.adder.hide();
    }
  };

  Annotator.prototype.isAnnotator = function(element) {
    return !!$(element).parents().addBack().filter('[class^=annotator-]').not('[class=annotator-hl]').not(this.wrapper).length;
  };

  Annotator.prototype.onHighlightMouseover = function(event) {
    if(($(event.target)).hasClass("annotator-hl-temporary") || this.editor.isShown()) {
      return;
    }
    else {
      var annotations;
      this.clearViewerHideTimer();
      if (this.mouseIsDown) {
        return false;
      }
      if (this.viewer.isShown()) {
        this.viewer.hide();
      }
      annotations = $(event.target).parents('.annotator-hl').addBack().map(function() {
        return $(this).data("annotation");
      }).toArray();

      //Dont open viewer if editor is open for same text.
      var editor = $(".annotator-editor");
      if(!($(editor).hasClass("annotator-hide"))) {
        var editorId = $(editor).attr("id");
        var viewerId = annotations[0]._id;
        if(editorId === viewerId) {
          return;
        } 
      }
      return this.showViewer(annotations, Util.mousePosition(event, this.wrapper[0]));
    }
  };

  Annotator.prototype.onAdderMousedown = function(event) {
    if (event != null) {
      event.preventDefault();
    }
    return this.ignoreMouseup = true;
  };

  /* Function called on click of Mic button (Used only in case of speak functionality.)*/
  Annotator.prototype.onMicAdderClick = function(event) {
    if (event != null) {
      event.preventDefault();
    }
    var annotation = this.setupMicAnnotation(this.createAnnotation());
    try {
      if (window.parent.myReader && window.parent.myReader.readerOptions && window.parent.myReader.readerOptions.config && window.parent.myReader.readerOptions.config.myReaderAdapter.speakText) {
        window.parent.myReader.readerOptions.config.myReaderAdapter.speakText(annotation.quote);
      }
    } catch(error) {
    }
    this.adder.hide();  
    return this.ignoreMouseup = false;
  };  

  /* Function used to setup mic annotation (Used only in case of speak functionality.)*/
  Annotator.prototype.setupMicAnnotation = function(annotation) {
    var e, j, k, len, len1, normed, normedRanges, r, ref, root;
    root = this.wrapper[0];
    annotation.ranges || (annotation.ranges = this.selectedRanges);

    normedRanges = [];
    ref = annotation.ranges;
    for (j = 0, len = ref.length; j < len; j++) {
      r = ref[j];
      try {
        normedRanges.push(Range.sniff(r).normalize(root));
      } catch (_error) {
        e = _error;
        if (e instanceof Range.RangeError) {
          this.publish('rangeNormalizeFail', [annotation, r, e]);
        } else {
          throw e;
        }
      }
    }
    annotation.quote = [];
    for (k = 0, len1 = normedRanges.length; k < len1; k++) {
      normed = normedRanges[k];
      annotation.quote.push($.trim(normed.text()));
    }
    annotation.quote = annotation.quote.join(' / ');
       
    return annotation;
  };  

  Annotator.prototype.onAdderClick = function(event) {
    // Reset height and width of annotation textarea everytime it is opened.  
    $("#annotator-field-0").css("height","");
    $("#annotator-field-0").css("width","");
    var annotation, cancel, cleanup, position, save;
    if (event != null) {
      event.preventDefault();
    }
    position = this.adder.position();
    /*if(this.adder.hasClass("annotator-invert-y")) {
      try {
        if(window.parent.myReader && window.parent.myReader.readerOptions && window.parent.myReader.readerOptions.config) {
          var config = window.parent.myReader.readerOptions.config;
          if (config !== undefined && config !== null && config.myReaderAdapter !== undefined && config.myReaderAdapter !== null && config.myReaderAdapter.getHeaderHeight) {
            position.top = position.top - config.myReaderAdapter.getHeaderHeight();
          }
        }
      } catch(error) {
      }
    }*/
    this.adder.hide();
    annotation = this.setupAnnotation(this.createAnnotation());
    $(annotation.highlights).addClass('annotator-hl-temporary');
    save = (function(_this) {
      return function() {
        cleanup();
        $(annotation.highlights).removeClass('annotator-hl-temporary');
        return _this.publish('annotationCreated', [annotation]);
      };
    })(this);
    cancel = (function(_this) {
      return function() {
        cleanup();
        return _this.deleteAnnotation(annotation);
      };
    })(this);
    cleanup = (function(_this) {
      return function() {
        _this.unsubscribe('annotationEditorHidden', cancel);
        return _this.unsubscribe('annotationEditorSubmit', save);
      };
    })(this);
    this.subscribe('annotationEditorHidden', cancel);
    this.subscribe('annotationEditorSubmit', save);
    return this.showEditor(annotation, position);
  };

  Annotator.prototype.onEditAnnotation = function(annotation) {
    var cleanup, offset, update;
    offset = this.viewer.element.position();
    update = (function(_this) {
      return function() {
        cleanup();
        return _this.updateAnnotation(annotation);
      };
    })(this);
    cleanup = (function(_this) {
      return function() {
        _this.unsubscribe('annotationEditorHidden', cleanup);
        return _this.unsubscribe('annotationEditorSubmit', update);
      };
    })(this);
    this.subscribe('annotationEditorHidden', cleanup);
    this.subscribe('annotationEditorSubmit', update);
    this.viewer.hide();
    return this.showEditor(annotation, offset);
  };

  Annotator.prototype.onDeleteAnnotation = function(annotation) {
    var thisAnnotator = this;
    var annotationConfirmBox = $('<div id="annotationConfirmBox"> Are you sure you want to delete this note? <br><br><button id="annotationYesButton">Yes</button>  &nbsp<button id="annotationNoButton">No</button></div>')
    $(".annotator-viewer .annotator-heading").after(annotationConfirmBox);
    try {
      if(window.parent.myReader && window.parent.myReader.readerOptions && window.parent.myReader.readerOptions.config && window.parent.myReader.readerOptions.config.applyEditor) {
        $(".annotator-viewer .wysiwyg-container").css({"min-height": "100px", "opacity": "0.2"});
      }
    } catch(error) {
    }
    $(".annotator-viewer .viewerarea").css({"min-height": "100px", "opacity": "0.2"});
    $(".annotator-viewer .annotator-heading").css("opacity", "0.2");
    $(".annotator-viewer .annotator-controls").addClass("annotator-hide");
    $("#annotationYesButton").on("click", function() {
      $("#annotationConfirmBox").remove();
      thisAnnotator.viewer.hide();
      return thisAnnotator.deleteAnnotation(annotation);
    });
    $("#annotationNoButton").on("click", function() {
      $(".annotator-viewer .annotator-heading").css("opacity", "");
      $(".annotator-viewer .annotator-controls").removeClass("annotator-hide");
      try {
        if(window.parent.myReader && window.parent.myReader.readerOptions && window.parent.myReader.readerOptions.config && window.parent.myReader.readerOptions.config.applyEditor) {
            $(".annotator-viewer .wysiwyg-container").css({"min-height": "", "opacity": ""});
        }
      } catch(error) {
      }
      $(".annotator-viewer .viewerarea").css({"min-height": "", "opacity": ""});
      $("#annotationConfirmBox").remove();
      // Move focus back to delete button when No button is pressed
      $('.annotator-delete').focus();
    });
  };

   Annotator.prototype.onCloseAnnotation = function(annotation) {
    this.viewer.hide();
  };

  try {
    if(window.parent.myReader && window.parent.myReader.readerOptions && window.parent.myReader.readerOptions.config) {
      var config = window.parent.myReader.readerOptions.config;
      if (config !== null && config!== undefined && config.readerSettings !== null && config.readerSettings !== undefined && (!config.readerSettings.isSyntheticSpread || (config.readerSettings.isSyntheticSpread && $('html').width() < 768)) && navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
        $("html").width("+=1");
        $("html").width("-=1");
      }    
    }
  } catch(error) {
  }
  return Annotator;

})(Delegator);

Annotator.Plugin = (function(superClass) {
  extend(Plugin, superClass);

  function Plugin(element, options) {
    Plugin.__super__.constructor.apply(this, arguments);
  }

  Plugin.prototype.pluginInit = function() {};

  return Plugin;

})(Delegator);

g = Util.getGlobal();

if (((ref = g.document) != null ? ref.evaluate : void 0) == null) {
  $.getScript('http://assets.annotateit.org/vendor/xpath.min.js');
}

if (g.getSelection == null) {
  $.getScript('http://assets.annotateit.org/vendor/ierange.min.js');
}

if (g.JSON == null) {
  $.getScript('http://assets.annotateit.org/vendor/json2.min.js');
}

if (g.Node == null) {
  g.Node = {
    ELEMENT_NODE: 1,
    ATTRIBUTE_NODE: 2,
    TEXT_NODE: 3,
    CDATA_SECTION_NODE: 4,
    ENTITY_REFERENCE_NODE: 5,
    ENTITY_NODE: 6,
    PROCESSING_INSTRUCTION_NODE: 7,
    COMMENT_NODE: 8,
    DOCUMENT_NODE: 9,
    DOCUMENT_TYPE_NODE: 10,
    DOCUMENT_FRAGMENT_NODE: 11,
    NOTATION_NODE: 12
  };
}

Annotator.$ = $;

Annotator.Delegator = Delegator;

Annotator.Range = Range;

Annotator.Util = Util;

Annotator._instances = [];

Annotator._t = _t;

Annotator.supported = function() {
  return (function() {
    return !!this.getSelection;
  })();
};

Annotator.noConflict = function() {
  Util.getGlobal().Annotator = _Annotator;
  return this;
};

$.fn.annotator = function(options) {
  var args;
  args = Array.prototype.slice.call(arguments, 1);
  return this.each(function() {
    var instance;
    instance = $.data(this, 'annotator');
    if (options === 'destroy') {
      $.removeData(this, 'annotator');
      return instance != null ? instance.destroy(args) : void 0;
    } else if (instance) {
      return options && instance[options].apply(instance, args);
    } else {
      instance = new Annotator(this, options);
      return $.data(this, 'annotator', instance);
    }
  });
};

this.Annotator = Annotator;

//# sourceMappingURL=annotator.js.map

// Generated by CoffeeScript 1.9.2
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;
  var isScrollDoc = true;
  try {
    if(window.parent.myReader && window.parent.myReader.readerOptions && window.parent.myReader.readerOptions.config) {
      var config = window.parent.myReader.readerOptions.config;
      var isScrollDoc;
      if (config !== undefined && config !== null && config.readerSettings !== undefined && config.readerSettings !== null && config.readerSettings.isScrollDoc) {
        isScrollDoc = config.readerSettings.isScrollDoc;
      } else {
        isScrollDoc = false;
      }
    }
  } catch(error) {
  }
Annotator.Widget = (function(superClass) {
  extend(Widget, superClass);

  Widget.prototype.classes = {
    hide: 'annotator-hide',
    invert: {
      x: 'annotator-invert-x',
      y: 'annotator-invert-y'
    }
  };

  function Widget(element, options) {
    Widget.__super__.constructor.apply(this, arguments);
    this.classes = $.extend({}, Annotator.Widget.prototype.classes, this.classes);
  }

  Widget.prototype.destroy = function() {
    this.removeEvents();
    return this.element.remove();
  };

  Widget.prototype.checkOrientation = function() {
    var current, offset, viewport, widget, framewindow, windowHeight, belowArea, aboveArea;

    //if editor has content then change height according to content
    if($(".annotator-editor textarea").length > 0) {
      if(!(this.element.hasClass("annotator-viewer"))) {
        if($('.annotator-editor textarea').val().trim().length > 0 ) {
          var padding = 10;
          var textareaHeight = document.querySelector('[id^="annotator-field-"]').scrollHeight + padding;
          $(".annotator-editor textarea").css("height", textareaHeight);
        }
      }
    } else {
      try {
        if(window.parent.myReader && window.parent.myReader.readerOptions && window.parent.myReader.readerOptions.config && window.parent.myReader.readerOptions.config.applyEditor) {
          if(!(this.element.hasClass("annotator-viewer"))) {
            if( !($('.annotator-editor .wysiwyg-editor').is(':empty')) ) {
              $(".annotator-editor .wysiwyg-editor").css("height","auto");
            }
          }
        }
      } catch(error) {
      }
    }
    this.resetOrientation();
    framewindow = $(Annotator.Util.getGlobal());
    widget = this.element.children(":first");
    offset = widget.offset();
    viewport = {
      top: framewindow.scrollTop(),
      right: framewindow.width() + framewindow.scrollLeft()
    };
    current = {
      top: offset.top,
      right: offset.left + widget.width()
    };
    /*if ((current.top - viewport.top) < 0) {
      this.invertY();
    }*/
    if ((current.right - viewport.right) > 0) {
      this.invertX();
    }
    windowHeight = framewindow.height();
    var docMode = isScrollDoc ? true : false;
    var contentHeight = 200; //default value
    //in document mode window height and top need to be calculated differently
    if(docMode) {
      var $window = $(window);
      if (config.myReaderAdapter.getContentHeight) {
        contentHeight = config.myReaderAdapter.getContentHeight();
      }
      windowHeight = contentHeight;
      /*windowHeight = $(window.top).height();*/
      current.top = current.top - $(parent.document.getElementById('epub-reader-container')).scrollTop();
    }

    
    //calculate area above selected element
    if(this.element.hasClass("annotator-editor")) {
      aboveArea = current.top + $(".annotator-editor .annotator-heading").outerHeight() + $(".annotator-editor .annotator-listing").outerHeight() + $(".annotator-editor .annotator-controls").outerHeight();
    }
    else {
      aboveArea = current.top + $(".annotator-widget").height();
    }

    //calculate area below selected element
    belowArea = windowHeight - aboveArea;

    //display editor/viewer in bigger area
    if(belowArea > aboveArea) {
      this.invertY();
    }
    return this;
  };

  Widget.prototype.resetOrientation = function() {
    this.element.removeClass(this.classes.invert.x).removeClass(this.classes.invert.y);
    return this;
  };

  Widget.prototype.invertX = function() {
    this.element.addClass(this.classes.invert.x);
    return this;
  };

  Widget.prototype.invertY = function() {
    this.element.addClass(this.classes.invert.y);
    return this;
  };

  Widget.prototype.isInvertedY = function() {
    return this.element.hasClass(this.classes.invert.y);
  };

  Widget.prototype.isInvertedX = function() {
    return this.element.hasClass(this.classes.invert.x);
  };

  return Widget;

})(Delegator);

//# sourceMappingURL=widget.js.map

// Generated by CoffeeScript 1.9.2
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Annotator.Editor = (function(superClass) {
  extend(Editor, superClass);

  Editor.prototype.events = {
    "form submit": "submit",
    ".annotator-save click": "submit",
    ".annotator-cancel click": "hide",
    ".annotator-cancel mouseover": "onCancelButtonMouseover",
    "textarea keydown": "processKeypress"
  };

  Editor.prototype.classes = {
    hide: 'annotator-hide',
    focus: 'annotator-focus'
  };
  // Added heading div and changed position of save and cancel button(customised).
  Editor.prototype.html = "<div class=\"annotator-outer annotator-editor\">\n  <form class=\"annotator-widget\">\n   <div class=\"annotator-heading\"><h2 role='heading' aria-level='2'>Note<span class='open' id='editor_note_open'>Open</span><span class='closed' id='editor_note_closed'>Closed</span></h2></div>\n   <ul class=\"annotator-listing\"></ul>\n    <div class=\"annotator-controls\">\n      <a href=\"#save\" class=\"annotator-save annotator-focus\">" + _t('Save') + "</a>\n<a href=\"#cancel\" class=\"annotator-cancel\">" + _t('Cancel') + "</a>\n    </div>\n  </form>\n</div>";
  Editor.prototype.options = {};

  function Editor(options) {
    this.onCancelButtonMouseover = bind(this.onCancelButtonMouseover, this);
    this.processKeypress = bind(this.processKeypress, this);
    this.submit = bind(this.submit, this);
    this.load = bind(this.load, this);
    this.hide = bind(this.hide, this);
    this.show = bind(this.show, this);
    Editor.__super__.constructor.call(this, $(this.html)[0], options);
    this.fields = [];
    this.annotation = {};
  }

  Editor.prototype.show = function(event) {
    //create instance of viewer
    this.viewer = new Annotator.Viewer({
      // readOnly: this.options.readOnly
    });
    var config;
    try {
      if(window.parent.myReader && window.parent.myReader.readerOptions && window.parent.myReader.readerOptions.config) {
        config = window.parent.myReader.readerOptions.config;
      }
    } catch(error) {
    }
    if (config !== null && config!== undefined && config.applyEditor) {
      //destroy wysiwyg-containers to create new instance of html-editor
      var htmleditor = document.getElementsByClassName("wysiwyg-editor");
      if(htmleditor.length !== 0) {
      $(".wysiwyg-editor").remove();
      $('.wysiwyg-container').replaceWith(function() {
         return $('textarea', this);
      });
      $(".wysiwyg-placeholder").remove();
      }

      //call html-editor on annotation editor
      this.viewer.htmlEditor('annotator-field-0');
    }
    Annotator.Util.preventEventDefault(event);
    this.element.removeClass(this.classes.hide);
    
    if (config !== null && config!== undefined && config.readerSettings !== null && config.readerSettings !== undefined && (!config.readerSettings.isSyntheticSpread || (config.readerSettings.isSyntheticSpread && $('html').width() < 768)) && navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
      $("html").width("+=1");
      $("html").width("-=1");
    }
    this.element.find('.annotator-save').addClass(this.classes.focus);
    this.checkOrientation();
    this.element.find(":input:first").focus();
    this.setupDraggables();

    /*check editor visibility(out of screen or not)*/
    if (config !== undefined && config !== null && config.myReaderAdapter !== undefined && config.myReaderAdapter !== null && config.myReaderAdapter.getContentHeight) {
      var windowHeight = config.myReaderAdapter.getContentHeight();
    } else {
      var windowHeight = window.innerHeight;
    }
    var editorHeight = $(".annotator-editor .annotator-heading").outerHeight() + $(".annotator-editor .annotator-listing").outerHeight() + $(".annotator-editor .annotator-controls").outerHeight();
    var editorTop = $(".annotator-editor .annotator-heading").offset().top;
    var isScrollDoc;
    if (config !== undefined && config !== null && config.readerSettings !== undefined && config.readerSettings !== null && config.readerSettings.isScrollDoc) {
      isScrollDoc = config.readerSettings.isScrollDoc;  
    } else {
      isScrollDoc = false;
    }
    var docMode = isScrollDoc ? true : false;
    if(docMode) {
      //in document mode(excluding ipad) top of editor need to be calculated differently
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) {
      } else {
        editorTop = editorTop - $(parent.document.getElementById('epub-reader-container')).scrollTop();
      }
    
      //ipad check for setting top of annotation editor in doc mode
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) {
        height = $(parent.document.getElementById('epub-reader-container')).scrollTop() + 15;
        var elm = document.getElementsByClassName("annotator-widget annotator-touch-widget-inner");
        $(elm).css("top",height);
      }
    }
    //bufferHeight includes padding, margin and height of controls,heading and listing area 
    bufferHeight = 135;

    //if editor is not empty then check for visibility
    if (config !== null && config!== undefined && config.applyEditor) {
      if( !($('.annotator-editor .wysiwyg-editor').is(':empty')) ) {
        if(this.element.hasClass("annotator-invert-y") || (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent))) {
          remainingHeight = windowHeight - editorTop - bufferHeight;
        }
        else {
          remainingHeight = editorHeight + editorTop - bufferHeight;
        }
      
        if(editorTop < 0 || ((editorTop + editorHeight) > windowHeight)) {
          $(".annotator-editor .wysiwyg-editor").css("height",remainingHeight);
          $(".annotator-editor .wysiwyg-editor").css("overflow","auto");
        } 
      }
    } else {
      if(this.element.hasClass("annotator-invert-y") || (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent))) {
        remainingHeight = windowHeight - editorTop - bufferHeight;
      }
      else {
        remainingHeight = editorHeight + editorTop - bufferHeight;
      }
    
      if(editorTop < 0 || ((editorTop + editorHeight) > windowHeight)) {
        $(".annotator-editor textarea").css("height",remainingHeight);
        $(".annotator-editor textarea").css("overflow","auto");
      }  
    }
    /*ends*/
    return this.publish('show');
  };

  Editor.prototype.hide = function(event) {
    Annotator.Util.preventEventDefault(event);
    this.element.addClass(this.classes.hide);
    try {
      if(window.parent.myReader && window.parent.myReader.readerOptions && window.parent.myReader.readerOptions.config) {
        var config = window.parent.myReader.readerOptions.config;
        if (config !== null && config !== undefined && config.applyEditor) {
          //remove html-editor on cancel click
          var htmleditor = document.getElementsByClassName("wysiwyg-editor");
          if(htmleditor.length !== 0) {
            $(".wysiwyg-editor").remove();
          }
        }
        if (config !== null && config!== undefined && config.readerSettings !== null && config.readerSettings !== undefined && (!config.readerSettings.isSyntheticSpread || (config.readerSettings.isSyntheticSpread && $('html').width() < 768)) && navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
          $("html").width("+=1");
          $("html").width("-=1");
        }
      }
    } catch(error) {
    }
    return this.publish('hide');
  };

  Editor.prototype.load = function(annotation) {
    var field, i, len, ref;
    this.annotation = annotation;
    this.publish('load', [this.annotation]);
    ref = this.fields;
    for (i = 0, len = ref.length; i < len; i++) {
      field = ref[i];
      field.load(field.element, this.annotation);
    }
    return this.show();
  };

  Editor.prototype.submit = function(event) {
    var field, i, len, ref;
    Annotator.Util.preventEventDefault(event);
    ref = this.fields;
    for (i = 0, len = ref.length; i < len; i++) {
      field = ref[i];
      field.submit(field.element, this.annotation);
    }
    if(this.annotation && this.annotation.updated) {
      this.annotation.updated = new Date();
    }
    this.publish('save', [this.annotation]);
    return this.hide();
  };

  Editor.prototype.addField = function(options) {
    var element, field, input;
    field = $.extend({
      id: 'annotator-field-' + Annotator.Util.uuid(),
      type: 'input',
      label: '',
      load: function() {},
      submit: function() {}
    }, options);
    input = null;
    element = $('<li class="annotator-item" />');
    field.element = element[0];
    switch (field.type) {
      case 'textarea':
        input = $('<textarea />');
        break;
      case 'input':
      case 'checkbox':
        input = $('<input />');
        break;
      case 'select':
        input = $('<select />');
    }
    element.append(input);
    input.attr({
      id: field.id,
      placeholder: field.label,
      maxlength: "1024"
    });
    if (field.type === 'checkbox') {
      input[0].type = 'checkbox';
      element.addClass('annotator-checkbox');
      element.append($('<label />', {
        "for": field.id,
        html: field.label
      }));
    }
    this.element.find('ul:first').append(element);
    this.fields.push(field);
    return field.element;
  };

  Editor.prototype.checkOrientation = function() {
    var controls, list;
    Editor.__super__.checkOrientation.apply(this, arguments);
    // Changed sequece of displaying divs in editor(customised).
    heading = this.element.find('.annotator-heading');
    list = this.element.find('ul');
    controls = this.element.find('.annotator-controls');
    if (this.element.hasClass(this.classes.invert.y)) {
      list.insertBefore(controls);
      heading.insertBefore(list);
    } else if (list.is(':first-child')) {
      list.insertAfter(controls);
    }
    return this;
  };

  Editor.prototype.processKeypress = function(event) {
    if (event.keyCode === 27) {
      return this.hide();
    } /*else if (event.keyCode === 13 && !event.shiftKey) {
      return this.submit();
    }*/
  };

  Editor.prototype.isShown = function() {
    return !this.element.hasClass(this.classes.hide);
  };

  Editor.prototype.onCancelButtonMouseover = function() {
    return this.element.find('.' + this.classes.focus).removeClass(this.classes.focus);
  };

  Editor.prototype.setupDraggables = function() {
    var classes, controls, cornerItem, editor, mousedown, onMousedown, onMousemove, onMouseup, resize, textarea, throttle;
    this.element.find('.annotator-resize').remove();
    if (this.element.hasClass(this.classes.invert.y)) {
       //corner item should be added to wysiwyg-wrapper if present
      var htmleditor = document.getElementsByClassName("wysiwyg-wrapper");
      if(htmleditor.length !== 0) {
        cornerItem = this.element.find('.wysiwyg-wrapper');
      } else {
        cornerItem = this.element.find('.annotator-item:first');
      }
    } else {
      var htmleditor = document.getElementsByClassName("wysiwyg-wrapper");
      if(htmleditor.length !== 0) {
        cornerItem = this.element.find('.wysiwyg-wrapper');
      } else {
        cornerItem = this.element.find('.annotator-item:first');
      }
    }
    if (cornerItem) {
      $('<span class="annotator-resize"></span>').appendTo(cornerItem);
    }
    mousedown = null;
    classes = this.classes;
    editor = this.element;
    textarea = null;
    resize = editor.find('.annotator-resize');
    controls = editor.find('.annotator-controls');
    heading = editor.find('.annotator-heading');
    throttle = false;
    onMousedown = function(event) {
      if (event.target === this) {
        mousedown = {
          element: this,
          top: event.pageY,
          left: event.pageX
        };
        var htmleditor = document.getElementsByClassName("wysiwyg-editor");
        
        if(htmleditor.length !== 0) {
          //html editor's div is textarea
          textarea = editor.find('.wysiwyg-editor');
        } else {
          textarea = editor.find('textarea:first');
        } 
        $(window).bind({
          'mouseup.annotator-editor-resize': onMouseup,
          'mousemove.annotator-editor-resize': onMousemove
        });
        return event.preventDefault();
      }
    };
    onMouseup = function(event) {
      /* adjust position of editor after resizing */
      elem = editor.find('.annotator-heading');
      listing = editor.find('.annotator-listing');
      controls = editor.find('.annotator-controls');
      elemTop = elem.offset().top;
      elemLeft = elem.offset().left;
      elemWidth = elem.width();
      var headerHeight = 0;
      var footerHeight = 0;
      var contentHeight = 200; //some default value
      var config;
      try {
        if(window.parent.myReader && window.parent.myReader.readerOptions && window.parent.myReader.readerOptions.config) {
          config = window.parent.myReader.readerOptions.config;
          if (config !== undefined && config !== null && config.myReaderAdapter !== undefined && config.myReaderAdapter !== null) {
            if (config.myReaderAdapter.getHeaderHeight) {
              headerHeight = config.myReaderAdapter.getHeaderHeight();
            }
            if (config.myReaderAdapter.getFooterHeight) {
              footerHeight = config.myReaderAdapter.getFooterHeight();
            }
            if (config.myReaderAdapter.getContentHeight) {
              contentHeight = config.myReaderAdapter.getContentHeight();
            }
          }
        }
      } catch(error) {
      }
      elemHeight = elem.height() + listing.height() + controls.height() + headerHeight + footerHeight;
      /*windowHeight = $(window.top).height() - 50;*/
      windowHeight = contentHeight;
      if(config !== undefined && config !== null && config.applyEditor) {
        $(".wysiwyg-editor").css("height","5em");
        $(".wysiwyg-editor").css("width","");
      } else {
        if(elemTop < 0 || ((elemLeft + elemWidth) > ($(window).width())) || ((elemTop + elemHeight) > windowHeight) || elemLeft < 0){
          $(".annotator-editor textarea").css("height","5em");
          $(".annotator-editor textarea").css("width","");
        }
      }
      
      /* end */
      mousedown = null;
      return $(window).unbind('.annotator-editor-resize');
    };
    onMousemove = (function(_this) {
      return function(event) {
        var diff, directionX, directionY, height, width;
        if (mousedown && throttle === false) {
          diff = {
            top: event.pageY - mousedown.top,
            left: event.pageX - mousedown.left
          };
          if (mousedown.element === resize[0]) {
            height = textarea.height();
            width = textarea.width();
            directionX = editor.hasClass(classes.invert.x) ? -1 : 1;
            directionY = editor.hasClass(classes.invert.y) ? 1 : -1;
            textarea.height(height + (diff.top * directionY));
            textarea.width(width + (diff.left * directionX));
            if (textarea.height() !== height) {
              mousedown.top = event.pageY;
            }
            if (textarea.width() !== width) {
              mousedown.left = event.pageX;
            }
          } else if (mousedown.element === controls[0] || mousedown.element === heading[0]) {
            editor.css({
              top: parseInt(editor.css('top'), 10) + diff.top,
              left: parseInt(editor.css('left'), 10) + diff.left
            });
            mousedown.top = event.pageY;
            mousedown.left = event.pageX;
          }
          throttle = true;
          return setTimeout(function() {
            return throttle = false;
          }, 1000 / 60);
        }
      };
    })(this);
    resize.off('mousedown').bind('mousedown', onMousedown);
    heading.off('mousedown').bind('mousedown', onMousedown);
    return controls.off('mousedown').bind('mousedown', onMousedown);
  };

  return Editor;

})(Annotator.Widget);

//# sourceMappingURL=editor.js.map

// Generated by CoffeeScript 1.9.2
var LinkParser,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Annotator.Viewer = (function(superClass) {
  extend(Viewer, superClass);

  Viewer.prototype.events = {
    ".annotator-edit click": "onEditClick",
    ".annotator-delete click": "onDeleteClick",
    ".annotator-close click": "onCloseClick"
  };

  Viewer.prototype.classes = {
    hide: 'annotator-hide',
    showControls: 'annotator-visible'
  };

  Viewer.prototype.html = {
    element: "<div tabindex='0' class=\"annotator-outer annotator-viewer\">\n  <ul class=\"annotator-widget annotator-listing\"></ul>\n</div>",
    item: "<li class=\"annotator-annotation annotator-item\">\n  <div class=\"annotator-heading\"><h2 role='heading' aria-level='2'>Note<span class='open' id='viewer_note_open'>Open</span><span class='closed' id='viewer_note_closed'>Closed</span></h2><span class=\"annotator-controls\">\n  <button title=\"Edit\" class=\"annotator-edit\"><i class='fa fa-pencil' aria-hidden='true'></i></button> <button title=\"Delete\" class=\"annotator-delete\"><i class='fa fa-trash-o' aria-hidden='true'></i></button> <button title=\"Close\" class=\"annotator-close\"><i class='fa fa-times' aria-hidden='true'></i></button> </span>\n </div>\n</li>"
  };

  Viewer.prototype.options = {
    readOnly: false
  };

  function Viewer(options) {
    this.onDeleteClick = bind(this.onDeleteClick, this);
    this.onEditClick = bind(this.onEditClick, this);
    this.onCloseClick = bind(this.onCloseClick, this);
    this.load = bind(this.load, this);
    this.hide = bind(this.hide, this);
    this.show = bind(this.show, this);
    Viewer.__super__.constructor.call(this, $(this.html.element)[0], options);
    this.item = $(this.html.item)[0];
    this.fields = [];
    this.annotations = [];
  }

  Viewer.prototype.show = function(event) {
    var controls;
    Annotator.Util.preventEventDefault(event);
    controls = this.element.find('.annotator-controls').addClass(this.classes.showControls);
    setTimeout(((function(_this) {
      return function() {
        return controls.removeClass(_this.classes.showControls);
      };
    })(this)), 500);
    this.element.css("position", "fixed");
    var config;
    try {
      if(window.parent.myReader && window.parent.myReader.readerOptions && window.parent.myReader.readerOptions.config) {
        config = window.parent.myReader.readerOptions.config;
        if (config !== null && config!== undefined && config.readerSettings !== null && config.readerSettings !== undefined && (!config.readerSettings.isSyntheticSpread || (config.readerSettings.isSyntheticSpread && $('html').width() < 768)) && navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
          $("html").width("+=1");
          $("html").width("-=1");
        }
        if (config.applyEditor) {
          //call html-editor on annotation viewer
          this.htmlEditor('viewerarea');
        }
      }
    } catch(error) {
    }
    this.element.removeClass(this.classes.hide);
    this.checkOrientation();

    /*check viewer visibility(out of screen or not)*/
    if (config !== undefined && config !== null && config.myReaderAdapter !== undefined && config.myReaderAdapter !== null && config.myReaderAdapter.getContentHeight) {
      var windowHeight = config.myReaderAdapter.getContentHeight();
    } else {
      var windowHeight = window.innerHeight;
    }
    
    var viewerHeight = $(".annotator-item").outerHeight();
    var viewerTop = $(".annotator-item").offset().top;
    var isScrollDoc;
    if (config !== undefined && config !== null && config.readerSettings !== undefined && config.readerSettings !== null && config.readerSettings.isScrollDoc) {
      isScrollDoc = config.readerSettings.isScrollDoc;
    } else {
      isScrollDoc = false;
    }
    var docMode = isScrollDoc ? true : false;
    //in document mode top of viewer need to be calculated differently
    if(docMode) {
      viewerTop = viewerTop - $(parent.document.getElementById('epub-reader-container')).scrollTop();
    }

    //bufferHeight includes heading area,padding and size of arrow
    bufferHeight = 65;
    if(this.element.hasClass("annotator-invert-y")) {
      remainingHeight = windowHeight - viewerTop - bufferHeight;
    }
    else {
      remainingHeight = viewerHeight + viewerTop - bufferHeight;
    }
    
    if((viewerTop < 0 || ((viewerTop + viewerHeight) > windowHeight)) && remainingHeight > 0){
      $(".annotator-viewer .viewerarea").css("height",remainingHeight);
      $(".annotator-viewer .viewerarea").css("overflow","auto");
    }
    /*ends*/
    return this.publish('show');
  };

  Viewer.prototype.isShown = function() {
    return !this.element.hasClass(this.classes.hide);
  };

  Viewer.prototype.hide = function(event) {
    Annotator.Util.preventEventDefault(event);
    this.element.addClass(this.classes.hide);
    var annotationid = this.element.attr("annotationid");
    if( annotationid ) {
      // Shift focus to the note whose viewer was open
      $('button[data-annotation-id='+ annotationid +']').focus();
      this.element.attr("annotationid", "");
    }    
    try {
      if(window.parent.myReader && window.parent.myReader.readerOptions && window.parent.myReader.readerOptions.config) {
        var config = window.parent.myReader.readerOptions.config;
        if (config !== null && config!== undefined && config.readerSettings !== null && config.readerSettings !== undefined && (!config.readerSettings.isSyntheticSpread || (config.readerSettings.isSyntheticSpread && $('html').width() < 768)) && navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
          $("html").width("+=1");
          $("html").width("-=1");
        }
      }
    } catch(error) {
    }
    return this.publish('hide');
  };

  Viewer.prototype.load = function(annotations) {
    var annotation, controller, controls, del, edit, element, field, i, item, j, len, len1, link, links, list, ref, ref1;
    this.annotations = annotations || [];
    list = this.element.find('ul:first').empty();
    ref = this.annotations;
    for (i = 0, len = ref.length; i < len; i++) {
      annotation = ref[i];
      item = $(this.item).clone().appendTo(list).data('annotation', annotation);
      controls = item.find('.annotator-controls');
      link = controls.find('.annotator-link');
      edit = controls.find('.annotator-edit');
      del = controls.find('.annotator-delete');
      links = new LinkParser(annotation.links || []).get('alternate', {
        'type': 'text/html'
      });
      if (links.length === 0 || (links[0].href == null)) {
        link.remove();
      } else {
        link.attr('href', links[0].href);
      }
      if (this.options.readOnly) {
        edit.remove();
        del.remove();
      } else {
        controller = {
          showEdit: function() {
            return edit.removeAttr('disabled');
          },
          hideEdit: function() {
            return edit.attr('disabled', 'disabled');
          },
          showDelete: function() {
            return del.removeAttr('disabled');
          },
          hideDelete: function() {
            return del.attr('disabled', 'disabled');
          }
        };
      }
      ref1 = this.fields;
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        field = ref1[j];
        element = $(field.element).clone().appendTo(item)[0];
        field.load(element, annotation, controller);
      }
    }
    this.publish('load', [this.annotations]);
    return this.show();
  };

  Viewer.prototype.addField = function(options) {
    var field;
    field = $.extend({
      load: function() {}
    }, options);
    field.element = $('<div class="viewerarea"/>')[0];
    try {
      if(window.parent.myReader && window.parent.myReader.readerOptions && window.parent.myReader.readerOptions.config && window.parent.myReader.readerOptions.config.applyEditor) {
        field.element = $('<textarea class="viewerarea" readonly="readonly"/>')[0];
      }
    } catch(error) {
    }
    this.fields.push(field);
    field.element;
    return this;
  };

  Viewer.prototype.onEditClick = function(event) {
    return this.onButtonClick(event, 'edit');
  };

  Viewer.prototype.onDeleteClick = function(event) {
    return this.onButtonClick(event, 'delete');
  };

  Viewer.prototype.onCloseClick = function(event) {
    return this.onButtonClick(event, 'close');
  };

  Viewer.prototype.onButtonClick = function(event, type) {
    var item;
    item = $(event.target).parents('.annotator-annotation');
    return this.publish(type, [item.data('annotation')]);
  };

  //function to create instance of html editor
  Viewer.prototype.htmlEditor = function(type) {
    if(type === "annotator-field-0") {
      var element = document.getElementById(type);
      try {
        $(element).wysiwyg();
      } catch(e) {
        console.log("html editor not found");
      }
    }
    else {
      //if more than one annotation on single text then use html editor on each annotation
      var element = document.getElementsByClassName(type);
      $.each(element,function() {
        try {
          $(this).wysiwyg();
        } catch(e) {
          console.log("html editor not found");
        }
        
      });
    }
  };

  return Viewer;

})(Annotator.Widget);

LinkParser = (function() {
  function LinkParser(data) {
    this.data = data;
  }

  LinkParser.prototype.get = function(rel, cond) {
    var d, i, k, keys, len, match, ref, results, v;
    if (cond == null) {
      cond = {};
    }
    cond = $.extend({}, cond, {
      rel: rel
    });
    keys = (function() {
      var results;
      results = [];
      for (k in cond) {
        if (!hasProp.call(cond, k)) continue;
        v = cond[k];
        results.push(k);
      }
      return results;
    })();
    ref = this.data;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      d = ref[i];
      match = keys.reduce((function(m, k) {
        return m && (d[k] === cond[k]);
      }), true);
      if (match) {
        results.push(d);
      } else {
        continue;
      }
    }
    return results;
  };

  return LinkParser;

})();

//# sourceMappingURL=viewer.js.map

// Generated by CoffeeScript 1.9.2
var Annotator,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Annotator = Annotator || {};

Annotator.Notification = (function(superClass) {
  extend(Notification, superClass);

  Notification.prototype.events = {
    "click": "hide"
  };

  Notification.prototype.options = {
    html: "<div class='annotator-notice'></div>",
    classes: {
      show: "annotator-notice-show",
      info: "annotator-notice-info",
      success: "annotator-notice-success",
      error: "annotator-notice-error"
    }
  };

  function Notification(options) {
    this.hide = bind(this.hide, this);
    this.show = bind(this.show, this);
    Notification.__super__.constructor.call(this, $(this.options.html).appendTo(document.body)[0], options);
  }

  Notification.prototype.show = function(message, status) {
    if (status == null) {
      status = Annotator.Notification.INFO;
    }
    this.currentStatus = status;
    $(this.element).addClass(this.options.classes.show).addClass(this.options.classes[this.currentStatus]).html(Util.escape(message || ""));
    setTimeout(this.hide, 5000);
    return this;
  };

  Notification.prototype.hide = function() {
    if (this.currentStatus == null) {
      this.currentStatus = Annotator.Notification.INFO;
    }
    $(this.element).removeClass(this.options.classes.show).removeClass(this.options.classes[this.currentStatus]);
    return this;
  };

  return Notification;

})(Delegator);

Annotator.Notification.INFO = 'info';

Annotator.Notification.SUCCESS = 'success';

Annotator.Notification.ERROR = 'error';

$(function() {
  var notification;
  notification = new Annotator.Notification;
  Annotator.showNotification = notification.show;
  return Annotator.hideNotification = notification.hide;
});

//# sourceMappingURL=notification.js.map

// Generated by CoffeeScript 1.9.2
var findChild, getNodeName, getNodePosition, simpleXPathJQuery, simpleXPathPure;

simpleXPathJQuery = function(relativeRoot) {
  var jq;
  jq = this.map(function() {
    var elem, idx, path, tagName;
    path = '';
    elem = this;
    while ((elem != null ? elem.nodeType : void 0) === Node.ELEMENT_NODE && elem !== relativeRoot) {
      tagName = elem.tagName.replace(":", "\\:");
      idx = $(elem.parentNode).children(tagName).index(elem) + 1;
      idx = "[" + idx + "]";
      path = "/" + elem.tagName.toLowerCase() + idx + path;
      elem = elem.parentNode;
    }
    return path;
  });
  return jq.get();
};

simpleXPathPure = function(relativeRoot) {
  var getPathSegment, getPathTo, jq, rootNode;
  getPathSegment = function(node) {
    var name, pos;
    name = getNodeName(node);
    pos = getNodePosition(node);
    return name + "[" + pos + "]";
  };
  rootNode = relativeRoot;
  getPathTo = function(node) {
    var xpath;
    xpath = '';
    while (node !== rootNode) {
      if (node == null) {
        throw new Error("Called getPathTo on a node which was not a descendant of @rootNode. " + rootNode);
      }
      xpath = (getPathSegment(node)) + '/' + xpath;
      node = node.parentNode;
    }
    xpath = '/' + xpath;
    xpath = xpath.replace(/\/$/, '');
    return xpath;
  };
  jq = this.map(function() {
    var path;
    path = getPathTo(this);
    return path;
  });
  return jq.get();
};

findChild = function(node, type, index) {
  var child, children, found, i, len, name;
  if (!node.hasChildNodes()) {
    throw new Error("XPath error: node has no children!");
  }
  children = node.childNodes;
  found = 0;
  for (i = 0, len = children.length; i < len; i++) {
    child = children[i];
    name = getNodeName(child);
    if (name === type) {
      found += 1;
      if (found === index) {
        return child;
      }
    }
  }
  throw new Error("XPath error: wanted child not found.");
};

getNodeName = function(node) {
  var nodeName;
  nodeName = node.nodeName.toLowerCase();
  switch (nodeName) {
    case "#text":
      return "text()";
    case "#comment":
      return "comment()";
    case "#cdata-section":
      return "cdata-section()";
    default:
      return nodeName;
  }
};

getNodePosition = function(node) {
  var pos, tmp;
  pos = 0;
  tmp = node;
  while (tmp) {
    if (tmp.nodeName === node.nodeName) {
      pos++;
    }
    tmp = tmp.previousSibling;
  }
  return pos;
};

//# sourceMappingURL=xpath.js.map

//
// showdown.js -- A javascript port of Markdown.
//
// Copyright (c) 2007 John Fraser.
//
// Original Markdown Copyright (c) 2004-2005 John Gruber
//   <http://daringfireball.net/projects/markdown/>
//
// The full source distribution is at:
//
//				A A L
//				T C A
//				T K B
//
//   <http://www.attacklab.net/>
//

//
// Wherever possible, Showdown is a straight, line-by-line port
// of the Perl version of Markdown.
//
// This is not a normal parser design; it's basically just a
// series of string substitutions.  It's hard to read and
// maintain this way,  but keeping Showdown close to the original
// design makes it easier to port new features.
//
// More importantly, Showdown behaves like markdown.pl in most
// edge cases.  So web applications can do client-side preview
// in Javascript, and then build identical HTML on the server.
//
// This port needs the new RegExp functionality of ECMA 262,
// 3rd Edition (i.e. Javascript 1.5).  Most modern web browsers
// should do fine.  Even with the new regular expression features,
// We do a lot of work to emulate Perl's regex functionality.
// The tricky changes in this file mostly have the "attacklab:"
// label.  Major or self-explanatory changes don't.
//
// Smart diff tools like Araxis Merge will be able to match up
// this file with markdown.pl in a useful way.  A little tweaking
// helps: in a copy of markdown.pl, replace "#" with "//" and
// replace "$text" with "text".  Be sure to ignore whitespace
// and line endings.
//


//
// Showdown usage:
//
//   var text = "Markdown *rocks*.";
//
//   var converter = new Attacklab.showdown.converter();
//   var html = converter.makeHtml(text);
//
//   alert(html);
//
// Note: move the sample code to the bottom of this
// file before uncommenting it.
//


//
// Attacklab namespace
//
var Attacklab = Attacklab || {}

//
// Showdown namespace
//
Attacklab.showdown = Attacklab.showdown || {}

//
// converter
//
// Wraps all "globals" so that the only thing
// exposed is makeHtml().
//
Attacklab.showdown.converter = function() {


// g_urls and g_titles allow arbitrary user-entered strings as keys. This
// caused an exception (and hence stopped the rendering) when the user entered
// e.g. [push] or [__proto__]. Adding a prefix to the actual key prevents this
// (since no builtin property starts with "s_"). See
// http://meta.stackoverflow.com/questions/64655/strange-wmd-bug
// (granted, switching from Array() to Object() alone would have left only __proto__
// to be a problem)
var SaveHash = function () {
    this.set = function (key, value) {
        this["s_" + key] = value;
    }
    this.get = function (key) {
        return this["s_" + key];
    }
}

//
// Globals:
//

// Global hashes, used by various utility routines
var g_urls;
var g_titles;
var g_html_blocks;

// Used to track when we're inside an ordered or unordered list
// (see _ProcessListItems() for details):
var g_list_level = 0;


this.makeHtml = function(text) {
//
// Main function. The order in which other subs are called here is
// essential. Link and image substitutions need to happen before
// _EscapeSpecialCharsWithinTagAttributes(), so that any *'s or _'s in the <a>
// and <img> tags get encoded.
//

	// Clear the global hashes. If we don't clear these, you get conflicts
	// from other articles when generating a page which contains more than
	// one article (e.g. an index page that shows the N most recent
	// articles):
    g_urls = new SaveHash();
    g_titles = new SaveHash();
	g_html_blocks = new Array();

	// attacklab: Replace ~ with ~T
	// This lets us use tilde as an escape char to avoid md5 hashes
	// The choice of character is arbitray; anything that isn't
    // magic in Markdown will work.
	text = text.replace(/~/g,"~T");

	// attacklab: Replace $ with ~D
	// RegExp interprets $ as a special character
	// when it's in a replacement string
	text = text.replace(/\$/g,"~D");

	// Standardize line endings
	text = text.replace(/\r\n/g,"\n"); // DOS to Unix
	text = text.replace(/\r/g,"\n"); // Mac to Unix

	// Make sure text begins and ends with a couple of newlines:
	text = "\n\n" + text + "\n\n";

	// Convert all tabs to spaces.
	text = _Detab(text);

	// Strip any lines consisting only of spaces and tabs.
	// This makes subsequent regexen easier to write, because we can
	// match consecutive blank lines with /\n+/ instead of something
	// contorted like /[ \t]*\n+/ .
	text = text.replace(/^[ \t]+$/mg,"");

	// Turn block-level HTML blocks into hash entries
	text = _HashHTMLBlocks(text);

	// Strip link definitions, store in hashes.
	text = _StripLinkDefinitions(text);

	text = _RunBlockGamut(text);

	text = _UnescapeSpecialChars(text);

	// attacklab: Restore dollar signs
	text = text.replace(/~D/g,"$$");

	// attacklab: Restore tildes
	text = text.replace(/~T/g,"~");

	return text;
}

var _StripLinkDefinitions = function(text) {
//
// Strips link definitions from text, stores the URLs and titles in
// hash references.
//

	// Link defs are in the form: ^[id]: url "optional title"

	/*
		var text = text.replace(/
				^[ ]{0,3}\[(.+)\]:  // id = $1  attacklab: g_tab_width - 1
				  [ \t]*
				  \n?				// maybe *one* newline
				  [ \t]*
				<?(\S+?)>?			// url = $2
                (?=\s|$)            // lookahead for whitespace instead of the lookbehind removed below
				  [ \t]*
				  \n?				// maybe one newline
				  [ \t]*
				(                   // (potential) title = $3
				  (\n*)				// any lines skipped = $4 attacklab: lookbehind removed
                  [ \t]+
				  ["(]
				  (.+?)				// title = $5
				  [")]
				  [ \t]*
				)?					// title is optional
				(?:\n+|$)
			  /gm,
			  function(){...});
	*/
	var text = text.replace(/^[ ]{0,3}\[(.+)\]:[ \t]*\n?[ \t]*<?(\S+?)>?(?=\s|$)[ \t]*\n?[ \t]*((\n*)["(](.+?)[")][ \t]*)?(?:\n+)/gm,
		function (wholeMatch,m1,m2,m3,m4,m5) {
			m1 = m1.toLowerCase();
			g_urls.set(m1, _EncodeAmpsAndAngles(m2));  // Link IDs are case-insensitive
			if (m4) {
				// Oops, found blank lines, so it's not a title.
				// Put back the parenthetical statement we stole.
				return m3;
			} else if (m5) {
				g_titles.set(m1, m5.replace(/"/g,"&quot;"));
			}
			
			// Completely remove the definition from the text
			return "";
		}
	);

	return text;
}

var _HashHTMLBlocks = function(text) {

	// Hashify HTML blocks:
	// We only want to do this for block-level HTML tags, such as headers,
	// lists, and tables. That's because we still want to wrap <p>s around
	// "paragraphs" that are wrapped in non-block-level tags, such as anchors,
	// phrase emphasis, and spans. The list of tags we're looking for is
	// hard-coded:
	var block_tags_a = "p|div|h[1-6]|blockquote|pre|table|dl|ol|ul|script|noscript|form|fieldset|iframe|math|ins|del"
	var block_tags_b = "p|div|h[1-6]|blockquote|pre|table|dl|ol|ul|script|noscript|form|fieldset|iframe|math"

	// First, look for nested blocks, e.g.:
	//   <div>
	//     <div>
	//     tags for inner block must be indented.
	//     </div>
	//   </div>
	//
	// The outermost tags must start at the left margin for this to match, and
	// the inner nested divs must be indented.
	// We need to do this before the next, more liberal match, because the next
	// match will start at the first `<div>` and stop at the first `</div>`.

	// attacklab: This regex can be expensive when it fails.
	/*
		var text = text.replace(/
		(						// save in $1
			^					// start of line  (with /m)
			<($block_tags_a)	// start tag = $2
			\b					// word break
								// attacklab: hack around khtml/pcre bug...
			[^\r]*?\n			// any number of lines, minimally matching
			</\2>				// the matching end tag
			[ \t]*				// trailing spaces/tabs
			(?=\n+)				// followed by a newline
		)						// attacklab: there are sentinel newlines at end of document
		/gm,function(){...}};
	*/
	text = text.replace(/^(<(p|div|h[1-6]|blockquote|pre|table|dl|ol|ul|script|noscript|form|fieldset|iframe|math|ins|del)\b[^\r]*?\n<\/\2>[ \t]*(?=\n+))/gm,hashElement);

	//
	// Now match more liberally, simply from `\n<tag>` to `</tag>\n`
	//

	/*
		var text = text.replace(/
		(						// save in $1
			^					// start of line  (with /m)
			<($block_tags_b)	// start tag = $2
			\b					// word break
								// attacklab: hack around khtml/pcre bug...
			[^\r]*?				// any number of lines, minimally matching
			.*</\2>				// the matching end tag
			[ \t]*				// trailing spaces/tabs
			(?=\n+)				// followed by a newline
		)						// attacklab: there are sentinel newlines at end of document
		/gm,function(){...}};
	*/
	text = text.replace(/^(<(p|div|h[1-6]|blockquote|pre|table|dl|ol|ul|script|noscript|form|fieldset|iframe|math)\b[^\r]*?.*<\/\2>[ \t]*(?=\n+)\n)/gm,hashElement);

	// Special case just for <hr />. It was easier to make a special case than
	// to make the other regex more complicated.  

	/*
		text = text.replace(/
		\n				    // Starting after a blank line
		[ ]{0,3}
		(						// save in $1
			(<(hr)				// start tag = $2
			\b					// word break
			([^<>])*?			// 
			\/?>)				// the matching end tag
			[ \t]*
			(?=\n{2,})			// followed by a blank line
		)
		/g,hashElement);
	*/
	text = text.replace(/\n[ ]{0,3}((<(hr)\b([^<>])*?\/?>)[ \t]*(?=\n{2,}))/g,hashElement);

	// Special case for standalone HTML comments:

	/*
		text = text.replace(/
		\n\n				// Starting after a blank line
		[ ]{0,3}			// attacklab: g_tab_width - 1
		(						// save in $1
			<!
			(--(?:|(?:[^>-]|-[^>])(?:[^-]|-[^-])*)--)    // see http://www.w3.org/TR/html-markup/syntax.html#comments
			>
			[ \t]*
			(?=\n{2,})			// followed by a blank line
		)
		/g,hashElement);
	*/
	text = text.replace(/\n\n[ ]{0,3}(<!(--(?:|(?:[^>-]|-[^>])(?:[^-]|-[^-])*)--)>[ \t]*(?=\n{2,}))/g, hashElement);

	// PHP and ASP-style processor instructions (<?...?> and <%...%>)

	/*
		text = text.replace(/
		(?:
			\n\n				// Starting after a blank line
		)
		(						// save in $1
			[ ]{0,3}			// attacklab: g_tab_width - 1
			(?:
				<([?%])			// $2
				[^\r]*?
				\2>
			)
			[ \t]*
			(?=\n{2,})			// followed by a blank line
		)
		/g,hashElement);
	*/
	text = text.replace(/(?:\n\n)([ ]{0,3}(?:<([?%])[^\r]*?\2>)[ \t]*(?=\n{2,}))/g,hashElement);

	return text;
}

var hashElement = function(wholeMatch,m1) {
	var blockText = m1;

	// Undo double lines
	blockText = blockText.replace(/^\n+/,"");
	
	// strip trailing blank lines
	blockText = blockText.replace(/\n+$/g,"");
	
	// Replace the element text with a marker ("~KxK" where x is its key)
	blockText = "\n\n~K" + (g_html_blocks.push(blockText)-1) + "K\n\n";
	
	return blockText;
};

var _RunBlockGamut = function(text, doNotUnhash) {
//
// These are all the transformations that form block-level
// tags like paragraphs, headers, and list items.
//
	text = _DoHeaders(text);

	// Do Horizontal Rules:
	var key = hashBlock("<hr />");
	text = text.replace(/^[ ]{0,2}([ ]?\*[ ]?){3,}[ \t]*$/gm,key);
	text = text.replace(/^[ ]{0,2}([ ]?-[ ]?){3,}[ \t]*$/gm,key);
	text = text.replace(/^[ ]{0,2}([ ]?_[ ]?){3,}[ \t]*$/gm,key);

	text = _DoLists(text);
	text = _DoCodeBlocks(text);
	text = _DoBlockQuotes(text);

	// We already ran _HashHTMLBlocks() before, in Markdown(), but that
	// was to escape raw HTML in the original Markdown source. This time,
	// we're escaping the markup we've just created, so that we don't wrap
	// <p> tags around block-level tags.
	text = _HashHTMLBlocks(text);
    text = _FormParagraphs(text, doNotUnhash);

	return text;
}


var _RunSpanGamut = function(text) {
//
// These are all the transformations that occur *within* block-level
// tags like paragraphs, headers, and list items.
//

	text = _DoCodeSpans(text);
	text = _EscapeSpecialCharsWithinTagAttributes(text);
	text = _EncodeBackslashEscapes(text);

	// Process anchor and image tags. Images must come first,
	// because ![foo][f] looks like an anchor.
	text = _DoImages(text);
	text = _DoAnchors(text);

	// Make links out of things like `<http://example.com/>`
	// Must come after _DoAnchors(), because you can use < and >
	// delimiters in inline links like [this](<url>).
	text = _DoAutoLinks(text);
	text = _EncodeAmpsAndAngles(text);
	text = _DoItalicsAndBold(text);

	// Do hard breaks:
	text = text.replace(/  +\n/g," <br />\n");

	return text;
}

var _EscapeSpecialCharsWithinTagAttributes = function(text) {
//
// Within tags -- meaning between < and > -- encode [\ ` * _] so they
// don't conflict with their use in Markdown for code, italics and strong.
//

	// Build a regex to find HTML tags and comments.  See Friedl's 
    // "Mastering Regular Expressions", 2nd Ed., pp. 200-201.
    
    // SE: changed the comment part of the regex

    var regex = /(<[a-z\/!$]("[^"]*"|'[^']*'|[^'">])*>|<!(--(?:|(?:[^>-]|-[^>])(?:[^-]|-[^-])*)--)>)/gi;

	text = text.replace(regex, function(wholeMatch) {
		var tag = wholeMatch.replace(/(.)<\/?code>(?=.)/g,"$1`");
		tag = escapeCharacters(tag,"\\`*_");
		return tag;
	});

	return text;
}

var _DoAnchors = function(text) {
//
// Turn Markdown link shortcuts into XHTML <a> tags.
//
	//
	// First, handle reference-style links: [link text] [id]
	//

	/*
		text = text.replace(/
		(							// wrap whole match in $1
			\[
			(
				(?:
					\[[^\]]*\]		// allow brackets nested one level
					|
					[^\[]			// or anything else
				)*
			)
			\]

			[ ]?					// one optional space
			(?:\n[ ]*)?				// one optional newline followed by spaces

			\[
			(.*?)					// id = $3
			\]
		)()()()()					// pad remaining backreferences
		/g,_DoAnchors_callback);
	*/
	text = text.replace(/(\[((?:\[[^\]]*\]|[^\[\]])*)\][ ]?(?:\n[ ]*)?\[(.*?)\])()()()()/g,writeAnchorTag);

	//
	// Next, inline-style links: [link text](url "optional title")
	//

	/*
		text = text.replace(/
		(   						// wrap whole match in $1
			\[
				(
					(?:
						\[[^\]]*\]	// allow brackets nested one level
					    |
					    [^\[\]]		// or anything else
				    )*
			    )
			\]
			\(						// literal paren
			[ \t]*
			()						// no id, so leave $3 empty
			<?(                     // href = $4
                (?:
                    \([^)]*\)       // allow one level of (correctly nested) parens (think MSDN)
                    |
                    [^()]
                )*?
            )>?				
			[ \t]*
			(						// $5
				(['"])				// quote char = $6
				(.*?)				// Title = $7
				\6					// matching quote
				[ \t]*				// ignore any spaces/tabs between closing quote and )
			)?						// title is optional
			\)
		)
		/g,writeAnchorTag);
	*/
    
	text = text.replace(/(\[((?:\[[^\]]*\]|[^\[\]])*)\]\([ \t]*()<?((?:\([^)]*\)|[^()])*?)>?[ \t]*((['"])(.*?)\6[ \t]*)?\))/g,writeAnchorTag);

	//
	// Last, handle reference-style shortcuts: [link text]
	// These must come last in case you've also got [link test][1]
	// or [link test](/foo)
	//

	/*
		text = text.replace(/
		(		 					// wrap whole match in $1
			\[
			([^\[\]]+)				// link text = $2; can't contain '[' or ']'
			\]
		)()()()()()					// pad rest of backreferences
		/g, writeAnchorTag);
	*/
	text = text.replace(/(\[([^\[\]]+)\])()()()()()/g, writeAnchorTag);

	return text;
}

var writeAnchorTag = function(wholeMatch,m1,m2,m3,m4,m5,m6,m7) {
	if (m7 == undefined) m7 = "";
	var whole_match = m1;
	var link_text   = m2;
	var link_id	 = m3.toLowerCase();
	var url		= m4;
	var title	= m7;
	
	if (url == "") {
		if (link_id == "") {
			// lower-case and turn embedded newlines into spaces
			link_id = link_text.toLowerCase().replace(/ ?\n/g," ");
		}
		url = "#"+link_id;
		
		if (g_urls.get(link_id) != undefined) {
			url = g_urls.get(link_id);
			if (g_titles.get(link_id) != undefined) {
				title = g_titles.get(link_id);
			}
		}
		else {
			if (whole_match.search(/\(\s*\)$/m)>-1) {
				// Special case for explicit empty url
				url = "";
			} else {
				return whole_match;
			}
		}
	}	
	
	url = escapeCharacters(url,"*_");
	var result = "<a href=\"" + url + "\"";
	
	if (title != "") {
		title = title.replace(/"/g,"&quot;");
		title = escapeCharacters(title,"*_");
		result +=  " title=\"" + title + "\"";
	}
	
	result += ">" + link_text + "</a>";
	
	return result;
}


var _DoImages = function(text) {
//
// Turn Markdown image shortcuts into <img> tags.
//

	//
	// First, handle reference-style labeled images: ![alt text][id]
	//

	/*
		text = text.replace(/
		(						// wrap whole match in $1
			!\[
			(.*?)				// alt text = $2
			\]

			[ ]?				// one optional space
			(?:\n[ ]*)?			// one optional newline followed by spaces

			\[
			(.*?)				// id = $3
			\]
		)()()()()				// pad rest of backreferences
		/g,writeImageTag);
	*/
	text = text.replace(/(!\[(.*?)\][ ]?(?:\n[ ]*)?\[(.*?)\])()()()()/g,writeImageTag);

	//
	// Next, handle inline images:  ![alt text](url "optional title")
	// Don't forget: encode * and _

	/*
		text = text.replace(/
		(						// wrap whole match in $1
			!\[
			(.*?)				// alt text = $2
			\]
			\s?					// One optional whitespace character
			\(					// literal paren
			[ \t]*
			()					// no id, so leave $3 empty
			<?(\S+?)>?			// src url = $4
			[ \t]*
			(					// $5
				(['"])			// quote char = $6
				(.*?)			// title = $7
				\6				// matching quote
				[ \t]*
			)?					// title is optional
		\)
		)
		/g,writeImageTag);
	*/
	text = text.replace(/(!\[(.*?)\]\s?\([ \t]*()<?(\S+?)>?[ \t]*((['"])(.*?)\6[ \t]*)?\))/g,writeImageTag);

	return text;
}

var writeImageTag = function(wholeMatch,m1,m2,m3,m4,m5,m6,m7) {
	var whole_match = m1;
	var alt_text   = m2;
	var link_id	 = m3.toLowerCase();
	var url		= m4;
	var title	= m7;

	if (!title) title = "";
	
	if (url == "") {
		if (link_id == "") {
			// lower-case and turn embedded newlines into spaces
			link_id = alt_text.toLowerCase().replace(/ ?\n/g," ");
		}
		url = "#"+link_id;
		
		if (g_urls.get(link_id) != undefined) {
			url = g_urls.get(link_id);
			if (g_titles.get(link_id) != undefined) {
				title = g_titles.get(link_id);
			}
		}
		else {
			return whole_match;
		}
	}	
	
	alt_text = alt_text.replace(/"/g,"&quot;");
	url = escapeCharacters(url,"*_");
	var result = "<img src=\"" + url + "\" alt=\"" + alt_text + "\"";

	// attacklab: Markdown.pl adds empty title attributes to images.
	// Replicate this bug.

	//if (title != "") {
		title = title.replace(/"/g,"&quot;");
		title = escapeCharacters(title,"*_");
		result +=  " title=\"" + title + "\"";
	//}
	
	result += " />";
	
	return result;
}


var _DoHeaders = function(text) {

	// Setext-style headers:
	//	Header 1
	//	========
	//  
	//	Header 2
	//	--------
	//
	text = text.replace(/^(.+)[ \t]*\n=+[ \t]*\n+/gm,
		function(wholeMatch,m1){return "<h1>" + _RunSpanGamut(m1) + "</h1>";});

	text = text.replace(/^(.+)[ \t]*\n-+[ \t]*\n+/gm,
		function(matchFound,m1){return "<h2>" + _RunSpanGamut(m1) + "</h2>";});

	// atx-style headers:
	//  # Header 1
	//  ## Header 2
	//  ## Header 2 with closing hashes ##
	//  ...
	//  ###### Header 6
	//

	/*
		text = text.replace(/
			^(\#{1,6})				// $1 = string of #'s
			[ \t]*
			(.+?)					// $2 = Header text
			[ \t]*
			\#*						// optional closing #'s (not counted)
			\n+
		/gm, function() {...});
	*/

	text = text.replace(/^(\#{1,6})[ \t]*(.+?)[ \t]*\#*\n+/gm,
		function(wholeMatch,m1,m2) {
			var h_level = m1.length;
			return "<h" + h_level + ">" + _RunSpanGamut(m2) + "</h" + h_level + ">";
		});

	return text;
}

// This declaration keeps Dojo compressor from outputting garbage:
var _ProcessListItems;

var _DoLists = function(text) {
//
// Form HTML ordered (numbered) and unordered (bulleted) lists.
//

	// attacklab: add sentinel to hack around khtml/safari bug:
	// http://bugs.webkit.org/show_bug.cgi?id=11231
	text += "~0";

	// Re-usable pattern to match any entirel ul or ol list:

	/*
		var whole_list = /
		(									// $1 = whole list
			(								// $2
				[ ]{0,3}					// attacklab: g_tab_width - 1
				([*+-]|\d+[.])				// $3 = first list item marker
				[ \t]+
			)
			[^\r]+?
			(								// $4
				~0							// sentinel for workaround; should be $
			|
				\n{2,}
				(?=\S)
				(?!							// Negative lookahead for another list item marker
					[ \t]*
					(?:[*+-]|\d+[.])[ \t]+
				)
			)
		)/g
	*/
	var whole_list = /^(([ ]{0,3}([*+-]|\d+[.])[ \t]+)[^\r]+?(~0|\n{2,}(?=\S)(?![ \t]*(?:[*+-]|\d+[.])[ \t]+)))/gm;

	if (g_list_level) {
		text = text.replace(whole_list,function(wholeMatch,m1,m2) {
			var list = m1;
			var list_type = (m2.search(/[*+-]/g)>-1) ? "ul" : "ol";

			var result = _ProcessListItems(list, list_type);
	
			// Trim any trailing whitespace, to put the closing `</$list_type>`
			// up on the preceding line, to get it past the current stupid
			// HTML block parser. This is a hack to work around the terrible
			// hack that is the HTML block parser.
			result = result.replace(/\s+$/,"");
			result = "<"+list_type+">" + result + "</"+list_type+">\n";
			return result;
		});
	} else {
		whole_list = /(\n\n|^\n?)(([ ]{0,3}([*+-]|\d+[.])[ \t]+)[^\r]+?(~0|\n{2,}(?=\S)(?![ \t]*(?:[*+-]|\d+[.])[ \t]+)))/g;
		text = text.replace(whole_list,function(wholeMatch,m1,m2,m3) {
			var runup = m1;
			var list = m2;

			var list_type = (m3.search(/[*+-]/g)>-1) ? "ul" : "ol";
			var result = _ProcessListItems(list, list_type);
			result = runup + "<"+list_type+">\n" + result + "</"+list_type+">\n";	
			return result;
		});
	}

	// attacklab: strip sentinel
	text = text.replace(/~0/,"");

	return text;
}

var _listItemMarkers = { ol: "\\d+[.]", ul: "[*+-]" };

_ProcessListItems = function(list_str, list_type) {
//
//  Process the contents of a single ordered or unordered list, splitting it
//  into individual list items.
//
//  list_type is either "ul" or "ol".

	// The $g_list_level global keeps track of when we're inside a list.
	// Each time we enter a list, we increment it; when we leave a list,
	// we decrement. If it's zero, we're not in a list anymore.
	//
	// We do this because when we're not inside a list, we want to treat
	// something like this:
	//
	//    I recommend upgrading to version
	//    8. Oops, now this line is treated
	//    as a sub-list.
	//
	// As a single paragraph, despite the fact that the second line starts
	// with a digit-period-space sequence.
	//
	// Whereas when we're inside a list (or sub-list), that line will be
	// treated as the start of a sub-list. What a kludge, huh? This is
	// an aspect of Markdown's syntax that's hard to parse perfectly
	// without resorting to mind-reading. Perhaps the solution is to
	// change the syntax rules such that sub-lists must start with a
	// starting cardinal number; e.g. "1." or "a.".

	g_list_level++;

	// trim trailing blank lines:
	list_str = list_str.replace(/\n{2,}$/,"\n");

	// attacklab: add sentinel to emulate \z
	list_str += "~0";

	// In the original attacklab WMD, list_type was not given to this function, and anything
	// that matched /[*+-]|\d+[.]/ would just create the next <li>, causing this mismatch:
	//
    //  Markdown          rendered by WMD        rendered by MarkdownSharp
	//  ------------------------------------------------------------------
	//  1. first          1. first               1. first
	//  2. second         2. second              2. second
	//  - third           3. third                   * third
	//
	// We changed this to behave identical to MarkdownSharp. This is the constructed RegEx,
    // with {MARKER} being one of \d+[.] or [*+-], depending on list_type:
	/*
		list_str = list_str.replace(/
			(^[ \t]*)						// leading whitespace = $1
			({MARKER}) [ \t]+   			// list marker = $2
			([^\r]+?						// list item text   = $3
			(\n+))
			(?= (~0 | \2 ({MARKER}) [ \t]+))
		/gm, function(){...});
	*/
    
    var marker = _listItemMarkers[list_type];
    var re = new RegExp("(^[ \\t]*)(" + marker + ")[ \\t]+([^\\r]+?(\\n+))(?=(~0|\\1(" + marker + ")[ \\t]+))", "gm");
    var last_item_had_a_double_newline = false;
	list_str = list_str.replace(re,
		function(wholeMatch,m1,m2,m3){
			var item = m3;
			var leading_space = m1;
            var ends_with_double_newline = /\n\n$/.test(item);
			var contains_double_newline = ends_with_double_newline || item.search(/\n{2,}/)>-1;

			if (contains_double_newline || last_item_had_a_double_newline) {
				item =  _RunBlockGamut(_Outdent(item), /* doNotUnhash = */ true);
			}
			else {
				// Recursion for sub-lists:
				item = _DoLists(_Outdent(item));
				item = item.replace(/\n$/,""); // chomp(item)
				item = _RunSpanGamut(item);
            }
            last_item_had_a_double_newline = ends_with_double_newline;
			return  "<li>" + item + "</li>\n";
		}
	);

	// attacklab: strip sentinel
	list_str = list_str.replace(/~0/g,"");

	g_list_level--;
	return list_str;
}


var _DoCodeBlocks = function(text) {
//
//  Process Markdown `<pre><code>` blocks.
//  

	/*
		text = text.replace(text,
			/(?:\n\n|^)
			(								// $1 = the code block -- one or more lines, starting with a space/tab
				(?:
					(?:[ ]{4}|\t)			// Lines must start with a tab or a tab-width of spaces - attacklab: g_tab_width
					.*\n+
				)+
			)
			(\n*[ ]{0,3}[^ \t\n]|(?=~0))	// attacklab: g_tab_width
		/g,function(){...});
	*/

	// attacklab: sentinel workarounds for lack of \A and \Z, safari\khtml bug
	text += "~0";
	
	text = text.replace(/(?:\n\n|^)((?:(?:[ ]{4}|\t).*\n+)+)(\n*[ ]{0,3}[^ \t\n]|(?=~0))/g,
		function(wholeMatch,m1,m2) {
			var codeblock = m1;
			var nextChar = m2;
		
			codeblock = _EncodeCode( _Outdent(codeblock));
			codeblock = _Detab(codeblock);
			codeblock = codeblock.replace(/^\n+/g,""); // trim leading newlines
			codeblock = codeblock.replace(/\n+$/g,""); // trim trailing whitespace

			codeblock = "<pre><code>" + codeblock + "\n</code></pre>";

			return "\n\n" + codeblock + "\n\n" + nextChar;
		}
	);

	// attacklab: strip sentinel
	text = text.replace(/~0/,"");

	return text;
}

var hashBlock = function(text) {
	text = text.replace(/(^\n+|\n+$)/g,"");
	return "\n\n~K" + (g_html_blocks.push(text)-1) + "K\n\n";
}


var _DoCodeSpans = function(text) {
//
//   *  Backtick quotes are used for <code></code> spans.
// 
//   *  You can use multiple backticks as the delimiters if you want to
//	 include literal backticks in the code span. So, this input:
//	 
//		 Just type ``foo `bar` baz`` at the prompt.
//	 
//	   Will translate to:
//	 
//		 <p>Just type <code>foo `bar` baz</code> at the prompt.</p>
//	 
//	There's no arbitrary limit to the number of backticks you
//	can use as delimters. If you need three consecutive backticks
//	in your code, use four for delimiters, etc.
//
//  *  You can use spaces to get literal backticks at the edges:
//	 
//		 ... type `` `bar` `` ...
//	 
//	   Turns to:
//	 
//		 ... type <code>`bar`</code> ...
//

	/*
		text = text.replace(/
			(^|[^\\])					// Character before opening ` can't be a backslash
			(`+)						// $2 = Opening run of `
			(							// $3 = The code block
				[^\r]*?
				[^`]					// attacklab: work around lack of lookbehind
			)
			\2							// Matching closer
			(?!`)
		/gm, function(){...});
	*/

	text = text.replace(/(^|[^\\])(`+)([^\r]*?[^`])\2(?!`)/gm,
		function(wholeMatch,m1,m2,m3,m4) {
			var c = m3;
			c = c.replace(/^([ \t]*)/g,"");	// leading whitespace
			c = c.replace(/[ \t]*$/g,"");	// trailing whitespace
			c = _EncodeCode(c);
			return m1+"<code>"+c+"</code>";
		});

	return text;
}


var _EncodeCode = function(text) {
//
// Encode/escape certain characters inside Markdown code runs.
// The point is that in code, these characters are literals,
// and lose their special Markdown meanings.
//
	// Encode all ampersands; HTML entities are not
	// entities within a Markdown code span.
	text = text.replace(/&/g,"&amp;");

	// Do the angle bracket song and dance:
	text = text.replace(/</g,"&lt;");
	text = text.replace(/>/g,"&gt;");

	// Now, escape characters that are magic in Markdown:
	text = escapeCharacters(text,"\*_{}[]\\",false);

// jj the line above breaks this:
//---

//* Item

//   1. Subitem

//            special char: *
//---

	return text;
}


var _DoItalicsAndBold = function(text) {

	// <strong> must go first:
	text = text.replace(/(\*\*|__)(?=\S)([^\r]*?\S[\*_]*)\1/g,
		"<strong>$2</strong>");

	text = text.replace(/(\*|_)(?=\S)([^\r]*?\S)\1/g,
		"<em>$2</em>");

	return text;
}


var _DoBlockQuotes = function(text) {

	/*
		text = text.replace(/
		(								// Wrap whole match in $1
			(
				^[ \t]*>[ \t]?			// '>' at the start of a line
				.+\n					// rest of the first line
				(.+\n)*					// subsequent consecutive lines
				\n*						// blanks
			)+
		)
		/gm, function(){...});
	*/

	text = text.replace(/((^[ \t]*>[ \t]?.+\n(.+\n)*\n*)+)/gm,
		function(wholeMatch,m1) {
			var bq = m1;

			// attacklab: hack around Konqueror 3.5.4 bug:
			// "----------bug".replace(/^-/g,"") == "bug"

			bq = bq.replace(/^[ \t]*>[ \t]?/gm,"~0");	// trim one level of quoting

			// attacklab: clean up hack
			bq = bq.replace(/~0/g,"");

			bq = bq.replace(/^[ \t]+$/gm,"");		// trim whitespace-only lines
			bq = _RunBlockGamut(bq);				// recurse
			
			bq = bq.replace(/(^|\n)/g,"$1  ");
			// These leading spaces screw with <pre> content, so we need to fix that:
			bq = bq.replace(
					/(\s*<pre>[^\r]+?<\/pre>)/gm,
				function(wholeMatch,m1) {
					var pre = m1;
					// attacklab: hack around Konqueror 3.5.4 bug:
					pre = pre.replace(/^  /mg,"~0");
					pre = pre.replace(/~0/g,"");
					return pre;
				});
			
			return hashBlock("<blockquote>\n" + bq + "\n</blockquote>");
		});
	return text;
}


var _FormParagraphs = function(text, doNotUnhash) {
//
//  Params:
//    $text - string to process with html <p> tags
//

	// Strip leading and trailing lines:
	text = text.replace(/^\n+/g,"");
	text = text.replace(/\n+$/g,"");

	var grafs = text.split(/\n{2,}/g);
	var grafsOut = new Array();

	//
	// Wrap <p> tags.
	//
	var end = grafs.length;
	for (var i=0; i<end; i++) {
		var str = grafs[i];

		// if this is an HTML marker, copy it
		if (str.search(/~K(\d+)K/g) >= 0) {
			grafsOut.push(str);
		}
		else if (str.search(/\S/) >= 0) {
			str = _RunSpanGamut(str);
			str = str.replace(/^([ \t]*)/g,"<p>");
			str += "</p>"
			grafsOut.push(str);
		}

	}
	//
	// Unhashify HTML blocks
	//
    if (!doNotUnhash) {
        end = grafsOut.length;
	    for (var i=0; i<end; i++) {
		    // if this is a marker for an html block...
		    while (grafsOut[i].search(/~K(\d+)K/) >= 0) {
			    var blockText = g_html_blocks[RegExp.$1];
			    blockText = blockText.replace(/\$/g,"$$$$"); // Escape any dollar signs
			    grafsOut[i] = grafsOut[i].replace(/~K\d+K/,blockText);
		    }
	    }
    }
	return grafsOut.join("\n\n");
}


var _EncodeAmpsAndAngles = function(text) {
// Smart processing for ampersands and angle brackets that need to be encoded.
	
	// Ampersand-encoding based entirely on Nat Irons's Amputator MT plugin:
	//   http://bumppo.net/projects/amputator/
	text = text.replace(/&(?!#?[xX]?(?:[0-9a-fA-F]+|\w+);)/g,"&amp;");
	
	// Encode naked <'s
	text = text.replace(/<(?![a-z\/?\$!])/gi,"&lt;");
	
	return text;
}


var _EncodeBackslashEscapes = function(text) {
//
//   Parameter:  String.
//   Returns:	The string, with after processing the following backslash
//			   escape sequences.
//

	// attacklab: The polite way to do this is with the new
	// escapeCharacters() function:
	//
	// 	text = escapeCharacters(text,"\\",true);
	// 	text = escapeCharacters(text,"`*_{}[]()>#+-.!",true);
	//
	// ...but we're sidestepping its use of the (slow) RegExp constructor
	// as an optimization for Firefox.  This function gets called a LOT.

	text = text.replace(/\\(\\)/g,escapeCharacters_callback);
	text = text.replace(/\\([`*_{}\[\]()>#+-.!])/g,escapeCharacters_callback);
	return text;
}


var _DoAutoLinks = function(text) {

	text = text.replace(/<((https?|ftp|dict):[^'">\s]+)>/gi,"<a href=\"$1\">$1</a>");

	// Email addresses: <address@domain.foo>

	/*
		text = text.replace(/
			<
			(?:mailto:)?
			(
				[-.\w]+
				\@
				[-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]+
			)
			>
		/gi, _DoAutoLinks_callback());
	*/
	text = text.replace(/<(?:mailto:)?([-.\w]+\@[-a-z0-9]+(\.[-a-z0-9]+)*\.[a-z]+)>/gi,
		function(wholeMatch,m1) {
			return _EncodeEmailAddress( _UnescapeSpecialChars(m1) );
		}
	);

	return text;
}


var _EncodeEmailAddress = function(addr) {
//
//  Input: an email address, e.g. "foo@example.com"
//
//  Output: the email address as a mailto link, with each character
//	of the address encoded as either a decimal or hex entity, in
//	the hopes of foiling most address harvesting spam bots. E.g.:
//
//	<a href="&#x6D;&#97;&#105;&#108;&#x74;&#111;:&#102;&#111;&#111;&#64;&#101;
//	   x&#x61;&#109;&#x70;&#108;&#x65;&#x2E;&#99;&#111;&#109;">&#102;&#111;&#111;
//	   &#64;&#101;x&#x61;&#109;&#x70;&#108;&#x65;&#x2E;&#99;&#111;&#109;</a>
//
//  Based on a filter by Matthew Wickline, posted to the BBEdit-Talk
//  mailing list: <http://tinyurl.com/yu7ue>
//

	// attacklab: why can't javascript speak hex?
	function char2hex(ch) {
		var hexDigits = '0123456789ABCDEF';
		var dec = ch.charCodeAt(0);
		return(hexDigits.charAt(dec>>4) + hexDigits.charAt(dec&15));
	}

	var encode = [
		function(ch){return "&#"+ch.charCodeAt(0)+";";},
		function(ch){return "&#x"+char2hex(ch)+";";},
		function(ch){return ch;}
	];

	addr = "mailto:" + addr;

	addr = addr.replace(/./g, function(ch) {
		if (ch == "@") {
		   	// this *must* be encoded. I insist.
			ch = encode[Math.floor(Math.random()*2)](ch);
		} else if (ch !=":") {
			// leave ':' alone (to spot mailto: later)
			var r = Math.random();
			// roughly 10% raw, 45% hex, 45% dec
			ch =  (
					r > .9  ?	encode[2](ch)   :
					r > .45 ?	encode[1](ch)   :
								encode[0](ch)
				);
		}
		return ch;
	});

	addr = "<a href=\"" + addr + "\">" + addr + "</a>";
	addr = addr.replace(/">.+:/g,"\">"); // strip the mailto: from the visible part

	return addr;
}


var _UnescapeSpecialChars = function(text) {
//
// Swap back in all the special characters we've hidden.
//
	text = text.replace(/~E(\d+)E/g,
		function(wholeMatch,m1) {
			var charCodeToReplace = parseInt(m1);
			return String.fromCharCode(charCodeToReplace);
		}
	);
	return text;
}


var _Outdent = function(text) {
//
// Remove one level of line-leading tabs or spaces
//

	// attacklab: hack around Konqueror 3.5.4 bug:
	// "----------bug".replace(/^-/g,"") == "bug"

	text = text.replace(/^(\t|[ ]{1,4})/gm,"~0"); // attacklab: g_tab_width

	// attacklab: clean up hack
	text = text.replace(/~0/g,"")

	return text;
}

var _Detab = function (text) {
	if (!/\t/.test(text))
		return text;

	var spaces = ["    ", "   ", "  ", " "],
		skew = 0,
		v;

	return text.replace(/[\n\t]/g, function (match, offset) {
		if (match === "\n") {
			skew = offset + 1;
			return match;
		}
		v = (offset - skew) % 4;
		skew = offset + 1;
		return spaces[v];
	});
}

//
//  attacklab: Utility functions
//


var escapeCharacters = function(text, charsToEscape, afterBackslash) {
	// First we have to escape the escape characters so that
	// we can build a character class out of them
	var regexString = "([" + charsToEscape.replace(/([\[\]\\])/g,"\\$1") + "])";

	if (afterBackslash) {
		regexString = "\\\\" + regexString;
	}

	var regex = new RegExp(regexString,"g");
	text = text.replace(regex,escapeCharacters_callback);

	return text;
}


var escapeCharacters_callback = function(wholeMatch,m1) {
	var charCodeToEscape = m1.charCodeAt(0);
	return "~E"+charCodeToEscape+"E";
}

} // end of Attacklab.showdown.converter


// Version 0.9 used the Showdown namespace instead of Attacklab.showdown
// The old namespace is deprecated, but we'll support it for now:
var Showdown = Attacklab.showdown;

// If anyone's interested, tell the world that this file's been loaded
if (Attacklab.fileLoaded) {
	Attacklab.fileLoaded("showdown.js");
}
// Generated by CoffeeScript 1.9.2
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

Annotator.Plugin.Store = (function(superClass) {
  extend(Store, superClass);

  Store.prototype.events = {
    'annotationCreated': 'annotationCreated',
    'annotationDeleted': 'annotationDeleted',
    'annotationUpdated': 'annotationUpdated'
  };

  Store.prototype.options = {
    annotationData: {},
    emulateHTTP: false,
    loadFromSearch: false,
    prefix: '/store',
    urls: {
      create: '/annotations',
      read: '/annotations/:id',
      update: '/annotations/:id',
      destroy: '/annotations/:id',
      search: '/search'
    }
  };

  function Store(element, options) {
    this._onError = bind(this._onError, this);
    this._onLoadAnnotationsFromSearch = bind(this._onLoadAnnotationsFromSearch, this);
    this._onLoadAnnotations = bind(this._onLoadAnnotations, this);
    this._getAnnotations = bind(this._getAnnotations, this);
    Store.__super__.constructor.apply(this, arguments);
    this.annotations = [];
  }

  Store.prototype.pluginInit = function() {
    if (!Annotator.supported()) {
      return;
    }
    if (this.annotator.plugins.Auth) {
      return this.annotator.plugins.Auth.withToken(this._getAnnotations);
    } else {
      return this._getAnnotations();
    }
  };

  Store.prototype._getAnnotations = function() {
    if (this.options.loadFromSearch) {
      return this.loadAnnotationsFromSearch(this.options.loadFromSearch);
    } else {
      return this.loadAnnotations();
    }
  };

  Store.prototype.annotationCreated = function(annotation) {
    if (indexOf.call(this.annotations, annotation) < 0) {
      this.registerAnnotation(annotation);
      return this._apiRequest('create', annotation, (function(_this) {
        return function(data) {
          if(data.id === undefined && data._id !== undefined) {
            data.id = data._id;
          }              
          if (data.id == null) {
            console.warn(Annotator._t("Warning: No ID returned from server for annotation "), annotation);
          }
          return _this.updateAnnotation(annotation, data);
        };
      })(this));
    } else {
      return this.updateAnnotation(annotation, {});
    }
  };

  Store.prototype.annotationUpdated = function(annotation) {
    if (indexOf.call(this.annotations, annotation) >= 0) {
      return this._apiRequest('update', annotation, ((function(_this) {
        return function(data) {
          return _this.updateAnnotation(annotation, data);
        };
      })(this)));
    }
  };

  Store.prototype.annotationDeleted = function(annotation) {
    if (indexOf.call(this.annotations, annotation) >= 0) {
      return this._apiRequest('destroy', annotation, ((function(_this) {
        return function() {
          return _this.unregisterAnnotation(annotation);
        };
      })(this)));
    }
  };

  Store.prototype.registerAnnotation = function(annotation) {
    return this.annotations.push(annotation);
  };

  Store.prototype.unregisterAnnotation = function(annotation) {
    return this.annotations.splice(this.annotations.indexOf(annotation), 1);
  };

  Store.prototype.updateAnnotation = function(annotation, data) {
    if (indexOf.call(this.annotations, annotation) < 0) {
      console.error(Annotator._t("Trying to update unregistered annotation!"));
    } else {
      $.extend(annotation, data);
    }
    $(annotation.highlights).attr('data-annotation-id', annotation._id);
    return $(annotation.highlights).data('annotation', annotation);
  };

  Store.prototype.loadAnnotations = function() {
    return this._apiRequest('read', null, this._onLoadAnnotations);
  };

  Store.prototype._onLoadAnnotations = function(data) {
    var a, annotation, annotationMap, i, j, len, len1, newData, ref;
    if (data == null) {
      data = [];
    }
    annotationMap = {};
    ref = this.annotations;
    for (i = 0, len = ref.length; i < len; i++) {
      a = ref[i];
      annotationMap[a.id] = a;
    }
    newData = [];
    for (j = 0, len1 = data.length; j < len1; j++) {
      a = data[j];
      if (annotationMap[a.id]) {
        annotation = annotationMap[a.id];
        this.updateAnnotation(annotation, a);
      } else {
        newData.push(a);
      }
    }
    this.annotations = this.annotations.concat(newData);
    return this.annotator.loadAnnotations(newData.slice());
  };

  Store.prototype.loadAnnotationsFromSearch = function(searchOptions) {
    return this._apiRequest('search', searchOptions, this._onLoadAnnotationsFromSearch);
  };

  Store.prototype._onLoadAnnotationsFromSearch = function(data) {
    if (data == null) {
      data = {};
    }
    return this._onLoadAnnotations(data.rows || []);
  };

  Store.prototype.dumpAnnotations = function() {
    var ann, i, len, ref, results;
    ref = this.annotations;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      ann = ref[i];
      results.push(JSON.parse(this._dataFor(ann)));
    }
    return results;
  };

  Store.prototype._apiRequest = function(action, obj, onSuccess) {
    var id, options, request, url;
    id = obj && obj.id;
    url = this._urlFor(action, id);
    options = this._apiRequestOptions(action, obj, onSuccess);
    request = $.ajax(url, options);
    request._id = id;
    request._action = action;
    return request;
  };

  Store.prototype._apiRequestOptions = function(action, obj, onSuccess) {
    var data, method, opts;
    method = this._methodFor(action);
    opts = {
      type: method,
      headers: this.element.data('annotator:headers'),
      dataType: "json",
      success: onSuccess || function() {},
      error: this._onError
    };
    if (this.options.emulateHTTP && (method === 'PUT' || method === 'DELETE')) {
      opts.headers = $.extend(opts.headers, {
        'X-HTTP-Method-Override': method
      });
      opts.type = 'POST';
    }
    if (action === "search") {
      opts = $.extend(opts, {
        data: obj
      });
      return opts;
    }
    data = obj && this._dataFor(obj);
    if (this.options.emulateJSON) {
      opts.data = {
        json: data
      };
      if (this.options.emulateHTTP) {
        opts.data._method = method;
      }
      return opts;
    }
    opts = $.extend(opts, {
      data: data,
      contentType: "application/json; charset=utf-8",
      cache: false
    });
    return opts;
  };

  Store.prototype._urlFor = function(action, id) {
    var url;
    url = this.options.prefix != null ? this.options.prefix : '';
    url += this.options.urls[action];
    url = url.replace(/\/:id/, id != null ? '/' + id : '');
    url = url.replace(/:id/, id != null ? id : '');
    if(action === "read") {
      var userid, productid, productcode, itemid;
      try {
        if(window.parent.myReader && window.parent.myReader.readerOptions && window.parent.myReader.readerOptions.config) {
          var config = window.parent.myReader.readerOptions.config;
          if(config !== undefined && config !== null) {
            if(config.userid) {
              userid = config.userid;
            }
            if(config.productid) {
              productid = config.productid; 
            }
            if(config.productcode) {
              productcode = config.productcode; 
            }          
            if(config.itemid) {
              itemid = config.itemid;
            }  
          }    
        }
      } catch(error) {
      }
      if((userid !== null && userid !== undefined) || (productid !== null && productid !== undefined) || (productcode !== null && productcode !== undefined) || (itemid !== null && itemid !== undefined)) {
        url += "/?";
        var count = 0;
        if(userid !== null && userid !== undefined) {
          url += "userid=" + userid;
          count = 1;
        }
        if(productid !== null && productid !== undefined) {
          if(count = 0) {
            count = 1;
          } else {
            url += "&";
          }
          url += "productid=" + productid;
        }  
        if(productcode !== null && productcode !== undefined) {
          if(count = 0) {
            count = 1;
          } else {
            url += "&";
          }
          url += "productcode=" + productcode;
        }          
        if(itemid !== null && itemid !== undefined) {
          if(count = 0) {
            count = 1;
          } else {
            url += "&";
          }
          url += "itemid=" + itemid;
        }                
      }    
    }
    return url;
  };

  Store.prototype._methodFor = function(action) {
    var table;
    table = {
      'create': 'POST',
      'read': 'GET',
      'update': 'PUT',
      'destroy': 'DELETE',
      'search': 'GET'
    };
    return table[action];
  };

  Store.prototype._dataFor = function(annotation) {
    var data, highlights;
    highlights = annotation.highlights;
    delete annotation.highlights;
    $.extend(annotation, this.options.annotationData);
    data = JSON.stringify(annotation);
    if (highlights) {
      annotation.highlights = highlights;
    }
    return data;
  };

  Store.prototype._onError = function(xhr) {
    var action, message;
    action = xhr._action;
    message = Annotator._t("Sorry something went wrong. Please try again after some time.");
    if(xhr.status === 401) {
      message = Annotator._t("Sorry, this action is not allowed (401).");
    } else if(xhr.status === 404) {
      message = Annotator._t("Sorry something went wrong (404). Please try again after some time.");
    } else if(xhr.status >= 500) {
      message = Annotator._t("Sorry something went wrong (" + xhr.status + "). Please try again after some time.");
    }
    Annotator.showNotification(message, Annotator.Notification.ERROR);
    return console.error(Annotator._t("API request failed:") + (" '" + xhr.status + "'"));
  };

  return Store;

})(Annotator.Plugin);

//# sourceMappingURL=store.js.map

// Generated by CoffeeScript 1.9.2
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Annotator.Plugin.Permissions = (function(superClass) {
  extend(Permissions, superClass);

  Permissions.prototype.events = {
    'beforeAnnotationCreated': 'addFieldsToAnnotation'
  };

  Permissions.prototype.options = {
    showViewPermissionsCheckbox: false,
    showEditPermissionsCheckbox: false,
    userId: function(user) {
      return user;
    },
    userString: function(user) {
      return user;
    },
    userAuthorize: function(action, annotation, user) {
      var i, len, token, tokens;
      if (annotation.permissions) {
        tokens = annotation.permissions[action] || [];
        if (tokens.length === 0) {
          return true;
        }
        for (i = 0, len = tokens.length; i < len; i++) {
          token = tokens[i];
          if (this.userId(user) === token) {
            return true;
          }
        }
        return false;
      } else if (annotation.user) {
        if (user) {
          return this.userId(user) === this.userId(annotation.user);
        } else {
          return false;
        }
      }
      return true;
    },
    user: '',
    permissions: {
      'read': [],
      'update': [],
      'delete': [],
      'admin': []
    }
  };

  function Permissions(element, options) {
    this._setAuthFromToken = bind(this._setAuthFromToken, this);
    this.updateViewer = bind(this.updateViewer, this);
    this.updateAnnotationPermissions = bind(this.updateAnnotationPermissions, this);
    this.updatePermissionsField = bind(this.updatePermissionsField, this);
    this.addFieldsToAnnotation = bind(this.addFieldsToAnnotation, this);
    Permissions.__super__.constructor.apply(this, arguments);
    if (this.options.user) {
      this.setUser(this.options.user);
      delete this.options.user;
    }
  }

  Permissions.prototype.pluginInit = function() {
    var createCallback, self;
    if (!Annotator.supported()) {
      return;
    }
    self = this;
    createCallback = function(method, type) {
      return function(field, annotation) {
        return self[method].call(self, type, field, annotation);
      };
    };
    // if (!this.user && this.annotator.plugins.Auth) {
    //   this.annotator.plugins.Auth.withToken(this._setAuthFromToken);
    // }
    if (!this.user) {
      var userID;
      try {
        if(window.parent.myReader && window.parent.myReader.readerOptions && window.parent.myReader.readerOptions.config) {
          userID = window.parent.myReader.readerOptions.config.userid;
        }
      } catch(error) {
      }
      var token = {
        "ttl": 86400,
        "userId": userID,
        "consumerKey": "annotateit"        
      };    
      this._setAuthFromToken(token);
    } 
    
    this.annotator.editor.addField({
      type: 'checkbox',
      label: Annotator._t('Share with my group')
    });
    
    /*if (this.options.showViewPermissionsCheckbox === true) {
      this.annotator.editor.addField({
        type: 'checkbox',
        label: Annotator._t('Allow anyone to <strong>view</strong> this annotation'),
        load: createCallback('updatePermissionsField', 'read'),
        submit: createCallback('updateAnnotationPermissions', 'read')
      });
    }
    if (this.options.showEditPermissionsCheckbox === true) {
      this.annotator.editor.addField({
        type: 'checkbox',
        label: Annotator._t('Allow anyone to <strong>edit</strong> this annotation'),
        load: createCallback('updatePermissionsField', 'update'),
        submit: createCallback('updateAnnotationPermissions', 'update')
      });
    }*/
    this.annotator.viewer.addField({
      load: this.updateViewer
    });
    if (this.annotator.plugins.Filter) {
      return this.annotator.plugins.Filter.addFilter({
        label: Annotator._t('User'),
        property: 'user',
        isFiltered: (function(_this) {
          return function(input, user) {
            var i, keyword, len, ref;
            user = _this.options.userString(user);
            if (!(input && user)) {
              return false;
            }
            ref = input.split(/\s*/);
            for (i = 0, len = ref.length; i < len; i++) {
              keyword = ref[i];
              if (user.indexOf(keyword) === -1) {
                return false;
              }
            }
            return true;
          };
        })(this)
      });
    }
  };

  Permissions.prototype.setUser = function(user) {
    return this.user = user;
  };

  Permissions.prototype.addFieldsToAnnotation = function(annotation) {
    if (annotation) {
      annotation.permissions = $.extend(true, {}, this.options.permissions);
      if (this.user) {
        return annotation.user = this.user;
      }
    }
  };

  Permissions.prototype.authorize = function(action, annotation, user) {
    if (user === void 0) {
      user = this.user;
    }
    if (this.options.userAuthorize) {
      return this.options.userAuthorize.call(this.options, action, annotation, user);
    } else {
      return true;
    }
  };

  Permissions.prototype.updatePermissionsField = function(action, field, annotation) {
    var input;
    field = $(field).show();
    input = field.find('input').removeAttr('disabled');
    if (!this.authorize('admin', annotation)) {
      field.hide();
    }
    if (this.authorize(action, annotation || {}, null)) {
      return input.attr('checked', 'checked');
    } else {
      return input.removeAttr('checked');
    }
  };

  Permissions.prototype.updateAnnotationPermissions = function(type, field, annotation) {
    var dataKey;
    if (!annotation.permissions) {
      annotation.permissions = $.extend(true, {}, this.options.permissions);
    }
    dataKey = type + '-permissions';
    if ($(field).find('input').is(':checked')) {
      return annotation.permissions[type] = [];
    } else {
      return annotation.permissions[type] = [this.options.userId(this.user)];
    }
  };

  Permissions.prototype.updateViewer = function(field, annotation, controls) {
    var user, username;
    field = $(field);
    username = this.options.userString(annotation.userid);
    if (annotation.userid && username && typeof username === 'string') {
      user = Annotator.Util.escape(this.options.userString(annotation.userid));
      field.html(user).addClass('annotator-user');
    } else {
      field.remove();
    }
    if (controls) {
      if (!this.authorize('update', annotation)) {
        controls.hideEdit();
      }
      if (!this.authorize('delete', annotation)) {
        return controls.hideDelete();
      }
    }
  };

  Permissions.prototype._setAuthFromToken = function(token) {
    return this.setUser(token.userId);
  };

  return Permissions;

})(Annotator.Plugin);

//# sourceMappingURL=permissions.js.map

// Generated by CoffeeScript 1.9.2
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

Annotator.Plugin.AnnotateItPermissions = (function(superClass) {
  extend(AnnotateItPermissions, superClass);

  function AnnotateItPermissions() {
    this._setAuthFromToken = bind(this._setAuthFromToken, this);
    this.updateAnnotationPermissions = bind(this.updateAnnotationPermissions, this);
    this.updatePermissionsField = bind(this.updatePermissionsField, this);
    this.addFieldsToAnnotation = bind(this.addFieldsToAnnotation, this);
    return AnnotateItPermissions.__super__.constructor.apply(this, arguments);
  }

  AnnotateItPermissions.prototype.options = {
    showViewPermissionsCheckbox: false,
    showEditPermissionsCheckbox: false,
    groups: {
      world: 'group:__world__',
      authenticated: 'group:__authenticated__',
      consumer: 'group:__consumer__'
    },
    userId: function(user) {
      return user.userId;
    },
    userString: function(user) {
      return user.userId;
    },
    userAuthorize: function(action, annotation, user) {
      var action_field, permissions, ref, ref1, ref2, ref3;
      permissions = annotation.permissions || {};
      action_field = permissions[action] || [];
      if (ref = this.groups.world, indexOf.call(action_field, ref) >= 0) {
        return true;
      } else if ((user != null) && (user.userId != null) && (user.consumerKey != null)) {
        if (user.userId === annotation.userid && user.consumerKey === annotation.consumer) {
          return true;
        } else if (ref1 = this.groups.authenticated, indexOf.call(action_field, ref1) >= 0) {
          return true;
        } else if (user.consumerKey === annotation.consumer && (ref2 = this.groups.consumer, indexOf.call(action_field, ref2) >= 0)) {
          return true;
        } else if (user.consumerKey === annotation.consumer && (ref3 = user.userId, indexOf.call(action_field, ref3) >= 0)) {
          return true;
        } else if (user.consumerKey === annotation.consumer && user.admin) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    permissions: {
      'read': ['group:__world__'],
      'update': [],
      'delete': [],
      'admin': []
    }
  };

  AnnotateItPermissions.prototype.addFieldsToAnnotation = function(annotation) {
    if (annotation) {
      annotation.permissions = this.options.permissions;
      if (this.user) {
        annotation.userid = this.user.userId;
        return annotation.consumer = this.user.consumerKey;
      }
    }
  };

  AnnotateItPermissions.prototype.updatePermissionsField = function(action, field, annotation) {
    var input;
    field = $(field).show();
    input = field.find('input').removeAttr('disabled');
    if (!this.authorize('admin', annotation)) {
      field.hide();
    }
    if (this.user && this.authorize(action, annotation || {}, {
      userId: '__nonexistentuser__',
      consumerKey: this.user.consumerKey
    })) {
      return input.attr('checked', 'checked');
    } else {
      return input.removeAttr('checked');
    }
  };

  AnnotateItPermissions.prototype.updateAnnotationPermissions = function(type, field, annotation) {
    var dataKey;
    if (!annotation.permissions) {
      annotation.permissions = this.options.permissions;
    }
    dataKey = type + '-permissions';
    if ($(field).find('input').is(':checked')) {
      return annotation.permissions[type] = [type === 'read' ? this.options.groups.world : this.options.groups.consumer];
    } else {
      return annotation.permissions[type] = [];
    }
  };

  AnnotateItPermissions.prototype._setAuthFromToken = function(token) {
    return this.setUser(token);
  };

  return AnnotateItPermissions;

})(Annotator.Plugin.Permissions);

//# sourceMappingURL=annotateitpermissions.js.map

// Generated by CoffeeScript 1.9.2
var base64Decode, base64UrlDecode, createDateFromISO8601, parseToken,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

createDateFromISO8601 = function(string) {
  var d, date, offset, ref, regexp, time;
  regexp = "([0-9]{4})(-([0-9]{2})(-([0-9]{2})" + "(T([0-9]{2}):([0-9]{2})(:([0-9]{2})(\\.([0-9]+))?)?" + "(Z|(([-+])([0-9]{2}):([0-9]{2})))?)?)?)?";
  d = string.match(new RegExp(regexp));
  offset = 0;
  date = new Date(d[1], 0, 1);
  if (d[3]) {
    date.setMonth(d[3] - 1);
  }
  if (d[5]) {
    date.setDate(d[5]);
  }
  if (d[7]) {
    date.setHours(d[7]);
  }
  if (d[8]) {
    date.setMinutes(d[8]);
  }
  if (d[10]) {
    date.setSeconds(d[10]);
  }
  if (d[12]) {
    date.setMilliseconds(Number("0." + d[12]) * 1000);
  }
  if (d[14]) {
    offset = (Number(d[16]) * 60) + Number(d[17]);
    offset *= (ref = d[15] === '-') != null ? ref : {
      1: -1
    };
  }
  offset -= date.getTimezoneOffset();
  time = Number(date) + (offset * 60 * 1000);
  date.setTime(Number(time));
  return date;
};

base64Decode = function(data) {
  var ac, b64, bits, dec, h1, h2, h3, h4, i, o1, o2, o3, tmp_arr;
  if (typeof atob !== "undefined" && atob !== null) {
    return atob(data);
  } else {
    b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    i = 0;
    ac = 0;
    dec = "";
    tmp_arr = [];
    if (!data) {
      return data;
    }
    data += '';
    while (i < data.length) {
      h1 = b64.indexOf(data.charAt(i++));
      h2 = b64.indexOf(data.charAt(i++));
      h3 = b64.indexOf(data.charAt(i++));
      h4 = b64.indexOf(data.charAt(i++));
      bits = h1 << 18 | h2 << 12 | h3 << 6 | h4;
      o1 = bits >> 16 & 0xff;
      o2 = bits >> 8 & 0xff;
      o3 = bits & 0xff;
      if (h3 === 64) {
        tmp_arr[ac++] = String.fromCharCode(o1);
      } else if (h4 === 64) {
        tmp_arr[ac++] = String.fromCharCode(o1, o2);
      } else {
        tmp_arr[ac++] = String.fromCharCode(o1, o2, o3);
      }
    }
    return tmp_arr.join('');
  }
};

base64UrlDecode = function(data) {
  var i, j, m, ref;
  m = data.length % 4;
  if (m !== 0) {
    for (i = j = 0, ref = 4 - m; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
      data += '=';
    }
  }
  data = data.replace(/-/g, '+');
  data = data.replace(/_/g, '/');
  return base64Decode(data);
};

parseToken = function(token) {
  var head, payload, ref, sig;
  ref = token.split('.'), head = ref[0], payload = ref[1], sig = ref[2];
  return JSON.parse(base64UrlDecode(payload));
};

Annotator.Plugin.Auth = (function(superClass) {
  extend(Auth, superClass);

  Auth.prototype.options = {
    token: null,
    tokenUrl: '/auth/token',
    autoFetch: true
  };

  function Auth(element, options) {
    Auth.__super__.constructor.apply(this, arguments);
    this.waitingForToken = [];
    if (this.options.token) {
      this.setToken(this.options.token);
    } else {
      this.requestToken();
    }
  }

  Auth.prototype.requestToken = function() {
    this.requestInProgress = true;
    return $.ajax({
      url: this.options.tokenUrl,
      dataType: 'text',
      xhrFields: {
        withCredentials: true
      }
    }).done((function(_this) {
      return function(data, status, xhr) {
        return _this.setToken(data);
      };
    })(this)).fail((function(_this) {
      return function(xhr, status, err) {
        var msg;
        msg = Annotator._t("Couldn't get auth token:");
        console.error(msg + " " + err, xhr);
        return Annotator.showNotification(msg + " " + xhr.responseText, Annotator.Notification.ERROR);
      };
    })(this)).always((function(_this) {
      return function() {
        return _this.requestInProgress = false;
      };
    })(this));
  };

  Auth.prototype.setToken = function(token) {
    var results;
    this.token = token;
    this._unsafeToken = parseToken(token);
    if (this.haveValidToken()) {
      if (this.options.autoFetch) {
        this.refreshTimeout = setTimeout(((function(_this) {
          return function() {
            return _this.requestToken();
          };
        })(this)), (this.timeToExpiry() - 2) * 1000);
      }
      this.updateHeaders();
      results = [];
      while (this.waitingForToken.length > 0) {
        results.push(this.waitingForToken.pop()(this._unsafeToken));
      }
      return results;
    } else {
      console.warn(Annotator._t("Didn't get a valid token."));
      if (this.options.autoFetch) {
        console.warn(Annotator._t("Getting a new token in 10s."));
        return setTimeout(((function(_this) {
          return function() {
            return _this.requestToken();
          };
        })(this)), 10 * 1000);
      }
    }
  };

  Auth.prototype.haveValidToken = function() {
    var allFields;
    allFields = this._unsafeToken && this._unsafeToken.issuedAt && this._unsafeToken.ttl && this._unsafeToken.consumerKey;
    if (allFields && this.timeToExpiry() > 0) {
      return true;
    } else {
      return false;
    }
  };

  Auth.prototype.timeToExpiry = function() {
    var expiry, issue, now, timeToExpiry;
    now = new Date().getTime() / 1000;
    issue = createDateFromISO8601(this._unsafeToken.issuedAt).getTime() / 1000;
    expiry = issue + this._unsafeToken.ttl;
    timeToExpiry = expiry - now;
    if (timeToExpiry > 0) {
      return timeToExpiry;
    } else {
      return 0;
    }
  };

  Auth.prototype.updateHeaders = function() {
    var current;
    current = this.element.data('annotator:headers');
    return this.element.data('annotator:headers', $.extend(current, {
      'x-annotator-auth-token': this.token
    }));
  };

  Auth.prototype.withToken = function(callback) {
    if (callback == null) {
      return;
    }
    if (this.haveValidToken()) {
      return callback(this._unsafeToken);
    } else {
      this.waitingForToken.push(callback);
      if (!this.requestInProgress) {
        return this.requestToken();
      }
    }
  };

  return Auth;

})(Annotator.Plugin);

//# sourceMappingURL=auth.js.map

// Generated by CoffeeScript 1.9.2
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Annotator.Plugin.Tags = (function(superClass) {
  extend(Tags, superClass);

  function Tags() {
    this.setAnnotationTags = bind(this.setAnnotationTags, this);
    this.updateField = bind(this.updateField, this);
    return Tags.__super__.constructor.apply(this, arguments);
  }

  Tags.prototype.options = {
    parseTags: function(string) {
      var tags;
      string = $.trim(string);
      tags = [];
      if (string) {
        tags = string.split(/\s+/);
      }
      return tags;
    },
    stringifyTags: function(array) {
      return array.join(" ");
    }
  };

  Tags.prototype.field = null;

  Tags.prototype.input = null;

  Tags.prototype.pluginInit = function() {
    if (!Annotator.supported()) {
      return;
    }
    this.field = this.annotator.editor.addField({
      label: Annotator._t('Add some tags here') + '\u2026',
      load: this.updateField,
      submit: this.setAnnotationTags
    });
    this.annotator.viewer.addField({
      load: this.updateViewer
    });
    if (this.annotator.plugins.Filter) {
      this.annotator.plugins.Filter.addFilter({
        label: Annotator._t('Tag'),
        property: 'tags',
        isFiltered: Annotator.Plugin.Tags.filterCallback
      });
    }
    return this.input = $(this.field).find(':input');
  };

  Tags.prototype.parseTags = function(string) {
    return this.options.parseTags(string);
  };

  Tags.prototype.stringifyTags = function(array) {
    return this.options.stringifyTags(array);
  };

  Tags.prototype.updateField = function(field, annotation) {
    var value;
    value = '';
    if (annotation.tags) {
      value = this.stringifyTags(annotation.tags);
    }
    return this.input.val(value);
  };

  Tags.prototype.setAnnotationTags = function(field, annotation) {
    return annotation.tags = this.parseTags(this.input.val());
  };

  Tags.prototype.updateViewer = function(field, annotation) {
    field = $(field);
    if (annotation.tags && $.isArray(annotation.tags) && annotation.tags.length) {
      return field.addClass('annotator-tags').html(function() {
        var string;
        return string = $.map(annotation.tags, function(tag) {
          return '<span class="annotator-tag">' + Annotator.Util.escape(tag) + '</span>';
        }).join(' ');
      });
    } else {
      return field.remove();
    }
  };

  return Tags;

})(Annotator.Plugin);

Annotator.Plugin.Tags.filterCallback = function(input, tags) {
  var i, j, keyword, keywords, len, len1, matches, tag;
  if (tags == null) {
    tags = [];
  }
  matches = 0;
  keywords = [];
  if (input) {
    keywords = input.split(/\s+/g);
    for (i = 0, len = keywords.length; i < len; i++) {
      keyword = keywords[i];
      if (tags.length) {
        for (j = 0, len1 = tags.length; j < len1; j++) {
          tag = tags[j];
          if (tag.indexOf(keyword) !== -1) {
            matches += 1;
          }
        }
      }
    }
  }
  return matches === keywords.length;
};

//# sourceMappingURL=tags.js.map

// Generated by CoffeeScript 1.9.2
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Annotator.Plugin.Unsupported = (function(superClass) {
  extend(Unsupported, superClass);

  function Unsupported() {
    return Unsupported.__super__.constructor.apply(this, arguments);
  }

  Unsupported.prototype.options = {
    message: Annotator._t("Sorry your current browser does not support the Annotator")
  };

  Unsupported.prototype.pluginInit = function() {
    if (!Annotator.supported()) {
      return $((function(_this) {
        return function() {
          Annotator.showNotification(_this.options.message);
          if ((window.XMLHttpRequest === void 0) && (ActiveXObject !== void 0)) {
            return $('html').addClass('ie6');
          }
        };
      })(this));
    }
  };

  return Unsupported;

})(Annotator.Plugin);

//# sourceMappingURL=unsupported.js.map

// Generated by CoffeeScript 1.9.2
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Annotator.Plugin.Filter = (function(superClass) {
  extend(Filter, superClass);

  Filter.prototype.events = {
    ".annotator-filter-property input focus": "_onFilterFocus",
    ".annotator-filter-property input blur": "_onFilterBlur",
    ".annotator-filter-property input keyup": "_onFilterKeyup",
    ".annotator-filter-previous click": "_onPreviousClick",
    ".annotator-filter-next click": "_onNextClick",
    ".annotator-filter-clear click": "_onClearClick"
  };

  Filter.prototype.classes = {
    active: 'annotator-filter-active',
    hl: {
      hide: 'annotator-hl-filtered',
      active: 'annotator-hl-active'
    }
  };

  Filter.prototype.html = {
    element: "<div class=\"annotator-filter\">\n  <strong>" + Annotator._t('Navigate:') + "</strong>\n<span class=\"annotator-filter-navigation\">\n  <button class=\"annotator-filter-previous\">" + Annotator._t('Previous') + "</button>\n<button class=\"annotator-filter-next\">" + Annotator._t('Next') + "</button>\n</span>\n<strong>" + Annotator._t('Filter by:') + "</strong>\n</div>",
    filter: "<span class=\"annotator-filter-property\">\n  <label></label>\n  <input/>\n  <button class=\"annotator-filter-clear\">" + Annotator._t('Clear') + "</button>\n</span>"
  };

  Filter.prototype.options = {
    appendTo: 'body',
    filters: [],
    addAnnotationFilter: true,
    isFiltered: function(input, property) {
      var i, keyword, len, ref;
      if (!(input && property)) {
        return false;
      }
      ref = input.split(/\s+/);
      for (i = 0, len = ref.length; i < len; i++) {
        keyword = ref[i];
        if (property.indexOf(keyword) === -1) {
          return false;
        }
      }
      return true;
    }
  };

  function Filter(element, options) {
    this._onPreviousClick = bind(this._onPreviousClick, this);
    this._onNextClick = bind(this._onNextClick, this);
    this._onFilterKeyup = bind(this._onFilterKeyup, this);
    this._onFilterBlur = bind(this._onFilterBlur, this);
    this._onFilterFocus = bind(this._onFilterFocus, this);
    this.updateHighlights = bind(this.updateHighlights, this);
    var base;
    element = $(this.html.element).appendTo((options != null ? options.appendTo : void 0) || this.options.appendTo);
    Filter.__super__.constructor.call(this, element, options);
    (base = this.options).filters || (base.filters = []);
    this.filter = $(this.html.filter);
    this.filters = [];
    this.current = 0;
  }

  Filter.prototype.pluginInit = function() {
    var filter, i, len, ref;
    ref = this.options.filters;
    for (i = 0, len = ref.length; i < len; i++) {
      filter = ref[i];
      this.addFilter(filter);
    }
    this.updateHighlights();
    this._setupListeners()._insertSpacer();
    if (this.options.addAnnotationFilter === true) {
      return this.addFilter({
        label: Annotator._t('Annotation'),
        property: 'text'
      });
    }
  };

  Filter.prototype.destroy = function() {
    var currentMargin, html;
    Filter.__super__.destroy.apply(this, arguments);
    html = $('html');
    currentMargin = parseInt(html.css('padding-top'), 10) || 0;
    html.css('padding-top', currentMargin - this.element.outerHeight());
    return this.element.remove();
  };

  Filter.prototype._insertSpacer = function() {
    var currentMargin, html;
    html = $('html');
    currentMargin = parseInt(html.css('padding-top'), 10) || 0;
    html.css('padding-top', currentMargin + this.element.outerHeight());
    return this;
  };

  Filter.prototype._setupListeners = function() {
    var event, events, i, len;
    events = ['annotationsLoaded', 'annotationCreated', 'annotationUpdated', 'annotationDeleted'];
    for (i = 0, len = events.length; i < len; i++) {
      event = events[i];
      this.annotator.subscribe(event, this.updateHighlights);
    }
    return this;
  };

  Filter.prototype.addFilter = function(options) {
    var f, filter;
    filter = $.extend({
      label: '',
      property: '',
      isFiltered: this.options.isFiltered
    }, options);
    if (!((function() {
      var i, len, ref, results;
      ref = this.filters;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        f = ref[i];
        if (f.property === filter.property) {
          results.push(f);
        }
      }
      return results;
    }).call(this)).length) {
      filter.id = 'annotator-filter-' + filter.property;
      filter.annotations = [];
      filter.element = this.filter.clone().appendTo(this.element);
      filter.element.find('label').html(filter.label).attr('for', filter.id);
      filter.element.find('input').attr({
        id: filter.id,
        placeholder: Annotator._t('Filter by ') + filter.label + '\u2026'
      });
      filter.element.find('button').hide();
      filter.element.data('filter', filter);
      this.filters.push(filter);
    }
    return this;
  };

  Filter.prototype.updateFilter = function(filter) {
    var annotation, annotations, i, input, len, property, ref;
    filter.annotations = [];
    this.updateHighlights();
    this.resetHighlights();
    input = $.trim(filter.element.find('input').val());
    if (input) {
      annotations = this.highlights.map(function() {
        return $(this).data('annotation');
      });
      ref = $.makeArray(annotations);
      for (i = 0, len = ref.length; i < len; i++) {
        annotation = ref[i];
        property = annotation[filter.property];
        if (filter.isFiltered(input, property)) {
          filter.annotations.push(annotation);
        }
      }
      return this.filterHighlights();
    }
  };

  Filter.prototype.updateHighlights = function() {
    this.highlights = this.annotator.element.find('.annotator-hl:visible');
    return this.filtered = this.highlights.not(this.classes.hl.hide);
  };

  Filter.prototype.filterHighlights = function() {
    var activeFilters, annotation, annotations, filtered, highlights, i, index, len, ref, uniques;
    activeFilters = $.grep(this.filters, function(filter) {
      return !!filter.annotations.length;
    });
    filtered = ((ref = activeFilters[0]) != null ? ref.annotations : void 0) || [];
    if (activeFilters.length > 1) {
      annotations = [];
      $.each(activeFilters, function() {
        return $.merge(annotations, this.annotations);
      });
      uniques = [];
      filtered = [];
      $.each(annotations, function() {
        if ($.inArray(this, uniques) === -1) {
          return uniques.push(this);
        } else {
          return filtered.push(this);
        }
      });
    }
    highlights = this.highlights;
    for (index = i = 0, len = filtered.length; i < len; index = ++i) {
      annotation = filtered[index];
      highlights = highlights.not(annotation.highlights);
    }
    highlights.addClass(this.classes.hl.hide);
    this.filtered = this.highlights.not(this.classes.hl.hide);
    return this;
  };

  Filter.prototype.resetHighlights = function() {
    this.highlights.removeClass(this.classes.hl.hide);
    this.filtered = this.highlights;
    return this;
  };

  Filter.prototype._onFilterFocus = function(event) {
    var input;
    input = $(event.target);
    input.parent().addClass(this.classes.active);
    return input.next('button').show();
  };

  Filter.prototype._onFilterBlur = function(event) {
    var input;
    if (!event.target.value) {
      input = $(event.target);
      input.parent().removeClass(this.classes.active);
      return input.next('button').hide();
    }
  };

  Filter.prototype._onFilterKeyup = function(event) {
    var filter;
    filter = $(event.target).parent().data('filter');
    if (filter) {
      return this.updateFilter(filter);
    }
  };

  Filter.prototype._findNextHighlight = function(previous) {
    var active, annotation, current, index, next, offset, operator, resetOffset;
    if (!this.highlights.length) {
      return this;
    }
    offset = previous ? 0 : -1;
    resetOffset = previous ? -1 : 0;
    operator = previous ? 'lt' : 'gt';
    active = this.highlights.not('.' + this.classes.hl.hide);
    current = active.filter('.' + this.classes.hl.active);
    if (!current.length) {
      current = active.eq(offset);
    }
    annotation = current.data('annotation');
    index = active.index(current[0]);
    next = active.filter(":" + operator + "(" + index + ")").not(annotation.highlights).eq(resetOffset);
    if (!next.length) {
      next = active.eq(resetOffset);
    }
    return this._scrollToHighlight(next.data('annotation').highlights);
  };

  Filter.prototype._onNextClick = function(event) {
    return this._findNextHighlight();
  };

  Filter.prototype._onPreviousClick = function(event) {
    return this._findNextHighlight(true);
  };

  Filter.prototype._scrollToHighlight = function(highlight) {
    highlight = $(highlight);
    this.highlights.removeClass(this.classes.hl.active);
    highlight.addClass(this.classes.hl.active);
    return $('html, body').animate({
      scrollTop: highlight.offset().top - (this.element.height() + 20)
    }, 150);
  };

  Filter.prototype._onClearClick = function(event) {
    return $(event.target).prev('input').val('').keyup().blur();
  };

  return Filter;

})(Annotator.Plugin);

//# sourceMappingURL=filter.js.map

(function() {
    var __bind = function(fn, me) {
            return function() {
                return fn.apply(me, arguments)
            }
        },
        __hasProp = {}.hasOwnProperty,
        __extends = function(child, parent) {
            for (var key in parent) {
                if (__hasProp.call(parent, key)) child[key] = parent[key]
            }

            function ctor() {
                this.constructor = child
            }
            ctor.prototype = parent.prototype;
            child.prototype = new ctor;
            child.__super__ = parent.prototype;
            return child
        };
    Annotator.Plugin.Touch = function(_super) {
        var jQuery, _t;
        __extends(Touch, _super);
        _t = Annotator._t;
        jQuery = Annotator.$;
        Touch.states = {
            ON: "on",
            OFF: "off"
        };
        Touch.prototype.template = '<div class="annotator-touch-widget annotator-touch-controls annotator-touch-hide">\n  <div class="annotator-touch-widget-inner">\n    <a class="annotator-button annotator-add annotator-focus">' + _t("Annotate") + '</a>\n<a class="annotator-button annotator-touch-toggle" data-state="off">' + _t("Start Annotating") + "</a>\n  </div>\n</div>";
        Touch.prototype.classes = {
            hide: "annotator-touch-hide"
        };
        Touch.prototype.options = {
            force: false,
            useHighlighter: false
        };

        function Touch(element, options) {
            this._onDocumentTap = __bind(this._onDocumentTap, this);
            this._onHighlightTap = __bind(this._onHighlightTap, this);
            this._onAdderTap = __bind(this._onAdderTap, this);
            this._onToggleTap = __bind(this._onToggleTap, this);
            this._onSelection = __bind(this._onSelection, this);
            this._watchForSelection = __bind(this._watchForSelection, this);
            Touch.__super__.constructor.apply(this, arguments);
            this.utils = Annotator.Plugin.Touch.utils;
            this.selection = null;
            this.document = jQuery(document)
        }
        Touch.prototype.pluginInit = function() {
            if (!(Annotator.supported() && (this.options.force || Touch.isTouchDevice()))) {
                return
            }
            //alert("init");
            this._setupControls();
            if (this.options.useHighlighter) {
                this.showControls();
                this.highlighter = new Highlighter({
                    root: this.element[0],
                    prefix: "annotator-selection",
                    enable: false,
                    highlightStyles: true
                })
            }
            this.document.delegate(".annotator-hl", "tap", {
                preventDefault: false
            }, this._onHighlightTap);
            this.subscribe("selection", this._onSelection);
            this._unbindAnnotatorEvents();
            this._setupAnnotatorEvents();
            return this._watchForSelection()
        };
        Touch.prototype.pluginDestroy = function() {
            if (this.controls) {
                this.controls.remove()
            }
            if (this.highlighter) {
                this.highlighter.disable()
            }
            if (this.annotator) {
                return this.annotator.editor.unsubscribe("hide", this._watchForSelection)
            }
        };
        Touch.prototype.startAnnotating = function() {
            if (this.highlighter) {
                this.highlighter.enable()
            }
            this.toggle.attr("data-state", Touch.states.ON);
            this.toggle.html("Stop Annotating");
            return this
        };
        Touch.prototype.stopAnnotating = function() {
            if (this.highlighter) {
                this.highlighter.disable()
            }
            this.toggle.attr("data-state", Touch.states.OFF);
            this.toggle.html("Start Annotating");
            return this
        };
        Touch.prototype.isAnnotating = function() {
            var usingHighlighter;
            usingHighlighter = this.options.useHighlighter;
            return !usingHighlighter || this.toggle.attr("data-state") === Touch.states.ON
        };
        Touch.prototype.showEditor = function(annotation) {
            this.annotator.showEditor(annotation, {});
            this.hideControls();
            return this
        };
        Touch.prototype.showControls = function() {
            this.controls.removeClass(this.classes.hide);
            return this
        };
        Touch.prototype.hideControls = function() {
            if (!this.options.useHighlighter) {
                this.controls.addClass(this.classes.hide)
            }
            return this
        };
        Touch.prototype._setupControls = function() {
            this.annotator.adder.remove();
            this.controls = jQuery(this.template).appendTo("body");
            this.adder = this.controls.find(".annotator-add");
            this.adder.bind("tap", {
                onTapDown: function(event) {
                    return event.stopPropagation()
                }
            }, this._onAdderTap);
            this.toggle = this.controls.find(".annotator-touch-toggle");
            this.toggle.bind({
                tap: this._onToggleTap
            });
            if (!this.options.useHighlighter) {
                return this.toggle.hide()
            }
        };
        Touch.prototype._setupAnnotatorEvents = function() {
            this.editor = new Touch.Editor(this.annotator.editor);
            this.viewer = new Touch.Viewer(this.annotator.viewer);
            this.annotator.editor.on("show", function(_this) {
                return function() {
                    _this._clearWatchForSelection();
                    _this.annotator.onAdderMousedown();
                    if (_this.highlighter) {
                        return _this.highlighter.disable()
                    }
                }
            }(this));
            this.annotator.viewer.on("show", function(_this) {
                return function() {
                    if (_this.highlighter) {
                        return _this.highlighter.disable()
                    }
                }
            }(this));
            this.annotator.editor.on("hide", function(_this) {
                return function() {
                    return _this.utils.nextTick(function() {
                        if (_this.highlighter) {
                            _this.highlighter.enable().deselect()
                        }
                        return _this._watchForSelection()
                    })
                }
            }(this));
            return this.annotator.viewer.on("hide", function(_this) {
                return function() {
                    return _this.utils.nextTick(function() {
                        if (_this.highlighter) {
                            return _this.highlighter.enable().deselect()
                        }
                    })
                }
            }(this))
        };
        Touch.prototype._unbindAnnotatorEvents = function() {
            this.document.unbind({
                mouseup: this.annotator.checkForEndSelection,
                mousedown: this.annotator.checkForStartSelection
            });
            return this.element.unbind("click mousedown mouseover mouseout")
        };
        Touch.prototype._watchForSelection = function() {
            var interval, start, step;
            if (this.timer) {
                return
            }
            interval = Touch.isAndroid() ? 300 : 1e3 / 60;
            start = (new Date).getTime();
            step = function(_this) {
                return function() {
                    var progress;
                    progress = (new Date).getTime() - start;
                    if (progress > interval) {
                        start = (new Date).getTime();
                        _this._checkSelection()
                    }
                    return _this.timer = _this.utils.requestAnimationFrame.call(window, step)
                }
            }(this);
            return step()
        };
        Touch.prototype._clearWatchForSelection = function() {
            this.utils.cancelAnimationFrame.call(window, this.timer);
            return this.timer = null
        };
        Touch.prototype._checkSelection = function() {
            var previous, selection, string;
            selection = window.getSelection();
            previous = this.selectionString;
            string = jQuery.trim(selection + "");
            if (selection.rangeCount && string !== this.selectionString) {
                this.range = selection.getRangeAt(0);
                this.selectionString = string
            }
            if (selection.rangeCount === 0 || this.range && this.range.collapsed) {
                this.range = null;
                this.selectionString = ""
            }
            if (this.selectionString !== previous) {
                return this.publish("selection", [this.range, this])
            }
        };
        Touch.prototype._onSelection = function() {
            if (this.isAnnotating() && this.range && this._isValidSelection(this.range)) {
                var isScrollDoc;
                try {
                    if(window.parent.myReader && window.parent.myReader.readerOptions && window.parent.myReader.readerOptions.config) {
                        isScrollDoc = window.parent.myReader.readerOptions.config.readerSettings.isScrollDoc;
                    }
                } catch(error) {
                }
                var docMode = isScrollDoc ? true : false;

                //in docmode add height of scrolled content
                if(docMode) {
                    height = $(parent.document.getElementById('epub-reader-container')).scrollTop() + 15;
                    this.adder.parent().parent().css("top",height);
                }
                this.adder.removeAttr("disabled");
                return this.showControls()
            } else {
                this.adder.attr("disabled", "");
                return this.hideControls()
            }
        };
        Touch.prototype._isValidSelection = function(range) {
            var inElement, isStartOffsetValid, isValidEnd, isValidStart;
            inElement = function(node) {
                return jQuery(node).parents(".annotator-wrapper").length
            };
            isStartOffsetValid = range.startOffset < range.startContainer.length;
            isValidStart = isStartOffsetValid && inElement(range.startContainer);
            isValidEnd = range.endOffset > 0 && inElement(range.endContainer);
            return isValidStart || isValidEnd
        };
        Touch.prototype._onToggleTap = function(event) {
            event.preventDefault();
            if (this.isAnnotating()) {
                return this.stopAnnotating()
            } else {
                return this.startAnnotating()
            }
        };
        Touch.prototype._onAdderTap = function(event) {
            var browserRange, onAnnotationCreated, range;
            event.preventDefault();
            if (this.range) {
                browserRange = new Annotator.Range.BrowserRange(this.range);
                range = browserRange.normalize().limit(this.element[0]);
                if (range && !this.annotator.isAnnotator(range.commonAncestor)) {
                    onAnnotationCreated = function(_this) {
                        return function(annotation) {
                            _this.annotator.unsubscribe("beforeAnnotationCreated", onAnnotationCreated);
                            annotation.quote = range.toString();
                            return annotation.ranges = [range]
                        }
                    }(this);
                    this.annotator.subscribe("beforeAnnotationCreated", onAnnotationCreated);
                    return this.annotator.onAdderClick(event)
                }
            }
        };
        Touch.prototype._onHighlightTap = function(event) {
            var clickable, original;
            clickable = jQuery(event.currentTarget).parents().filter(function() {
                return jQuery(this).is("a, [data-annotator-clickable]")
            });
            if (clickable.length) {
                return
            }
            if (jQuery.contains(this.element[0], event.currentTarget)) {
                original = event.originalEvent;
                if (original && original.touches) {
                    event.pageX = original.touches[0].pageX;
                    event.pageY = original.touches[0].pageY
                }
                if (this.annotator.viewer.isShown()) {
                    this.annotator.viewer.hide()
                }
                this.annotator.onHighlightMouseover(event);
                this.document.unbind("tap", this._onDocumentTap);
                return this.document.bind("tap", {
                    preventDefault: false
                }, this._onDocumentTap)
            }
        };
        Touch.prototype._onDocumentTap = function(event) {
            if (!this.annotator.isAnnotator(event.target)) {
                this.annotator.viewer.hide()
            }
            if (!this.annotator.viewer.isShown()) {
                return this.document.unbind("tap", this._onDocumentTap)
            }
        };
        Touch.isTouchDevice = function() {
            return "ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch
        };
        Touch.isAndroid = function() {
            return /Android/i.test(window.navigator.userAgent)
        };
        return Touch
    }(Annotator.Plugin);
    Annotator.Plugin.Touch.Editor = function(_super) {
        var Touch, jQuery, _t;
        __extends(Editor, _super);
        _t = Annotator._t;
        jQuery = Annotator.$;
        Touch = Annotator.Plugin.Touch;
        Editor.prototype.events = {
            click: "_onOverlayTap",
            ".annotator-save tap": "_onSubmit",
            ".annotator-cancel tap": "_onCancel",
            ".annotator-quote-toggle tap": "_onExpandTap"
        };
        Editor.prototype.classes = {
            expand: "annotator-touch-expand"
        };
        Editor.prototype.templates = {
            quote: '<button class="annotator-quote-toggle">' + _t("expand") + '</button>\n<span class="quote"></span>'
        };

        function Editor(editor, options) {
            this.editor = editor;
            this._onOverlayTap = __bind(this._onOverlayTap, this);
            this._onCancel = __bind(this._onCancel, this);
            this._onSubmit = __bind(this._onSubmit, this);
            this._onExpandTap = __bind(this._onExpandTap, this);
            this._triggerAndroidRedraw = __bind(this._triggerAndroidRedraw, this);
            Editor.__super__.constructor.call(this, this.editor.element[0], options);
            this.element.addClass("annotator-touch-editor");
            this.element.wrapInner('<div class="annotator-touch-widget" />');
            this.element.find("form").addClass("annotator-touch-widget-inner");
            this.element.find(".annotator-controls a").addClass("annotator-button");
            this.element.undelegate("textarea", "keydown");
            this.on("hide", function(_this) {
                return function() {
                    return _this.element.find(":focus").blur()
                }
            }(this));
            /*this._setupQuoteField();*/
            this._setupAndroidRedrawHack()
        }
        Editor.prototype.showQuote = function() {
            this.quote.addClass(this.classes.expand);
            this.quote.find("button").text(_t("Collapse"));
            return this
        };
        Editor.prototype.hideQuote = function() {
            this.quote.removeClass(this.classes.expand);
            this.quote.find("button").text(_t("Expand"));
            return this
        };
        Editor.prototype.isQuoteHidden = function() {
            return !this.quote.hasClass(this.classes.expand)
        };
        Editor.prototype._setupQuoteField = function() {
            this.quote = jQuery(this.editor.addField({
                id: "quote",
                load: function(_this) {
                    return function(field, annotation) {
                        _this.hideQuote();
                        _this.quote.find("span").html(Annotator.Util.escape(annotation.quote || ""));
                        return _this.quote.find("button").toggle(_this._isTruncated())
                    }
                }(this)
            }));
            this.quote.empty().addClass("annotator-item-quote");
            return this.quote.append(this.templates.quote)
        };
        Editor.prototype._setupAndroidRedrawHack = function() {
            var check, timer;
            if (Touch.isAndroid()) {
                timer = null;
                check = function(_this) {
                    return function() {
                        timer = null;
                        return _this._triggerAndroidRedraw()
                    }
                }(this);
                return jQuery(window).bind("scroll", function() {
                    if (!timer) {
                        return timer = setTimeout(check, 100)
                    }
                })
            }
        };
        Editor.prototype._triggerAndroidRedraw = function() {
            if (!this._input) {
                this._input = this.element.find(":input:first")
            }
            if (!this._default) {
                this._default = parseFloat(this._input.css("padding-top"))
            }
            this._multiplier = (this._multiplier || 1) * -1;
            this._input[0].style.paddingTop = this._default + this._multiplier + "px";
            return this._input[0].style.paddingTop = this._default - this._multiplier + "px"
        };
        Editor.prototype._isTruncated = function() {
            var expandedHeight, isHidden, truncatedHeight;
            isHidden = this.isQuoteHidden();
            if (!isHidden) {
                this.hideQuote()
            }
            truncatedHeight = this.quote.height();
            this.showQuote();
            expandedHeight = this.quote.height();
            if (isHidden) {
                this.hideQuote()
            } else {
                this.showQuote()
            }
            return expandedHeight > truncatedHeight
        };
        Editor.prototype._onExpandTap = function(event) {
            event.preventDefault();
            event.stopPropagation();
            if (this.isQuoteHidden()) {
                return this.showQuote()
            } else {
                return this.hideQuote()
            }
        };
        Editor.prototype._onSubmit = function(event) {
            event.preventDefault();
            return this.editor.submit()
        };
        Editor.prototype._onCancel = function(event) {
            event.preventDefault();
            return this.editor.hide()
        };
        Editor.prototype._onOverlayTap = function(event) {
            if (event.target === this.element[0]) {
                return this.editor.hide()
            }
        };
        return Editor
    }(Annotator.Delegator);
    jQuery.event.special.tap = {
        add: function(eventHandler) {
            var context, data, onTapEnd, onTapStart;
            data = eventHandler.data = eventHandler.data || {};
            context = this;
            onTapStart = function(event) {
                if (data.preventDefault !== false) {
                    event.preventDefault()
                }
                if (data.onTapDown) {
                    data.onTapDown.apply(this, arguments)
                }
                data.event = event;
                data.touched = setTimeout(function() {
                    return data.touched = null
                }, data.timeout || 300);
                return jQuery(document).bind({
                    touchend: onTapEnd,
                    mouseup: onTapEnd
                })
            };
            onTapEnd = function(event) {
                var handler;
                if (data.touched != null) {
                    clearTimeout(data.touched);
                    if (event.target === context || jQuery.contains(context, event.target)) {
                        handler = eventHandler.origHandler || eventHandler.handler;
                        handler.call(this, data.event)
                    }
                    data.touched = null
                }
                if (data.onTapUp) {
                    data.onTapUp.apply(this, arguments)
                }
                return jQuery(document).unbind({
                    touchstart: onTapEnd,
                    mousedown: onTapEnd
                })
            };
            data.tapHandlers = {
                touchstart: onTapStart,
                mousedown: onTapStart
            };
            if (eventHandler.selector) {
                return jQuery(context).delegate(eventHandler.selector, data.tapHandlers)
            } else {
                return jQuery(context).bind(data.tapHandlers)
            }
        },
        remove: function(eventHandler) {
            return jQuery(this).unbind(eventHandler.data.tapHandlers)
        }
    };
    Annotator.Delegator.natives.push("touchstart", "touchmove", "touchend", "tap");
    Annotator.Plugin.Touch.utils = function() {
        var cancelAnimationFrame, lastTime, prefix, requestAnimationFrame, vendors, _i, _len;
        vendors = ["ms", "moz", "webkit", "o"];
        requestAnimationFrame = window.requestAnimationFrame;
        cancelAnimationFrame = window.cancelAnimationFrame;
        for (_i = 0, _len = vendors.length; _i < _len; _i++) {
            prefix = vendors[_i];
            if (!!requestAnimationFrame) {
                continue
            }
            requestAnimationFrame = window["" + prefix + "RequestAnimationFrame"];
            cancelAnimationFrame = window["" + prefix + "CancelAnimationFrame"] || window["" + prefix + "CancelRequestAnimationFrame"]
        }
        if (!requestAnimationFrame) {
            lastTime = 0;
            requestAnimationFrame = function(callback, element) {
                var currTime, timeToCall;
                currTime = (new Date).getTime();
                timeToCall = Math.max(0, 16 - (currTime - lastTime));
                lastTime = currTime + timeToCall;
                return window.setTimeout(function() {
                    return callback(currTime + timeToCall)
                }, timeToCall)
            }
        }
        if (!cancelAnimationFrame) {
            cancelAnimationFrame = function(id) {
                return clearTimeout(id)
            }
        }
        return {
            requestAnimationFrame: requestAnimationFrame,
            cancelAnimationFrame: cancelAnimationFrame,
            nextTick: function(fn) {
                return setTimeout(fn, 0)
            }
        }
    }();
    Annotator.Plugin.Touch.Viewer = function(_super) {
        var jQuery;
        __extends(Viewer, _super);
        jQuery = Annotator.$;
        Viewer.prototype.events = {
            /*".annotator-item tap": "_onTap",*/
            ".annotator-edit tap": "_onEdit",
            ".annotator-delete tap": "_onDelete",
            ".annotator-close tap": "_onClose"
        };

        function Viewer(viewer, options) {
            this.viewer = viewer;
            this._onLoad = __bind(this._onLoad, this);
            Viewer.__super__.constructor.call(this, this.viewer.element[0], options);
            this.element.unbind("click");
            this.element.addClass("annotator-touch-widget annotator-touch-viewer");
            this.on("load", this._onLoad)
        }
        Viewer.prototype.hideAllControls = function() {
            this.element.find(".annotator-item").removeClass(this.viewer.classes.showControls);
            return this
        };
        Viewer.prototype._onLoad = function() {
            var controls;
            controls = this.element.find(".annotator-controls");
            controls.toggleClass("annotator-controls annotator-touch-controls");
            if((controls.find("button")).hasClass("annotator-edit") || (controls.find("button")).hasClass("annotator-delete")) {
                controls.toggleClass("annotator-touch-controls annotator-controls");
                return;
            } else {
                return controls.find("button").addClass("annotator-button");
            }
        };
        /*Viewer.prototype._onTap = function(event) {
            var isVisible, target;
            target = jQuery(event.currentTarget);
            isVisible = target.hasClass(this.viewer.classes.showControls);
            this.hideAllControls();
            if (!isVisible) {
                return target.addClass(this.viewer.classes.showControls)
            }
        };*/
        Viewer.prototype._onEdit = function(event) {
            event.preventDefault();
            return this.viewer.onEditClick(event)
        };
        Viewer.prototype._onDelete = function(event) {
            event.preventDefault();
            return this.viewer.onDeleteClick(event)
        };
        Viewer.prototype._onClose = function(event) {
            event.preventDefault();
            return this.viewer.onCloseClick(event)
        };
        return Viewer
    }(Annotator.Delegator)
}).call(this);
/*global comprodls*/
/*global Util*/


(function () {
    var devAnnotator;
    Annotation = function() {
      var applyEditor = false;
      if(comprodls.READER.applyEditor) {
        applyEditor = comprodls.READER.applyEditor();
      }
      function placeCaretAtEnd(el) {
          el.focus();
          if (typeof window.getSelection != "undefined"
                  && typeof document.createRange != "undefined") {
              var range = document.createRange();
              range.selectNodeContents(el);
              range.collapse(false);
              var sel = window.getSelection();
              sel.removeAllRanges();
              sel.addRange(range);
          } else if (typeof document.body.createTextRange != "undefined") {
              var textRange = document.body.createTextRange();
              textRange.moveToElementText(el);
              textRange.collapse(false);
              textRange.select();
          }
      };
      //Options are passed to provide support for speaking functionality.

      Annotator.prototype.html.wrapper = '<div class="annotator-wrapper readerContainer"></div>';

      Annotator.prototype.events[".annotator-hl click"] = "onHighlightMouseover";

      Annotator.prototype.checkForEndSelection = function(event) {
        this.mouseIsDown = false;
        if ( ['ee-overlaysA','ee-overlaysB'].indexOf($(event.target).attr("id")) >= 0  && !this.viewer.isShown() ) {
          
          if (this.ignoreMouseup) {
            return;
          }
          if (applyEditor) {
            //remove html editor to stop video on double click
            var htmleditor = document.getElementsByClassName("wysiwyg-editor");
            if(htmleditor.length !== 0) {
              $(htmleditor).remove();
            }
          }
          var position = Util.mousePosition(event, this.wrapper[0]);
          var adderWidth = this.adder.width();
          //calculating mouse left position in IE
          if(navigator.userAgent.indexOf("MSIE") !== -1 || window.navigator.userAgent.indexOf('Trident/') !== -1) {
            position.left = event.clientX + document.body.scrollLeft;
          }
          
          
          if(position.left > $(window).width()) {
            position.left = $(window).width();
          }
          if (position.left < 0) {
            position.left = 0;
          }
          if((position.left - adderWidth)  < 0) {
            if (this.adder.hasClass("annotator-mic-adder")) {
              position.left = position.left + 35;
            } else {
              position.left = position.left + 20;
            }
          }
          if((adderWidth + position.left) > ($(window).width())) {
            if (this.adder.hasClass("annotator-mic-adder")) {
              position.left = position.left - 40;
            } else {
              position.left = position.left - 25;
            }
          }
           
          var headerHeight = 50;
          
          var adderTop = position.top;
          if((headerHeight - adderTop) > 0) {
            this.adder.addClass("annotator-invert-y");
            this.adder.css("transform","scaleY(-1)");
            this.adder.css("-ms-transform","scaleY(-1)");
            this.adder.css("-webkit-transform","scaleY(-1)");
            position.top = position.top + headerHeight;
          }
          else {
            this.adder.removeClass("annotator-invert-y");
            this.adder.css("transform","");
            this.adder.css("-ms-transform","");
            this.adder.css("-webkit-transform","");
          }

          if (this.adder.hasClass("annotator-mic-adder")) {
            position.top -= 50;
            position.left -= 35;  
          }      
          this.onAdderClick(event);
          return this.ignoreMouseup = true;
        }     
      };
      Annotator.prototype.onAdderClick = function(event) {
        // Reset height and width of annotation textarea everytime it is opened.  
        $("#annotator-field-0").css("height","");
        $("#annotator-field-0").css("width","");
        var annotation, cancel, cleanup, position, save;
        if (event != null) {
          event.preventDefault();
        }
        var editorPosition = $(event.target).parent().offset();
        editorPosition.top = event.pageY - $("#reader-container-wrapper").offset().top;
        if ($(event.target).attr("id") === "ee-overlaysA") {
          editorPosition.left = event.pageX - $("#reader-container-wrapper").offset().left - parseInt($(this.adder).css("margin-left"),10) + 20;
        } else if ($(event.target).attr("id") === "ee-overlaysB") {
          editorPosition.left = event.pageX - $("#reader-container-wrapper").offset().left - parseInt($(this.adder).css("margin-left"),10) + 20;
          if($("#reader-container-wrapper").width() < editorPosition.left+275) {
            editorPosition.left -= 280;
          }
        }
        
        if(navigator.userAgent.indexOf("MSIE") !== -1 || window.navigator.userAgent.indexOf('Trident/') !== -1) {
          editorPosition.top = event.pageY;
          if ($(event.target).attr("id") === "ee-overlaysA") {
            editorPosition.left = event.pageX + $("#annotationLeftBar").width();
          } else if ($(event.target).attr("id") === "ee-overlaysB") {
            editorPosition.left = event.pageX - 275;
          }
        }
        this.adder.hide();
        annotation = this.setupAnnotation(this.createAnnotation(), event);
        $(annotation.highlights).addClass('annotator-hl-temporary');
        save = (function(_this) {
          return function() {
            cleanup();
            $(annotation.highlights).removeClass('annotator-hl-temporary');
            $(annotation.highlights).find(".dls-imgbook-font-temp").removeClass("dls-imgbook-font-temp");
            return _this.publish('annotationCreated', [annotation]);
          };
        })(this);
        cancel = (function(_this) {
          return function() {
            cleanup();
            return _this.deleteAnnotation(annotation);
          };
        })(this);
        cleanup = (function(_this) {
          return function() {
            _this.unsubscribe('annotationEditorHidden', cancel);
            return _this.unsubscribe('annotationEditorSubmit', save);
          };
        })(this);
        this.subscribe('annotationEditorHidden', cancel);
        this.subscribe('annotationEditorSubmit', save);
        return this.showEditor(annotation, editorPosition);
      };
      Annotator.prototype.setupAnnotation = function(annotation, event) {
        var normedRanges, ref, root,pagelabels,pagelabel,pageserials,pageserial,position, positionX,parentOffset,relY, relX;
        root = this.wrapper[0];
        try {
          pagelabels = comprodls.READER.getPdfPageLevel(); //  Get page labels in array format [1,2]
        } catch(e){
          pagelabels = [];
        }
        try {
          pageserials = comprodls.READER.getCurrentSerial(); //  Get page serials in array format [1,2]
        } catch(e){
          pageserials = [];
        }
        if (event) {
          var eventTarget = $(event.target);  
          
          if (pagelabels.length > 0) {
            if (pagelabels.length === 1) {
                pagelabel = pagelabels[0];
            } else if (pagelabels.length === 2) {
              if (eventTarget.attr("id") === "ee-overlaysA") {
                pagelabel = pagelabels[0];
              } else if (eventTarget.attr("id") === "ee-overlaysB") {
                pagelabel = pagelabels[1];
              }
            }
          }
          if (pageserials.length > 0) {
            if (pagelabels.length === 1) {
              pageserial = pageserials[0];
            } else if (pagelabels.length === 2) {
              if (eventTarget.attr("id") === "ee-overlaysA") {
                pageserial = pageserials[0];
              } else if (eventTarget.attr("id") === "ee-overlaysB") {
                pageserial = pageserials[1];
              }
            }
          }
          parentOffset = eventTarget.parent().offset();
          relY = event.pageY - parentOffset.top;
          relX = event.pageX - parentOffset.left;
          eventTarget.append('<i class="dls-imgbook-font dls-imgbook-annotation dls-imgbook-font-temp"><!-- keep this --></i>');

          position = relY/(2.8*comprodls.READER.getFontSize());
          positionX = relX/(2.8*comprodls.READER.getFontSize());

          annotation.position = position;
          annotation.positionX = positionX;
        } else if (annotation.position) {
          
          if (pagelabels.length === 2) {
            if ( pagelabels[0]+"" === annotation.pagelabel+"") {
              $("#ee-overlaysA").append('<i class="dls-imgbook-font dls-imgbook-annotation dls-imgbook-font-temp"><!-- keep this --></i>');    
            } else if ( pagelabels[1]+"" === annotation.pagelabel+"") {
              $("#ee-overlaysB").append('<i class="dls-imgbook-font dls-imgbook-annotation dls-imgbook-font-temp"><!-- keep this --></i>');    
            } else {
              return annotation;
            }
          } else if (pagelabels.length === 1) {
            if (comprodls.READER.getCurrentPagePosition() === "left") {
              $("#ee-overlaysA").append('<i class="dls-imgbook-font dls-imgbook-annotation dls-imgbook-font-temp"><!-- keep this --></i>');
            } else if (comprodls.READER.getCurrentPagePosition() === "right") {
              $("#ee-overlaysA").append('<i class="dls-imgbook-font dls-imgbook-annotation dls-imgbook-font-temp"><!-- keep this --></i>');
            }
          }          
        }  
        var orgid, productid, productcode;     
        productid = comprodls.READER.getBookId();
        orgid = comprodls.READER.getOrgId();
        productcode = comprodls.READER.getProductCode();
        
        if(orgid !== null && orgid !== undefined) {
          annotation.orgid = orgid;
        }
        if(productid !== null && productid !== undefined) {
          annotation.productid = productid;
        }
        if(productcode !== null && productcode !== undefined) {
          annotation.productcode = productcode;
        }
        if(pagelabel !== null && pagelabel !== undefined) {
          annotation.pagelabel = pagelabel;
        }
        if(pageserial !== null && pageserial !== undefined) {
          annotation.pageserial = pageserial;
        }
        normedRanges = [];
        ref = annotation.ranges;
        annotation.quote = [];
        annotation.ranges = [];
        annotation.highlights = [];

        $.merge(annotation.highlights, this.highlightRange($(".dls-imgbook-font-temp")));
        annotation.quote = annotation.quote.join(' / ');
        $(annotation.highlights).data('annotation', annotation);
        $(annotation.highlights).attr('data-annotation-id', annotation._id);
        $(annotation.highlights).css("position","absolute");
        $(annotation.highlights).css("font-size","2.8em");
        if (event) {
          //#869 Reader - Annotation icon placed below visible area fixed.
          if (relY + $(".dls-imgbook-annotation.dls-imgbook-font-temp").height() > $("#ee-overlaysA").height()) {
            relY = $("#ee-overlaysA").height() - $(".dls-imgbook-annotation.dls-imgbook-font-temp").height() -5;
            position = relY/(2.8*comprodls.READER.getFontSize());
            annotation.position = position;
          }
          $(annotation.highlights).css("top",relY/(2.8*comprodls.READER.getFontSize())+"em");

          if ((relX + $(".dls-imgbook-annotation.dls-imgbook-font-temp").outerWidth()) > $("#ee-overlaysA").width()) {
            relX = $("#ee-overlaysA").width() - $(".dls-imgbook-annotation.dls-imgbook-font-temp").outerWidth() -10;
            positionX = relX/(2.8*comprodls.READER.getFontSize());
            annotation.positionX = positionX;
          }
          $(annotation.highlights).css("left",relX/(2.8*comprodls.READER.getFontSize())+"em");
        } else {
          $(annotation.highlights).css("top",annotation.position + "em");
          if(annotation.positionX) {
            $(annotation.highlights).css("left",annotation.positionX + "em");
          }
          $(annotation.highlights).find(".dls-imgbook-font-temp").removeClass("dls-imgbook-font-temp");
        }
        return annotation;
      };
      Annotator.prototype.highlightRange = function(element, cssClass) {
        var hl, results;
        if (cssClass == null) {
          cssClass = 'annotator-hl';
        }
       
        //hl = $("<span class='" + cssClass + "'></span>");
        hl = $("<button aria-label='Note' class='" + cssClass + "'></button>");

        results = [];
        results.push(element.wrapAll(hl).parent().show()[0]);
       
        return results;
      }; 
      Annotator.prototype.onHighlightMouseover = function(event) {
        if((($(event.target)).hasClass("annotator-hl-temporary") || ($(event.target).parent()).hasClass("annotator-hl-temporary")) || this.editor.isShown()) {
          return;
        }
        else {
          var annotations;
          this.clearViewerHideTimer();
          if (this.mouseIsDown) {
            return false;
          }
          if (this.viewer.isShown()) {
            this.viewer.hide();
          }
          annotations = $(event.target).parents('.annotator-hl').addBack().map(function() {
            return $(this).data("annotation");
          }).toArray();
          //Dont open viewer if editor is open for same text.
          var editor = $(".annotator-editor");
          if(!($(editor).hasClass("annotator-hide"))) {
            var editorId = $(editor).attr("id");
            var viewerId = annotations[0]._id;
            if(editorId === viewerId) {
              return;
            } 
          }
          return this.showViewer(annotations, Util.mousePosition(event, this.wrapper[0]), event);
        }
      };
      Annotator.prototype.showViewer = function(annotations, location, event) {
        if(navigator.userAgent.indexOf("MSIE") !== -1 || window.navigator.userAgent.indexOf('Trident/') !== -1) {
          location.left = event.clientX + document.body.scrollLeft;
        }
        event.pageX = $(event.currentTarget).offset().left;
        var bufferLeft = 15;
        if(event.pageX < ($("#readerpagedivA").offset().left + $("#readerpagedivA").width())) {
          location.left = $(event.currentTarget).offset().left + bufferLeft;
        } else {
          location.left = $(event.currentTarget).offset().left + bufferLeft;
        }
        if(!(navigator.userAgent.indexOf("MSIE") !== -1 || window.navigator.userAgent.indexOf('Trident/') !== -1)) {
          location.left -= $("#reader-container-wrapper").offset().left;
          location.top = $(event.currentTarget).offset().top - $("#reader-container-wrapper").offset().top;
        } else {
          //in IE
          location.top = $(event.currentTarget).offset().top;
        }
        this.viewer.element.css(location);
        var annotationId = '';
        if(annotations[0]) {
          annotationId = annotations[0]._id
        }
        // Added annotation id on viewer to shift focus to the note whose viewer was open when the viewer is closed
        this.viewer.element.attr("annotationid", annotationId);
        this.viewer.load(annotations);
        this.viewer.element.find('h2 span').hide();
        if(annotations[0].isClosed) {
          this.viewer.element.find('#viewer_note_closed').show();
        } else {
          this.viewer.element.find('#viewer_note_open').show();
        }
        // Shift focus to viewer when it is opened
        this.viewer.element.focus();
        return this.publish('annotationViewerShown', [this.viewer, annotations]);
      };
      Annotator.prototype.deleteAnnotation = function(annotation) {
        var h, j, len, ref;
        if(annotation.id === undefined && annotation._id !== undefined) {
          annotation.id = annotation._id;
        }        
        if (annotation.highlights != null) {
          ref = annotation.highlights;
          for (j = 0, len = ref.length; j < len; j++) {
            h = ref[j];
            $(h).remove();
          }
        }
        // Delete clone references of notes from UI
        if(annotation.id) {
          if($("[data-annotation-id='" + annotation.id + "']").length > 0) {
            $("[data-annotation-id='" + annotation.id + "']").remove();
          } 
        }

        this.publish('annotationDeleted', [annotation]);
        return annotation;
      };
      Annotator.prototype.destroy = function() {
        var base, idx, name, plugin, ref;
        Annotator.__super__.destroy.apply(this, arguments);
        $(document).unbind({
          "mouseup": this.checkForEndSelection,
          "mousedown": this.checkForStartSelection
        });
        $('#annotator-dynamic-style').remove();
        this.adder.remove();
        this.viewer.destroy();
        this.editor.destroy();
        this.wrapper.find('.annotator-hl').each(function() {
          $(this).remove();
        });
        /* Dont't remove anotator-wrapper as it force the activity iframe to refresh, which creates problem. */
        // this.wrapper.contents().insertBefore(this.wrapper);
        // this.wrapper.remove();
        this.element.data('annotator', null);
        ref = this.plugins;
        for (name in ref) {
          plugin = ref[name];
          if (typeof (base = this.plugins[name]).destroy === "function") {
            base.destroy();
          }
        }
        idx = Annotator._instances.indexOf(this);
        if (idx !== -1) {
          return Annotator._instances.splice(idx, 1);
        }
      };
      Annotator.prototype.onEditAnnotation = function(annotation) {
        var cleanup, offset, update;
        offset = this.viewer.element.position();
        if(!(navigator.userAgent.indexOf("MSIE") !== -1 || window.navigator.userAgent.indexOf('Trident/') !== -1)) {
          offset.top = offset.top - $("#reader-container-wrapper").offset().top;
          offset.left = offset.left - $("#reader-container-wrapper").offset().left;
        }

        update = (function(_this) {
          return function() {
            cleanup();
            return _this.updateAnnotation(annotation);
          };
        })(this);
        cleanup = (function(_this) {
          return function() {
            _this.unsubscribe('annotationEditorHidden', cleanup);
            return _this.unsubscribe('annotationEditorSubmit', update);
          };
        })(this);
        this.subscribe('annotationEditorHidden', cleanup);
        this.subscribe('annotationEditorSubmit', update);
        this.viewer.hide();
        return this.showEditor(annotation, offset);
      };
      Annotator.prototype.showEditor = function(annotation, location) {
        this.editor.element.find('h2 span').hide();
        if(annotation._id) {
          //Get annotation id and add it on editor.
          this.editor.element.attr("id",annotation._id);          
          if(annotation.isClosed) {
            this.editor.element.find('#editor_note_closed').show();
          } else {
            this.editor.element.find('#editor_note_open').show();
          }
        }
        this.editor.element.css(location);
        this.editor.element.css("position", "fixed");
        this.editor.load(annotation);
        this.publish('annotationEditorShown', [this.editor, annotation]);
        return this;
      };

      Annotator.Widget.prototype.checkOrientation = function() {
        var current, offset, viewport, widget, framewindow, windowHeight, belowArea, aboveArea;
        //if editor has content then change height according to content
        if (applyEditor) {
          if(!(this.element.hasClass("annotator-viewer"))) {
            if( !($('.annotator-editor .wysiwyg-editor').is(':empty')) ) {
              $(".annotator-editor .wysiwyg-editor").css("height","auto");
            }
          }
        } else {
          if(!(this.element.hasClass("annotator-viewer"))) {
            if($('.annotator-editor textarea').val().trim().length > 0 ) {
              var padding = 10;
              var textareaHeight = document.querySelector('[id^="annotator-field-"]').scrollHeight + padding;
              $(".annotator-editor textarea").css("height", textareaHeight);
            }
          }
        }
        this.resetOrientation();
        framewindow = $(Annotator.Util.getGlobal());
        widget = this.element.children(":first");
        offset = widget.offset();
        viewport = {
          top: framewindow.scrollTop(),
          right: framewindow.width() + framewindow.scrollLeft()
        };
        current = {
          top: offset.top,
          right: offset.left + widget.width()
        };
        /*if ((current.top - viewport.top) < 0) {
          this.invertY();
        }*/
        if ((current.right - ($("#reader-container-wrapper").offset().left + $("#reader-container-wrapper").width())) > 0) {
          this.invertX();
          // New styles
          if(this.element.hasClass("annotator-editor") && this.element.hasClass("annotator-invert-x")) {
            this.element.css({
              left: $("#reader-container-wrapper").width() - $(".annotator-hl.annotator-hl-temporary").outerWidth()
            });
          }
        }
        windowHeight = $(window).height();  
        /*windowHeight = $(window.top).height();*/
        current.top = current.top;
        

        
        //calculate area above selected element
        if(this.element.hasClass("annotator-editor")) {
          aboveArea = current.top + $(".annotator-editor .annotator-heading").outerHeight() + $(".annotator-editor .annotator-listing").outerHeight() + $(".annotator-editor .annotator-controls").outerHeight();
        }
        else {
          aboveArea = current.top + $(".annotator-widget").height();
        }

        //calculate area below selected element
        belowArea = windowHeight - aboveArea;

        //display editor/viewer in bigger area
        if(belowArea > aboveArea) {
          this.invertY();
        }
        return this;
      };

      Annotator.Viewer.prototype.show = function(event) {
        var controls;
        var parentEl = $("#"+comprodls.READER.getElParent());
        //var headerHeight = parentEl.scrollTop() + $("#reader-container-wrapper").position().top;

        var headerHeight;
        if (isNaN(parseInt($('#reader-container-wrapper').css('top'), 10))) {
          headerHeight = parentEl.offset().top;
        } else {
          headerHeight = parentEl.offset().top + parseInt($('#reader-container-wrapper').css('top'), 10);
        }
        
        Annotator.Util.preventEventDefault(event);
        controls = this.element.find('.annotator-controls').addClass(this.classes.showControls);
        setTimeout(((function(_this) {
          return function() {
            return controls.removeClass(_this.classes.showControls);
          };
        })(this)), 500);
        this.element.css("position", "fixed");
        if (applyEditor) {
          //call html-editor on annotation viewer
          this.htmlEditor('viewerarea');
        }
        this.element.removeClass(this.classes.hide);
        this.checkOrientation();
        var windowHeight;
        if (isNaN(parseInt($('#reader-container-wrapper').css('top'), 10))) {
          windowHeight = comprodls.READER.getContentHeight();
        } else {
          windowHeight = comprodls.READER.getContentHeight() - parseInt($('#reader-container-wrapper').css('top'), 10);
        }               
        var viewerHeight = $(".annotator-item").height();
        var viewerTop = $(".annotator-listing").offset().top - $("#imgbook").offset().top;
        
        //bufferHeight includes heading area,padding and size of arrow
        var bufferHeight = 65;
        var remainingHeight;
        if(this.element.hasClass("annotator-invert-y")) {
          remainingHeight = windowHeight - viewerTop - bufferHeight;
        } else {
          remainingHeight = viewerHeight + viewerTop - bufferHeight - parseInt($('#reader-container-wrapper').css('top'), 10);
        }
        if (applyEditor) {
          if((viewerTop - parseInt($("#reader-container-wrapper").css("top"), 10) < 0 || ((viewerTop + viewerHeight) > windowHeight)) && remainingHeight > 0){
            $(".annotator-viewer .wysiwyg-editor").css("height",remainingHeight);
            $(".annotator-viewer .wysiwyg-editor").css("overflow","auto");
          }
        } else {
          if((viewerTop - parseInt($("#reader-container-wrapper").css("top"), 10) < 0 || ((viewerTop + viewerHeight) > windowHeight)) && remainingHeight > 0){
            $(".annotator-viewer .viewerarea").css("height",remainingHeight);
            $(".annotator-viewer .viewerarea").css("overflow","auto");
          }
        }
        if(this.element.hasClass("annotator-invert-y")) {

        } else {
          var top = this.element.css("top")
          top = parseInt(top, 10) + 20;
          this.element.css("top", top);
        }
        /*ends*/
        return this.publish('show');
      };

      //function to create instance of html editor
      Annotator.Viewer.prototype.htmlEditor = function(type) {
        if(type === "viewerarea") {
          //if more than one annotation on single text then use html editor on each annotation
          var element = document.getElementsByClassName(type);
          $.each(element,function() {
            try {
              $(this).wysiwyg();
            } catch(e) {
              console.log("html editor not found");
            }
            
          });
        } else {
          var element = $(".annotator-editor .annotator-item textarea");
          try {
            element.wysiwyg();
          } catch(e) {
            console.log("html editor not found");
          }
        }
      };

      Annotator.Editor.prototype.show = function(event) {
        // Reset height and width of annotation textarea everytime it is opened.  
        $(".annotator-editor textarea").css("height","");
        $(".annotator-editor textarea").css("width","");
        //create instance of viewer
        this.viewer = new Annotator.Viewer({
          // readOnly: this.options.readOnly
        });
        if (applyEditor) {
          // Remove data from editor textarea
          var textareaID = $(".annotator-editor textarea").attr("id");
          $("#" + textareaID).removeData('wysiwyg');

          //destroy wysiwyg-containers to create new instance of html-editor
          var htmleditor = document.getElementsByClassName("wysiwyg-container");
          if(htmleditor.length !== 0) {
            $(".wysiwyg-editor").remove();
            $('.wysiwyg-container').replaceWith(function() {
               return $('textarea', this);
            });
            $(".wysiwyg-placeholder").remove();
          }

          //call html-editor on annotation editor
          this.viewer.htmlEditor('annotator-field-0');
        }
        Annotator.Util.preventEventDefault(event);
        this.element.removeClass(this.classes.hide);
        
        this.element.find('.annotator-save').addClass(this.classes.focus);
        this.checkOrientation();
        this.setupDraggables();

        /*check editor visibility(out of screen or not)*/
        
        var windowHeight;
        if (isNaN(parseInt($('#reader-container-wrapper').css('top'), 10))) {
          windowHeight = comprodls.READER.getContentHeight();
        } else {
          windowHeight = comprodls.READER.getContentHeight() - parseInt($('#reader-container-wrapper').css('top'), 10);
        }
       
        var editorHeight = $(".annotator-editor .annotator-heading").outerHeight() + $(".annotator-editor .annotator-listing").outerHeight() + $(".annotator-editor .annotator-controls").outerHeight();
        var editorTop = $(".annotator-editor .annotator-heading").offset().top - $("#imgbook").offset().top;
        var isScrollDoc = true;
        
        //bufferHeight includes padding, margin and height of controls,heading and listing area 
        var bufferHeight = 135;
        var remainingHeight;

        //if editor is not empty then check for visibility
        if (applyEditor) {
          if( !($('.annotator-editor .wysiwyg-editor').is(':empty')) ) {
            if(this.element.hasClass("annotator-invert-y") || (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent))) {
              remainingHeight = windowHeight - editorTop - bufferHeight;
            }
            else {
              if (isNaN(parseInt($('#reader-container-wrapper').css('top'), 10))) {
                remainingHeight = editorHeight + editorTop - bufferHeight;
              } else {
                remainingHeight = editorHeight + editorTop - bufferHeight - parseInt($('#reader-container-wrapper').css('top'), 10);
              } 
            }
            if(editorTop - parseInt($("#reader-container-wrapper").css("top"), 10) < 0 || ((editorTop + editorHeight) > windowHeight)) {
              $(".annotator-editor .wysiwyg-editor").css("height",remainingHeight);
              $(".annotator-editor .wysiwyg-editor").css("overflow","auto");
            }
          }
        } else {
            if(this.element.hasClass("annotator-invert-y") || (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent))) {
              remainingHeight = windowHeight - editorTop - bufferHeight;
            }
            else {
              if (isNaN(parseInt($('#reader-container-wrapper').css('top'), 10))) {
                remainingHeight = editorHeight + editorTop - bufferHeight;
              } else {
                remainingHeight = editorHeight + editorTop - bufferHeight - parseInt($('#reader-container-wrapper').css('top'), 10);
              }
              
            }
          
            if(editorTop - parseInt($("#reader-container-wrapper").css("top"), 10) < 0 || ((editorTop + editorHeight) > windowHeight)) {
              $(".annotator-editor textarea").css("height",remainingHeight);
              $(".annotator-editor textarea").css("overflow","auto");
            }
        }
        /*ends*/
        this.element.find(":input:first").focus();
        if (applyEditor) {
          placeCaretAtEnd(document.getElementsByClassName('wysiwyg-editor')[0]);
        }
        return this.publish('show');
      };
      
      Annotator.Editor.prototype.hide = function(event) {
        Annotator.Util.preventEventDefault(event);
        this.element.addClass(this.classes.hide);
        if (applyEditor) {
          //remove html-editor on cancel click
          var htmleditor = document.getElementsByClassName("wysiwyg-editor");
          if(htmleditor.length !== 0) {
            $(".wysiwyg-editor").remove();
            $('.wysiwyg-container').replaceWith(function() {
               return $('textarea', this);
            });
            $(".wysiwyg-placeholder").remove();
          }
        }
        $(".dls-imgbook-font-temp").each( function() {
            $(this).remove();
        });
        return this.publish('hide');
      };
      Annotator.Editor.prototype.checkOrientation = function() {
        var controls, list;
        Annotator.Editor.__super__.checkOrientation.apply(this, arguments);
        // Changed sequece of displaying divs in editor(customised).
        heading = this.element.find('.annotator-heading');
        list = this.element.find('ul');
        controls = this.element.find('.annotator-controls');
        if (this.element.hasClass(this.classes.invert.y)) {
          list.insertBefore(controls);
          heading.insertBefore(list);
        } else if (list.is(':first-child')) {
          list.insertAfter(controls);
        }else {
          var top = this.element.css("top")
          top = parseInt(top, 10) + 20;
          this.element.css("top", top);
        }
        return this;
      };

      Annotator.Plugin.Permissions.prototype.pluginInit = function() {
        var createCallback, self;
        if (!Annotator.supported()) {
          return;
        }
        self = this;
        createCallback = function(method, type) {
          return function(field, annotation) {
            return self[method].call(self, type, field, annotation);
          };
        };
        // if (!this.user && this.annotator.plugins.Auth) {
        //   this.annotator.plugins.Auth.withToken(this._setAuthFromToken);
        // }
        if (!this.user) {
          var userid = comprodls.READER.getUser();
          var token = {
            "ttl": 86400,
            "userId": userid,
            "consumerKey": "annotateit"        
          };    
          this._setAuthFromToken(token);
        }
        
        this.annotator.viewer.addField({
          load: this.updateViewer
        });
        if (this.annotator.plugins.Filter) {
          return this.annotator.plugins.Filter.addFilter({
            label: Annotator._t('User'),
            property: 'user',
            isFiltered: (function(_this) {
              return function(input, user) {
                var i, keyword, len, ref;
                user = _this.options.userString(user);
                if (!(input && user)) {
                  return false;
                }
                ref = input.split(/\s*/);
                for (i = 0, len = ref.length; i < len; i++) {
                  keyword = ref[i];
                  if (user.indexOf(keyword) === -1) {
                    return false;
                  }
                }
                return true;
              };
            })(this)
          });
        }
      };
      Annotator.Plugin.Store.prototype._urlFor = function(action, id) {
        var url;
        url = this.options.prefix != null ? this.options.prefix : '';
        url += this.options.urls[action];
        url = url.replace(/\/:id/, id != null ? '/' + id : '');
        url = url.replace(/:id/, id != null ? id : '');
        if(action === "read") {
          
          var orgid, userid, productid, productcode;
          orgid = comprodls.READER.getOrgId();
          userid = comprodls.READER.getUser();
          productid = comprodls.READER.getBookId();
          productcode = comprodls.READER.getProductCode();

          var pagelabels;
          try {
            pagelabels = comprodls.READER.getPdfPageLevel(); //  Get page number in array format [1,2]
          } catch(e){
            pagelabels = [];
          }

          if((orgid !== null && orgid !== undefined) || (userid !== null && userid !== undefined) || (productid !== null && productid !== undefined) || (productcode !== null && productcode !== undefined) || (pagelabels!== null && pagelabels !== undefined)) {
            url += "/?";
            var count = 0;
            if(orgid !== null && orgid !== undefined) {
              url += "orgid=" + orgid;
              count = 1;
            }
            if(userid !== null && userid !== undefined) {
              if(count = 0) {
                count = 1;
              } else {
                url += "&";
              }
              url += "userid=" + userid;
            }
            if(productid !== null && productid !== undefined) {
              if(count = 0) {
                count = 1;
              } else {
                url += "&";
              }
              url += "productid=" + productid;
            }
            if(productcode !== null && productcode !== undefined) {
              if(count = 0) {
                count = 1;
              } else {
                url += "&";
              }
              url += "productcode=" + productcode;
            }
            if(pagelabels !== null && pagelabels !== undefined && pagelabels.length !== 0) {
              if(count = 0) {
                count = 1;
              } else {
                url += "&";
              }
              if (pagelabels.length === 1) {
                url += "pagelabel=" + pagelabels[0] ;
              } else if (pagelabels.length === 2) {
                url += "pagelabel=" + pagelabels[0] + "||" + pagelabels[1];
              }    
            }
          }
        }
        return url;
      };

      Annotator.Plugin.Store.prototype.annotationCreated = function(annotation) {
        if (indexOf.call(this.annotations, annotation) < 0) {
          this.registerAnnotation(annotation);
          return this._apiRequest('create', annotation, (function(_this) {
            return function(data) {
              if(data.id === undefined && data._id !== undefined) {
                data.id = data._id;
              }              
              if (data.id == null) {
                console.warn(Annotator._t("Warning: No ID returned from server for annotation "), annotation);
              }
              comprodls.READER.annotationEventHandler("create", $.extend({}, data));
              return _this.updateAnnotation(annotation, data);
            };
          })(this));
        } else {
          return this.updateAnnotation(annotation, {});
        }
      };

      Annotator.Plugin.Store.prototype.annotationUpdated = function(annotation) {
        if (indexOf.call(this.annotations, annotation) >= 0) {
          return this._apiRequest('update', annotation, ((function(_this) {
            return function(data) {
              comprodls.READER.annotationEventHandler("update", $.extend({}, annotation));
              return _this.updateAnnotation(annotation, data);
            };
          })(this)));
        }
      };

      Annotator.Plugin.Store.prototype.annotationDeleted = function(annotation) {
        if (indexOf.call(this.annotations, annotation) >= 0) {
          return this._apiRequest('destroy', annotation, ((function(_this) {
            return function() {
              comprodls.READER.annotationEventHandler("destroy", $.extend({}, annotation));
              return _this.unregisterAnnotation(annotation);
            };
          })(this)));
        }
      };      

      Annotator.Editor.prototype.setupDraggables = function() {
        var classes, controls, cornerItem, editor, mousedown, onMousedown, onMousemove, onMouseup, resize, textarea, throttle;
        this.element.find('.annotator-resize').remove();
        var htmleditor;
        if (this.element.hasClass(this.classes.invert.y)) {
           //corner item should be added to wysiwyg-wrapper if present
          htmleditor = document.getElementsByClassName("wysiwyg-wrapper");
          if(htmleditor.length !== 0) {
            cornerItem = this.element.find('.wysiwyg-wrapper');
          } else {
            cornerItem = this.element.find('.annotator-item:first');
          }
        } else {
          htmleditor = document.getElementsByClassName("wysiwyg-wrapper");
          if(htmleditor.length !== 0) {
            cornerItem = this.element.find('.wysiwyg-wrapper');
          } else {
            cornerItem = this.element.find('.annotator-item:first');
          }
        }
        if (cornerItem) {
          $('<span class="annotator-resize"></span>').appendTo(cornerItem);
        }
        mousedown = null;
        classes = this.classes;
        editor = this.element;
        textarea = null;
        resize = editor.find('.annotator-resize');
        controls = editor.find('.annotator-controls');
        var heading = editor.find('.annotator-heading');
        throttle = false;
        onMousedown = function(event) {
          event.stopPropagation();
          if (event.target === this) {
            mousedown = {
              element: this,
              top: event.pageY,
              left: event.pageX
            };
            var htmleditor = document.getElementsByClassName("wysiwyg-editor");
            
            if(htmleditor.length !== 0) {
            //html editor's div is textarea
              textarea = editor.find('.wysiwyg-editor');
            } else {
              textarea = editor.find('textarea:first');
            } 
            $(window).bind({
              'mouseup.annotator-editor-resize': onMouseup,
              'mousemove.annotator-editor-resize': onMousemove
            });
            return event.preventDefault();
          }
        };
        onMouseup = function() {
          /* adjust position of editor after dragging */
          controls = editor.find('.annotator-controls');
          elem = editor.find('.annotator-heading');
          var elemTop = elem.offset().top;
          var elemLeft = elem.offset().left;
          var elemWidth = elem.width();
          var editorPadding = 60;
          var elemHeight = editor.find('.annotator-heading').height() + editor.find('.annotator-listing').height() + editor.find('.annotator-controls').height() + editorPadding;

          if((elemLeft + elemWidth) > ($("#reader-container-wrapper").offset().left + $("#reader-container-wrapper").width())) {
            var containerMargin = 20;
            if(editor.hasClass("annotator-invert-x")) {
              editor.css({
                left: $("#reader-container-wrapper").width() - $("#annotationRightBar").width() - containerMargin
              });
            } else {
              editor.css({
                left: $("#reader-container-wrapper").width() - elemWidth - $("#annotationRightBar").width() - containerMargin
              }); 
            }
          }
          if(elemTop < $("#reader-container-wrapper").offset().top) {
            if(editor.hasClass("annotator-invert-y")) {
              editor.css({
                top: 0
              });
            } else {
              editor.css({
                top: elemHeight
              }); 
            }  
          }
          if(elemLeft < $("#reader-container-wrapper").offset().left) {
            containerMargin = 20;
            if(editor.hasClass("annotator-invert-x")) {
              editor.css({
                left: elemWidth + $("#annotationLeftBar").width() + containerMargin
              });
            } else {
              editor.css({
                left: $("#annotationLeftBar").width() + containerMargin
              }); 
            }
          }
          if(elemTop + elemHeight - 2*(parseInt($("#reader-container-wrapper").css("top"),10)) > $("#reader-container-wrapper").height() - $("#imgbook").scrollTop()) {
            if(editor.hasClass("annotator-invert-y")) {
              editor.css({
                top: $("#reader-container-wrapper").height() - elemHeight
              });
            } else {
              editor.css({
                top: $("#reader-container-wrapper").height()
              });
            } 
          }
          /* 
          var headerHeight = 0;
          var footerHeight = 0;
          var contentHeight = 200; //some default value*/
            
          /* end */
          mousedown = null;
          return $(window).unbind('.annotator-editor-resize');
        };
        onMousemove = (function() {
          return function(event) {
            var diff, directionX, directionY, height, width;
            if (mousedown && throttle === false) {
              diff = {
                top: event.pageY - mousedown.top,
                left: event.pageX - mousedown.left
              };
              if (mousedown.element === resize[0]) {
                height = textarea.height();
                width = textarea.width();
                directionX = editor.hasClass(classes.invert.x) ? -1 : 1;
                directionY = editor.hasClass(classes.invert.y) ? 1 : -1;
                textarea.height(height + (diff.top * directionY));
                textarea.width(width + (diff.left * directionX));
                if (textarea.height() !== height) {
                  mousedown.top = event.pageY;
                }
                if (textarea.width() !== width) {
                  mousedown.left = event.pageX;
                }
              } else if (mousedown.element === controls[0] || mousedown.element === heading[0]) {
                editor.css({
                  top: parseInt(editor.css('top'), 10) + diff.top,
                  left: parseInt(editor.css('left'), 10) + diff.left
                });
                mousedown.top = event.pageY;
                mousedown.left = event.pageX;
              }
              throttle = true;
              return setTimeout(function() {
                return throttle = false;
              }, 1000 / 60);
            }
          };
        })(this);
        resize.off('mousedown').bind('mousedown', onMousedown);
        heading.off('mousedown').bind('mousedown', onMousedown);
        return controls.off('mousedown').bind('mousedown', onMousedown);
      };
      this.enable_annotation = function(options, annotationId) {
        var pagelabels;
        try {
          pagelabels = comprodls.READER.getPdfPageLevel(); //  Get page number in array format [1,2]
        } catch(e){
          pagelabels = [];
        }
        pagelabels = pagelabels.join("||");
        options.pagelabels = pagelabels;
        /*if(devAnnotator === null || devAnnotator === undefined) {*/
          // If annotations are loaded and page is changed then unload and load annotations of the new page else do not detroy the annotations
          if (devAnnotator && devAnnotator.options && devAnnotator.options.pagelabels !== pagelabels) {
            devAnnotator.unsubscribe("annotationsLoaded");
            devAnnotator.destroy();
            devAnnotator = undefined;            
          } else if (devAnnotator && devAnnotator.options && devAnnotator.options.pagelabels === pagelabels) {
            // If annotations of the page are already loaded just update the options of annotator instance
            devAnnotator.changeOptions(options);
            return;
          }

          var elem = document.getElementById('reader-container');
          devAnnotator = new Annotator(elem, options)
            // .addPlugin('Auth', {
            //    tokenUrl: '/api/token/'
            // })
            .addPlugin('Unsupported')
            .addPlugin('AnnotateItPermissions')
            .addPlugin('Store', {
              prefix: '/api'
              /*loadFromSearch: {
                uri: 'http://localhost/annotator/dev.html'
              },
              annotationData: {
                uri: 'http://localhost/annotator/dev.html'
              }*/
          });

          // devAnnotator.plugins.Auth.withToken(function (tok) {
          //   console.log(tok);
          // })  
        /*}  else {*/

        /*} */
        if(annotationId) {
          devAnnotator.subscribe("annotationsLoaded", function() {
            if($("[data-annotation-id='" + annotationId + "']").length > 0) {
              $("[data-annotation-id='" + annotationId + "']")[0].click();
            } 
          });
        }
      };

      this.disable_annotation = function() {
        if(devAnnotator !== null && devAnnotator !== undefined) {
          devAnnotator.destroy();
          devAnnotator = undefined;
        } else {
          /* create annotator-wrapper if annotation is off */
          var elem = document.getElementById('airlock');
          $(elem).find('script').remove();
          /* Add annotator-wrapper only if its not present.*/
          if(!(($(elem).find('.annotator-wrapper')).length)) {
            /* Adding annotator wrapper.*/
            $(elem).wrapInner(Annotator.prototype.html.wrapper);
            //$(this.element).children(':not(.activity)').wrapAll(this.wrapper);    
          }
        }  
      };

      this.open_annotation = function(annotationId) {
        if (devAnnotator) {
          if($("[data-annotation-id='" + annotationId + "']").length > 0) {
            $("[data-annotation-id='" + annotationId + "']")[0].click();
          } else {
            devAnnotator.subscribe("annotationsLoaded", function() {
              if($("[data-annotation-id='" + annotationId + "']").length > 0) {
                $("[data-annotation-id='" + annotationId + "']")[0].click();
              } 
            });    
          }
        }
      };
    };
    return Annotation;
}());

/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (typeof define === 'function' && define.amd) {
    define(function() {
        return Hammer;
    });
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');

/*! Image eReader - v2.3.7 - 2025-02-17
* www.comprodls.com
* Copyright (c) 2025 ComproDLS | Compro Technologies; Licensed comproDLS © 2015-2016 */
function LRUCache (limit) {
  // Current size of the cache. (Read-only).
  this.size = 0;
  // Maximum number of items this cache can hold.
  this.limit = limit;
  this.oldest = this.newest = undefined;
  this._keymap = {};
}


LRUCache.prototype._markEntryAsUsed = function(entry) {
  if (entry === this.newest) {
    // Already the most recenlty used entry, so no need to update the list
    return;
  }
  // HEAD--------------TAIL
  //   <.older   .newer>
  //  <--- add direction --
  //   A  B  C  <D>  E
  if (entry.newer) {
    if (entry === this.oldest) {
      this.oldest = entry.newer;
    }
    entry.newer.older = entry.older; // C <-- E.
  }
  if (entry.older) {
    entry.older.newer = entry.newer; // C. --> E
  }
  entry.newer = undefined; // D --x
  entry.older = this.newest; // D. --> E
  if (this.newest) {
    this.newest.newer = entry; // E. <-- D
  }
  this.newest = entry;
};

/**
 * Put <value> into the cache associated with <key>. Returns the entry which was
 * removed to make room for the new entry. Otherwise undefined is returned
 * (i.e. if there was enough room already).
 */
LRUCache.prototype.put = function(key, value) {
  var entry = this._keymap[key];

  if (entry) {
    // update existing
    entry.value = value;
    this._markEntryAsUsed(entry);
    return;
  }

  // new entry
  this._keymap[key] = entry = {key:key, value:value, older:undefined, newer:undefined};

  if (this.newest) {
    // link previous tail to the new tail (entry)
    this.newest.newer = entry;
    entry.older = this.newest;
  } else {
    // we're first in -- yay
    this.oldest = entry;
  }

  // add new entry to the end of the linked list -- it's now the freshest entry.
  this.newest = entry;
  this.size++;
  if (this.size > this.limit) {
    // we hit the limit -- remove the head
    return this.shift();
  }
};

/**
 * Purge the least recently used (oldest) entry from the cache. Returns the
 * removed entry or undefined if the cache was empty.
 *
 * If you need to perform any form of finalization of purged items, this is a
 * good place to do it. Simply override/replace this function:
 *
 *   var c = new LRUCache(123);
 *   c.shift = function() {
 *     var entry = LRUCache.prototype.shift.call(this);
 *     doSomethingWith(entry);
 *     return entry;
 *   }
 */
LRUCache.prototype.shift = function() {
  // todo: handle special case when limit == 1
  var entry = this.oldest;
  if (entry) {
    if (this.oldest.newer) {
      // advance the list
      this.oldest = this.oldest.newer;
      this.oldest.older = undefined;
    } else {
      // the cache is exhausted
      this.oldest = undefined;
      this.newest = undefined;
    }
    // Remove last strong reference to <entry> and remove links from the purged
    // entry being returned:
    entry.newer = entry.older = undefined;
    // delete is slow, but we need to do this to avoid uncontrollable growth:
    delete this._keymap[entry.key];
    this.size--;
  }
  return entry;
};

/**
 * Get and register recent use of <key>. Returns the value associated with <key>
 * or undefined if not in cache.
 */
LRUCache.prototype.get = function(key, returnEntry) {
  // First, find our cache entry
  var entry = this._keymap[key];
  if (entry === undefined) { return; }// Not cached. Sorry.
  // As <key> was found in the cache, register it as being requested recently
  this._markEntryAsUsed(entry);
  return returnEntry ? entry : entry.value;
};

// ----------------------------------------------------------------------------
// Following code is optional and can be removed without breaking the core
// functionality.

/**
 * Check if <key> is in the cache without registering recent use. Feasible if
 * you do not want to chage the state of the cache, but only "peek" at it.
 * Returns the entry associated with <key> if found, or undefined if not found.
 */
LRUCache.prototype.find = function(key) {
  return this._keymap[key];
};

/**
 * Update the value of entry with <key>. Returns the old value, or undefined if
 * entry was not in the cache.
 */
LRUCache.prototype.set = function(key, value) {
  var oldvalue, entry = this.get(key, true);
  if (entry) {
    oldvalue = entry.value;
    entry.value = value;
  } else {
    oldvalue = this.put(key, value);
    if (oldvalue) { oldvalue = oldvalue.value; }
  }
  return oldvalue;
};

/**
 * Remove entry <key> from cache and return its value. Returns undefined if not
 * found.
 */
LRUCache.prototype.remove = function(key) {
  var entry = this._keymap[key];
  if (!entry) { return; }
  delete this._keymap[entry.key]; // need to do delete unfortunately
  if (entry.newer && entry.older) {
    // relink the older entry with the newer entry
    entry.older.newer = entry.newer;
    entry.newer.older = entry.older;
  } else if (entry.newer) {
    // remove the link to us
    entry.newer.older = undefined;
    // link the newer entry to head
    this.oldest = entry.newer;
  } else if (entry.older) {
    // remove the link to us
    entry.older.newer = undefined;
    // link the newer entry to head
    this.newest = entry.older;
  } else {// if(entry.older === undefined && entry.newer === undefined) {
    this.oldest = this.newest = undefined;
  }

  this.size--;
  return entry.value;
};

/** Removes all entries */
LRUCache.prototype.removeAll = function() {
  // This should be safe, as we never expose strong refrences to the outside
  this.oldest = this.newest = undefined;
  this.size = 0;
  this._keymap = {};
};

/**
 * Return an array containing all keys of entries stored in the cache object, in
 * arbitrary order.
 */
if (typeof Object.keys === 'function') {
  LRUCache.prototype.keys = function() {
    return Object.keys(this._keymap);
  };
} else {
  LRUCache.prototype.keys = function() {
    var keys = [];
    for (var k in this._keymap) {
      keys.push(k);
    }
    return keys;
  };
}

/**
 * Call `fun` for each entry. Starting with the newest entry if `desc` is a true
 * value, otherwise starts with the oldest (head) enrty and moves towards the
 * tail.
 *
 * `fun` is called with 3 arguments in the context `context`:
 *   `fun.call(context, Object key, Object value, LRUCache self)`
 */
LRUCache.prototype.forEach = function(fun, context, desc) {
  var entry;
  if (context === true) {
    desc = true;
    context = undefined;
  } else if (typeof context !== 'object') {
    context = this;
  }
  if (desc) {
    entry = this.newest;
    while (entry) {
      fun.call(context, entry.key, entry.value, this);
      entry = entry.older;
    }
  } else {
    entry = this.oldest;
    while (entry) {
      fun.call(context, entry.key, entry.value, this);
      entry = entry.newer;
    }
  }
};

/** Returns a JSON (array) representation */
LRUCache.prototype.toJSON = function() {
  var s = new Array(this.size), i = 0, entry = this.oldest;
  while (entry) {
    s[i++] = { key: entry.key, value: entry.value };
    entry = entry.newer;
  }
  return s;
};

/** Returns a String representation */
LRUCache.prototype.toString = function() {
  var s = '', entry = this.oldest;
  while (entry) {
    s += String(entry.key)+':'+entry.value;
    entry = entry.newer;
    if (entry) {
      s += ' < ';
    }
  }
  return s;
};

// Export ourselves
if (typeof this === 'object') { this.LRUCache = LRUCache; }
/*global window*/
(function () {

	/* localStorage may be disabled due to zero-quota issues (e.g. iPad in private browsing mode) */
	var _isLocalStorageEnabled;
	var imgReaderNamespace = "comprodls.imgbook";
	var version = "2.3.7";
	window.Settings = function() {
		/**
		* Purpose: To check if local storage is enabled in browser or not.
		* Input Parameter :none
		* Output : true or false.
		*/
		var isLocalStorageEnabled = function() {
			if (_isLocalStorageEnabled) {
				return true;
			}
			if (typeof _isLocalStorageEnabled === "undefined") {
				_isLocalStorageEnabled = false;
				if (localStorage) {
					try {
						localStorage.setItem("_isLocalStorageEnabled", "?");
						localStorage.removeItem("_isLocalStorageEnabled");
						_isLocalStorageEnabled = true;
					} catch(e) {
				}
			}
			return _isLocalStorageEnabled;
			} else {
				return false;
			}
		};

		/**
		 * Purpose: To set a value for corresponding key in localstorage
		 * Input Parameter :key, value and callback function
		 * Output : none
		 */ 
		this.put = function(key, val, callback){
			if (!isLocalStorageEnabled()) {
				if (callback) {
					callback();
				}
				return;
			}

			val = JSON.stringify(val);
			localStorage[imgReaderNamespace + "." + key + "-" + version] = val;

			if (callback) {
				callback();
			}
		};

		/**
		 * Purpose: To get a value for corresponding key in localstorage
		 * Input Parameter :key and callback function
		 * Output : Value for the corresponding key.
		 */     
		this.get = function(key, callback){
			if (!isLocalStorageEnabled()) {
				if (callback) {
					callback(null);
				}
				return;
			}

			var val = localStorage[imgReaderNamespace + "." + key + "-" + version];
			if (val){
				callback(JSON.parse(val));
			}
			else{
				callback(null);
			}

		};

		/**
		 * Purpose: To get values for all corresponding keys in localstorage
		 * Input Parameter :keys and callback function
		 * Output : Values for the corresponding keys.
		 */         
		this.getMultiple = function(keys, callback) {
			if (!isLocalStorageEnabled()) {
				if (callback) {
					callback({});
				}
				return;
			}

			var retVal = {};
			for (var i = 0; i < keys.length; i++){
				if (localStorage[imgReaderNamespace + "." + keys[i] + "-" + version]){
					retVal[keys[i]] = localStorage[imgReaderNamespace + "." + keys[i] + "-" + version];
				}
			}
			callback(retVal);
		};

		/**
		 * Purpose: To remove all old version keys from localstorage.
		 */         
		this.removeMultiple = function(callback) {
			if (!isLocalStorageEnabled()) {
				if (callback) {
					callback();
				}
				return;
			}			
			var removeItems = [];
			for (var i = 0, len = localStorage.length; i < len; ++i ) {
				var key = localStorage.key(i);
				if(key.indexOf(imgReaderNamespace) !== -1) {
					var localstorageVersion = key.substring(key.lastIndexOf("-") + 1, key.length);
					if(localstorageVersion !== version) {
						removeItems.push(key);
					}
				}
			}
			for (var j = 0; j < removeItems.length; j++) {
				localStorage.removeItem(removeItems[j]);
			}            
			if (callback) {
				callback();
			}
		};


		/**
		 * Purpose: To remove a specific key from localStorage.
		 */         
		this.remove = function(key, callback) {
			if (!isLocalStorageEnabled()) {
				if (callback) {
					callback();
				}
				return;
			}			
			localStorage.removeItem(imgReaderNamespace + "." + key + "-" + version);
			if (callback) {
				callback();
			}
		};
	};
}());
/*global Annotation*/

//Setup Namspace
var comprodls = comprodls || {};

comprodls.READER = (function ()
{
    /********************************************************/
    /*                PRIVATES DATA MEMBERS                 */
    /********************************************************/

    /*  
      Current Page of the book. Initialize during load & updated by next/prev functions
    */
    var __curPage = 1;

    /* 
      Unique identifier for the book. Initialized during load
      For example "wcg" or "ow"
     */
    var __bookId = "";

    var __bookData = "";
    
    /*
      This global variable always has the ORIGINAL / un-modified zoom state, as specified by 
      config/end-user (in case no zoom state was specified as part of the book config, a default is 
      assumed.)
    */                                         
    var __originalZoomingStateData = [];

    /* Loading status of every page - true/false.. used by preloading to avoid loading pages (images) twice */ 
    var __pagesStatus = {};


    /* Objects (one per page) of type comprodls.RENDERER.* - with functions for 
       rendering the eBook  */
    var __pageRendererDivA, 
        __pageRendererDivB,
        __imageRendererDivA, 
        __imageRendererDivB, 
        __html5RendererDivA, 
        __html5RendererDivB;
        
    /* Page Indexes/Serial currently been displayed*/            
    var __firstPage = '';
    var __secondPage = '';

    /* This variable represents the current Zoom State 
    i.e. represented in terms of array index of __originalZoomingStateData */
    var __eeZoomState = -1 ;

    /* Image transform gesture Object */
    var gestureTransform = {};

    /* Last allowed "zoom out"" state (index of the ZoomingStateData array) */
    var __minZoom = 0;

    /* Used by the HTML5 reader strategy */
    var __currentFontSize = '';

    /* Timer for Pre-loader, Automatically controls the preloading in background*/
    var __preloaderTimerId = -1;
    var __preLoaderEnabled = false;
    
    /* For Detecting Idle time, If idle time (no next/prev) exceed 2sec, preloader is 
       initiated background*/
    var __navigationIdleDetectionTimerId = -1;
    var __timeFromLastNavigationEvent = '';

    /* Manages Annotation related functions*/
    var annotationObj;

    var isFitToHeight;

    var scrollbarBuffer = 25;

    // variable to store the event handler passed for reader page click event.
    var captureModeEventHandler = null;

    /* Local Storage, Used to managed the last positions/page serial for a user */
    var lsSettings = new Settings();

    /* Default Config */
    var config = {

        bookBaseFolder : '',
        mediaBaseFolder :'',
        bookAssetServer : '',

        // pageAccessArray for partially downloaded book
        downloadedPageAccessArray: [],
        
        /* Staring default for display */
        initialPageNo: '',  
        pageLayout : '',
        hasCover: true,
        
        /* Is Single page allowed, can be set by user OR controlled via ZoomingStateConfig */
        singleScreen : 'false',
        
        /* Number of page to preload --?? What is the logic*/
        preLoadPages: 4,
        
        /* How many times user is allowed to Zoom out from default ZoomingState*/
        minZoomLimit : 12,
        
        /* Used by HTML5 Reader, Change names */
        baseFontSize : 10,
        
        /* Parent div ids of E-reader page */
        elParent : '',
        elGrandParent : "imgbook_wrapper",
                       
        /* HTML5 reader is enable via this option */
        useWebFonts : false,

        /* Callbacks */
        onBookDataLoad: '',
        onPageLoad: '',
        onPageZoom: '',
        onOverlayJSONLoad: '',
        bookInfo: '', // book json (optional - if passed by the app, imgbook will not make a remote fetch call for book json) 

        
        /* Used to move the laoding of the Book JSON outside of the ImageReader */
        bookDataJSON: '',
        
        /* Function, that returns Height of Container. This should be implemented
           by the caller. */
        contentHeight: undefined,
        isCoverSmall: true, // used only to handle cover size (if provided as false, cover page will be displayed simmilar to other pages)
        showPageSeparator : true,
        enableOverlays: true,
        showAnimation: false,
        animationStyles: ".outer-container .ee-overlay .invisibleHotspot-overlay{animation: changeBackgroundColor 1s linear 6 alternate;} .outer-container .ee-overlay .animation-overlay{animation: changeBackgroundColor 1s linear 6 alternate;}",
        animationTime: 6000, // in miliseconds
        enableAnnotations: false,
        showAnnotationsAlways: false,
        disableAutoLayoutSwitch: false,
        onPinchOutGesture : '',
        onPinchInGesture : '',
        onPinchEndGesture : '',
        startLoader: '',

        paths: {
            "imageRenderer" : {
                "pageSmImgFolder": "images/sm/",
                "pageMedImgFolder": "images/med/",
                "pageLrgImgFolder": "images/lrg/",
                "pageThumbImgFolder": "images/thumbnail/",
                "pagexlLrgImgFolder": "images/xlrg/",

                "pageSmImgTextFolder": "images/smtext/",        
                "pageMedImgTextFolder": "images/medtext/",        
                "pageLrgImgTextFolder": "images/lrgtext/",
                "pageThumbImgTextFolder": "images/thumbnailtext/",
                "pagexlLrgImgTextFolder": "images/xlrgtext/",
                "pageTextDataFolder": "images/json/"
            },
            "bookDataPath": "imgbook-meta/book.json",
            "hotspotDataFolder": "imgbook-meta",
            "mediaFolder" : "overlay-assets",
            "pageTextMetaFolder": "pagetext-meta/"
        },

        // Error Codes as an object to ensure consistency.
        ERROR_CODES: {
            "FILE_NOT_FOUND" : "File not found"
        },
                
        //The array will contain the images entries in order of the decreasing dpi
        imageConfig: [
            {category: "xlarge", width: 3825, height: 4898, dpi: 450, folderRef: "xlrg"},
            {category: "large", width: 2550, height: 3265, dpi: 300, folderRef: "lrg"},
            {category: "medium", width: 1275, height: 1633, dpi: 150, folderRef: "med"},
            {category: "small", width: 816, height: 1045, dpi: 96, folderRef: "sm"},
            {category: "thumbnail", width: 612, height: 784, dpi: 72, folderRef: "thumbnail"}
        ],

        // update the touch device definition to include new ipad versions 13 and above.
        isTouchDevice: /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) || ((navigator.userAgent.indexOf("Mac") > -1) && "ontouchend" in document),
        
        // parameter to enable pinch in mobile devices.
        pinchEnabled: undefined,

        // parameter to check if scrolbar is hidden or shown in APP that uses this library
        isScrollbarHidden: false,

        // toggle swipe, pan and pinch
        isSwipeDisabled: false,
        isPanDisabled: false,
        isPinchDisabled: false,

        // page zoom state on the basis of secreen resolution
        zoomingStateData :
            [
                { pcwidth: 300, singlePage : "true", singlePageFitFactor: 1.0 },
                { pcwidth: 400, singlePage : "true", singlePageFitFactor: 1.0 },
                { pcwidth: 500, singlePage : "true", singlePageFitFactor: 1.0 },
                { pcwidth: 600, singlePage : "true", singlePageFitFactor: 0.90 },
                { pcwidth: 768, singlePage : "true", singlePageFitFactor: 0.80 },
                { pcwidth: 910, singlePage : "true", singlePageFitFactor: 0.80 },
                { pcwidth: 1024, singlePage : "false", singlePageFitFactor: 0.75 },
                { pcwidth: 1120, singlePage : "false", singlePageFitFactor: 0.70 },
                { pcwidth: 1280, singlePage : "false", singlePageFitFactor: 0.65 },
                { pcwidth: 1440, singlePage : "false", singlePageFitFactor: 0.60 },
                { pcwidth: 1800, singlePage : "false", singlePageFitFactor: 0.50 },
                { pcwidth: 2400, singlePage : "false", singlePageFitFactor: 0.50 },
                { pcwidth: 3000, singlePage : "false", singlePageFitFactor: 0.50 },
                { pcwidth: 3600, singlePage : "false", singlePageFitFactor: 0.50 }
            ]
    }; /* End of config */


    //-------------------------------------------------------//

    /*
     *This function is called to start rendering left and right page resources from the server
     * It load the resources for the requested "pageNumber"
     * It updates __startPage for rendering next page
     */

    var initializeRenderer = function(renderer, $element) {
        renderer.initialize({
            $element: $element,
            config: config
        });
    };

    /* Function to check if we need to show double page or single page. */
    var isDoublePage = function() {
        if(config.pageLayout === 'double') {
            if(config.disableAutoLayoutSwitch || config.singleScreen === 'false') {
                return true;
            } else {
                return false;    
            }
        } else {
            return false;
        }
    };
    
    var onSomethingLoaded = function(pageNo) {
        if(config.hasCover) {
            if(isDoublePage()) {
                if(__firstPage === pageNo) {
                    renderPage(pageNo);
                } else if(__secondPage === pageNo) {
                    renderPage(pageNo);
                }
            } else {
                if(__firstPage === pageNo) {
                    renderPage(pageNo);
                }
            }
        } else {
            if(isDoublePage()) {
                if(__firstPage === pageNo) {
                    renderPage(__firstPage);
                } else if(__secondPage === pageNo) {
                    renderPage(__secondPage);
                }
            } else {
                if(__firstPage === pageNo) {
                    renderPage(__firstPage);
                }
            }
        }
    };

    var getPagePreloader = function(renderer) {
        var $element, preloader, isInitialized = true;

        $element = $("#readerpagedivA");

        if(!renderer) {
            if(config.renderer) {
                renderer = config.renderer;
            } else {
                renderer = __bookData.renderer;
            }
        }

        if(renderer === 'image') {
            if(!__imageRendererDivA && $element && $element.length) {
                isInitialized = false;

                // $element = $("#readerpagedivA");
                __imageRendererDivA = new comprodls.RENDERER.IMAGE();
            }
            renderer = __imageRendererDivA;
            preloader = comprodls.RENDERER.IMAGE;
        } else {
            if(config.useWebFonts) {
                if(!__html5RendererDivA && $element && $element.length) {
                    isInitialized = false;

                    // $element = $("#readerpagedivA");
                    __html5RendererDivA = new comprodls.RENDERER.HTML5();
                }
                renderer = __html5RendererDivA;
                preloader = comprodls.RENDERER.HTML5;
            } else {
                if(!__imageRendererDivA && $element && $element.length) {
                    isInitialized = false;
                    
                    // $element = $("#readerpagedivA");
                    __imageRendererDivA = new comprodls.RENDERER.IMAGE();
                }
                renderer = __imageRendererDivA;
                preloader = comprodls.RENDERER.IMAGE;
            }
        }

        if (!isInitialized) {
            initializeRenderer(renderer,$element);

            preloader.prototype.$el = $element;
            preloader.prototype.coreConfig = config;
        }

        return preloader;
    };

    var getPageRenderer = function(renderer,pageType) {
        var $element, isInitialized = true;

        if(!renderer) {
            if(config.renderer) {
                renderer = config.renderer;
            } else {
                renderer = __bookData.renderer;
            }
        }

        if(pageType === "A") {
            $element = $("#readerpagedivA");

            if(renderer === 'image') {
                if(!__imageRendererDivA && $element && $element.length) {
                    isInitialized = false;

                    __imageRendererDivA = new comprodls.RENDERER.IMAGE();
                }
                renderer = __imageRendererDivA;
            } else {
                if(config.useWebFonts) {
                    if(!__html5RendererDivA && $element && $element.length) {
                        isInitialized = false;

                        __html5RendererDivA = new comprodls.RENDERER.HTML5();
                    }
                    renderer = __html5RendererDivA;
                } else {
                    if(!__imageRendererDivA && $element && $element.length) {
                        isInitialized = false;

                        __imageRendererDivA = new comprodls.RENDERER.IMAGE();
                    }
                    renderer = __imageRendererDivA;
                }
            }
        } else if (pageType === "B") {
            $element = $("#readerpagedivB");

            if(renderer === 'image') {
                if(!__imageRendererDivB && $element && $element.length) {
                    isInitialized = false;

                    __imageRendererDivB = new comprodls.RENDERER.IMAGE();
                }
                renderer = __imageRendererDivB;
            } else {
                if(config.useWebFonts) {
                    if(!__html5RendererDivB && $element && $element.length) {
                        isInitialized = false;

                        __html5RendererDivB = new comprodls.RENDERER.HTML5();
                    }
                    renderer = __html5RendererDivB;
                } else {
                    if(!__imageRendererDivB && $element && $element.length) {
                        isInitialized = false;
                        
                        __imageRendererDivB = new comprodls.RENDERER.IMAGE();
                    }
                    renderer = __imageRendererDivB;
                }
            }
        }

        if(!isInitialized) {
            initializeRenderer(renderer,$element);
        }

        return renderer;
    };

    var webFontCheck =  function(pageNumber) {

        var useWebFonts = config.useWebFonts;
        if(__bookData.pages.page[pageNumber].webFonts !== undefined) {
            useWebFonts = __bookData.pages.page[pageNumber].webFonts;
        }

        return useWebFonts;

    };
    var renderPage = function(pageNo, annotationId, isReRendering) {
        setEreaderContainerStyle();
        setupCoverPageAndNextPages(__curPage);
        var pageMetaData = __bookData.pages.page[pageNo];
        var pageType, renderer, $overlaysDiv;

        if (pageMetaData !== undefined) {
            if(pageNo === __firstPage) {
                pageType = 'A';

                if(__pageRendererDivA) {
                    __pageRendererDivA.unrender();
                }

                renderer = __pageRendererDivA = getPageRenderer(pageMetaData.renderer, pageType);
                $overlaysDiv = $("#ee-overlaysA");

            } else if(pageNo === __secondPage) {
                pageType = 'B';

                if(__pageRendererDivB) {
                    __pageRendererDivB.unrender();
                }

                renderer = __pageRendererDivB = getPageRenderer(pageMetaData.renderer, pageType);
                $overlaysDiv = $("#ee-overlaysB");

            } else {
                return;
            }

            renderer.renderPage(pageMetaData, function() {
                if (__pagesStatus[pageNo]) {
                    __pagesStatus[pageNo].resources.rendered = true;    
                }
                if (config.onPageLoad !== undefined && config.onPageLoad !== "") {
                    var pageLoadedData = {};
                    if(isDoublePage()) {
                         if((__firstPage === 0 && config.hasCover) || __firstPage === __bookData.pagecount-1) {
                            pageLoadedData = {
                                firstPage : $.extend({}, __bookData.pages.page[__firstPage])
                            };
                            if (__bookData.pages.page[__firstPage+1]) {
                                pageLoadedData.firstPage.nextPage = $.extend({}, __bookData.pages.page[__firstPage+1]);
                            }
                            if (__bookData.pages.page[__firstPage-1]) {
                                pageLoadedData.firstPage.prevPage = $.extend({}, __bookData.pages.page[__firstPage-1]);
                            }
                            
                            if (config.enableAnnotations) {
                                if (!annotationObj) {
                                    annotationObj = new Annotation();
                                }
                                annotationObj.enable_annotation({readOnly: false},annotationId);
                            } else if(config.showAnnotationsAlways) {
                                if (!annotationObj) {
                                    annotationObj = new Annotation();
                                }
                                annotationObj.enable_annotation({readOnly: true},annotationId);
                            }

                            config.onPageLoad(pageLoadedData);

                         } else {
                            if (__pagesStatus[__firstPage] && __pagesStatus[__firstPage].resources.rendered && __pagesStatus[__secondPage] && __pagesStatus[__secondPage].resources.rendered) {
                                pageLoadedData = {
                                    firstPage : $.extend({}, __bookData.pages.page[__firstPage]),
                                    secondPage : $.extend({}, __bookData.pages.page[__secondPage])
                                };
                                if (__bookData.pages.page[__firstPage+1]) {
                                    pageLoadedData.firstPage.nextPage = $.extend({}, __bookData.pages.page[__firstPage+1]);
                                }
                                if (__bookData.pages.page[__firstPage-1]) {
                                    pageLoadedData.firstPage.prevPage = $.extend({}, __bookData.pages.page[__firstPage-1]);
                                }
                                if (__bookData.pages.page[__secondPage+1]) {
                                    pageLoadedData.secondPage.nextPage = $.extend({}, __bookData.pages.page[__secondPage+1]);
                                }
                                if (__bookData.pages.page[__secondPage-1]) {
                                    pageLoadedData.secondPage.prevPage = $.extend({}, __bookData.pages.page[__secondPage-1]);
                                }
                
                                if (config.enableAnnotations) {
                                    if (!annotationObj) {
                                        annotationObj = new Annotation();
                                    }
                                    annotationObj.enable_annotation({readOnly: false},annotationId);
                                } else if(config.showAnnotationsAlways) {
                                    if (!annotationObj) {
                                        annotationObj = new Annotation();
                                    }
                                    annotationObj.enable_annotation({readOnly: true},annotationId);
                                }

                                config.onPageLoad(pageLoadedData);
                            }    
                        }

                    } else {
                        pageLoadedData = {
                            firstPage : $.extend({}, __bookData.pages.page[pageNo])
                        };
                        if (__bookData.pages.page[pageNo+1]) {
                            pageLoadedData.firstPage.nextPage =  $.extend({}, __bookData.pages.page[pageNo+1]);
                        }
                        if (__bookData.pages.page[pageNo-1]) {
                            pageLoadedData.firstPage.prevPage =  $.extend({}, __bookData.pages.page[pageNo-1]);
                        }
                        
                        if (config.enableAnnotations) {
                            if (!annotationObj) {
                                annotationObj = new Annotation();
                            }
                            annotationObj.enable_annotation({readOnly: false},annotationId);
                        } else if(config.showAnnotationsAlways) {
                            if (!annotationObj) {
                                annotationObj = new Annotation();
                            }
                            annotationObj.enable_annotation({readOnly: true},annotationId);
                        }

                        config.onPageLoad(pageLoadedData);

                    }
                }
                //Store last visited page info in localstorage.
                var json = {lastVisitedPage: pageMetaData};
                var lsKey = __bookId + "-" + config.user_unique_id;
                lsSettings.put(lsKey, json);
                
                renderOverlays(pageNo, webFontCheck(pageNo), pageType, isReRendering);
            });
        }
    };

    var renderOverlays = function(pageIndex, useWebFonts, pageType, isReRendering) {

        function _fetchOverlaysResopnseHandler(response) {
            var hotspotJsonData = response;
            config.overlaysData = {};

            for (var i = 0; i < hotspotJsonData.pages.page.length; i++) {
                var key = hotspotJsonData.pages.page[i].sno;
                var value = hotspotJsonData.pages.page[i].overlays;
                config.overlaysData[key] = value;
            }
            if (config.overlayConfig) {
                config.overlaysData["overlay-config"] = config.overlayConfig;
            } else if (__bookData["overlay-config"]) {
                config.overlaysData["overlay-config"] = __bookData["overlay-config"];
            }

            if (config.onOverlayJSONLoad !== undefined && config.onOverlayJSONLoad !== "") {
                config.onOverlayJSONLoad(config.overlaysData);
            }

            comprodls.OVERLAYSRENDERER.renderOverlaysData(pageIndex, pageType, config.overlaysData, config.paths.mediaFolder, config, __currentFontSize, __bookData.pageWidth, __bookData.pageHeight, __bookData, isReRendering);
            if (__pagesStatus[pageIndex]) {
                __pagesStatus[pageIndex].overlays.rendered = true;
            }
        }

        if(config.enableOverlays) {
            if (!config.overlaysData) {

                // check if overlays json is passed from experience app.
                // if yes, use it else, fetch again from server.
                if (config.bookOverlayJSON && config.bookOverlayJSON !== '') {
                    _fetchOverlaysResopnseHandler(config.bookOverlayJSON);
                } else {
                    var hotSpotContentURL = '';
                    hotSpotContentURL = config.bookAssetServer + config.bookBaseFolder + config.paths.hotspotDataFolder + "/book-overlays.json";

                    comprodls.READER.IMGREADER.UTIL.loadJson(hotSpotContentURL, function (response) {
                        _fetchOverlaysResopnseHandler(response);
                    }, function (fnError) {
                        console.error("rpc error :" + JSON.stringify(fnError.data['status']));
                    });

                }
                
            } else {
                comprodls.OVERLAYSRENDERER.renderOverlaysData(pageIndex,pageType,config.overlaysData,config.paths.mediaFolder,config,__currentFontSize, __bookData.pageWidth, __bookData.pageHeight, __bookData, isReRendering);
                if(__pagesStatus[pageIndex]) {
                    __pagesStatus[pageIndex].overlays.rendered = true;
                }
            }
        } else {
            if(__pagesStatus[pageIndex]) {
                __pagesStatus[pageIndex].overlays.rendered = true;
            }
        }

    };

    var setupCoverPageAndNextPages = function(pageIndex) {

        var $readerpagedivA = $("#readerpagedivA");

        if(!((pageIndex < 1 && config.hasCover) || pageIndex === __bookData.pagecount-1) && isDoublePage()) {
            /*
             *  DOUBLE PAGE SCENARIO
             */
            if (config.enableAnnotations === true) {
                $readerpagedivA.css('width',"50%");
                $("#annotationLeftBar, #annotationRightBar").show();
                if (__bookData.pages.page[__firstPage] && __bookData.pages.page[__firstPage].type === "whitepage") {
                    $("#annotationLeftBar").css("visibility","hidden");
                } else {
                    $("#annotationLeftBar").css("visibility","");
                }
                if  (__bookData.pages.page[__secondPage] && __bookData.pages.page[__secondPage].type === "whitepage") {
                    $("#annotationRightBar").css("visibility","hidden");
                } else {
                    $("#annotationRightBar").css("visibility","");
                }
            } else {
                $readerpagedivA.css('width',"50%");
                $("#annotationLeftBar, #annotationRightBar").hide();
            }

            if (config.enableAnnotations === true) {
                $("#readerpagedivB").removeClass('reader-display-none').css('width',"50%");
            } else {
                $("#readerpagedivB").removeClass('reader-display-none').css('width',"50%");
            }
            
        } else {
            /*
             *  SINGLE PAGE SCENARIO
             *  Also show only one page in case of cover page and last page.
             */
            
            if (config.enableAnnotations === true) {
                $readerpagedivA.css('width',"100%");
                if (getCurrentPagePosition() === "left") {
                    $("#annotationLeftBar").show();
                    $("#annotationRightBar").hide();
                    if (__bookData.pages.page[__firstPage] && __bookData.pages.page[__firstPage].type === "whitepage") {
                        $("#annotationLeftBar").css("visibility","hidden");
                    } else {
                        $("#annotationLeftBar").css("visibility","");
                    }
                } else if (getCurrentPagePosition() === "right") {
                    $("#annotationRightBar").show();
                    $("#annotationLeftBar").hide();
                    if (__bookData.pages.page[__firstPage] && __bookData.pages.page[__firstPage].type === "whitepage") {
                        $("#annotationRightBar").css("visibility","hidden");
                    } else {
                        $("#annotationRightBar").css("visibility","");
                    }
                }
            } else {
                $readerpagedivA.css('width',"100%");
                $("#annotationLeftBar, #annotationRightBar").hide();
            }
            $("#readerpagedivB").addClass('reader-display-none');
        }
    };

    var getAvailableScreenWidth = function() {
        var winWidth;
        if ($("#" + config.elGrandParent).length !== 0) {
            var $elGrandParent = $("#"+config.elGrandParent);
            //If IE 11 and imgbook is in iframe calculate width by a diffrent method
            if (!!(navigator.userAgent.match(/Trident/) && navigator.userAgent.match(/rv[ :]11/)) && window.self !== window.top && document.getElementById(config.elGrandParent) && document.getElementById(config.elGrandParent).clientWidth !== 0) {
                winWidth = $elGrandParent.width() * (document.getElementById(config.elGrandParent).clientWidth / (document.getElementById(config.elGrandParent).getBoundingClientRect().right - document.getElementById(config.elGrandParent).getBoundingClientRect().left));
            } else {
                winWidth = $elGrandParent.width();
            }
        } else {
            winWidth = $(window).width();
        }
        if (config.contentHeight === undefined) {
            return winWidth;
        } else {
            if(config.isScrollbarHidden) {
                scrollbarBuffer = 0;
            }
            if (winWidth > scrollbarBuffer) {
                return winWidth - scrollbarBuffer;
            }
            return winWidth;
        }
    };

    var getContentHeight = function() {
        if (config.contentHeight !== undefined) {
            return config.contentHeight();
        } else {
            return window.innerHeight;
        }
    };
    
    /* 
        Typically, this function is called when end user has either selects RESET ZOOM feature. This
        feature require IMAGE BOOK to automatically resize based on available width 
        (of the container) - accomplished via finding the "closest matching" zoom state (as specified
        in the config).
        
        Parameters:     
            availableWidth: Current true width of container, minus scrollbar, etc. The imageBook has to 
            fit within this area.
        
        Notes:    
            1. __originalZoomingStateData - this global variable always has the ORIGINAL / un-modified
                                            zoom state, as specified by config/end-user (in case no zoom
                                            state was specified as part of the book config, a default is 
                                            assumed.)
            2. config.zoomingStateData - this is a working copy of the original zoom state. Its modified
                                         by the function below - "best match state" is updated such that
                                         pcWidth match the actual with (available width of the container).
                                         
                                         This variable (config.zoomingStateData) is used by various other 
                                         function for calculations.                                              
    */    
    function findBestZoomStateAndUpdate(availableWidth) {

        /* Copy the original "zoomstate"" Array
            
            zoomingStateData : {
                pcWidth: number (or target available width)
                singlePage:  (true/false)
                singlePageFitFactor: number 
            }
        */
        
        var arrayZoomStates = $.extend(true, [], __originalZoomingStateData); 
        
        //Leave this variable undefined.
        var bestMatchIndex;

        /* 
         Check if available/container width is less/equal to the smallest. 
         zoom state (i.e. first element). If yes, our search for the best match
         is over.
         
         Similarly also check if available/container width is higher/equal to 
         larger zoom state. If yes, no need to search further
        */
        if(availableWidth <= arrayZoomStates[0].pcwidth) {
            bestMatchIndex = 0;
        }
        else if(availableWidth >= arrayZoomStates[arrayZoomStates.length-1].pcwidth) {
            bestMatchIndex = arrayZoomStates.length-1;
        }
        
        /*
          Its not the first element, or last. So lets Search!
          
          Setup the limits for search  
        */
        var searchStartIndex = 0;
        var searchEndIndex = arrayZoomStates.length - 1;

        /*
            BINARY SEARCH
            Also known as half-interval search. Finds the position of a target value within a sorted array
            It works by comparing the target value to the middle element of the array; if they are unequal,
            the lower or upper half of the array is eliminated depending on the result
            and the search is repeated in the remaining subarray until it is successful.
        */
        while(bestMatchIndex === undefined) {
            
            /*
               If there are there are only TWO elements left to search, check 
               and END the loop. 
            */
            if(searchEndIndex === searchStartIndex + 1) {
                var distanceFromEnd = Math.abs(availableWidth - arrayZoomStates[searchEndIndex].pcwidth);
                var distanceFromStart = Math.abs(availableWidth - arrayZoomStates[searchStartIndex].pcwidth);
                bestMatchIndex = (distanceFromEnd < distanceFromStart ? searchEndIndex : searchStartIndex);
                break;
            }

            //Locate the Mid point of the Array we're searching..
            var searchMiddleIndex = searchStartIndex + Math.ceil((searchEndIndex - searchStartIndex) / 2);

            var searchStartWidth = arrayZoomStates[searchStartIndex].pcwidth;
            var searchMiddleWidth = arrayZoomStates[searchMiddleIndex].pcwidth;
           
            //Restrict the search to first half or second half... (as per binary search algo)
            if(searchStartWidth <= availableWidth && availableWidth <= searchMiddleWidth) {
                searchEndIndex = searchMiddleIndex;
            }
            else {
                searchStartIndex = searchMiddleIndex;
            }
        }

        /*
            Modify the current config, by replacing the closest match "pcwidth" with the current
            available width
        */
        arrayZoomStates[bestMatchIndex].pcwidth = availableWidth;

        /*
            In ideal case scenarios, 
            the product of pcwidth and singlePageFitFactor must be in increasing order in arrayZoomStates array.
            After the current available width replaces closest match "pcwidth", 
            there is a possibility that this product may not be greater than its previous element in array.
            Due to this, even when user clicks on zoom in(in single page view),
            the image becomes smaller in size(give impression of zoom out) and vice cersa on zoom out.
            So we have added a logic to remove those states from the zoom config,
            which are affecting the the normal increasing order(product of pcwidth and singlePageFitFactor) in the array.
        */
        var updatedArrayZoomStates =[];
        var minZoomDiff = 1; // Minimum pixel difference(of product of pcwidth and singlePageFitFactor) that must exist between 2 consecutive zoom states
        for (var i =0,j=0; i < arrayZoomStates.length-1; i++ ) {
            if (arrayZoomStates[i+1].pcwidth*arrayZoomStates[i+1].singlePageFitFactor - arrayZoomStates[i].pcwidth*arrayZoomStates[i].singlePageFitFactor >= minZoomDiff) {
                updatedArrayZoomStates[j] = arrayZoomStates[i];
                j++;
            } else if (arrayZoomStates[i+1].pcwidth !== availableWidth) {
                updatedArrayZoomStates[j] = arrayZoomStates[i];
                j++;
                i++;
            } else {
                i++;
                updatedArrayZoomStates[j] = arrayZoomStates[i];
                j++;
                bestMatchIndex--;
            }          
        }         
        updatedArrayZoomStates[j] = arrayZoomStates[arrayZoomStates.length-1];
        config.zoomingStateData = updatedArrayZoomStates;
        $.each(config.zoomingStateData, function(i) {
            if(config.zoomingStateData[i].pcwidth > 768) {
                config.zoomingStateData[i].singlePage = "false"; 
            }
        });

        // override best match index if it is passed to this library 
        if(config.bestMatchZoomStateIndex!==undefined && config.bestMatchZoomStateIndex > -1) {
            return config.bestMatchZoomStateIndex;
        }

        //Return the Best Match Index
        return bestMatchIndex;

    }

    // resetZoomParametersFromConfig - the function reverts to current zoomSate.
    var  resetZoomParametersFromConfig = function(availableWidth) {
        
        var bestMatchZoomState = findBestZoomStateAndUpdate(availableWidth);
        
        //Update Internal Page Display variables
        __eeZoomState = bestMatchZoomState;
        __minZoom = __eeZoomState  -  config.minZoomLimit;

        //Check if we need change the layout (single to double of vica-versa)
        if(config.zoomingStateData[__eeZoomState].singlePage !== config.singleScreen) {
           
           //Update the config 
           config.singleScreen =  config.zoomingStateData[__eeZoomState].singlePage;
           
            /*
                If the user had previously selected a DOUBLE PAGE view, but there wasn't enough
                space for a double-page (and reader had forced a single page) . Now change the layout
                if double page is allowed.
            */   
            if(isDoublePage() && __pagesStatus[__curPage]) {
                config.pageLayout = "single";
                changePageLayout("double");
            }

            // trigger a callback in studentbook when page layout is changed automatically upon resize.
            if(config && typeof config.onPageLayoutChange === "function") {
                config.onPageLayoutChange();
            }

        }
    };
    
    var setEreaderContainerStyle = function(zoomedWidth, zoomedHeight) {

        var availableScreenWidth = getAvailableScreenWidth();
        var translateX = gestureTransform.translateX || 0;
        var contentWidth;

        var pcWidth;
        if(zoomedWidth) {
            pcWidth = zoomedWidth;
        } else {
            pcWidth = config.zoomingStateData[__eeZoomState].pcwidth;
        }
        var $elParent = $("#"+config.elParent);
        var readerHeight, contentHeight, heightDiff;
        
        if(!( (__curPage < 1 && config.hasCover) || __curPage === __bookData.pagecount-1) && isDoublePage()) {
            __currentFontSize = config.baseFontSize * pcWidth/ __bookData.pageWidth / 2;
            if (config.enableAnnotations === true) {
                readerHeight = __bookData.pageHeight/__bookData.pageWidth * (pcWidth/2) ;
            } else {
                if(zoomedHeight) {
                    readerHeight = zoomedHeight; 
                } else {
                    readerHeight = __bookData.pageHeight/__bookData.pageWidth * pcWidth/2 ;
                }
            }            
            if (config.contentHeight === undefined) {
                $elParent.css({
                    "width" : pcWidth + "px",
                    "font-size" : __currentFontSize + "px",
                    'height' :  Math.round(readerHeight)
                });
            } else {
                contentHeight = config.contentHeight();
                $elParent.css({
                    "font-size" : __currentFontSize + "px",
                    "overflow" : "auto",
                    'height' : contentHeight
                });
                var $readerContainerWrapper = $elParent.find("#reader-container-wrapper");
                $readerContainerWrapper.css({
                  "width" : pcWidth + "px",
                  'height' :  Math.round(readerHeight)
                });

                // if touch device use translate for centre aligning else use margin
                setEreaderContainerAlignment($readerContainerWrapper, contentWidth, availableScreenWidth, translateX);

                if (readerHeight < contentHeight) {
                    heightDiff = contentHeight - readerHeight;
                    $readerContainerWrapper.css("top", heightDiff/2);
                } else {
                    $readerContainerWrapper.css("top", "");
                }
            }
            if (config.enableAnnotations === true) {
                $("#annotationRightBar, #annotationLeftBar").css({
                    "width" : "0%",
                    'height' :  Math.round(readerHeight)
                });
            }

            //call resize handlers of the renderers
            if(__pagesStatus[__firstPage] && __pageRendererDivA) {

                __pageRendererDivA.resizeHandler(__bookData.pages.page[__firstPage]);
            }
            if(__pagesStatus[__secondPage] && __pageRendererDivB) {
                __pageRendererDivB.resizeHandler(__bookData.pages.page[__secondPage]);
            }
        } else {

            if(config.isTouchDevice) {
                if(zoomedWidth) {
                    pcWidth = zoomedWidth;
                } else {
                    pcWidth = config.zoomingStateData[__eeZoomState].pcwidth;
                }
            } else {

                if(config.zoomingStateData[__eeZoomState].singlePageFitFactor) {
                    pcWidth = config.zoomingStateData[__eeZoomState].pcwidth * config.zoomingStateData[__eeZoomState].singlePageFitFactor;
                } else {
                    pcWidth = config.zoomingStateData[__eeZoomState].pcwidth * 0.65;
                }
                if(isFitToHeight) {
                    pcWidth = config.zoomingStateData[__eeZoomState].pcwidth;
                }             
                if (__curPage < 1 && config.hasCover) {
                    if(config.isCoverSmall) {
                        pcWidth = config.zoomingStateData[__eeZoomState].pcwidth * 0.45;
                    }
                    if(isFitToHeight) {
                        if(!isDoublePage()) {
                            pcWidth = config.zoomingStateData[__eeZoomState].pcwidth;
                        } else {
                            pcWidth = config.zoomingStateData[__eeZoomState].pcwidth * 0.5;
                        }
                    }
                }
                if (!isNotLastPageSingleInDoublePageMode(__curPage) && isFitToHeight) {
                    pcWidth = config.zoomingStateData[__eeZoomState].pcwidth * 0.50;
                    if(!isDoublePage()) {
                        pcWidth = config.zoomingStateData[__eeZoomState].pcwidth;
                    }
                }
            }
            
            __currentFontSize = config.baseFontSize * pcWidth / __bookData.pageWidth ;
            if (config.enableAnnotations === true) {
                readerHeight = __bookData.pageHeight/__bookData.pageWidth * (pcWidth) ;
            } else {
                if(zoomedHeight) {
                    readerHeight = zoomedHeight;
                } else {
                    readerHeight = __bookData.pageHeight/__bookData.pageWidth * pcWidth ;
                }
            }
            if (config.contentHeight === undefined) {
                $elParent.css({
                    "width" : pcWidth + "px",
                    "font-size" : __currentFontSize + "px",
                    'height' :  Math.round(readerHeight)
                });
            } else {
                contentHeight = config.contentHeight();
                $elParent.css({
                    "font-size" : __currentFontSize + "px",
                    "overflow" : "auto",
                    'height' : contentHeight
                });
                var $readerContainerWrapperElement = $elParent.find("#reader-container-wrapper");
                $readerContainerWrapperElement.css({
                    "width" : pcWidth + "px",
                    'height' :  Math.round(readerHeight)
                });
  
                // if touch device use translate for centre aligning else use margin
                setEreaderContainerAlignment($readerContainerWrapperElement, contentWidth, availableScreenWidth, translateX);

                if (readerHeight < contentHeight) {
                    heightDiff = contentHeight - readerHeight;
                    $readerContainerWrapperElement.css("top", heightDiff/2);
                } else {
                    $readerContainerWrapperElement.css("top", "");
                }
            }
            if (config.enableAnnotations === true) {
                 $("#annotationLeftBar,#annotationRightBar").css({
                    "width" : "0",
                    'height' : Math.round(readerHeight)
                });

            }
            /*$elParent.find("#reader-container").css({
                "width" : pcWidth + "px",
                "font-size" : __currentFontSize + "px",
                'height' :  Math.round(__bookData.pageHeight/__bookData.pageWidth * pcWidth)
            });*/

            //call resize handlers of the renderers
            if(__pagesStatus[__firstPage] && __pageRendererDivA) {
                __pageRendererDivA.resizeHandler(__bookData.pages.page[__firstPage]);
            }

        }

    };

    var setEreaderContainerAlignment = function (element, contentWidth, availableScreenWidth, translateX) {
        if (config.isTouchDevice) {
            contentWidth = (document.querySelector('#reader-container') && document.querySelector('#reader-container').getBoundingClientRect().width) || 0;
            if (availableScreenWidth >= contentWidth) {
                translateX = (availableScreenWidth - contentWidth) / 2;
            }
            gestureTransform.translateX = translateX;
            $("#reader-container").css("transform", 'translate(' + gestureTransform.translateX + 'px, ' + gestureTransform.translateY + 'px)');
            setTranslateValues(gestureTransform);
        } else {
            element.css({
                "margin": "0 auto"
            });
        }
    };

    /*
     * This function is called to start loading page resource from the server
     * using information available in __bookData.
     *
     * It load the resources for the requested "pageNumber" and continue pre-fectch
     * subsequent pages based pre-fetching algo.
     *
     * It updates __pagesLoadingStatus for each page/resource loaded
     *
     * It fires the following events
     *  - onPageLoad(pageNum)
     *
     */
    var startPageResourceLoading = function(pageNumber, callBackLoaded) {

        var initializeStatusFlags = function(pageNo)  {
            __pagesStatus[pageNo] = {
                resources: {
                    preloaded: false,
                    rendered: false
                },
                overlays: {
                    preloaded: true,    //Do not preload the overlays
                    rendered: false
                }
            };

        };

        if( __pagesStatus[pageNumber] === undefined) {
            initializeStatusFlags (pageNumber);
        }

        var pageMetaData = __bookData.pages.page[pageNumber];

        if (pageMetaData !== undefined) {
            var pagePreloader = getPagePreloader(pageMetaData.renderer);

            pagePreloader.preload(pageMetaData, function() {
                 if (__pagesStatus[pageNumber]) {
                    __pagesStatus[pageNumber].resources.preloaded = true;
                    onSomethingLoaded(pageNumber);

                    if(typeof callBackLoaded  !== 'undefined') {
                        callBackLoaded();
                    }
                }
            });
        }
    };

    var initializeEReaderPinch = function() {
        /*Gesture Variables start*/

        // Variable to track if pinch event is going on or not.
        // Used to stop pan while pinch is in process.
        var isPinchEventGoingOn = false;

        var initialWidth = $("#reader-container").width();
        var gestureReaderContainerElement, requestAnimationForReaderArea, animateReaderAreaForGestures;
        var gesturePanInitX = 0;
        var gesturePanInitY = 0;
        var gestureScaleInit = 1;
        var gestureCenterX = 0;
        var gestureCenterY = 0;
        var pinchended = false;     
        // requestAnimationFrame tick
        var gestureTicking = false;
        // Save all current transform values like scale, translate etc.
        /*var gestureTransform = {};*/
        gestureTransform.translateX = gesturePanInitX;
        gestureTransform.translateY = gesturePanInitY;
        gestureTransform.pinchActive = false;
        /*Gesture Variables end*/

        /*
         * Enable Hammer gesture support only in mobile devices
         */ 
        //gestureImgBookElement = document.querySelector("#imgbook");
        gestureReaderContainerElement = document.querySelector('#reader-container');
        var gesture = new Hammer.Manager(gestureReaderContainerElement);
        gesture.add(new Hammer.Pan({ threshold: 20, pointers: 1 }));
        gesture.add(new Hammer.Swipe({ threshold: 20, velocity: 0.7 })).recognizeWith([gesture.get('pan')]);
        gesture.add(new Hammer.Pinch({ threshold: 0, pointers: 2 }));
        //gesture.add(new Hammer.Pinch({ threshold: 0 })).recognizeWith([gesture.get('pan')]);
        
        var onSwipe = function( ev ) {

            // return if swipe feature is disabled.
            if(config.isSwipeDisabled) {
                return;
            }

            // width of imgbook || outer-container || grandparent || actual width available to show content.
            // content container - offsetleft - tocwidth. all handled here.
            var imgbookContainerWidth = getAvailableScreenWidth();

            if (ev.type === 'swipeleft') {

                // if content width + scrolled width ( is negative ) is less than container width 
                // i.e i have reached the end while panning and then a swipe has occured then change the page else dont.
                // TODO : use velocity when required => Math.abs(ev.overallVelocityX) > 1.8
                if ( (gestureReaderContainerElement.getBoundingClientRect().width + gestureTransform.translateX <= imgbookContainerWidth) ) {

                    // In case user is on last page do not start loading next page
                    var pageserials = getCurrentSerial();
                    if (pageserials[0] === __bookData.pagecount || pageserials[1] === __bookData.pagecount) {
                        return;
                    }

                    // Use next page function from studentbook if required else use native function.
                    if (config.swipeNextPage) {
                        config.swipeNextPage();
                    } else {
                        if (config.startLoader) {
                            config.startLoader();   
                        }
                        pageNavigator('next');
                    }

                }


            }

            if (ev.type === 'swiperight') {


                // if the scrolled width is 0 that means the content cant be panned any furthur 
                // i.e i have reached the end while panning and then a swipe has occured then change the page else dont.
                // TODO : use velocity when required => Math.abs(ev.overallVelocityX) > 1.8
                if ( (Math.abs(gestureTransform.translateX) <= 1) ) {

                    // In case user is on first page do not start loading previous page
                    var pageserial = getPageNumber();
                    if (pageserial === 0) {
                        return;
                    }

                    // Use prev page function from studentbook if required else use native function.
                    if (config.swipePrevPage) {
                        config.swipePrevPage();
                    } else {
                        if (config.startLoader) {
                            config.startLoader();   
                        }
                        pageNavigator('previous');
                    }
                    
                }

            }
            
        };

        var onPan = function( ev ) {

            if(config.isPanDisabled) {
                return;
            }

            // Check if pan was called right-after or while pinch is in process.
            // If yes, it may have been accidental and return from here.
            if(isPinchEventGoingOn) {
				return;
            }
            
            /*
             * 1) Prevent panning if horizontal && vertical scrolling is not available
             * 2) Allow only panup/pandown if vertical scroll is available but horizontal scroll is not
             */
            
            
            /*if($('#reader-container-wrapper')[0].scrollWidth >= gestureReaderContainerElement.getBoundingClientRect().width){
                if($('#reader-container-wrapper')[0].scrollHeight >= gestureReaderContainerElement.getBoundingClientRect().height)
                    return;
                else
                    if(ev.type !== 'panstart' && ev.type != "panup" && ev.type != "pandown")
                        return;
            }*/
            var imgbookContainerHeight = getContentHeight();
            var imgbookContainerWidth = getAvailableScreenWidth();

            // Fix for issue NEMO-5619.
            // Commenting the if check as now the panning will be controlled via getTranslateCorrectedValue().
            // if( (gestureReaderContainerElement.getBoundingClientRect().width <= imgbookContainerWidth) && (imgbookContainerHeight >= gestureReaderContainerElement.getBoundingClientRect().height)) {
            //   return;
            // } 

            /*
             * capture translateX and translateY on panstart
             */

            // X,Y correction code here is nt required anymore as it is handled seperately. 
            if ( ev.type === 'panstart' ) {
                gesturePanInitX = parseInt(gestureTransform.translateX,10);
                gesturePanInitY = parseInt(gestureTransform.translateY,10);
            }

            /*
             * Do not allow user's pan event to detach imgbook from its corners. negative panning is not allowed! 
             */
            
            gestureTransform.translateX = gesturePanInitX + ev.deltaX;
            // get corrected translate values for X translate.
            gestureTransform.translateX =  getTranslateCorrectedValue(gestureTransform.translateX, gestureReaderContainerElement.getBoundingClientRect().width, imgbookContainerWidth);

            gestureTransform.translateY = gesturePanInitY + ev.deltaY;
            // get corrected translate values for Y translate.
            gestureTransform.translateY =  getTranslateCorrectedValue(gestureTransform.translateY, gestureReaderContainerElement.getBoundingClientRect().height, imgbookContainerHeight);

            
            requestAnimationForReaderArea("pan");
        };

        var onPinch = function( ev ) {

            if(config.isPinchDisabled) {
                return;
            }
            //Dont allow page to zoom out below best fit.
            var availableWidth = getAvailableScreenWidth();
            var bestMatchZoomState = findBestZoomStateAndUpdate(availableWidth);
            if(ev.type === "pinchout" && !canZoomIn()) {
                return;
            }
            if(ev.type === "pinchin" ) {
                
                if(__eeZoomState <= bestMatchZoomState){
                    __eeZoomState = bestMatchZoomState - 1;
                    pageZoomIn();

                    if (config.onPinchInGesture !== undefined && config.onPinchInGesture !== "") {
                        config.onPinchInGesture();
                    }
                    return;
                }else{
                    if (config.onPinchInGesture !== undefined && config.onPinchInGesture !== "") {
                        config.onPinchInGesture();
                    }
                }
            }
            if(ev.type === "pinchend"){

                // set pinchend event false after a delay to prevent accidental pan event trigger after pinchend.
                setTimeout(function(){
					isPinchEventGoingOn = false;	
				},100);


                pinchended = true;
                //Dont allow page to zoom out below best fit.
                if(__eeZoomState < bestMatchZoomState) {
                    __eeZoomState = bestMatchZoomState - 1;
                    pageZoomIn();
                }
                if(__eeZoomState > bestMatchZoomState && gestureReaderContainerElement.getBoundingClientRect().width > availableWidth) {
                    gestureTransform.scale = 1;
                    setEreaderContainerStyle(gestureReaderContainerElement.getBoundingClientRect().width, gestureReaderContainerElement.getBoundingClientRect().height);
                }

                // this case is handled seperately in translateCorrection()
                // will be deleted onces the changes are tested and confirmed.
                // if(gestureTransform.translateX > 0) {
                //     pinchended = false;
                //     gestureTransform.translateX = 0;
                //     gestureTransform.translateY = 0;
                //     requestAnimationForReaderArea("pinch"); 
                // }
                
                if(config.onPinchEndGesture !== undefined && config.onPinchEndGesture !== "") {
                  config.onPinchEndGesture();
                }

                gestureTransform.pinchActive = false;
                translateCorrection();
                return;
            }
            if (ev.type === 'pinchstart') {
                isPinchEventGoingOn = true;
                gestureScaleInit = gestureTransform.scale;
                gesturePanInitX = gestureTransform.translateX;
                gesturePanInitY = gestureTransform.translateY;
                gestureCenterX = ev.center.x;
                gestureCenterY = ev.center.y;   
                gestureTransform.pinchActive = true;   
            }                

            if(ev.type === 'pinchout') {
              if(config.onPinchOutGesture !== undefined && config.onPinchOutGesture !== "") {
                config.onPinchOutGesture();  
              }
            }

            var scale = gestureScaleInit * ev.scale;
            var crtPointerPosX = gestureCenterX - gesturePanInitX;
            var crtPointerPosY = gestureCenterY - gesturePanInitY;

            var finalPointerPosX = crtPointerPosX * ( scale / gestureScaleInit );
            var finalPointerPosY = crtPointerPosY * ( scale / gestureScaleInit );

            var transX = gesturePanInitX + crtPointerPosX - finalPointerPosX;

            var transY = gesturePanInitY + crtPointerPosY - finalPointerPosY;
            gestureTransform.translateX = transX;
            gestureTransform.translateY = transY;
            gestureTransform.scale = scale;
            requestAnimationForReaderArea("pinch");
            var containerWidth = gestureReaderContainerElement.getBoundingClientRect().width;
            var minDiff = initialWidth;
            var zoomstate;
            $.each(config.zoomingStateData, function(i) {
                if(minDiff > Math.abs(containerWidth - config.zoomingStateData[i].pcwidth)) {
                    minDiff = Math.abs(containerWidth - config.zoomingStateData[i].pcwidth);
                    zoomstate = i;
                }
            });
            __eeZoomState = zoomstate;
        };

        // Register hammer.js events
        gesture.on("panstart panup pandown panleft panright", onPan);
        gesture.on("swipeleft swiperight", onSwipe);
        gesture.on("pinchstart pinchout pinchin pinchend", onPinch);

        /* "Throttle" touchmove/pointermove event with requestAnimationFrame */
        requestAnimationForReaderArea = function(eventType, value) {
            if ( !gestureTicking ) {
                window.requestAnimationFrame( function() {
                    animateReaderAreaForGestures(eventType, value);
                } );
                gestureTicking = true;
            }
        };

        animateReaderAreaForGestures = function() {
            if(!pinchended) {
                setTranslateValues(gestureTransform);
            }
            gestureTicking = false;
            pinchended = false;                   
        };

        gestureTransform.scale = 1;
        requestAnimationForReaderArea();

        $(window).on('blur',function(){
            gestureTransform.translateX = 0;
            gestureTransform.translateY = 0;
            requestAnimationForReaderArea();
        });
    };

    /* function generate the html for ereader page.
     * set #pagecontent width and base font size
     */
    var  createAndSetupDom = function() {

        /* ---------------- PRIVATE FUNCTIONS FOR SETUP DOM ------------------------*/

        var $elParent = $("#"+config.elParent);

        $elParent.find("#reader-container-wrapper").remove();
        //$elParent.find("#videojsdiv").remove();

        $elParent.addClass('outer-container');

        //Added class="needsclick" class on annotationLeftBar and annotationRightBar for FastClick to ignore these elements.
        $elParent.append('<div id="reader-container-wrapper"><div role="region" aria-live="polite" id="reader-container" class="readerContainer"><span id="annotationLeftBar" class="needsclick"></span><span id="annotationRightBar" class="needsclick"></span></div></div>'/*+ 
            '<div id="videojsdiv" style="display:none"></div>'*/);
        
        var $readerContainer = $elParent.find("#reader-container");
        if(config.showPageSeparator) {
            $readerContainer.append('<div id="readerpagedivA" class="readerpagediv reader-inner-border-right"></div>');
        } else {
            $readerContainer.append('<div id="readerpagedivA" class="readerpagediv"></div>');
        }

        var $readerpagedivA = $readerContainer.find("#readerpagedivA");

        $readerpagedivA.append(
            '<div id="ee-overlaysA" class="readerpagediv ee-transparentImage"> </div>'
        );

        if(config.showPageSeparator) {
            $readerContainer.append('<div id="readerpagedivB" class="readerpagediv reader-inner-border-left"></div>');
        } else {
            $readerContainer.append('<div id="readerpagedivB" class="readerpagediv"></div>');
        }

        var $readerpagedivB = $readerContainer.children("#readerpagedivB");

        $readerpagedivB.append(
            '<div id="ee-overlaysB" class="readerpagediv ee-transparentImage"></div>'
        );
    };


    /**
     * function to get translate values and check it with current content w,h and container w,h if the content has to be translated
     * such that no grey space is visible on edges. 
     * To prevent image book from detaching from corners. 
     */
    var translateCorrection = function() {

        var imgbookContainerHeight = getContentHeight();
        var imgbookContainerWidth = getAvailableScreenWidth();
        var gestureReaderContainerElement = document.querySelector('#reader-container');
      
        if (Math.floor(gestureReaderContainerElement.getBoundingClientRect().width) > Math.floor(imgbookContainerWidth)) {
            // get corrected translate values for X translate.
            gestureTransform.translateX = getTranslateCorrectedValue(gestureTransform.translateX, gestureReaderContainerElement.getBoundingClientRect().width, imgbookContainerWidth);
        }

        if (Math.floor(gestureReaderContainerElement.getBoundingClientRect().height) > Math.floor(imgbookContainerHeight)) {
            // get corrected translate values for Y translate.
            gestureTransform.translateY = getTranslateCorrectedValue(gestureTransform.translateY, gestureReaderContainerElement.getBoundingClientRect().height, imgbookContainerHeight);
        } else {
            gestureTransform.translateY = 0;
        }
      
        // set the corrected values.
        setTranslateValues(gestureTransform);
      
        //vertical align the imgbook if content height is less than container height.
        verticalAlignReaderContainerWrapper();
      
    };

    var resetPageStatus = function(pageNo) {
        if(__pagesStatus[pageNo] !== undefined) {

            __pagesStatus[pageNo].resources.rendered = false;
            __pagesStatus[pageNo].overlays.rendered = false;
        }
    };

    var getCurrentContainerWidth = function() {
        var pcWidth = config.zoomingStateData[__eeZoomState].pcwidth;
        return pcWidth;
    };

    var getPageNumber = function() {
        return __firstPage;
    };

    var getBookTotalPage = function() {
        return __bookData.pagecount;
    };

    var getPageLevel = function() {

        var pageLevelArray =[];

        if(isDoublePage()) {

            if(__firstPage === 0 && config.hasCover) {
                pageLevelArray.push(__bookData.pages.page[__firstPage].pagelabel);
            } else if (__firstPage === __bookData.pagecount-1) {
                pageLevelArray.push(__bookData.pages.page[__firstPage].pagelabel);
            } else {
                pageLevelArray.push(__bookData.pages.page[__firstPage].pagelabel);
                pageLevelArray.push(__bookData.pages.page[__firstPage + 1].pagelabel);
            }

        } else {
            pageLevelArray.push(__bookData.pages.page[__firstPage].pagelabel);
        }
        return pageLevelArray;
    };

    var getCurrentSerial = function() {
        var pageSerialArray =[];

        if(isDoublePage()) {
            if(__firstPage === 0 && config.hasCover) {
                pageSerialArray.push(__bookData.pages.page[__firstPage].sno);
            } else if (__firstPage === __bookData.pagecount-1) {
                pageSerialArray.push(__bookData.pages.page[__firstPage].sno);
            } else {
                pageSerialArray.push(__bookData.pages.page[__firstPage].sno);
                pageSerialArray.push(__bookData.pages.page[__firstPage + 1].sno);
            }
        } else {
            pageSerialArray.push(__bookData.pages.page[__firstPage].sno);
        }
        return pageSerialArray;
    };

    var jumpToPageLabel = function(pdfLevel, isSearch) {

        var pdfLevelFlag = false;

        try {
            for(var i = 0 ; i <__bookData.pagecount; i++) {
                var bookJsonData = (__bookData.pages.page[i].pagelabel).toString();
                if(bookJsonData.toLowerCase() === pdfLevel.toLowerCase()) {

                    var pageNo = parseInt(parseInt(__bookData.pages.page[i].sno, 10) - 1,null);
                    gotoPageNavigator(pageNo, isSearch);
                    pdfLevelFlag = true;
                }

            }
        }
        catch(error) {
            console.log("catach block error : " + error.message + " : "+ i);
        }
        return pdfLevelFlag;
    };

    var jumpToPageSerial = function(serialNo, isSearch) {
        var pdfLevelFlag = false;
        try {
            var pageNo = serialNo - 1;
            gotoPageNavigator(pageNo, isSearch);
            pdfLevelFlag = true;
        } catch(error) {
            console.log("catach block error : " + error.message);
        }

        return pdfLevelFlag;
    };

    var getPageLayout = function() {
        return config.pageLayout;
    };

    var getPageScreen = function() {
        if( __curPage === 0 && config.hasCover) {
            return "true";
        } else if (config.disableAutoLayoutSwitch) {
            return "false";
        } else {
            return config.singleScreen;
        }
    };
    var gotoPageNavigator = function(pageNo, isSearch) {
        var searchPage;
        if (isSearch) {
            searchPage = pageNo;
        }
        var startPageLoading = function(pageNo) {

            if(isDoublePage() && !(__curPage < 1 && config.hasCover)) {
                //For double page layout, we need to load the current 2 pages before preloading
                var leftPageLoaded = false;
                var rightPageLoaded = false;
                var preloaderNotstarted = true;
                startPageResourceLoading(pageNo,function() {
                    leftPageLoaded = true;
                    if (searchPage === pageNo) {
                        $("#readerpagedivA").append('<div class="readerpagediv search-alert"></div><div class="search-popover popover top"> <div class="popover-content"><p>' + __bookData.pages.page[searchPage].pagelabel  + '</p></div>  </div>');

                    }
                    if(leftPageLoaded && rightPageLoaded && preloaderNotstarted) {
                        preloaderNotstarted = false;
                        setTimeout(function() {
                            startPreloading();
                        },1000);
                        setTimeout(function() {
                           $(".search-alert, .search-popover").fadeOut(1000, function() { $(".search-alert").remove();$(".search-popover").remove();});
                        },2000);
                    }
                });
                startPageResourceLoading((pageNo * 1)+1,function() {
                    rightPageLoaded = true;
                    if (searchPage === (pageNo * 1)+1) {
                        $("#readerpagedivB").append('<div class="readerpagediv search-alert"></div><div class="search-popover popover top"> <div class="popover-content"><p>' + __bookData.pages.page[searchPage].pagelabel  + '</p></div>  </div>');
                    }
                    if(leftPageLoaded && rightPageLoaded && preloaderNotstarted) {
                        preloaderNotstarted = false;
                        setTimeout(function() {
                            startPreloading();
                        },1000);
                        setTimeout(function() {
                            $(".search-alert, .search-popover").fadeOut(1000, function() { $(".search-alert").remove();$(".search-popover").remove();});
                        },2000);
                    }
                });

            } else {
                //For single page layout, we need to load only 1 page before starting the preloading
                startPageResourceLoading(pageNo,function() {
                    setTimeout(function() {
                        startPreloading();
                    },1000);
                });
            }

        };
        var currentDisplayedPage = __curPage;
        __curPage = pageNo;
        if(isDoublePage()) {
            if (config.hasCover) {
                if (__curPage % 2 === 0 && __curPage !== 0) {
                    __curPage--;
                }
            } else if (__curPage % 2 !== 0) {
                __curPage--;
            }
            
        }

        var pageToBeDisplayed = __curPage;

        if(currentDisplayedPage !== pageToBeDisplayed) {
            stopPreLoading();
            var $elParent = $("#"+config.elParent);
            $elParent.find("#ee-overlaysA").empty();
            $elParent.find("#ee-overlaysB").empty();

            __firstPage = (__curPage);
            __secondPage = __firstPage + 1;

            resetPageStatus(__firstPage);
            resetPageStatus(__secondPage);
            startPageLoading(__firstPage);
        } else {
            // In case the user is already on the page to be displayed, the pageLoaded event was not being called. Issue fixed.
            if (config.onPageLoad !== undefined && config.onPageLoad !== "") {
                var pageLoadedData;
                if(isDoublePage()) {
                    pageLoadedData = {
                        firstPage : $.extend({}, __bookData.pages.page[__firstPage]),
                        secondPage : $.extend({}, __bookData.pages.page[__secondPage])
                    };
                    if (__bookData.pages.page[__firstPage+1]) {
                        pageLoadedData.firstPage.nextPage = $.extend({}, __bookData.pages.page[__firstPage+1]);
                    }
                    if (__bookData.pages.page[__firstPage-1]) {
                        pageLoadedData.firstPage.prevPage = $.extend({}, __bookData.pages.page[__firstPage-1]);
                    }
                    if (__bookData.pages.page[__secondPage+1]) {
                        pageLoadedData.secondPage.nextPage = $.extend({}, __bookData.pages.page[__secondPage+1]);
                    }
                    if (__bookData.pages.page[__secondPage-1]) {
                        pageLoadedData.secondPage.prevPage = $.extend({}, __bookData.pages.page[__secondPage-1]);
                    }
                    
                    config.onPageLoad(pageLoadedData);
                } else {
                    pageLoadedData = {
                        firstPage : $.extend({}, __bookData.pages.page[__firstPage])
                    };
                    if (__bookData.pages.page[__firstPage+1]) {
                        pageLoadedData.firstPage.nextPage = $.extend({}, __bookData.pages.page[__firstPage+1]);
                    }
                    if (__bookData.pages.page[__firstPage-1]) {
                        pageLoadedData.firstPage.prevPage = $.extend({}, __bookData.pages.page[__firstPage-1]);
                    }
                    config.onPageLoad(pageLoadedData);
                }
            }
        }
    };

    var eReaderResetZoom = function(doNotZoomOut) {
        /*
        Reset the zoom level (means ignore any user specific zoom levels). Typically this should be 
        called on window.resize to automatically adjust the book zoom level to best available 
        default -- based on space available AND zoom states config.
        */
        isFitToHeight = undefined;
        var availableWidth = getAvailableScreenWidth();
        if (!doNotZoomOut || (doNotZoomOut && availableWidth > config.zoomingStateData[__eeZoomState].pcwidth)) {
            resetZoomParametersFromConfig(availableWidth);
            //Need to reset values of gesture transform if image is pinched in.
            gestureTransform.scale = 1;
            gestureTransform.translateX = 0;
            gestureTransform.translateY = 0;
            $("#reader-container").css("transform","scale(1, 1)");
            //Resize the parent/content divs
            setEreaderContainerStyle();
            //Resize the image divs
            setupCoverPageAndNextPages(__curPage);
        }
    };

    var fitToHeight = function() {
        isFitToHeight = true;
        var $elParent = $("#"+config.elParent);
        var initialZoomConfig = $.extend(true, [], getZoomConfig()); 
        var updatedZoomConfig = $.extend(true, [], initialZoomConfig);

        var aspectRatio = __bookData.pageHeight/__bookData.pageWidth;
        var containerHeight = $elParent.height() - scrollbarBuffer;
        var availableWidth;
        var isDoublePageOpen = false;
        var pageNumbers = getPageLevel();
        if (pageNumbers[1]) {
            isDoublePageOpen = true;
        }
        if ((__curPage < 1 && config.hasCover && isDoublePage()) || !isNotLastPageSingleInDoublePageMode(__curPage) ) {
            isDoublePageOpen = true;
        }
        availableWidth = isDoublePageOpen ? 2*containerHeight/aspectRatio: containerHeight/aspectRatio;

        var bestMatchIndex;
        if(availableWidth <= updatedZoomConfig[0].pcwidth) {
            bestMatchIndex = 0;
        } else if(availableWidth >= updatedZoomConfig[updatedZoomConfig.length-1].pcwidth) {
            bestMatchIndex = updatedZoomConfig.length-1;
        }
        
        var searchStartIndex = 0;
        var searchEndIndex = updatedZoomConfig.length - 1;

        while(bestMatchIndex === undefined) {
            if(searchEndIndex === searchStartIndex + 1) {
                var distanceFromEnd = Math.abs(availableWidth - updatedZoomConfig[searchEndIndex].pcwidth);
                var distanceFromStart = Math.abs(availableWidth - updatedZoomConfig[searchStartIndex].pcwidth);
                bestMatchIndex = (distanceFromEnd < distanceFromStart ? searchEndIndex : searchStartIndex);
                break;
            }

            var searchMiddleIndex = searchStartIndex + Math.ceil((searchEndIndex - searchStartIndex) / 2);

            var searchStartWidth = updatedZoomConfig[searchStartIndex].pcwidth;
            var searchMiddleWidth = updatedZoomConfig[searchMiddleIndex].pcwidth;
        
            if(searchStartWidth <= availableWidth && availableWidth <= searchMiddleWidth) {
                searchEndIndex = searchMiddleIndex;
            } else {
                searchStartIndex = searchMiddleIndex;
            }
        }
        updatedZoomConfig[bestMatchIndex].pcwidth = parseInt(availableWidth, 10);
        updatedZoomConfig[bestMatchIndex].singlePageFitFactor = updatedZoomConfig[bestMatchIndex+1] && updatedZoomConfig[bestMatchIndex+1].singlePageFitFactor;
        updatedZoomConfig[bestMatchIndex].isFitToHeightState = true;
        config.zoomingStateData = updatedZoomConfig;
        
        if(__eeZoomState > bestMatchIndex) {
            while(__eeZoomState !== bestMatchIndex && canZoomOut()) {
                pageZoomOut();
            }
        } else if(__eeZoomState < bestMatchIndex) {
            while(__eeZoomState !== bestMatchIndex && canZoomIn()) {
                pageZoomIn();
            }
        } else {
            resizeImgbookHandler();
        }
        isFitToHeight = true;
    };

    var isDoublePageAllowed = function() {
        var singleScreen = getPageScreen();
        if (singleScreen === "false") {
            return true;
        } else if (singleScreen === "true") {
            return false;
        }
    };

    var canResetZoom = function() {
        var availableWidth = getAvailableScreenWidth();
        var bestMatchZoomState = findBestZoomStateAndUpdate(availableWidth);
        if(__eeZoomState === bestMatchZoomState) {
            return false;
        } else {
            return true;
        }
    };

    var canFitToHeight = function() {
        if(config.zoomingStateData[__eeZoomState] && config.zoomingStateData[__eeZoomState].isFitToHeightState) {
            return false;
        } else {
            return true;
        }
    };

    var animateHotlinks = function(isReRendering) {
        if($("#animationStyles").length === 0 && !isReRendering) {
            $("head").append(
                $(document.createElement("style"))
                .html(config.animationStyles).attr("id", "animationStyles")
            );
            var timeoutCounter = setTimeout(function() {
                $("#animationStyles").remove();
            },config.animationTime);
            return timeoutCounter;
        }
    };

    var resizeImgbookHandler = function() {
        setEreaderContainerStyle();
        setupCoverPageAndNextPages(__curPage);
    };

    var checkFirstPage = function(pageNo) {
        if (config.hasCover) {
        return (pageNo >= 0 ? true : false);
        } else {
            return (pageNo >= -1 ? true : false);
        }
    };

    var checkLastPage = function(pageNo) {
        if(isDoublePage()) {
            if (config.hasCover) {
                if( (pageNo+1) < __bookData.pagecount ) {
                    return true;
                } else {
                    return false;
                }
            } else {
                if( (pageNo+1) <= __bookData.pagecount ) {
                    return true;
                } else {
                    return false;
                }
            }
            
        } else {
            if( pageNo <= __bookData.pagecount ) {
                return true;
            } else {
                return false;
            }
        }
    };

    var isNotLastPageSingleInDoublePageMode = function(pageNo) {
        if(isDoublePage()) {
            if( (pageNo+1) < __bookData.pagecount ) {
                return true;
            } else {
                return false;
            }
        } else {
          return true;
        }
    };

    var pageNavigator = function(direction) {
        var $elParent = $("#"+config.elParent);
        $elParent.find("#ee-overlaysA").empty();
        $elParent.find("#ee-overlaysB").empty();
        $("#annotationLeftBar").empty();
        $("#annotationRightBar").empty();

        // do not wait 500ms to preload in case of desktop app. Content is already downloaded.
        var navigationPreloadIntervalTime = config.preLoadPages === 0 ? 10 : 500;

        __timeFromLastNavigationEvent = (new Date()).getTime();
        stopPreLoading();

        if(direction === 'next') {
            if(isDoublePage()) {

                if( (__curPage+1) < __bookData.pagecount ) {
                    
                    if( __curPage === 0 && config.hasCover) {
                        __curPage =  __curPage + 1;
                    } else {
                        __curPage =  __curPage + 2;
                    }
                    __firstPage = __curPage ;
                } else { 
                    return;
                }

                if(checkLastPage(__curPage)) {

                    __secondPage = __firstPage + 1;
                    if(__pagesStatus[__firstPage] !== undefined) {

                        if(__firstPage === 0 && config.hasCover) {
                            resetPageStatus(__firstPage);
                            renderPage(__firstPage);
                        } else {
                            resetPageStatus(__firstPage);
                            renderPage(__firstPage);

                            if(__pagesStatus[__secondPage] !== undefined) {
                                resetPageStatus(__secondPage);
                                renderPage(__secondPage);
                            }
                        }
                        startPreloading();

                    } else {
                        disablePreloading();
                        if(__navigationIdleDetectionTimerId === -1) {
                            __navigationIdleDetectionTimerId = setInterval(function() {
                                enablePreloadingAfterNavigation();
                            }, navigationPreloadIntervalTime);
                        }
                    }

                } else {
                    if (__bookData.pagecount % 2 === 0) {
                        if(__pagesStatus[__firstPage] !== undefined) {
                            resetPageStatus(__firstPage);
                            renderPage(__firstPage);
                        } else {
                            disablePreloading();
                            if(__navigationIdleDetectionTimerId === -1) {
                                __navigationIdleDetectionTimerId = setInterval(function() {
                                    var currentTime = (new Date()).getTime();
                                    // console.log("Checking for post navigation loading ... " + (currentTime - __timeFromLastNavigationEvent));
                                    if( (currentTime - __timeFromLastNavigationEvent) > 2000 ) {

                                        startPageResourceLoading(__firstPage);

                                        clearInterval(__navigationIdleDetectionTimerId);
                                        __navigationIdleDetectionTimerId = -1;
                                    }
                                }, navigationPreloadIntervalTime);
                            }
                        }    
                    }
                    
                    console.log("End of the book");
                }

            } else {

                if( (__curPage+1) < __bookData.pagecount ) {

                    __curPage =  __curPage + 1;
                    __firstPage = __curPage ;
                } else {
                    return;
                }

                if(__curPage < __bookData.pagecount) {
                    if( __pagesStatus[__firstPage] !== undefined) {
                        resetPageStatus(__firstPage);
                        renderPage(__firstPage);
                        startPreloading();
                    } else {
                        disablePreloading();
                        if(__navigationIdleDetectionTimerId === -1) {
                            __navigationIdleDetectionTimerId = setInterval(function() {
                                enablePreloadingAfterNavigation();
                            }, navigationPreloadIntervalTime);
                        }
                    }

                } else {
                    console.log("End of the book");
                }
            }
        } else {

            if(isDoublePage()) {
                if(__curPage > 0) {
                    if( __curPage === 1) {
                        __curPage =  __curPage - 1;
                    } else {
                        __curPage =  __curPage - 2;
                    }
                } else {
                    return;
                }

                if( checkFirstPage(__curPage)) {
                    __firstPage = __curPage ;
                    __secondPage = __firstPage + 1;
                    if(__pagesStatus[__firstPage] !== undefined) {

                        if(__firstPage === 0 && config.hasCover) {
                            resetPageStatus(__firstPage);
                            renderPage(__firstPage);
                        } else {
                            resetPageStatus(__firstPage);
                            renderPage(__firstPage);

                            if(__pagesStatus[__secondPage] !== undefined) {
                                resetPageStatus(__secondPage);
                                renderPage(__secondPage);
                            }
                        }
                        startPreloading();
                    } else {
                        disablePreloading();
                        if(__navigationIdleDetectionTimerId === -1) {
                            __navigationIdleDetectionTimerId = setInterval(function() {
                                enablePreloadingAfterNavigation();
                            }, navigationPreloadIntervalTime);
                        }
                    }
                } else {
                    console.log("Cover Page");
                }
            } else { 
                if(__curPage > 0) {
                    __curPage =  __curPage - 1;
                } else {
                    return;
                }

                if(__curPage >= 0) {
                    __firstPage = __curPage ;
                    if( __pagesStatus[__firstPage] !== undefined) {
                        resetPageStatus(__firstPage);
                        renderPage(__firstPage);
                        startPreloading();
                    } else {
                        disablePreloading();
                        if(__navigationIdleDetectionTimerId === -1) {
                            __navigationIdleDetectionTimerId = setInterval(function() {
                                enablePreloadingAfterNavigation();
                            }, navigationPreloadIntervalTime);
                        }
                    }
                } else {
                    console.log("Cover Page");
                }
            }
        }

        var enablePreloadingAfterNavigation = function () {

            var currentTime = (new Date()).getTime();

            // if no pages to preload, then do not start preloading.
            if (config.preLoadPages === 0) {
                startPageResourceLoading(__firstPage);
                if (!config.downloadedPageAccessArray.length || config.downloadedPageAccessArray.indexOf(__firstPage + 2) > -1) {
                    startPageResourceLoading(__firstPage + 1);
                }

                clearInterval(__navigationIdleDetectionTimerId);
                __navigationIdleDetectionTimerId = -1;
                stopPreLoading();
            } else {
                if ((currentTime - __timeFromLastNavigationEvent) > 2000) {
                    startPageResourceLoading(__firstPage);
                    if (!config.downloadedPageAccessArray.length || config.downloadedPageAccessArray.indexOf(__firstPage + 2) > -1) {
                        startPageResourceLoading(__firstPage + 1);
                    }

                    clearInterval(__navigationIdleDetectionTimerId);
                    __navigationIdleDetectionTimerId = -1;

                    enablePreloading();
                    startPreloading();
                }

            }
        };


    };


    var changePageLayout = function(layout) {

        if(config.pageLayout===layout) {
            return;
        }

        config.pageLayout = layout;


        if(checkFirstPage(__curPage)) {

            if(isDoublePage()) {
                stopPreLoading();

                if(config.showPageSeparator) {
                    $("#readerpagedivA").addClass('reader-inner-border-right');
                }
                if (config.hasCover) {
                    if(__curPage % 2 === 0 && __curPage !== 0) {
                        __curPage--;
                    } 
                } else if(__curPage % 2 !== 0) {
                    __curPage--;
                }
                
                __firstPage = __curPage ;
                __secondPage = __firstPage + 1;

                setTimeout(function() {
                    if(__curPage < 1 && config.hasCover) {
                        resetPageStatus(__firstPage);
                        renderPage(__firstPage);
                    } else {
                        if(__pagesStatus[__firstPage] !== undefined) {
                            resetPageStatus(__firstPage);
                            renderPage(__firstPage);
                        } else {
                            startPageResourceLoading(__firstPage);
                        }
                        if(__pagesStatus[__secondPage] !== undefined) {
                            resetPageStatus(__secondPage);
                            renderPage(__secondPage);
                        } else {
                            startPageResourceLoading(__secondPage);
                        }
                    }
                },100);

                startPreloading();
            } else {

                __firstPage = __curPage;
                resetPageStatus(__firstPage);
                $("#readerpagedivA").removeClass('reader-inner-border-right');    
                renderPage(__firstPage);
            } 
        }

        if(config.zoomingStateData[__eeZoomState].singlePageFitFactor >= 0.90 && config.pageLayout === 'double' && !isFitToHeight) {
            eReaderResetZoom();
        }

        if(isFitToHeight) {
            fitToHeight();
        }
    };

    /* This function is called to render pages again in case 
        i) Annotation is enable/disabled 
        ii) Overlays are enabled/disabled
    */
    var renderPageAfterChange = function(annotationId, isReRendering) {
        if(checkFirstPage(__curPage)) {
            if(isDoublePage()) {
                stopPreLoading();
                if(config.showPageSeparator) {
                    $("#readerpagedivA").addClass('reader-inner-border-right');
                }
                if (config.hasCover) {
                    if(__curPage % 2 === 0 && __curPage !== 0) {
                        __curPage--;
                    } 
                } else if(__curPage % 2 !== 0) {
                    __curPage--;
                }
                __firstPage = __curPage ;
                __secondPage = __firstPage + 1;

                setTimeout(function() {
                    if(__curPage < 1 && config.hasCover) {
                        resetPageStatus(__firstPage);
                        renderPage(__firstPage, annotationId, isReRendering);
                    } else {
                        if(__pagesStatus[__firstPage] !== undefined) {
                            resetPageStatus(__firstPage);
                            renderPage(__firstPage, annotationId, isReRendering);
                        } else {
                            startPageResourceLoading(__firstPage);
                        }
                        if(__pagesStatus[__secondPage] !== undefined) {
                            resetPageStatus(__secondPage);
                            renderPage(__secondPage, annotationId, isReRendering);
                        }
                    }
                },100);
                startPreloading();
            } else {
                __firstPage = __curPage ;
                resetPageStatus(__firstPage);
                $("#readerpagedivA").removeClass('reader-inner-border-right');
                renderPage(__firstPage, annotationId, isReRendering);
            }
        }
    };

    var canZoomIn = function() {
        
        // Check if __eeZoomState is less than the totalZoomStates(config.zoomingStateData.length-1)
        /* Changed totalZoomStates = config.zoomingStateData.length-1
        This change is done as the length of __originalZoomingStateData can be different from config.zoomingStateData,
        and zooming actually depends on config.zoomingStateData */
        if(__eeZoomState < config.zoomingStateData.length-1) {
            return true;
        } else {
            return false;
        }
    };
    
    var canZoomOut = function() {
        if(config.isTouchDevice) {
            //Get best matched zoom state according to width available.
            var availableWidth = getAvailableScreenWidth();
            var bestMatchZoomState = findBestZoomStateAndUpdate(availableWidth);
            if(__eeZoomState === bestMatchZoomState) {
                return false;
            } else {
                return true;
            }
        } else {
            if(__eeZoomState !== 0 && __eeZoomState > __minZoom) {
                return true;
            } else {
                return false;
            }
        }
    };

    var zoomEReaderTo = function() {
        //call resize handlers of the renderers
        if(__pagesStatus[__firstPage] && __pageRendererDivA) {
            __pageRendererDivA.resizeHandler(__bookData.pages.page[__firstPage],config.onPageZoom);
        }
        if(__pagesStatus[__secondPage] && __pageRendererDivB) {
            __pageRendererDivB.resizeHandler(__bookData.pages.page[__secondPage],config.onPageZoom);
        }
    };

    var pageZoomIn = function() {
        // Check if __eeZoomState is less than the totalZoomStates(config.zoomingStateData.length-1)
        /* Changed totalZoomStates = config.zoomingStateData.length-1
        This change is done as the length of __originalZoomingStateData can be different from config.zoomingStateData,
        and zooming actually depends on config.zoomingStateData */
        
        if(__eeZoomState < config.zoomingStateData.length-1) {
            // Reset image transform gesture.
            $("#reader-container").css("transform","scale(1, 1)");
            gestureTransform.scale = 1;
            // not required as handled seperately.
            // gestureTransform.translateX = 0;
            // gestureTransform.translateY = 0;

            __eeZoomState++;
            setEreaderContainerStyle();
            // translate imagebook to prevent detaching from edges.
            if (config.isTouchDevice) {
				translateCorrection();
			}
        } else {
            if (config.onPageZoom !== undefined && config.onPageZoom !== "") {
                config.onPageZoom(true);
            }
        }
    };
    var pageZoomOut = function() {
        if(config.isTouchDevice) {
            //Get best matched zoom state according to width available.
            var availableWidth = getAvailableScreenWidth();
            var bestMatchZoomState = findBestZoomStateAndUpdate(availableWidth);
            if(__eeZoomState === bestMatchZoomState) {
                return;
            } else {
                // Reset image transform gesture.
                $("#reader-container").css("transform","scale(1, 1)");
                gestureTransform.scale = 1;
                // not required as handled seperately.
                // gestureTransform.translateX = 0;
                // gestureTransform.translateY = 0;
                
                __eeZoomState--;
                setEreaderContainerStyle(); 
                // prevent image book from detaching from edges.
                translateCorrection();
            }
        } else if(__eeZoomState > __minZoom && __eeZoomState > 0) {
            
            // Reset image transform gesture.
            $("#reader-container").css("transform","scale(1, 1)");
            gestureTransform.scale = 1;
            gestureTransform.translateX = 0;
            gestureTransform.translateY = 0;
            
            __eeZoomState--;
            setEreaderContainerStyle();
        } else {
            if (config.onPageZoom !== undefined && config.onPageZoom !== "") {
                config.onPageZoom(true);
            }
        }
    };

    var disablePreloading = function() {
        __preLoaderEnabled = false;
    };
    var enablePreloading = function() {
        __preLoaderEnabled = true;
    };

    var setTranslateCoords = function (translateCoords) {
        
        var imgbookContainerHeight = getContentHeight();
        var imgbookContainerWidth = getAvailableScreenWidth();
        var gestureReaderContainerElement = document.querySelector('#reader-container');

        if (translateCoords.x !== undefined) {
          gestureTransform.translateX = translateCoords.x;
          // get corrected translate values for X translate.
          gestureTransform.translateX =  getTranslateCorrectedValue(gestureTransform.translateX, gestureReaderContainerElement.getBoundingClientRect().width, imgbookContainerWidth);
        }
    
        if (translateCoords.y !== undefined) {
          gestureTransform.translateY = translateCoords.y;
          // get corrected translate values for Y translate.
          gestureTransform.translateY =  getTranslateCorrectedValue(gestureTransform.translateY, gestureReaderContainerElement.getBoundingClientRect().height, imgbookContainerHeight);
        }
        // set the corrected values.
        setTranslateValues(gestureTransform);
    
        //vertical align the imgbook if content height is less than container height.
        verticalAlignReaderContainerWrapper();
    
    };

    /**
     * function to return current gestureTransform translate X and Y values back to studentBook.
     * this prevents calculation in studentbook from translate 2d and 3d values.
     */
    var getTranslateCoords = function () {
        return { x: gestureTransform.translateX, y: gestureTransform.translateY };
    };
      
    /**
       * Function to correct the translate value such that no grey area is visible.
       * Prevent imgbook to detach from corners.
       * Common function called from multiple places.
       * @param {*} translateVal - gestureTransform.translate X or Y value that needs to be corrected.
       * @param {*} contentDim - Page width/ height with current zoom conditions.
       * @param {*} containerDim - Screen Width/ height.
       */
    var getTranslateCorrectedValue = function (translateVal, contentDim, containerDim) {

        // if translateX > 0 then we have grey area on left and should be avaoided so set translateX to 0.
        if (translateVal > 0) {
            translateVal = 0;
        }
        // if value of TranslateX > the difference of width of container and content then grey area will be visible on right so remove it by capping the max translateX.
        else if (Math.abs(translateVal) > contentDim - containerDim) {
            // if the width of content is < container the grey area is outside our reach to fix so again set translate to 0.
            if (contentDim < containerDim) {
                translateVal = 0;
            } else {
                translateVal = -contentDim + containerDim;
            }
        }
        return translateVal;
    };

    /**
     * Function to set the calculated translate values to reader container.
     * Uses translate3d.
     * Common function called from multiple places.
     * @param {*} transX 
     * @param {*} transY 
     */
    var setTranslateValues = function (transform) {

        var value = [];
        var imgbookContainerWidth = getAvailableScreenWidth();
        var gestureReaderContainerElement = document.querySelector('#reader-container');

        if (gestureReaderContainerElement === undefined || gestureReaderContainerElement === null) {
            return;
        }

        // centre align imgbook if screen width is more than imgbook width
        if (!transform.pinchActive && config.isTouchDevice && Math.floor(gestureReaderContainerElement.getBoundingClientRect().width) <= Math.floor(imgbookContainerWidth)) {
            var translateX = (imgbookContainerWidth - gestureReaderContainerElement.getBoundingClientRect().width)/2;
            transform.translateX = translateX;
        }
        value.push('translate3d(' + transform.translateX + 'px, ' + transform.translateY + 'px, 0px)');
        value.push('scale(' + transform.scale + ', ' + transform.scale + ')');
        value = value.join(' ');
        gestureReaderContainerElement.style[Hammer.prefixed(document.body.style, 'transform')] = value;
  
    };

    /**
    * Function to vertically align reader-container-wrapper when content height is less than container height.
    * Common function called from multiple places.
    */
    var verticalAlignReaderContainerWrapper = function () {

        var $elParent = $("#" + config.elParent);
        var $readerContainerWrapperElement = $elParent.find("#reader-container-wrapper");
        var gestureReaderContainerElement = document.querySelector('#reader-container');
        var readerHeight = gestureReaderContainerElement.getBoundingClientRect().height;
        var imgbookContainerHeight = getContentHeight();
        var heightDiff;

        if (readerHeight < imgbookContainerHeight) {
            heightDiff = imgbookContainerHeight - readerHeight;
            $readerContainerWrapperElement.css("top", heightDiff / 2);
        } else {
            $readerContainerWrapperElement.css("top", "");
        }

    };

    /**
       * Function to set app in capture mode and retreive coords if clicked on #reader-container. It adds a click event listener on the whole document in capture mode.
       * Gives position data relative to the #reader-container.
       * @param {*} options - options object, it accepts two props- disableClickDisablePosition and enableClickDisablePosition. Both of these will be an array of selector string values. 
       * In disableClickDisablePosition, click on the selector element will not register, also the position data on the element wil not be returned. 
       * In enableClickDisablePosition, click on the selector element will register, but the position data on the element wil still not be returned.
       * @param {*} cursorPositionCallback - callback function when user has clicked on container, has two arguments. First is error to check if user click position is valid or not(like outside or invalid area). Second one is position data if the click postion is valid.
      */
    var getCursorPosition = function (cursorPositionCallback) {
        var readerContainer = document.getElementById('reader-container');

        //Add click event listener on the whole document
        if (captureModeEventHandler) {
            readerContainer.removeEventListener('click', captureModeEventHandler, true);
            captureModeEventHandler = null;
        }
        captureModeEventHandler = getClickPositionEventHandler.bind(null, cursorPositionCallback);
        readerContainer.addEventListener('click', captureModeEventHandler, true);
    };

    //Click event handler
    var getClickPositionEventHandler = function (cursorPositionCallback, event) {
        var readerContainer = document.getElementById('reader-container');

        event.preventDefault();
        event.stopImmediatePropagation();

        //hotspot check
        var hotspotElements = document.querySelectorAll('.hotSpotBox');
        for (var index = 0; index < hotspotElements.length; index++) {
            var hotspot = hotspotElements[index];
            if (hotspot.contains(event.target)) {
                console.log("hotspot clicked");
                readerContainer.removeEventListener('click', captureModeEventHandler, true);
                cursorPositionCallback("hotspot clicked");
                return;
            }
        }

        readerContainer.removeEventListener('click', captureModeEventHandler, true);

        //Getting position relative to reader-container
        var bnds = readerContainer.getBoundingClientRect();
        var fontSize = comprodls.READER.getFontSize();
        
        console.log("Event", event);
        var relX = event.pageX - bnds.left;
        var relY = event.pageY - bnds.top;

        var page = 'A';
        var overlayWidthPageA = document.getElementById('ee-overlaysA').getBoundingClientRect().width;
        var overlayHeightPageA = document.getElementById('ee-overlaysA').getBoundingClientRect().height;

        //Check if clicked on pageB if in double page layout and getting position relative to that
        if (relX > overlayWidthPageA) {
            relX = relX - overlayWidthPageA;
            page = 'B';
        }

        //values adjusted to prevent hotspot icon to overflow the clicked page
        if (relX < (1.6 * fontSize)) {
            relX = 1.6 * fontSize;
        }

        if (relY < (1.6 * fontSize)) {
            relY = 1.6 * fontSize;
        }

        if (relX + (1.6 * fontSize) > overlayWidthPageA) {
            relX = relX - ((relX + (1.6 * fontSize)) - overlayWidthPageA);
        }

        if (relY + (1.6 * fontSize) > overlayHeightPageA) {
            relY = relY - ((relY + (1.6 * fontSize)) - overlayHeightPageA);
        }

        //get values scaled according to the original book
        var bookValues = getScaledOriginalBookValues({
            x: relX,
            y: relY
        });

        //values adjusted so that icon can be on centre of clicked cursor position
        var positioningData = getAdjustedToCentre({
            defaultData: {
                screenCoords: {
                    positionEM: {
                        x: relX / fontSize,
                        y: relY / fontSize
                    },
                    positionPX: {
                        x: relX,
                        y: relY
                    }
                },
                bookCoords: {
                    positionEM: {
                        x: bookValues.x / fontSize,
                        y: bookValues.y / fontSize
                    },
                    positionPX: {
                        x: bookValues.x,
                        y: bookValues.y
                    }
                }
            },
            fontSize: fontSize,
            page: page
        });

        cursorPositionCallback(null, positioningData);
    };

    //Values scaled according to the original book height and width
    var getScaledOriginalBookValues = function (coords) {
        var $readerpagedivA = $("#readerpagedivA");
        var pageScreenWd = $readerpagedivA.width();
        var pageScreenHeight = $readerpagedivA.height();

        var bookX = ((coords.x * __bookData.pageWidth) / pageScreenWd);
        var bookY = ((coords.y * __bookData.pageHeight) / pageScreenHeight);

        return {
            x: bookX,
            y: bookY
        };
    };

    //Values adjusted so that clicked position will be centre of hotspot icon
    var getAdjustedToCentre = function (data) {
        var fontSize = comprodls.READER.getFontSize();
        var $readerpagedivA = $("#readerpagedivA");
        var pageScreenWd = $readerpagedivA.width();
        var pageScreenHeight = $readerpagedivA.height();

        //Em in page dimensions
        var emX = ((1.6 * __bookData.pageWidth) / pageScreenWd);
        var emY = ((1.6 * __bookData.pageHeight) / pageScreenHeight);

        var centeredData = {
            //1.6em in screen dimensions
            screenCoords: {
                positionEM: {
                    x: data.defaultData.screenCoords.positionEM.x - 1.6,
                    y: data.defaultData.screenCoords.positionEM.y - 1.6
                },
                positionPX: {
                    x: data.defaultData.screenCoords.positionPX.x - (1.6 * fontSize),
                    y: data.defaultData.screenCoords.positionPX.y - (1.6 * fontSize)
                }
            },
            bookCoords: {
                positionEM: {
                    x: data.defaultData.bookCoords.positionEM.x - emX,
                    y: data.defaultData.bookCoords.positionEM.y - emY
                },
                positionPX: {
                    x: data.defaultData.bookCoords.positionPX.x - (emX * fontSize),
                    y: data.defaultData.bookCoords.positionPX.y - (emY * fontSize)
                }
            }
        };

        data.centeredData = centeredData;
        return data;
    };

    var exitCaptureMode = function () {
        var readerContainer = document.getElementById('reader-container');
        if (captureModeEventHandler) {
            readerContainer.removeEventListener('click', captureModeEventHandler, true);
            captureModeEventHandler = null;
        }
    };


    var stopPreLoading = function() {
        if(__preloaderTimerId !== -1) {
            window.clearInterval(__preloaderTimerId);
            __preloaderTimerId = -1;
        }
    };

    var startPreloading = function() {

        stopPreLoading();

        // preloading is not required in case of desktop app as content is already downloaded.
        if (config.disablePagePreloading) {
            return;
        }

        __preLoaderEnabled = true;
        var numOfPages = config.preLoadPages;
        var pageCounter = 1;

        var loadPages = function() {

            var preloadCounter = (__curPage + pageCounter);

            if(preloadCounter > __bookData.pagecount || preloadCounter < 0) {
                if(pageCounter === 1) {
                    pageCounter = 0 - numOfPages;
                } else if(pageCounter === -1) {
                    pageCounter += 3;
                } else {
                    pageCounter++;
                }
                return;
            }

            if( typeof __pagesStatus[preloadCounter]  !== 'undefined' ) {

                if(__pagesStatus[preloadCounter].resources.preloaded === false) {

                } else if( __pagesStatus[preloadCounter].resources.preloaded === true) {
                    if(pageCounter === 1) {
                        pageCounter = 0 - numOfPages;
                    } else if(pageCounter === -1) {
                        pageCounter += 3;
                    } else {
                        pageCounter++;
                    }
                }
            } else if (!config.downloadedPageAccessArray.length || config.downloadedPageAccessArray.indexOf(preloadCounter + 1) > -1) {
                startPageResourceLoading(preloadCounter);
            }
        };

        var preloadTimerId = window.setInterval(function() {
            if(numOfPages >= pageCounter-1) {
                loadPages();
            } else {
                //console.log('==== start preloading for ' + (__curPage ))
                window.clearInterval(preloadTimerId);
                __preloaderTimerId = -1;
            }
        }, 1000);

        __preloaderTimerId = preloadTimerId;

    };

    var getConfigData = function() {
        return config;
    };

    var setWebFontData = function(webFontFlag) {
        if(webFontFlag === true) {
            config.useWebFonts = true;
        } else {
            config.useWebFonts = false;
        }
    };
    
    /*var keyboardNavigation = function() {
        $(document).keydown(function(e) {
            if (e.target && e.target.nodeName && e.target.nodeName.toLowerCase() === "body") {
                if (e.keyCode === 37) {
                    pageNavigator('prev');
                    return;
                }
                if (e.keyCode === 39) {
                    pageNavigator('next');
                    return;
                }
            }
        });
    };*/
  
    //providing a function to get value of imageconfig. 
    var getImageConfig = function() {
        if(__bookData.imageConfig !== null && __bookData.imageConfig !== undefined) {
            return __bookData.imageConfig;
        } else {
           return config.imageConfig; 
        }
        
    };
    //providing a function to update imageconfig at runtime. 
    var updateImageConfig = function(imageConfig) {
        if(imageConfig !== null && imageConfig !== undefined) {
            config.imageConfig = imageConfig;
        }
        return true;
    };

    //providing a function to get value of zoomConfig. 
    var getZoomConfig = function(getCurrentZoomState) {
        if(getCurrentZoomState) {
            return {
                zoomStateData: __originalZoomingStateData,
                currentZoomState: __eeZoomState
            }; 
        } else {
            return __originalZoomingStateData; 
        }
    };

    //providing a function to set zoomConfig at runtime. 
    var setZoomConfig = function(zoomConfig, bestMatchZoomStateIndex) {
        if(zoomConfig !== null && zoomConfig !== undefined) {
            __originalZoomingStateData = zoomConfig;
        }
        
        config.bestMatchZoomStateIndex = undefined;
        if(bestMatchZoomStateIndex!==undefined) {
            config.bestMatchZoomStateIndex = bestMatchZoomStateIndex;
        }

        return true;
    };

    // returns true if content totally fits inside the container height 
    var isContentFitToScreen = function(passedHeight) {
        var height = passedHeight || window.innerHeight;
        if(Math.abs($('#reader-container-wrapper').height()) <= height) {
            return true; 
        }
        return false;
    };
    
    // returns true if the content totally fit inside container width 
    var isContentFitToWidth = function(passedWidth) {
        var width = passedWidth || window.innerWidth;
        if(Math.abs($('#reader-container-wrapper').width()-width) < 1) {
            return true; 
        }
        return false;
    };

    // Get Current Overlays JSON
    var getOverlaysJSON = function() {
      return config.overlaysData;
    };
  
    // Modify/edit Overlays JSON (@params - modified JSON, page index, page type)
    var setOverlaysJSON = function(overlaysJSON) {
      var overlaysConfig = JSON.parse(JSON.stringify(config.overlaysData["overlay-config"]));
      config.overlaysData = overlaysJSON;
      config.overlaysData["overlay-config"] = overlaysConfig;
      renderPageAfterChange();       
    };


    var setIconColor = function(color) {
        if (config.overlaysData ) {
            if (config.overlaysData["overlay-config"]) {
                config.overlaysData["overlay-config"]["icon-color"] = color;    
            } else {
                config.overlaysData["overlay-config"] = {"icon-color": color};
            }
            $(".ee-overlay i").css('color', color);
        }
        return true;
    };

    var setCircleColor = function(color) {
        if (config.overlaysData ) {
            if (config.overlaysData["overlay-config"]) {
                config.overlaysData["overlay-config"]["background-color"] = color;    
            } else {
                config.overlaysData["overlay-config"] = {"background-color": color};
            }
            $(".ee-overlay .circle-shape").css('background-color', color);
        }
        return true;
    };

    var setBorderColor = function(color) {
        if (config.overlaysData ) {
            if (config.overlaysData["overlay-config"]) {
                config.overlaysData["overlay-config"]["border-color"] = color;    
            } else {
                config.overlaysData["overlay-config"] = {"border-color": color};
            }
            $(".ee-overlay .circle-shape").css('border-color', color);
        }
        return true;
    };

    var setHotspotBorder = function(color) {
        if (config.overlaysData ) {
            if (config.overlaysData["overlay-config"]) {
                config.overlaysData["overlay-config"]["invisible-hotspot-border"] = color;    
            } else {
                config.overlaysData["overlay-config"] = {"invisible-hotspot-border": color};
            }
            $(".invisibleHotspot div div").css('border-color', color);
        }
        return true;
    };

    var setHoverColor = function(color) {
        if (config.overlaysData ) {
            if (config.overlaysData["overlay-config"]) {
                config.overlaysData["overlay-config"]["hover-color"] = color;    
            } else {
                config.overlaysData["overlay-config"] = {"hover-color": color};
            }
        }
        return true;
    };

    var getIconColor = function() {
        if (config.overlaysData && config.overlaysData["overlay-config"] && config.overlaysData["overlay-config"]["border-color"]) {
            return config.overlaysData["overlay-config"]["icon-color"];
        } else {
            return "#FFFFFF";
        }
    };

    var getCircleColor = function() {
        if (config.overlaysData && config.overlaysData["overlay-config"] && config.overlaysData["overlay-config"]["background-color"]) {
            return config.overlaysData["overlay-config"]["background-color"];
        } else {
            return "#747474";
        }
    };

    var getBorderColor = function() {
        if (config.overlaysData && config.overlaysData["overlay-config"] && config.overlaysData["overlay-config"]["background-color"]) {
            return config.overlaysData["overlay-config"]["border-color"];
        } else {
            return "#000000";
        }
    };

    var getHoverColor = function() {
        if (config.overlaysData && config.overlaysData["overlay-config"] && config.overlaysData["overlay-config"]["hover-color"]) {
            return config.overlaysData["overlay-config"]["hover-color"];
        } else {
            return "#403939";
        }
    };

    var getHotspotBorder = function() {
        if (config.overlaysData && config.overlaysData["overlay-config"] && config.overlaysData["overlay-config"]["invisible-hotspot-border"]) {
            return config.overlaysData["overlay-config"]["invisible-hotspot-border"];
        } else {
            return "#AAAAAA";
        }
    };

    var getCurrentPagePosition = function() {
        var pageNumber = __firstPage;
        if (config.hasCover !== false) {
            if (pageNumber === 0) {
                return "left";
            } else {
                if (pageNumber % 2 === 0) {
                    return "right";
                } else {
                    return "left";
                }
            }
        } else {
            if (pageNumber % 2 === 0) {
                return "left";
            } else {
                return "right";
            }
        }
    };

    var enableAnnotations = function(value, annotationId) {
        if (!annotationObj) {
            annotationObj = new Annotation();
        }
        if(config.enableAnnotations !== value) {
            if (value === true) {
                config.enableAnnotations = true;
                //Reset page zoom to normal on enabling annotations.
                if(config.isTouchDevice) {
                  var availableWidth = getAvailableScreenWidth();
                  var bestMatchZoomState = findBestZoomStateAndUpdate(availableWidth);
                  __eeZoomState = bestMatchZoomState;
                  $("#reader-container").css("transform","scale(1, 1)");
                  gestureTransform.scale = 1;
                  gestureTransform.translateX = 0;
                  gestureTransform.translateY = 0;
                }
                setEreaderContainerStyle();
                setupCoverPageAndNextPages(__curPage);
                renderPageAfterChange(annotationId, true);
            } else if (value === false) {
                config.enableAnnotations = false;
                // annotationObj.disable_annotation();
                setEreaderContainerStyle();
                setupCoverPageAndNextPages(__curPage);
                renderPageAfterChange(undefined, true);
            }     
        }
    };

    var openAnnotation = function(annotationId) {
        if (!annotationObj) {
            annotationObj = new Annotation();
        }
        if (config.enableAnnotations === false) {
            enableAnnotations(true,annotationId);
        } else {
            annotationObj.open_annotation(annotationId);    
        } 
    };

    var enableOverlays = function() {
        if (config.enableOverlays) {
            config.enableOverlays = false;
             //Remove all the hotspots present on the page
            $('#ee-overlaysA').empty();
            $('#ee-overlaysB').empty();
        } else {
            config.enableOverlays = true;
            renderPageAfterChange();
        }
    };

    var enableTouchScreenGestures = function(options) {
        /*
            * options can have three properties(disablePinch, disablePan, and disableSwipe)
            * to disable pan, swipe amd pinch pass boolean variable according
        */
        if(options.hasOwnProperty('disablePinch') && (typeof options.disablePinch === 'boolean')) {
            config.isPinchDisabled = options.disablePinch;
        }
        if(options.hasOwnProperty('disablePan') && (typeof options.disablePan === 'boolean')) {
            config.isPanDisabled = options.disablePan;
        }
        if(options.hasOwnProperty('disableSwipe') && (typeof options.disableSwipe === 'boolean')) {
            config.isSwipeDisabled = options.disableSwipe;
        }
    };

    var getPageDimensionsFromJSON = function() {
        var dimensions = {width:  __bookData.pageWidth,
                        height : __bookData.pageHeight};
        return dimensions;
    };

    var getFontSize = function() {
        return __currentFontSize;
    };

    var getBookId = function () {
        return __bookId;
    };

    var getUser = function () {
        return config.user_unique_id;
    };

    var getOrgId = function () {
        if (config.annotationObject) {
            return config.annotationObject.orgId;
        }
    };

    var getProductCode = function () {
        if (config.annotationObject) {
            return config.annotationObject.productCode;
        }
    };

    var annotationEventHandler = function (status, annotation) {
        if (config.annotationObject && config.annotationObject.eventContext && status) {
            if (status === "create" && config.annotationObject.eventContext._readerEvt_annotationCreated) {
                return config.annotationObject.eventContext._readerEvt_annotationCreated(annotation);
            } else if (status === "destroy" && config.annotationObject.eventContext._readerEvt_annotationDeleted) {
                return config.annotationObject.eventContext._readerEvt_annotationDeleted(annotation);
            } else if (status === "update" && config.annotationObject.eventContext._readerEvt_annotationUpdated) {
                return config.annotationObject.eventContext._readerEvt_annotationUpdated(annotation);
            }
        }
    };

    var getElParent = function () {
        return config.elParent;
    };

    var getImageMapByPageLabel = function(fromPageLabel, toPageLabel) {
        var serNum1, serNum2;
        var resultJSON = {
            "pages": {
                "count": 0,
                "start-label": fromPageLabel,
                "end-label": toPageLabel,
                "label-to-sno-map": {},
                "layout-label": []
            },
            "label-to-images-map": {}
        };
        for(var i = 0 ; i <__bookData.pagecount; i++) {
            var pagelabel = (__bookData.pages.page[i].pagelabel).toString();    
            if(pagelabel.toLowerCase() === fromPageLabel.toLowerCase()) {
                serNum1 = parseInt(parseInt(__bookData.pages.page[i].sno, 10) - 1,null);
            } else if(pagelabel.toLowerCase() === toPageLabel.toLowerCase()) {
                serNum2 = parseInt(parseInt(__bookData.pages.page[i].sno, 10) - 1,null);
                break;
            }
        }

        resultJSON.pages.count = serNum2 - serNum1 + 1;
        var j;
        for(j = serNum1 ; j <= serNum2; j++) {
            resultJSON.pages["label-to-sno-map"][__bookData.pages.page[j].pagelabel] = j + 1;
            resultJSON["label-to-images-map"][__bookData.pages.page[j].pagelabel] = __bookData.pages.page[j].bgimage;
        }
        var label1, label2 ;
        if (config.hasCover !== false) {
            for(j = serNum1, i=0 ; j <= serNum2;) {
                if (serNum1 === j) {
                    if (serNum1 % 2 !== 0) {
                        label1 = __bookData.pages.page[j].pagelabel;
                        label2 = __bookData.pages.page[j+1].pagelabel;
                        resultJSON.pages["layout-label"][i] = [label1,label2];
                        j += 2;
                    } else if (serNum1 % 2 === 0) {
                        label1 = __bookData.pages.page[j].pagelabel;
                        resultJSON.pages["layout-label"][i] = [label1];
                        j ++;
                    }
                } else {
                    if ( (j+1) <= serNum2) {
                        label1 = __bookData.pages.page[j].pagelabel;
                        label2 = __bookData.pages.page[j+1].pagelabel;
                        resultJSON.pages["layout-label"][i] = [label1,label2];
                        j += 2;
                    } else {
                        label1 = __bookData.pages.page[j].pagelabel;
                        resultJSON.pages["layout-label"][i] = [label1];
                        j ++; 
                    }
                }
                i++;
            }
        } else {
            for(j = serNum1, i=0 ; j <= serNum2;) {
                if (serNum1 === j) {
                    if (serNum1 % 2 === 0) {
                        label1 = __bookData.pages.page[j].pagelabel;
                        label2 = __bookData.pages.page[j+1].pagelabel;
                        resultJSON.pages["layout-label"][i] = [label1,label2];
                        j += 2;
                    } else if (serNum1 % 2 !== 0) {
                        label1 = __bookData.pages.page[j].pagelabel;
                        resultJSON.pages["layout-label"][i] = [label1];
                        j ++;
                    }
                } else {
                    if ( (j+1) <= serNum2) {
                        label1 = __bookData.pages.page[j].pagelabel;
                        label2 = __bookData.pages.page[j+1].pagelabel;
                        resultJSON.pages["layout-label"][i] = [label1,label2];
                        j += 2;
                    } else {
                        label1 = __bookData.pages.page[j].pagelabel;
                        resultJSON.pages["layout-label"][i] = [label1];
                        j ++; 
                    }
                }
                i++;
            }

        }
        
        return resultJSON;
    };

    var getImageMapByPageSerial = function(fromPageSerial, toPageSerial) {
        var resultJSON = {
            "pages": {
                "count": 0,
                "start-sno": fromPageSerial,
                "end-sno": toPageSerial,
                "sno-to-label-map": {},
                "layout-sno": []
            },
            "sno-to-images-map": {}
        };
        fromPageSerial--;
        toPageSerial--;

        resultJSON.pages.count = toPageSerial - fromPageSerial + 1;
        var j;
        for(j = fromPageSerial ; j <= toPageSerial; j++) {
            resultJSON["sno-to-images-map"][__bookData.pages.page[j].sno] = __bookData.pages.page[j].bgimage;
            resultJSON.pages["sno-to-label-map"][j+1] = __bookData.pages.page[j].pagelabel;
        }
        var sno1, sno2;
        var i=0;
        if (config.hasCover !== false) {
            for(j = fromPageSerial ; j <= toPageSerial;) {   
                if (fromPageSerial === j) {
                    if (fromPageSerial % 2 !== 0) {
                        sno1 = __bookData.pages.page[j].sno;
                        sno2 = __bookData.pages.page[j+1].sno;
                        resultJSON.pages["layout-sno"][i] = [sno1, sno2];
                        j += 2;
                    } else if (fromPageSerial % 2 === 0) {
                        sno1 = __bookData.pages.page[j].sno;
                        resultJSON.pages["layout-sno"][i] = [sno1];
                        j ++;
                    }
                } else {
                    if ( (j+1) <= toPageSerial) {
                        sno1 = __bookData.pages.page[j].sno;
                        sno2 = __bookData.pages.page[j+1].sno;
                        resultJSON.pages["layout-sno"][i] = [sno1, sno2];
                        j += 2;
                    } else {
                        sno1 = __bookData.pages.page[j].sno;
                        resultJSON.pages["layout-sno"][i] = [sno1];
                        j ++; 
                    }
                }
                i++;
            }
        } else {
            for(j = fromPageSerial ; j <= toPageSerial;) {
                if (fromPageSerial === j) {
                    if (fromPageSerial % 2 === 0) {
                        sno1 = __bookData.pages.page[j].sno;
                        if (__bookData.pages.page[j+1]) {
                          sno2 = __bookData.pages.page[j+1].sno;  
                          resultJSON.pages["layout-sno"][i] = [sno1, sno2];
                        }else {
                          resultJSON.pages["layout-sno"][i] = [sno1];
                        }
                        j += 2;
                    } else if (fromPageSerial % 2 !== 0) {
                        sno1 = __bookData.pages.page[j].sno;
                        resultJSON.pages["layout-sno"][i] = [sno1];
                        j ++;
                    }
                } else {
                    if ( (j+1) <= toPageSerial) {
                        sno1 = __bookData.pages.page[j].sno;
                        sno2 = __bookData.pages.page[j+1].sno;
                        resultJSON.pages["layout-sno"][i] = [sno1, sno2];
                        j += 2;
                    } else {
                        sno1 = __bookData.pages.page[j].sno;
                        resultJSON.pages["layout-sno"][i] = [sno1];
                        j ++; 
                    }
                }
                i++;
            }
        }
        return resultJSON;
    };

    var showHotspotBorder = function(value) {
        if (value) {
            $(".hotSpotBox").css("border-width","2px");
        }  else {
            $(".hotSpotBox").css("border-width","0");
        }
        if (config.overlaysData ) {
            if (config.overlaysData["overlay-config"]) {
                config.overlaysData["overlay-config"]["show-hotspot-border"] = value; 
            } else {
                config.overlaysData["overlay-config"] = {"show-hotspot-border": value};
            }
        }
        return true;
    };
    
    var loadBook = function (bookId, configNew) {
        
        /* Clear local storage */
        lsSettings.removeMultiple();
        
        /* Remove/clear any existing DOM elements */
        if(__pageRendererDivB) {
            __pageRendererDivB.unrender();
        }
        if(__pageRendererDivA) {
            __pageRendererDivA.unrender();
        }
        if(__imageRendererDivA) {
            __imageRendererDivA = undefined;    
        }
        if (__imageRendererDivB) {
            __imageRendererDivB = undefined;    
        }
        if (config.overlaysData) {
            config.overlaysData = undefined;    
        }
        __pagesStatus = {};

        // Reset to default fitToWidth when new book is loaded without refresh
        isFitToHeight = false;

        // Reset page to current page when loaded again.
        __curPage = 1;

        /*----------- PRIVATE LOAD FUNCTIONS ---------------*/

        var loadBookDataJSON = function(bookId,callback) {
            if (config.bookDataJSON !== '') {
                setTimeout(function () {
                    _responseHandler(config.bookDataJSON);
                });

            } else {
                var jsonPath;
                jsonPath = config.bookAssetServer + config.bookBaseFolder + config.paths.bookDataPath;

                comprodls.READER.IMGREADER.UTIL.loadJson(jsonPath, function (response) {
                    _responseHandler(response);
                }, function (fnError) {
                    config.onBookDataLoad(false);
                    console.error("rpc error :" + JSON.stringify(fnError.data['status']));
                    throw new Error("book.json is not loaded");
                });
            }
  
            
  
            // handling book data response
            function _responseHandler(response) {
              if (response && response.pages && response.pages.page) {
                for (var index= 0; index < response.pages.page.length; index++) {
                    response.pages.page[index].sno = index + 1;
                }
                response.pagecount= response.pages.page.length;
              }
              __bookData = response;
              if (__bookData.hasCover === true) {
                  config.hasCover = true;
              } else if (__bookData.hasCover === false) {
                  config.hasCover = false;
              } else {
                  config.hasCover = true;
              }
              readBook(callback);
            }
        };

        var readBook = function(callback) {

            if(__bookData.zoomingStateData !== null && __bookData.zoomingStateData !== undefined) {
                config.zoomingStateData = __bookData.zoomingStateData;
            }
            
            /* Store the original ZoomingStateData, for future reference, as the config will get modified */
            __originalZoomingStateData = $.extend(true, [], config.zoomingStateData);
            var availableWidth = getAvailableScreenWidth();
            resetZoomParametersFromConfig(availableWidth);

            var lsKey = bookId + "-" + config.user_unique_id;
            lsSettings.get( lsKey, function(json) {
                var pageNumber;
                if (json !== null && json !== undefined && json.lastVisitedPage !== undefined && json.lastVisitedPage !== null && json.lastVisitedPage.sno > __bookData.pages.page.length) {
                    console.log("SNO in localstorage is greater then total number of pages in book so setting the page number to 1");
                }
                if (json !== null && json !== undefined && json.lastVisitedPage !== undefined && json.lastVisitedPage !== null && json.lastVisitedPage.sno <= __bookData.pages.page.length && (config.initialPageNo === '' || config.initialPageNo === undefined || config.initialPageNo === null) ) {
                    pageNumber = json.lastVisitedPage.sno;
                    __curPage = parseInt(parseInt(pageNumber, 10) - 1,null);
                    if(config.pageLayout ==='double') {
                        if(config.hasCover) {
                            if(__curPage % 2 === 0 && __curPage !== 0) {
                                __curPage--;
                            }  
                        } else if(__curPage % 2 !== 0) {
                            __curPage--;
                        }
                        
                    }
                    __firstPage = __curPage ;
                    __secondPage = __firstPage + 1;
                } else {
                    if (config.initialPageNo === '' || config.initialPageNo === undefined || config.initialPageNo === null) {
                        pageNumber = 1;
                        __curPage = parseInt(parseInt(pageNumber, 10) - 1,null);
                        if(config.pageLayout ==='double') {
                            if(config.hasCover) {
                                if( __curPage % 2 === 0 && __curPage !== 0) {
                                    __curPage--;
                                }
                            } else if( __curPage % 2 !== 0) {
                                __curPage--;
                            }
                        }
                        __firstPage = __curPage ;
                        __secondPage = __firstPage + 1;

                    } else {
                        /**
                         * Get the serial number from the page label coming from the config
                         */
                        for(var i = 0 ; i <__bookData.pagecount; i++) {
                            var bookJsonData = (__bookData.pages.page[i].pagelabel).toString();

                            if(bookJsonData.toLowerCase() === config.initialPageNo.toLowerCase()) {
                                __curPage = parseInt(parseInt(__bookData.pages.page[i].sno, 10) - 1,null);
                                if(isDoublePage()) {
                                    if(config.hasCover) {
                                        if(__curPage % 2 === 0 && __curPage !== 0) {
                                            __curPage--;
                                        }
                                    } else {
                                        if(__curPage % 2 !== 0) {
                                            __curPage--;
                                        }  
                                    }
                                }
                                break;
                            }
                        }
                        __firstPage = __curPage;
                        __secondPage = __firstPage + 1;
                    }
                }
                /**
                 * The path values mentioned in the book.json will have a higher priority than paths mentioned in the configuration.
                 */
                var currBookPath;
                if(__bookData.paths !== null && __bookData.paths !== undefined) {
                    currBookPath = __bookData.paths;
                    if(currBookPath.pageSmImgFolder) {
                        config.paths.imageRenderer.pageSmImgFolder = currBookPath.pageSmImgFolder;
                    }
                    if(currBookPath.pageSmImgTextFolder) {
                        config.paths.pageSmImgTextFolder = currBookPath.pageSmImgTextFolder;
                    }
                    if(currBookPath.pageMedImgFolder) {
                        config.paths.imageRenderer.pageMedImgFolder = currBookPath.pageMedImgFolder;
                    }
                    if(currBookPath.pageMedImgTextFolder) {
                        config.paths.imageRenderer.pageMedImgTextFolder = currBookPath.pageMedImgTextFolder;
                    }
                    if(currBookPath.pageLrgImgFolder) {
                        config.paths.imageRenderer.pageLrgImgFolder = currBookPath.pageLrgImgFolder;
                    }
                    if(currBookPath.pageLrgImgTextFolder) {
                        config.paths.imageRenderer.pageLrgImgTextFolder = currBookPath.pageLrgImgTextFolder;
                    }
                    if(currBookPath.pagexlLrgImgFolder) {
                        config.paths.imageRenderer.pagexlLrgImgFolder = currBookPath.pagexlLrgImgFolder;
                    }
                    if(currBookPath.pagexlLrgImgTextFolder) {
                        config.paths.imageRenderer.pagexlLrgImgTextFolder = currBookPath.pagexlLrgImgTextFolder;
                    }
                    if(currBookPath.pageThumbImgFolder) {
                        config.paths.imageRenderer.pageThumbImgFolder = currBookPath.pageThumbImgFolder;
                    }
                    if(currBookPath.pageThumbImgTextFolder) {
                        config.paths.imageRenderer.pageThumbImgTextFolder = currBookPath.pageThumbImgTextFolder;
                    }
                    if(currBookPath.pageTextDataFolder) {
                        config.paths.pageTextDataFolder = currBookPath.pageTextDataFolder;
                    }
                    if(currBookPath.mediaFolder) {
                        config.paths.mediaFolder = currBookPath.mediaFolder;
                    }
                }
                
                /* 
                   Override default config BY config data defined in the book (if exists) 
                */

                if(__bookData.imageConfig !== null && __bookData.imageConfig !== undefined) {
                    config.imageConfig = __bookData.imageConfig;
                }
                        
                callback();
                config.onBookDataLoad(true, __bookData.pages.page.length,__bookData.pages.page[0].pagelabel);
                
                var $eeOverlays = $("#ee-overlaysA,#ee-overlaysB");
                $eeOverlays.on("touchstart",function() {
                    $(document).trigger('CustomTouchStart');
                });
                $eeOverlays.on("touchmove",function() {
                    $(document).trigger('CustomTouchMove');
                });
                $eeOverlays.on("touchend",function() {
                    $(document).trigger('CustomTouchEnd');
                });
            });
        };

        /*----------- PRIVATE LOAD FUNCTIONS ---------------*/


        //Start loading

        $.extend(config, configNew);

        if(config.pinchEnabled === undefined) {
            config.pinchEnabled = config.isTouchDevice;
        }
        __bookId = bookId;
        
        loadBookDataJSON(__bookId, function() {
            createAndSetupDom();
            
            var availableWidth = getAvailableScreenWidth();
            resetZoomParametersFromConfig(availableWidth);

            __minZoom = __eeZoomState  -  config.minZoomLimit;
            setEreaderContainerStyle();
            setupCoverPageAndNextPages(__curPage);

            if(isDoublePage() && !(__curPage < 1 && config.hasCover)) {
                //For double page layout, we need to load the current 2 pages before preloading
                var leftPageLoaded = false;
                var rightPageLoaded = false;
                var preloaderNotstarted = true;
                startPageResourceLoading(__curPage,function() {
                    leftPageLoaded = true;
                    if(leftPageLoaded && rightPageLoaded && preloaderNotstarted) {
                        if(config.pinchEnabled) {
                            initializeEReaderPinch();
                        }
                        preloaderNotstarted = false;
                        setTimeout(function() {
                            startPreloading();
                        },1000);
                    }
                });
                startPageResourceLoading((__curPage * 1)+1,function() {
                    rightPageLoaded = true;
                    if(leftPageLoaded && rightPageLoaded && preloaderNotstarted) {

                        if(config.pinchEnabled) {
                            initializeEReaderPinch();
                        }
                        preloaderNotstarted = false;
                        setTimeout(function() {
                            startPreloading();
                        },1000);
                    }
                });

            } else {
                //For single page layout, we need to load only 1 page before starting the preloading
                startPageResourceLoading(__curPage,function() {
                    if(config.pinchEnabled) {
                        initializeEReaderPinch();
                    }
                    setTimeout(function() {
                        startPreloading();
                    },1000);
                });
            }

        });
    };

    /********************************************************/
    /*                 ONE TIME INIT FUNCTIONS              */
    /********************************************************/
    //keyboardNavigation();   

    
    /********************************************************/
    /*                 PUBLIC METHODS                       */
    /********************************************************/
    return {

        // Exposed functions used in html integration
        loadBook: loadBook,
        gotoPage:gotoPageNavigator,
        changeLayout :changePageLayout,
        changePage: pageNavigator,
        zoomIn : pageZoomIn,
        zoomOut : pageZoomOut,
        zoomTo: zoomEReaderTo,
        canZoomIn :canZoomIn,
        canZoomOut :canZoomOut,
        resetZoom : eReaderResetZoom,
        canResetZoom : canResetZoom,
        fitToHeight: fitToHeight,
        isDoublePageAllowed: isDoublePageAllowed,
        resizeImgbook: resizeImgbookHandler,
        getConfigInfo : getConfigData,
        pageLevel : getPageNumber,
        getPdfPageLevel : getPageLevel,
        getCurrentSerial: getCurrentSerial,
        getTotalPage : getBookTotalPage,
        jumpToPageLabel :jumpToPageLabel,
        jumpToPageSerial: jumpToPageSerial,
        setWebFontInfo : setWebFontData,
        setTranslateCoords: setTranslateCoords,
        getTranslateCoords: getTranslateCoords,
        getCursorPosition: getCursorPosition,
        exitCaptureMode:exitCaptureMode,
        getScaledOriginalBookValues: getScaledOriginalBookValues,
        
        // Exposed functions used in Edition internal testing
        containerWidth : getCurrentContainerWidth,
        pageLayout : getPageLayout,
        updateImageConfig: updateImageConfig,
        getImageConfig: getImageConfig,
        getZoomConfig: getZoomConfig,
        setZoomConfig: setZoomConfig,
        isContentFitToScreen: isContentFitToScreen,
        isContentFitToWidth: isContentFitToWidth,
        getOverlaysJSON: getOverlaysJSON,
        setOverlaysJSON: setOverlaysJSON,
        setIconColor: setIconColor,
        setCircleColor: setCircleColor, 
        setBorderColor: setBorderColor,
        setHotspotBorder: setHotspotBorder,
        setHoverColor: setHoverColor,
        getIconColor: getIconColor,
        getCircleColor: getCircleColor,
        getBorderColor: getBorderColor,
        getHotspotBorder :getHotspotBorder,
        getHoverColor: getHoverColor,
        enableAnnotations: enableAnnotations,
        getFontSize: getFontSize,
        getBookId : getBookId,
        getUser: getUser,
        getOrgId: getOrgId,
        annotationEventHandler: annotationEventHandler,
        getProductCode: getProductCode,
        getElParent : getElParent,
        enableOverlays: enableOverlays,
        enableTouchScreenGestures: enableTouchScreenGestures,
        getImageMapByPageLabel : getImageMapByPageLabel,
        getImageMapByPageSerial: getImageMapByPageSerial,
        showHotspotBorder : showHotspotBorder,
        getContentHeight: getContentHeight,
        getPageDimensionsFromJSON : getPageDimensionsFromJSON,
        getCurrentPagePosition: getCurrentPagePosition,
        openAnnotation: openAnnotation,
        canFitToHeight: canFitToHeight,
        animateHotlinks: animateHotlinks

    };

}());

//Setup Namspace
var comprodls = comprodls || {};
comprodls.RENDERER = comprodls.RENDERER || {};

comprodls.RENDERER.BASE = function() {};

comprodls.RENDERER.BASE.prototype = {

    $el: null,  //jQuery reference of the root element
    coreConfig: {}, //Config of eReader core

    /**
     * This method initializes the renderer
     * @param metadata
     */
    initialize: function() {},

    createAndSetupDOM: function() {},

    renderPage: function() {},

    unrender: function() {},

    resizeHandler: function() {}

};


/**
 * Abstract class to support background image fetching:
 *      - while preloading of the page
 *      - on resize of the page
 */

comprodls.RENDERER.ABSTRACT = function() {};

//Inheriting Base Renderer
comprodls.RENDERER.ABSTRACT.prototype = new comprodls.RENDERER.BASE();
comprodls.RENDERER.ABSTRACT.constructor = comprodls.RENDERER.ABSTRACT;

$.extend(comprodls.RENDERER.ABSTRACT.prototype, {

    getImagePath: function(useWebFonts, currentFolderRef) {

        var loadingRequired = false;
        var containerWidth = this.$el.width();
        var index;
        var imageSuffix;
        var newFolderPath;

        for(index=0; index< this.coreConfig.imageConfig.length; index++) {
            if(containerWidth < this.coreConfig.imageConfig[index].width) {
                if(currentFolderRef === this.coreConfig.imageConfig[index].folderRef) {
                    loadingRequired = false;
                    break;
                }
            } else {

                index -= 1;
                loadingRequired = true;
                break;
            }
        }

        if(index >= this.coreConfig.imageConfig.length) {
            index -= 1;
            loadingRequired = true;
        } else if (index < 0) {
            index = 0;
            loadingRequired = true;
        }

        if(loadingRequired) {
            newFolderPath = this.coreConfig.imageConfig[index].folderRef;
            imageSuffix = this.getImageSuffix(newFolderPath, useWebFonts);

        } else {
            imageSuffix = this.getImageSuffix(currentFolderRef, useWebFonts);
        }

        return {
            loadingRequired: loadingRequired,
            folderRef: loadingRequired ? newFolderPath : currentFolderRef,
            imageSuffix: imageSuffix
        };
    },

    getImageSuffix: function(folderRef, useWebFonts) {

        var imageSuffix = '';
        var paths = this.coreConfig.paths.imageRenderer;
        
        if(folderRef === "xlrg") {
            if(useWebFonts) {
                imageSuffix = paths.pagexlLrgImgTextFolder;
            } else {
                imageSuffix = paths.pagexlLrgImgFolder;
            }
        } else if(folderRef === "lrg") {
            if(useWebFonts) {
                imageSuffix = paths.pageLrgImgTextFolder;
            } else {
                imageSuffix = paths.pageLrgImgFolder;
            }
        } else if(folderRef === "med") {
            if(useWebFonts) {
                imageSuffix = paths.pageMedImgTextFolder;
            } else {
                imageSuffix = paths.pageMedImgFolder;
            }
        } else if(folderRef === "sm") {
            if(useWebFonts) {
                imageSuffix = paths.pageSmImgTextFolder;
            } else {
                imageSuffix = paths.pageSmImgFolder;
            }
        } else if(folderRef === "thumbnail") {
            imageSuffix = paths.pageThumbImgFolder;
        } else {
            if(useWebFonts) {
                imageSuffix = paths.pageMedImgTextFolder;
            } else { 
                imageSuffix = paths.pageMedImgFolder;
            }
        }

        return imageSuffix;
    },

    getUpdatedImagePath: function(metadata, useWebFonts, folderRef) {
        var imagePath = this.getImagePath(useWebFonts, folderRef);
        var imagePathToLoad, htmlPathToLoad;
        if (metadata.fid !== undefined && metadata.fid !== null ) {
            imagePathToLoad = this.coreConfig.bookAssetServer + this.coreConfig.bookBaseFolder + imagePath.imageSuffix + metadata.fid + '.jpg';
        } else {
            imagePathToLoad = this.coreConfig.bookAssetServer + this.coreConfig.bookBaseFolder + imagePath.imageSuffix + metadata.bgimage;
        }
        if(metadata["page-text"]) {
            htmlPathToLoad = this.coreConfig.bookAssetServer + this.coreConfig.bookBaseFolder + this.coreConfig.paths.pageTextMetaFolder + metadata["page-text"];
        }
        

        return {
            loadingRequired: imagePath.loadingRequired,
            imagePathToLoad: imagePathToLoad,
            folderRef: imagePath.folderRef,
            htmlPathToLoad: htmlPathToLoad
        };

    },

    renderImageAndHtml: function(paths, callback) {
        var imgSrc = paths.imagePathToLoad;

        var config = this.coreConfig;
        this.$el.find("img.imageLayer").attr('src', imgSrc).one('load', function() {

            if (callback) {
                callback();    
            }

        }).one('error', function(event) {

            if (event.type === 'error' && config.onPageLoadErrorCallback) {
                var data = {
                    orgError: event,
                    errorType: config.ERROR_CODES.FILE_NOT_FOUND,
                    errorFn: "renderImageAndHtml",
                    imgPath: imgSrc
                };
                config.onPageLoadErrorCallback(data);
            }

        });
        if(paths.htmlPathToLoad) {
            var htmlSrc = paths.htmlPathToLoad;
            comprodls.READER.IMGREADER.UTIL.loadHTML(htmlSrc, function(htmlOfImg) {
                this.$el.find("div.textLayer").html(htmlOfImg);
            }.bind(this));
            
        }
        
        
    },

    resizeHandler: function(metadata, useWebFonts, folderRef, callback) {

        var self = this;
        var paths = self.getUpdatedImagePath(metadata, useWebFonts, folderRef);

        if(paths.loadingRequired) {
            comprodls.READER.IMGREADER.UTIL.loadImageAndHtml(paths, function() {
                //Render the image
                self.renderImageAndHtml(paths, callback);

            }, function() {

            });
        } else {
            if (callback) {
                callback();    
            }
        }

        return paths;
    }

});

//Setup Namspace
var comprodls = comprodls || {};
comprodls.RENDERER = comprodls.RENDERER || {};

comprodls.RENDERER.IMAGE = function(){

    /**
     * This method initializes the renderer
     * @param metadata
     */
    this.initialize = function(metadata) {
        //this.parent.initialize(metadata);
        this.$el = metadata.$element;
        this.coreConfig = metadata.config;
        this.imageFolderPaths = this.coreConfig.paths.imageRenderer;
    };

    this.createAndSetupDOM = function() {
        this.$el.find("div.textLayer").remove();
        this.$el.append('<img aria-hidden="true" class="imageLayer readerpagediv"/><div class="textLayer readerpagediv"></div>');
    };

    /**
     * This method renders the page using the metadata provided
     * @param metadata
     */
    this.renderPage = function(metadata, callback) {

        //Create and setup the required DOM structure
        this.createAndSetupDOM();

        this.$el.find("img.imageLayer").one('load', function() {
            callback();
        });

        var pageIndex = metadata.sno;
        if(comprodls.RENDERER.IMAGE.pagesStatus[pageIndex]) {
            var paths = this.getUpdatedImagePath(metadata, false, comprodls.RENDERER.IMAGE.pagesStatus[pageIndex].folderRef);
            if(paths.loadingRequired) {
                comprodls.RENDERER.IMAGE.pagesStatus[pageIndex].folderRef = paths.folderRef;
            }

            this.renderImageAndHtml(paths);
        }
    };

    this.unrender = function() {
        this.$el.find('.imageLayer').remove();
    };

    this.resizeHandler = function(metadata, callback) {
        if (metadata !== undefined) {
            var imagePath = this.parent.resizeHandler.call(this, metadata, false, comprodls.RENDERER.IMAGE.pagesStatus[metadata.sno].folderRef, callback);
            if(imagePath.loadingRequired) {
                comprodls.RENDERER.IMAGE.pagesStatus[metadata.sno].folderRef = imagePath.folderRef;
            }
        }
    };

};

//Inheriting Base Renderer
comprodls.RENDERER.IMAGE.prototype = new comprodls.RENDERER.ABSTRACT();
comprodls.RENDERER.IMAGE.constructor = comprodls.RENDERER.IMAGE;
comprodls.RENDERER.IMAGE.prototype.parent = comprodls.RENDERER.ABSTRACT.prototype;

//static property
comprodls.RENDERER.IMAGE.pagesStatus = {};

/**
 * Preload the assets required to render the page
 * @param metadata
 * @param callback
 */
comprodls.RENDERER.IMAGE.preload = function(metadata, callback) {
    var pageIndex = metadata.sno;

    if(this.pagesStatus[pageIndex] === undefined) {
        this.pagesStatus[pageIndex] = {
            folderRef: null
        };
    }

    this.prototype.imageFolderPaths = this.prototype.coreConfig.paths.imageRenderer;
    var paths = this.prototype.getUpdatedImagePath(metadata, false, this.pagesStatus[pageIndex].folderRef);
    var config = this.prototype.coreConfig;

    if(paths.loadingRequired) {
        this.pagesStatus[pageIndex].folderRef = paths.folderRef;

        comprodls.READER.IMGREADER.UTIL.loadImageAndHtml(paths, function() {
            callback();
        }, function(err) {

            //todo exception handling
            if (config.onPageLoadErrorCallback) {
                var data = {
                    orgError: err,
                    errorType: config.ERROR_CODES.FILE_NOT_FOUND,
                    errorFn: "READER.IMGREADER.UTIL.loadImageAndHtml in RENDERER.IMAGE.preload",
                    imgPath: paths.imagePathToLoad
                };
                config.onPageLoadErrorCallback(data);
            }

            
        });
    } else {
        callback();
    }
};

/*global AudioAdapterGenerator*/
/*global MediaElementPlayer*/
//Setup Namspace
var comprodls = comprodls || {};
var audioAdaptorMap = {};
var timeoutCounter;

comprodls.OVERLAYSRENDERER = (function () 
{
    var renderOverlays = function(pageNo,pagetype,jsonData,mediaFolder,config,fontSize, pageWidth, pageHeight, bookData, isReRendering){
        var pageAssets= 0;
        var iconType;
        var pageNumber = bookData.pages.page[pageNo].sno;
        var overlayHighlightStyle = {
            'background-color': 'rgb(109,230,195)'
        };
        stopPreviousOverlay();
        
        if(jsonData !== null) {
            if ( jsonData[pageNumber] ) {
                pageAssets = jsonData[pageNumber].length;
            }
        }

        var renderOverlaysDataType = function(index,overlaysId){
            var leftPosition = '';
            var topPosition ='';
            var $readerpagedivA = $("#readerpagedivA");
            var $currentOverlay = $('#ee-overlays'+pageNo+'-'+index);
            var bindMouseMoveEvents = false;

            iconType =  jsonData[pageNumber][index].type;

            var overlaysName = jsonData[pageNumber][index].icon;

            var pageScreenWd = $readerpagedivA.width();
            var pageScreenHeight = $readerpagedivA.height();

            leftPosition =  ((jsonData[pageNumber][index].x * pageScreenWd)/pageWidth) ;
            topPosition =   ((jsonData[pageNumber][index].y * pageScreenHeight)/pageHeight) ;

            $currentOverlay.css({
                "left" : leftPosition/fontSize + "em",
                "top": topPosition/fontSize + "em"
            });

            $currentOverlay.children("div").attr('type',iconType);

            // set an attribute for visibilty for the current hotspot.
            // this is set from the experience app.
            // not related to the visiblity flag set via builder.
            // used to differentiate and / or identify visible and invisible type of hotspots.
            $currentOverlay.children("div").attr('visibility', jsonData[pageNumber][index] && jsonData[pageNumber][index].meta && jsonData[pageNumber][index].meta.visibility);
            // set an attribute for icontype for the current hotspot.
            // this is set from the experience app.
            // not related to the visiblity flag set via builder.
            // used to differentiate and / or identify the type of hotspot (audio, video, jump to page, link etc).
            $currentOverlay.children("div").attr('iconType', jsonData[pageNumber][index] && jsonData[pageNumber][index].meta && jsonData[pageNumber][index].meta.iconType);
            // set an attribute for aria-label for the current hotspot.
            $currentOverlay.children("div").attr('aria-label', jsonData[pageNumber][index] && jsonData[pageNumber][index].meta && jsonData[pageNumber][index].meta.ariaLabel);
            // append a string of classes to current hotspot.
            // this is set from the experience app.
            // not related to the visiblity flag set via builder.
            $currentOverlay.addClass(jsonData[pageNumber][index].classes);

            // iterate over the hotspot object's data and add any attribute as provided by the experience app.
            if (jsonData[pageNumber][index] && jsonData[pageNumber][index].attributesObject) {
                var attributeObject = jsonData[pageNumber][index].attributesObject;

                for (var key in attributeObject) {
                    if (attributeObject.hasOwnProperty(key)) {
                        $currentOverlay.attr(key, attributeObject[key]);
                    }
                }
            }
            
            var overlay = $('#ee-overlays'+pageNo+'-'+index +" > div");
            var overlayIcon = overlay.children("i");
            applyTooltip(overlay, index);
            
            if(overlaysName === 'invisible') {
                var iconWidth = (jsonData[pageNumber][index].w * pageScreenWd)/(pageWidth*fontSize);
                var iconHeight = (jsonData[pageNumber][index].h * pageScreenHeight)/(pageHeight*fontSize);
                var borderColor;
                var borderWidth;
                
                if (jsonData["overlay-config"] && jsonData["overlay-config"]["invisible-hotspot-border"]) {
                     borderColor = jsonData["overlay-config"]["invisible-hotspot-border"];
                } else {
                    borderColor = "#AAAAAA";
                }
                if (jsonData["overlay-config"] && jsonData["overlay-config"]["show-hotspot-border"]) {
                     borderWidth = "2px";
                } else {
                    borderWidth = "0px";
                }
                $currentOverlay.children("div").children("i").remove();
                $currentOverlay.children("div").append('<div class ="hotSpotBox" style="width:' + iconWidth + 'em; height:' + iconHeight + 'em;background-color:transparent;border:' + borderWidth + ' solid '+ borderColor + ';"></div>');
                $currentOverlay.addClass("invisibleHotspot");
                if (jsonData[pageNumber][index].style !== undefined) {
                    if (jsonData[pageNumber][index].style.hover && jsonData[pageNumber][index].style.hover === "underline") {
                         overlay.addClass("underline");
                    }
                }
                // Add config based class
                if(config.showAnimation) {
                    overlay.addClass("invisibleHotspot-overlay");
                    overlay.css("background-color", getColorWithoutOpacity(jsonData[pageNumber][index]['animation-color'] || overlayHighlightStyle['background-color']));
                    if(jsonData[pageNumber][index].h < 16 || jsonData[pageNumber][index].w < 16) {
                      overlay.css('border-radius', '3px');
                    } else {
                      overlay.css('border-radius', '5px');
                    }
                }
            } else {
                
                if (overlaysName.indexOf("dls-imgbook-supersite") !== -1 && overlaysName.indexOf("-ttf") === -1) {
                    overlayIcon.parent().html("<div class='dls-imgbook-supersite'></div>");
                } else if (overlaysName.indexOf("dls-imgbook-mouse") !== -1 && overlaysName.indexOf("-ttf") === -1) {
                    overlayIcon.parent().html("<div class='dls-imgbook-mouse'></div>");
                } else {
                    if (overlaysName.indexOf("dls-imgbook-supersite-ttf") === -1 && overlaysName.indexOf("dls-imgbook-mouse-ttf") === -1 ) {
                        overlay.addClass( 'circle-shape');
                        if (overlaysName.indexOf("dls-imgbook-volume-up") !== -1) {
                            overlay.addClass( 'audio-circle');
                        }
                        
                        if (jsonData["overlay-config"] && jsonData["overlay-config"]["background-color"]) {
                            overlay.css('background-color' , jsonData["overlay-config"]["background-color"]);    
                        }
                        if (jsonData["overlay-config"] && jsonData["overlay-config"]["border-color"]) {
                            overlay.css('border-color' , jsonData["overlay-config"]["border-color"]);
                        }
                        bindMouseMoveEvents = true;
                        overlay.mouseover(function() {
                            overlay.css("background-color", comprodls.READER.getHoverColor());
                        }).mouseout(function() {
                            overlay.css("background-color", comprodls.READER.getCircleColor());
                        });
                        
                        if (jsonData["overlay-config"] && jsonData["overlay-config"]["icon-color"]) {
                            overlayIcon.css('color' , jsonData["overlay-config"]["icon-color"]);
                        }
                    }
                }
                
                overlayIcon.addClass( overlaysName +' icon-1x overlays-style');
                // Add config based class
                if(config.showAnimation) {
                    var $animationOverlay = $('<span class="animation-overlay"></span>');
                    $animationOverlay.css("background-color", getColorWithoutOpacity(jsonData[pageNumber][index]['animation-color'] || overlayHighlightStyle['background-color']));
                    $animationOverlay.appendTo($currentOverlay);
                    applyTooltip($animationOverlay, index); 
                    if (bindMouseMoveEvents) {
                      $animationOverlay.mouseover(function() {
                          overlay.css("background-color", comprodls.READER.getHoverColor());
                      }).mouseout(function() {
                          overlay.css("background-color", comprodls.READER.getCircleColor());
                      });
                    }
                }
            }
            if(iconType === 'audio') {
                // In case no default audio icon is provided keep icon "dls-imgbook-font dls-imgbook-volume-up"
                if (!overlaysName) {
                    overlaysName = "dls-imgbook-font dls-imgbook-volume-up";
                }
                var audioOverlay = $('#ee-overlays'+pageNo+'-'+index +" > div");
                var audioOverlayIcon = audioOverlay.children("i");
                
                audioOverlayIcon.addClass( overlaysName +' icon-1x overlays-style');
                audioOverlay.addClass('audio-circle');

                audioOverlayIcon.removeClass(overlaysName).addClass(overlaysName);
            }
         
            if (jsonData[pageNumber][index]['clickEvents'] && jsonData[pageNumber][index]['clickEvents'].dblClick) {
                // double-click handler for imgbook overlays
                $('#' + overlaysId).on('dblclick keypress', function (event) {

                    if((event.type === 'keypress' && event.which === 13) || (event.type === 'dblclick')) {
                        event.stopPropagation();
                        iconType = $($(this).children()[0]).attr("type");
                        if (config.onOverlayDblClick && jQuery.isFunction(config.onOverlayDblClick)) {
                            config.onOverlayDblClick(overlaysId, index, pageWidth, pageHeight, fontSize, pageNo, event, pageNumber, jsonData[pageNumber][index]);
                        }
                    }
                });
            }
            
            if(!jsonData[pageNumber][index]['clickEvents'] || (jsonData[pageNumber][index]['clickEvents'] && jsonData[pageNumber][index]['clickEvents'].singleClick)) {
                // if click events are not passed for an overlay, run the normal click handler or if click events are passed and it is the single click event then run the single click handler
                $('#' + overlaysId).on('click keypress', function (event) {

                    if((event.type === 'keypress' && event.which === 13) || (event.type === 'click')) {
                        event.stopPropagation();
                        iconType = $($(this).children()[0]).attr("type");
                        if (config.onOverlaySelect && jQuery.isFunction(config.onOverlaySelect)) {
                            var result = config.onOverlaySelect(overlaysId, index, pageWidth, pageHeight, fontSize, pageNo, event, pageNumber, jsonData[pageNumber][index]);
                            if (result) {
                                overlaysDataClickedInternalEvent(overlaysId, index, pageWidth, pageHeight, fontSize, pageNo, event, pageNumber, jsonData[pageNumber][index]);
                            }
                        } else {
                            overlaysDataClickedInternalEvent(overlaysId, index, pageWidth, pageHeight, fontSize, pageNo, event, pageNumber, jsonData[pageNumber][index]);
                        }
                    }
                });
            }            
        };
        var overlaysDataClickedInternalEvent = function(overlaysId , assetsNo, pageWidth, pageHeight, fontSize, pageNo, event, pageNumber){

            var resourceType = $('#'+ overlaysId + '> div').attr('type');
            var fullAssetsUrl;
            var assetsUrl,baseURL;
            var pat;
            if(resourceType === 'video') {
              
                stopAudioPlayer();
                //assetsUrl =jsonData.overlays.assets.asset[assetsNo].path;
                assetsUrl =jsonData[pageNumber][assetsNo].video.baseURL;
                
                fullAssetsUrl = config.bookAssetServer + config.bookBaseFolder + mediaFolder + assetsUrl;
             
                pat = /^http?:\/\//i;
                           
                if (pat.test(assetsUrl)) {
                    playHTML5Video(assetsUrl, true, jsonData[pageNumber][assetsNo]);
                } else {
                    if(config.mediaBaseFolderPath !== undefined && config.mediaBaseFolderPath !== ''){
                                    
                        fullAssetsUrl = config.mediaBaseFolderPath + assetsUrl;  
                    } else {          
                        fullAssetsUrl = config.bookAssetServer + config.bookBaseFolder + mediaFolder + assetsUrl;
                    }
                    
                    playHTML5Video(fullAssetsUrl, false, jsonData[pageNumber][assetsNo]);
           
                }
            }
            if(resourceType === 'audio') {
                var currentTarget = $(event.currentTarget);
                var overlayCircle = currentTarget.children(".audio-circle");
                var targetId = event.currentTarget.id;

                if(!audioAdaptorMap[targetId]) {
                    stopPreviousOverlay();
                    overlayCircle.addClass("selected music-icon-selected");
                    /*overlayCircle.children("i").removeClass("dls-imgbook-volume-up").addClass("dls-imgbook-pause");*/
                    overlayCircle.removeClass("paused");
                    var audioadptrGen = new AudioAdapterGenerator();
                    var filepath = jsonData[pageNumber][assetsNo].audio.path;
                    pat = /^http?:\/\//i; 
                    var pat2 = /^https?:\/\//i;
                    var audioAdapter;
                    
                    if($.isArray(filepath)) {
                        var audioArray = $.extend(true, [], filepath);
                        for (var index in audioArray) {
                            if (jsonData[pageNumber][assetsNo].audio.baseURL) {
                                baseURL = jsonData[pageNumber][assetsNo].audio.baseURL;
                                audioArray[index] = bookData["overlay-config"]["external-base-urls"][baseURL] + audioArray[index];
                            } else if (!(pat.test(audioArray[index]) || pat2.test(audioArray[index]))) {
                                audioArray[index] = config.bookAssetServer + config.bookBaseFolder + mediaFolder + audioArray[index];
                            }
                        }
                        audioAdapter = audioadptrGen.getAudioAdapter({
                            "id": targetId,
                            "url": audioArray,
                            "resetAudioIcon": resetAudioIcon,
                            "togglePlayPauseIcon": togglePlayPauseIcon,
                            "onAudioStop": config.onAudioStop
                        });
                        audioAdaptorMap[targetId] = audioAdapter;
                        var delay = 0;
                        if (jsonData[pageNumber][assetsNo].audio["delay-between-audios"]) {
                            delay = jsonData[pageNumber][assetsNo].audio["delay-between-audios"];
                        } else if (bookData["overlay-config"] && bookData["overlay-config"].audio && bookData["overlay-config"].audio["delay-between-audios"]) {
                            delay = bookData["overlay-config"].audio["delay-between-audios"];
                        }
                        
                        audioAdaptorMap[targetId].startAudioPlayList(delay, function(audioNumber, length){
                            //Show Controls ** Emit event
                            if (config.onAudioStart) {
                                // Passing the audioAdaptorMap, 
                                // AND current audio number played and total number of audios(in case of multiple audios)
                                config.onAudioStart(audioAdaptorMap[targetId], audioNumber, length);
                            }    
                        });
                    } else {
                        if (jsonData[pageNumber][assetsNo].audio.baseURL) {
                            baseURL = jsonData[pageNumber][assetsNo].audio.baseURL;
                            filepath = bookData["overlay-config"]["external-base-urls"][baseURL] + filepath;
                        } else if (!(pat.test(filepath) || pat2.test(filepath))) {
                            filepath = config.bookAssetServer + config.bookBaseFolder + mediaFolder + filepath;
                        }
                        
                        audioAdapter = audioadptrGen.getAudioAdapter({
                            "id": targetId,
                            "url": filepath,
                            "resetAudioIcon": resetAudioIcon,
                            "togglePlayPauseIcon": togglePlayPauseIcon,
                            "onAudioStop": config.onAudioStop
                        });  
                        audioAdaptorMap[targetId] = audioAdapter;
                        audioAdaptorMap[targetId].startAudio(function(){
                            //Show Controls ** Emit event
                            if (config.onAudioStart) {
                                config.onAudioStart(audioAdaptorMap[targetId]);
                            }    
                        });
                    }
                } else {
                    if (audioAdaptorMap[targetId].isAudioPlaying()) {
                        audioAdaptorMap[targetId].pauseAudio();
                    } else {
                        audioAdaptorMap[targetId].playAudio(); 
                    }
                    
                }
            }
            if(resourceType === 'img') {
                
                assetsUrl =jsonData[pageNumber][assetsNo].url.baseURL;
                pat = /^http?:\/\//i;
                if (pat.test(assetsUrl)){
                    $.featherlight(assetsUrl, {
                        afterContent: function () {
                            var contentHtml  = $(".featherlight .featherlight-content").html();
                            $(".featherlight .featherlight-content").html("<div id='main-content'></div>");
                            $(".featherlight .featherlight-content #main-content").html(contentHtml);
                            $(".featherlight .featherlight-content").prepend("<div id='left-content'><div id='header-content'><h1>" + jsonData[pageNumber][assetsNo].title + "</h1></div><div><p class='lead'>" + jsonData[pageNumber][assetsNo].desc + "</p></div></div>");
                        }
                    });
                }
                else{
                    if(config.mediaBaseFolderPath !== undefined && config.mediaBaseFolderPath !== ''){
                        fullAssetsUrl = config.mediaBaseFolderPath + assetsUrl;  
                    } else {
                        fullAssetsUrl = config.bookAssetServer + config.bookBaseFolder + mediaFolder + assetsUrl;
                    }
                    $.featherlight(fullAssetsUrl, {
                        afterContent: function () {
                            var contentHtml  = $(".featherlight .featherlight-content").html();
                            $(".featherlight .featherlight-content").html("<div id='main-content'></div>");
                            $(".featherlight .featherlight-content #main-content").html(contentHtml);
                            $(".featherlight .featherlight-content").prepend("<div id='left-content'><div id='header-content'><h1>" + jsonData[pageNumber][assetsNo].title + "</h1></div><div><p class='lead'>" + jsonData[pageNumber][assetsNo].desc + "</p></div></div>");
                        }
                    });
                }
            }
            if(resourceType === 'pdf') {
                assetsUrl =jsonData[pageNumber][assetsNo].url.path;
                pat = /^http?:\/\//i;
                if (pat.test(assetsUrl)) {
                    window.open(assetsUrl,'_blank');
                } else {
                    if( config.mediaBaseFolderPath !== undefined && config.mediaBaseFolderPath !== '' ) { 
                        fullAssetsUrl = config.mediaBaseFolderPath + assetsUrl;
                    } else{ 
                        fullAssetsUrl = config.bookAssetServer + config.bookBaseFolder + mediaFolder + assetsUrl;
                    }
                    window.open(fullAssetsUrl,'_blank');
                }   
            }
            if(resourceType === 'text'){
                var text =jsonData[pageNumber][assetsNo].text;
                $.featherlight(text, {
                    text : text,
                    afterContent: function () {
                        $(".featherlight .featherlight-content").width(jsonData[pageNumber][assetsNo].w);
                    }
                });
            }
            if(resourceType === 'activity'){
                assetsUrl =jsonData[pageNumber][assetsNo].activity.path;
                if(config.mediaBaseFolderPath !== undefined && config.mediaBaseFolderPath !== ''){
                    fullAssetsUrl = config.mediaBaseFolderPath + assetsUrl;  
                }
                else {
                    fullAssetsUrl = config.bookAssetServer + config.bookBaseFolder + mediaFolder + assetsUrl;
                }
                var objectId = jsonData[pageNumber][assetsNo].activity.id;
                var loaderID = "loader_" + objectId;
                var activityBoxId = "activity-overlay"+ pageNo + '-' + assetsNo;
                var hotspotId = "ee-overlays"+ pageNo + '-' + assetsNo;
                var itemParams = {
                    "bowerComponentPath": "../bower_components/",
                    "displaySubmit": false,
                    "engineType" : jsonData[pageNumber][assetsNo].activity.engineType,
                    "layoutType" : jsonData[pageNumber][assetsNo].activity.layoutType,
                    "id" : loaderID,
                    "contentFile" : fullAssetsUrl
                };
                var eventContext = {                
                    "afterItemSave" : function(objectId) {
                        console.log("afterItemSave"+objectId);
                    },
                    "afterItemSubmit" : function(objectId) {
                        /*$("#"+objectId + " .nextQuestionButton", epubContentDocument).each(function() {
                            $(this).show();
                        });*/
                        console.log("afterItemSubmit"+objectId);
                    },
                    "afterItemLoaded" : function(objectId) {
                        $("#"+objectId + " .wrapper").each(function() {
                            $(this).removeClass("hidden");
                        });
                       
                        $("#"+ objectId).parent().parent().show();
                        var animation;
                        if ($("#"+activityBoxId).css("left") === "0px") {
                            animation = "fadeInLeft";
                        } else {
                            animation = "fadeInRight";
                        }
                        
                        var animateElement = $("#"+ objectId).parent().parent();
                        var animationDuration = 800;
                        
                        animateElement.addClass('animated '+ animation);
                        
                        setTimeout(function(){
                            animateElement.removeClass(animation);
                            $("#" + hotspotId + " div div i").remove();
                        }, animationDuration);
                    },
                    "afterDimensionChange" : function(activityResizeParams) {                        
                        console.log("afterDimensionChange"+activityResizeParams);
                    },
                    "doAfterSkipQuestion" : function(objectId, json) {
                        console.log("Inside doAfterSkipQuestion");
                        console.log("ObjectID: " + objectId);
                        console.log("JSON Response: " + json);
                    }  
                };  
                
                var initParams = {
                    "baseURLs" : {
                        "questionJSON": ""
                    },
                    "paintPrefsActivity" : {
                        "size":"medium", 
                        "color":"style-white"
                    }
                };      

                /*$.featherlight('#activity-lightbox', {
                    afterContent: function () {
                        var styles = "<style>.hidden {display: none !important;visibility: hidden !important;}.ui-loader {z-index: 9999999;position:absolute!important;}object .container-fluid{position:relative;}.wrapper{position: relative;border: 2px solid #7C7C7C;border-radius: 4px;margin: 0 20px;}.ribbon {position: absolute;left:15px;top:-9px;z-index: 1;}.ribbon h2 {background: #275B89;color: #fff;font-size: 14px;font-weight:bold;position: relative;box-shadow: 4px 5px 3px #DCDCDC;padding: 6px 20px;margin: 0;}.ribbon h2:after {border-width: 4px 4px;border-style: solid;border-color: transparent #444444 #444444 transparent ;content: '';position: absolute;top:0;left:-8px;}.btn {-moz-user-select: none;background-image: none;border: 1px solid transparent;border-radius: 2px;cursor: pointer;display: inline-block;font-size: 13px;font-weight: 400;line-height: 1.42857;margin-bottom: 0;padding: 6px 12px;text-align: center;vertical-align: middle;white-space: nowrap;}.btn-warning {background-color: #c79121;border-color: #b1811d;color: #fff;}.btn-warning.active, .btn-warning.focus, .btn-warning:active, .btn-warning:focus, .btn-warning:hover, .open > .dropdown-toggle.btn-warning {background-color: #9b711a;border-color: #7d5b15;color: #fff;}.btn-warning.active, .btn-warning:active, .open > .dropdown-toggle.btn-warning {background-image: none;}.nextQuestionButton {position: absolute;bottom: -18px;left: 15px;}</style>";
                        var activityHTML = "<div id='"+ objectId +"'><div><div id='" + loaderID + "' class='ui-loader hidden'><svg version='1.1' id='loader-1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.   w3.org/1999/xlink' x='0px' y='0px'width='40px' height='40px' viewBox='0 0 40 40' enable-background='new 0 0 40 40' xml:space='preserve'><path style='stroke-linecap: butt; stroke: rgb(0, 0, 0); stroke-width: 4;' opacity='0.2' fill='#000' d='M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z'/><path style='stroke-linecap: butt; stroke: rgb(0, 0, 0); stroke-width: 4;' fill='#000' d='M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0C22.32,8.481,24.301,9.057,26.013,10.047z'><animateTransform attributeType='xml'attributeName='transform'type='rotate'from='0 20 20'to='360 20 20'dur='0.8s'repeatCount='indefinite'/></path></svg></div><div class='row-fluid'><!-- Activity Container Starts here --><div class='wrapper hidden'><div class='span12 activityContainer book-activity'><div class='inner iframeContainer text-center' id='iframeContainer'></div><button class='btn btn-default btn-warning nextQuestionButton' style='display: none;'>Next Question &gt;&gt;</button></div> <!-- Activity Container ends here --></div></div></div></div>";
                        $('.featherlight-content').append(styles + activityHTML);
                        $('.featherlight-content').css("min-height", "140px");

                        var contentHtml  = $(".featherlight .featherlight-content").html();
                        $(".featherlight .featherlight-content").html("<div id='main-content'></div>");
                        $(".featherlight .featherlight-content #main-content").html(contentHtml);
                        $(".featherlight .featherlight-content").prepend("<div id='left-content'><div id='header-content'><h1>Activity</h1></div><div><p class='lead'>"+ jsonData[pageNumber][assetsNo].desc + "</p></div></div>");
                    },
                    afterOpen: function () {
                        var testRunner = new TestRunner();
                        testRunner.init(initParams, "#"+ objectId + " #iframeContainer", eventContext, objectId, "#" + loaderID, function() {
                        testRunner.initializeLauncher(itemParams, objectId, function() {
                            console.log("here");
                        });
                        var activitySettings =  {"size":"large"};
                        testRunner.updatePaintPreferences(activitySettings, objectId);
                    });
                    },
                    beforeClose: function () {
                        
                    }
                });*/

                    
                //Open new activity in pop up if already not opened else if already opened, close the pop up.
                if (activityBoxId !== $("body .activityBox").attr("id")) {
                    //Removing border on any previous activity hotspot
                    $(".invisibleHotspot div div").css("border-width","0");
                    $("#" + hotspotId + " div div").css("border-width","2px");
                    $("#" + hotspotId + " div div").css("box-shadow","2px 2px 1px #e5e5e5");
                    $("#" + hotspotId + " div div").append("<i class='dls-imgbook-font dls-imgbook-spinner dls-imgbook-pulse' style='font-size:30px;margin:5% 0 0 40%;'></i>");
                    $("body .activityBox").remove();
                    
                    $("body").append('<div style="display:none;" class="activityBox" id="' + activityBoxId + '"></div>');
                    if ($('#ee-overlays'+pageNo+'-'+assetsNo).offset().left > window.innerWidth/2) {
                        $("#"+activityBoxId).css("left","0");
                        $("#"+activityBoxId).css("right","");
                    } else {
                        $("#"+activityBoxId).css("right","0");
                        $("#"+activityBoxId).css("left","");
                    }

                    //Set Up Activity HTML
                    var styles = "<style>.hidden {display: none !important;visibility: hidden !important;}.ui-loader {z-index: 9999999;position:absolute!important;}object .container-fluid{position:relative;}.wrapper{position: relative;}.ribbon {position: absolute;left:15px;top:-9px;z-index: 1;}.ribbon h2 {background: #275B89;color: #fff;font-size: 14px;font-weight:bold;position: relative;box-shadow: 4px 5px 3px #DCDCDC;padding: 6px 20px;margin: 0;}.ribbon h2:after {border-width: 4px 4px;border-style: solid;border-color: transparent #444444 #444444 transparent ;content: '';position: absolute;top:0;left:-8px;}.btn {-moz-user-select: none;background-image: none;border: 1px solid transparent;border-radius: 2px;cursor: pointer;display: inline-block;font-size: 13px;font-weight: 400;line-height: 1.42857;margin-bottom: 0;padding: 6px 12px;text-align: center;vertical-align: middle;white-space: nowrap;}.btn-warning {background-color: #c79121;border-color: #b1811d;color: #fff;}.btn-warning.active, .btn-warning.focus, .btn-warning:active, .btn-warning:focus, .btn-warning:hover, .open > .dropdown-toggle.btn-warning {background-color: #9b711a;border-color: #7d5b15;color: #fff;}.btn-warning.active, .btn-warning:active, .open > .dropdown-toggle.btn-warning {background-image: none;}.nextQuestionButton {position: absolute;bottom: -18px;left: 15px;}.iframeContainer{max-height:350px;overflow:auto;}.submitActivity{padding:10px;}</style>";
                    var activityHTML = "<div id='"+ objectId +"'><div><div id='" + loaderID + "' class='ui-loader hidden'><svg version='1.1' id='loader-1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.   w3.org/1999/xlink' x='0px' y='0px'width='40px' height='40px' viewBox='0 0 40 40' enable-background='new 0 0 40 40' xml:space='preserve'><path style='stroke-linecap: butt; stroke: rgb(0, 0, 0); stroke-width: 4;' opacity='0.2' fill='#000' d='M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z'/><path style='stroke-linecap: butt; stroke: rgb(0, 0, 0); stroke-width: 4;' fill='#000' d='M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0C22.32,8.481,24.301,9.057,26.013,10.047z'><animateTransform attributeType='xml'attributeName='transform'type='rotate'from='0 20 20'to='360 20 20'dur='0.8s'repeatCount='indefinite'/></path></svg></div><div class='row-fluid'><!-- Activity Container Starts here --><div class='wrapper hidden'><div class='span12 activityContainer book-activity'><div class='inner iframeContainer text-center' id='iframeContainer'></div></div> <!-- Activity Container ends here --></div><div class='text-center submitActivity'><button class='btn btn-sm btn-primary doneQuestion'>Submit</button></div></div></div></div>";
                    $("#"+ activityBoxId).append(styles + activityHTML);

                    var contentHtml  = $("#"+ activityBoxId).html();
                    $("#"+ activityBoxId).html("<div id='main-content'></div>");
                    $("#" + activityBoxId + " #main-content").html(contentHtml);
                    $("#"+ activityBoxId).prepend("<span class='close-icon'>x</span><div id='left-content'><div id='header-content'><div class='iconBox'><i class='dls-imgbook-font dls-imgbook-list-alt'> </i></div><div class='description'><h1>Activity</h1><p class='lead'>"+ jsonData[pageNumber][assetsNo].desc + "</p></div></div>");

                    var testRunner = new TestRunner();
                    testRunner.init(initParams, "#"+ objectId + " #iframeContainer", eventContext, objectId, "#" + loaderID, function() {
                        testRunner.initializeLauncher(itemParams, objectId, function() {
                            console.log("here");
                        });
                        var activitySettings =  {"size":"large"};
                        testRunner.updatePaintPreferences(activitySettings, objectId);
                    });
                    $("#"+ activityBoxId + ' .doneQuestion').click(function(){
                        testRunner.submitAnswer(objectId);  
                        $("#"+ activityBoxId + ' .doneQuestion').removeClass("btn-primary").addClass("btn-disabled").off("click");
                    });
                    $(".activityBox .close-icon").click(function() {
                        /*$("#"+ objectId).parent().parent().show();*/
                        $("#" + hotspotId + " div div").css("border-width","0");
                        $("#" + hotspotId + " div div").css("box-shadow","");

                        var animation;
                        if ($("#"+activityBoxId).css("left") === "0px") {
                            animation = "fadeOutLeft";
                        } else {
                            animation = "fadeOutRight";
                        }
                        var animateElement = $("#"+ objectId).parent().parent();
                        var animationDuration = 800;
                        
                        animateElement.addClass('animated '+ animation);
                        
                        setTimeout(function(){
                            animateElement.removeClass(animation);
                            animateElement.remove();
                        }, animationDuration);
                        
                    });
                } else {
                    $(".activityBox .close-icon").trigger( "click" );
                }             
            }
            if (resourceType === "coming_soon_pop") {
                var objectId1 = "coming_soon";
                var activityBoxId1 = "activity-overlay"+ pageNo + '-' + assetsNo;
                var hotspotId1= "ee-overlays"+ pageNo + '-' + assetsNo;
                if (activityBoxId1 !== $("body .activityBox").attr("id")) { 
                    $(".invisibleHotspot div div").css("border-width","0");
                    $("#" + hotspotId1+ " div div").css("border-width","2px");
                    $("#" + hotspotId1+ " div div").css("box-shadow","2px 2px 1px #e5e5e5");
                    $("body .activityBox").remove();

                    $("body").append('<div class="activityBox" id="' + activityBoxId1 + '"></div>');
                    if ($('#ee-overlays'+pageNo+'-'+assetsNo).offset().left > window.innerWidth/2) {
                        $("#"+activityBoxId1).css("left","0");
                        $("#"+activityBoxId1).css("right","");
                    } else {
                        $("#"+activityBoxId1).css("right","0");
                        $("#"+activityBoxId1).css("left","");
                    }

                    var styles1 = "<style>.hidden {display: none !important;visibility: hidden !important;}.ui-loader {z-index: 9999999;position:absolute!important;}object .container-fluid{position:relative;}.wrapper{position: relative;}.ribbon {position: absolute;left:15px;top:-9px;z-index: 1;}.ribbon h2 {background: #275B89;color: #fff;font-size: 14px;font-weight:bold;position: relative;box-shadow: 4px 5px 3px #DCDCDC;padding: 6px 20px;margin: 0;}.ribbon h2:after {border-width: 4px 4px;border-style: solid;border-color: transparent #444444 #444444 transparent ;content: '';position: absolute;top:0;left:-8px;}.btn {-moz-user-select: none;background-image: none;border: 1px solid transparent;border-radius: 2px;cursor: pointer;display: inline-block;font-size: 13px;font-weight: 400;line-height: 1.42857;margin-bottom: 0;padding: 6px 12px;text-align: center;vertical-align: middle;white-space: nowrap;}.btn-warning {background-color: #c79121;border-color: #b1811d;color: #fff;}.btn-warning.active, .btn-warning.focus, .btn-warning:active, .btn-warning:focus, .btn-warning:hover, .open > .dropdown-toggle.btn-warning {background-color: #9b711a;border-color: #7d5b15;color: #fff;}.btn-warning.active, .btn-warning:active, .open > .dropdown-toggle.btn-warning {background-image: none;}.nextQuestionButton {position: absolute;bottom: -18px;left: 15px;}.iframeContainer{background-color:#fff;margin:10px;min-height:450px;max-height:450px;overflow:auto;text-align:center;}.submitActivity{padding:10px;}</style>";
                    var activityHTML1 = "<div id='"+ objectId1 +"'><div><div class='row-fluid'><!-- Activity Container Starts here --><div class='wrapper hidden'><div class='span12 activityContainer book-activity'><div class='inner iframeContainer text-center'></div></div> <!-- Activity Container ends here --></div></div></div></div>";
                    $("#"+ activityBoxId1).append(styles1 + activityHTML1);

                    var contentHtml1  = $("#"+ activityBoxId1).html();
                    $("#"+ activityBoxId1).html("<div id='main-content'></div>");
                    $("#" + activityBoxId1 + " #main-content").html(contentHtml1);
                    $("#"+ activityBoxId1).prepend("<span class='close-icon'>x</span><div id='left-content'><div id='header-content'><div class='iconBox'><i class='dls-imgbook-font dls-imgbook-list-alt'> </i></div><div class='description'><h1>Activity</h1><p class='lead'>"+ jsonData[pageNumber][assetsNo].desc + "</p></div></div>");

                    $("#"+objectId1 + " .wrapper").each(function() {
                        $(this).removeClass("hidden");
                    });
                   
                    $("#"+ objectId1).parent().parent().show();
                    var animation;
                    if ($("#"+activityBoxId1).css("left") === "0px") {
                        animation = "fadeInLeft";
                    } else {
                        animation = "fadeInRight";
                    }
                    
                    var animateElement = $("#"+ objectId1).parent().parent();
                    var animationDuration = 800;
                    
                    animateElement.addClass('animated '+ animation);
                    
                    setTimeout(function(){
                        animateElement.removeClass(animation);
                        $("#" + hotspotId1+ " div div i").remove();
                    }, animationDuration);


                    $(".activityBox .close-icon").click(function() {
                        /*$("#"+ objectId1).parent().parent().show();*/
                        $("#" + hotspotId1+ " div div").css("border-width","0");
                        $("#" + hotspotId1+ " div div").css("box-shadow","");

                        var animation;
                        if ($("#"+activityBoxId1).css("left") === "0px") {
                            animation = "fadeOutLeft";
                        } else {
                            animation = "fadeOutRight";
                        }
                        var animateElement = $("#"+ objectId1).parent().parent();
                        var animationDuration = 800;
                        
                        animateElement.addClass('animated '+ animation);
                        
                        setTimeout(function(){
                            animateElement.removeClass(animation);
                            animateElement.remove();
                        }, animationDuration);
                        
                    });
                } else {
                    $(".activityBox .close-icon").trigger( "click" );
                }                
            }
            if(resourceType === 'url') {
                if (jsonData[pageNumber][assetsNo].url.baseURL) {
                    baseURL = jsonData[pageNumber][assetsNo].url.baseURL;
                    assetsUrl = bookData["overlay-config"]["external-base-urls"][baseURL] + jsonData[pageNumber][assetsNo].url.path;
                } else {
                    assetsUrl = jsonData[pageNumber][assetsNo].url.path;
                }
                
                if(jsonData[pageNumber][assetsNo].url.type && jsonData[pageNumber][assetsNo].url.type === "iframe") {
                    $.featherlight(assetsUrl,{
                        iframe: assetsUrl,
                        iframeWidth: jsonData[pageNumber][assetsNo].w,
                        iframeHeight: jsonData[pageNumber][assetsNo].h
                    });
                } else {
                    window.open(assetsUrl,'_blank');    
                }
            }
            if(resourceType === 'page') {
                if (config.startLoader) {
                    config.startLoader();    
                }
                var pagelabel =jsonData[pageNumber][assetsNo].page.pagelabel;
                comprodls.READER.jumpToPageLabel(pagelabel);
            }
        };
        
        var playHTML5Video = function (videopath, isExternalVideo, overlayInfo) {   
            if (isExternalVideo) {
                // In case video is of youtube/ vimeo etc.
                $.featherlight(videopath, {
                    iframe: videopath, 
                    iframeWidth: overlayInfo.video.width,
                    iframeHeight: overlayInfo.video.height,
                    afterContent: function () {
                        var contentHtml  = $(".featherlight .featherlight-content").html();
                        $(".featherlight .featherlight-content").html("<div id='main-content'></div>");
                        $(".featherlight .featherlight-content #main-content").html(contentHtml);
                        $(".featherlight .featherlight-content").prepend("<div id='left-content'><div id='header-content'><h1>" + overlayInfo.title + "</h1></div><div><p class='lead'>"+overlayInfo.desc+"</p></div></div>");
                        $(".featherlight .featherlight-content #main-content iframe").css("margin", "0 auto");
                    }
                });
            } else {
                $.featherlight('#video-lightbox', {
                    afterContent: function () {
                        var content = '<video id="video" width="'+ overlayInfo.video.width +'" height="'+ overlayInfo.video.height +'" preload="none" controls="controls"><source src="' + videopath + '.mp4" type="video/mp4" /><source src="'+ videopath + '.ogv" type="video/ogg" /><div>Your browser does not support the HTML5 video tag.</div></video>';
                        $('.featherlight-content').append(content);

                        var contentHtml  = $(".featherlight .featherlight-content").html();
                        $(".featherlight .featherlight-content").html("<div id='main-content'></div>");
                        $(".featherlight .featherlight-content #main-content").html(contentHtml);
                        $(".featherlight .featherlight-content").prepend("<div id='left-content'><div id='header-content'><h1>" + overlayInfo.title + "</h1></div><div><p class='lead'>"+overlayInfo.desc+"</p></div></div>");
                    },
                    afterOpen: function () {
                        new MediaElementPlayer($(".featherlight .featherlight-content #main-content").find("video")[0], {success: function() {
                            // do things
                            $(".featherlight .featherlight-content #main-content .mejs-container.mejs-video").css("margin", "0 auto");
                        }});
                    }
                });
           }
        };

        var applyTooltip = function(overlay, index) {
            overlay.attr("title", jsonData[pageNumber][index].desc);
            if (jsonData[pageNumber][index].desc !== "" && overlay.tooltipster !== undefined) {
                overlay.tooltipster({
                   maxWidth: "350",
                   arrow: false,
                   offsetY: -10
                });
            }
        };

        //Remove all the hotspots present on the page
        var $overlayContainer = $('#ee-overlays'+pagetype);

        $overlayContainer.find('.ee-overlay').remove();

        /*  Add styles for showing animation on page load(in case its first time page load and style already not added in case of double page view).
            Remove the styles after the animation has run once.
            In case of new page load, remove the earlier set timeout so that it doesnt finish the animation on new page soon
        */
        if(!isReRendering) {
            // console.log("deleting counter ", timeoutCounter);
            clearTimeout(timeoutCounter);
            $("#animationStyles").remove();
        }

        timeoutCounter = comprodls.READER.animateHotlinks(isReRendering);

        for(var j = 0; j < pageAssets; j++) {
            var overlaysId = 'ee-overlays'+pageNo+'-'+ j;
            if($overlayContainer.find('#'+overlaysId).length === 0) {
				if($('#'+overlaysId).length) {
					$('#'+overlaysId).remove();
				}
                $overlayContainer.append('<div id= \"' + overlaysId + '\" class="ee-overlay" pagetype="'+pagetype+'"></div>');
                $overlayContainer.find('#'+overlaysId).append('<div><i></i></div>');
                renderOverlaysDataType(j,overlaysId);
            }
        }
    };

    /*var isAudioPlayerRunning = function(audioPlayer) {
        return !audioPlayer.paused && !audioPlayer.ended && audioPlayer.currentTime > 0;
    };*/

    var stopAudioPlayer = function() {
        for (var property in audioAdaptorMap) {
            audioAdaptorMap[property].pauseAudio();
        }
    };

    var stopPreviousOverlay = function() {
        for (var property in audioAdaptorMap) {
            audioAdaptorMap[property].stopAudio();
        }
    };

    var resetAudioIcon = function(id) {
        delete audioAdaptorMap[id];
        var audioOverlay = $('#'+id + " > div");
        /*audioOverlay.removeClass("selected music-icon-selected").children("i").removeClass("dls-imgbook-volume-up dls-imgbook-pause").addClass("dls-imgbook-volume-up");*/
        audioOverlay.removeClass("selected music-icon-selected").addClass("paused");
    };

    var togglePlayPauseIcon = function (id) {
        var overlayCircle = $("#"+id).children(".audio-circle");
        if (audioAdaptorMap[id]) {
            if (audioAdaptorMap[id].isAudioPlaying()) {
                /*$(overlayCircle.children("i")[0]).removeClass("dls-imgbook-volume-up").addClass("dls-imgbook-pause");*/
                overlayCircle.removeClass("paused");
            } else {
                /*$(overlayCircle.children("i")[0]).removeClass("dls-imgbook-pause").addClass("dls-imgbook-volume-up");*/
                overlayCircle.addClass("paused");

            }
        }
    };

    /*
        * This function return RGB value of color if code has in RGBA format
        * If color is not RGBA format returns same color.
    */
    var getColorWithoutOpacity = function(colorCode) {
        var rgbaRegEx = new RegExp(/^rgba\(((,?\s*\d+){3}).+$/);
        return rgbaRegEx.test(colorCode) ? colorCode.replace(rgbaRegEx, 'rgb($1)') : colorCode;
    };

    return {
        renderOverlaysData : renderOverlays,
        stopAudioPlayer: stopAudioPlayer
    };
}());

/**
 * Created with JetBrains WebStorm.
 * User: nitish
 * Date: 2/28/14
 * Time: 12:22 PM
 * To change this template use File | Settings | File Templates.
 */
var comprodls = comprodls || {};

comprodls.READER.IMGREADER = comprodls.IMGREADER || {};

comprodls.READER.IMGREADER.UTIL = (function() {
    var htmlCache = new LRUCache(100);

    var loadJson = function(path, success) {
        
        $.getJSON(path)
          .done(function( json ) {
            success(json);
          })
          .fail(function( jqxhr, textStatus, error ) {
            console.log( "Error: " + textStatus + " , " +  error);
        });

    };

    var loadImageAndHtml = function(paths, success, error) {
        var imagePath = paths.imagePathToLoad;
        var htmlPath = paths.htmlPathToLoad;
        var image = new Image();
        image.src = imagePath;
        if(htmlPath) {
            var lruHtmlKey = 'html' + '-' +  htmlPath.substr(htmlPath.lastIndexOf("/")+1);
            var cachedHTML = htmlCache.get(lruHtmlKey);
            if (!cachedHTML) { 
                $.ajax({
                    url: htmlPath,
                    dataType: "html",
                    success: function(data) {
                        htmlCache.put(lruHtmlKey, data);
                    },
                    error: function(e) {
                        console.log('Error: ' + e);
                    }
                });
                
            }
        }

        image.onload = function() {
            success();
        };

        image.onerror = function(err) {
            error(err);
        };
    };
    
    var loadCSS = function(cssArray, success) {
        yepnope({
            load: cssArray,
            complete: success
        });
    };

    var loadHTML = function(htmlPath, callback) {

        if(!htmlPath) {
            callback();
        }
        var lruHtmlKey = 'html' + '-' +  htmlPath.substr(htmlPath.lastIndexOf("/")+1);
        var cachedHTML = htmlCache.get(lruHtmlKey);
        if (!cachedHTML) {
            $.ajax({
                url: htmlPath,
                dataType: "html",
                success: function(data) {
                    htmlCache.put(lruHtmlKey, data);
                    callback(modifyHtml(data));
                },
                error: function(e) {
                    console.log('Error: ' + e);
                    callback();
                }
            });            
        } else {
            callback(modifyHtml(cachedHTML));
        }
    };

    var modifyHtml = function(html) {
        var parser = new DOMParser();
        var parsedData = parser.parseFromString(html, 'text/html');
        var htmlElem = parsedData.getElementsByTagName('html')[0];
        var lang = htmlElem && (htmlElem.getAttribute('lang') || htmlElem.getAttribute('xml:lang'));
        var bodyHtml = /<body.*?>([\s\S]*)<\/body>/.exec(html)[1];
        var dom_nodes = $($.parseHTML(("<div class='lang-wrapper' " + (lang ? "lang= "+ lang : " ") + " >"+bodyHtml+"</div>").trim()));
        dom_nodes.find('img').each(function () {
            var imgAttr = $(this).attr('src');
            $(this).removeAttr('src');
            $(this).attr('data-src', imgAttr);
        });
        dom_nodes.find('a').each(function () {
            var hrefAttr = $(this).attr('href');
            $(this).removeAttr('href');
            $(this).attr('data-href', hrefAttr);
        });
        return dom_nodes;
    };

    return {
        'loadJson': loadJson,
        'loadImageAndHtml': loadImageAndHtml,
        'loadCSS': loadCSS,
        'loadHTML': loadHTML
    };
}());
/*global comprodls*/
/*global window*/

(function( $, window ) {
    "use strict";
    
    var pluginName = "imgBookReader",
                    defaults = {
                    propertyName: "value"
    };
    $.fn[pluginName] = function ( bookID, options ) {
        var plugin = new Plugin( this, bookID, options);
        return plugin;
    };
    
    // constructor
    function Plugin ( element, bookID, options ) {
        this.element = element;

        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.loadBook(element, bookID, options);
    }
    

    // to avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        loadBook: function (element, bookID, options) {
            options.elParent = element[0].id;
            comprodls.READER.loadBook(bookID, options);
        },
        nextPage: function () {
            comprodls.READER.changePage('next');
        },
        prevPage: function () {
            comprodls.READER.changePage('prev');
        },
        jumpToPageLabel: function (pageLabelToNavigate, isSearch) {
            return comprodls.READER.jumpToPageLabel(pageLabelToNavigate, isSearch);
        },
        jumpToPageSerial : function(serialNoToNavigate, isSearch) {
            return comprodls.READER.jumpToPageSerial(serialNoToNavigate, isSearch);
        },
        changeLayout: function (layout) {
            comprodls.READER.changeLayout(layout); // Possible values of layout are 'single' and 'double'
        },
        zoomin: function () {
            comprodls.READER.zoomIn();
        },
        zoomout: function () {
            comprodls.READER.zoomOut();
        },
        canZoomIn: function () {
            return comprodls.READER.canZoomIn();
        },
        canZoomOut: function () {
            return comprodls.READER.canZoomOut();
        },
        resetZoom: function (doNotZoomOut) {
            /*
            To reset the zoom level (means ignore any user specific zoom levels). Typically this should be 
            called on window.resize to automatically adjust the book zoom level to best available 
            default (based on space available).
            */
            comprodls.READER.resetZoom(doNotZoomOut);
        },
        canResetZoom: function() {
            return comprodls.READER.canResetZoom();
        },
        getPageNumber: function() {
            return comprodls.READER.getPdfPageLevel();
        },
        getPageLayout: function () {
            return comprodls.READER.pageLayout();
        },
        getCurrentSerial: function() {
            return comprodls.READER.getCurrentSerial();
        },
        getPageSerial: function(){
            return comprodls.READER.pageLevel();
        },
        resizeImgbook: function() {
            return comprodls.READER.resizeImgbook();
        },
        updateImageConfig: function(imageConfig) {
            return comprodls.READER.updateImageConfig(imageConfig);
        },
        getImageConfig: function() {
            return comprodls.READER.getImageConfig();  
        },
        getZoomConfig: function(getCurrentZoomState) {
            return comprodls.READER.getZoomConfig(getCurrentZoomState);
        },
        getPageDimensionsFromJSON: function() {
            return comprodls.READER.getPageDimensionsFromJSON();
        },
        setZoomConfig: function(zoomConfig, bestMatchZoomStateIndex) {
            return comprodls.READER.setZoomConfig(zoomConfig, bestMatchZoomStateIndex);
        },
        isContentFitToScreen: function(height) {
          return comprodls.READER.isContentFitToScreen(height);
        },
        isContentFitToWidth: function(width) {
          return comprodls.READER.isContentFitToWidth(width);
        },
        getOverlaysJSON: function() {
            return comprodls.READER.getOverlaysJSON();
        },
        setOverlaysJSON: function(overlaysJSON) {
            return comprodls.READER.setOverlaysJSON(overlaysJSON);
        },
        setCircleColor: function(color) {
            return comprodls.READER.setCircleColor(color);
        },
        setIconColor: function(color) {
            return comprodls.READER.setIconColor(color);
        },
        setBorderColor: function(color) {
            return comprodls.READER.setBorderColor(color);
        },
        setHotspotBorder : function(color) {
            return comprodls.READER.setHotspotBorder(color);
        },
        setHoverColor: function(color) {
            return comprodls.READER.setHoverColor(color);
        },
        setTranslateCoords: function (coords) {
			return comprodls.READER.setTranslateCoords(coords);
        },
        getTranslateCoords: function () {
			return comprodls.READER.getTranslateCoords();
        },
        getCursorPosition: function (callback) {
            return comprodls.READER.getCursorPosition(callback);
        },
        exitCaptureMode: function () {
            return comprodls.READER.exitCaptureMode();
        },
        getScaledOriginalBookValues: function (coords) {
            return comprodls.READER.getScaledOriginalBookValues(coords);
        },
        getCircleColor: function() {
            return comprodls.READER.getCircleColor();
        },
        getIconColor: function() {
            return comprodls.READER.getIconColor();
        },
        getBorderColor: function() {
            return comprodls.READER.getBorderColor();
        },
        getHotspotBorder: function() {
            return comprodls.READER.getHotspotBorder();
        },
        getHoverColor: function() {
            return comprodls.READER.getHoverColor();
        },
        enableAnnotations : function(value) {
          return comprodls.READER.enableAnnotations(value);
        },
        enableOverlays : function() {
          return comprodls.READER.enableOverlays();
        },
        getImageMapByPageLabel : function(fromPageLabel, toPageLabel) {
            return comprodls.READER.getImageMapByPageLabel(fromPageLabel, toPageLabel);
        },
        getImageMapByPageSerial : function(fromPageSerial, toPageSerial) {
          return comprodls.READER.getImageMapByPageSerial(fromPageSerial, toPageSerial);  
        },
        showHotspotBorder : function(value) {
          return comprodls.READER.showHotspotBorder(value);
        },
        isDoublePageAllowed : function () {
            return comprodls.READER.isDoublePageAllowed();
        },
        getCurrentPagePosition : function() {
            return comprodls.READER.getCurrentPagePosition();
        },
        openAnnotation : function(id) {
            comprodls.READER.openAnnotation(id);
        },
        fitToHeight : function() {
            comprodls.READER.fitToHeight();
        },
        canFitToHeight : function() {
            return comprodls.READER.canFitToHeight();
        },
        animateHotlinks: function() {
            return comprodls.READER.animateHotlinks();
        },
        enableTouchScreenGestures : function (options) {
            comprodls.READER.enableTouchScreenGestures(options);
        }
    });
    window.imgBookReader = $.fn[pluginName];
})( jQuery, window );
var AudioAdapterGenerator = (function () {
    "use strict";

    /* Constructor function */
    function audioAdaptorGenerator() {
        this.audioConfig = {
            id : "",
            url: "",
            audioInstance: "",
            audioStopped: false,
            togglePlayPauseIcon : function(){},
            resetAudioIcon: function(){},
            onAudioStop: function(){}
        };
       
    }
    
    audioAdaptorGenerator.prototype = {
        
        getAudioAdapter: function(options){
            jQuery.extend(this.audioConfig, options);
            return this;
        },
        startAudio: function(callback) {
            var audioConfig = this.audioConfig;
            var audioId = audioConfig.id;
            audioConfig.audioInstance = new Audio();
            audioConfig.audioInstance.src = audioConfig.url;
            audioConfig.audioInstance.load();
            audioConfig.audioInstance.addEventListener('loadeddata', function() {
                audioConfig.audioInstance.play();
                audioConfig.audioStopped = false;
                if (callback) {
                    callback();
                }
            });
            audioConfig.audioInstance.addEventListener('ended', function() {
                audioConfig.resetAudioIcon(audioId);
                audioConfig.onAudioStop();
            });
        },
        loadTrack: function(audioFile) {
            var audioConfig = this.audioConfig;
            audioConfig.audioInstance.src = audioFile;
            audioConfig.audioInstance.load();
        },
        startAudioPlayList: function (delay, callback) {
            var self = this;
            var audioConfig = this.audioConfig;
            var audioId = audioConfig.id;
            audioConfig.audioInstance = new Audio();
            var i = 0;
            audioConfig.audioInstance.src = audioConfig.url[i];
            audioConfig.audioInstance.load();
            audioConfig.audioInstance.addEventListener('loadeddata', function() {
                audioConfig.audioInstance.play();
                if (callback) {
                    // Passing the current audio number played and total number of audios
                    callback(i+1,audioConfig.url.length);
                }
            });
            audioConfig.audioInstance.addEventListener('ended', function() {
                i++;
                setTimeout(function() { 
                    if (i >= audioConfig.url.length) {
                        audioConfig.resetAudioIcon(audioId);
                        audioConfig.onAudioStop();
                    } else {
                        if (!audioConfig.audioStopped) {
                            self.loadTrack(audioConfig.url[i]);
                        }
                    }
                }, delay);
            });
        },
        isAudioPlaying: function() {
            return !this.audioConfig.audioInstance.paused;
        },
        playAudio: function() {
            if (this.audioConfig.audioInstance && !this.audioConfig.audioStopped) {
                this.audioConfig.audioInstance.play();
                this.audioConfig.togglePlayPauseIcon(this.audioConfig.id);    
            }
            
        },
        pauseAudio: function () {
            this.audioConfig.audioInstance.pause();
            this.audioConfig.togglePlayPauseIcon(this.audioConfig.id);
        },
        stopAudio: function () {
            this.audioConfig.audioInstance.pause();
            this.audioConfig.audioInstance.currentTime = "0";
            this.audioConfig.audioStopped = true;
            this.audioConfig.resetAudioIcon(this.audioConfig.id);    
            this.audioConfig.onAudioStop();
        },
        getDuration: function () {
            return this.audioConfig.audioInstance.duration;
        },
        getPosition: function () {
            return this.audioConfig.audioInstance.currentTime;
        },
        setPosition: function (position) {
            this.audioConfig.audioInstance.currentTime = position;
        }
    };
    
    return audioAdaptorGenerator;
    
}());